export default {
  en: {
    "customers.label.add_Child": "Add Child",
    "customers.label.existing_customer": "Existing Customer",
    "customers.label.parent": "Parent",
    "customers.label.temporaryBlock": "Temporary Block",
    "customers.label.unBlock": "Unblock",
    "customers.label.feedback": "Feedback",
    "customers.label.event_id": "Event Id",
    "customers.label.slc_state_history": "SLC State History",
    "customers.label.slc": "SLC",
    "customers.label.state_Change_Time": "State Change Time",
    "customers.label.event": "Event",
    "customers.label.previous_state": "Previous State",
    "customers.label.resolution_date": "Resolution Date",
    "customers.label.current_state": "Current State",
    "customers.label.created_time": "Created Time",
    "customers.label.creation_time": "Creation Time",
    "customers.label.Promotion": "Promotion",
    "customers.label.slc_status": "SLC Status",
    "customers.label.update_slc_status": "Update SLC Status",
    "customers.label.temporary_block": "Temporary Block",
    "customers.label.workflow_id": "Workflow Id",
    "customers.label.externalPromoId": "External Promo ID",
    "customers.label.externalPromoName": "External Promo Name",
    "customers.label.promoCode": "Promo Code",
    "customers.label.promoDescription": "Promo Description",
    "customers.label.ViewRateLimit": "View Rate Limit",
    "customers.label.SelectType": "Select Type",
    "customers.label.ScheduleOrder": "Schedule Order",
    "customers.label.ScheduledDate": "Scheduled Date",
    "customers.label.search": "Search",
    "customers.label.SelectTaxExemption": "Select Tax Exemption",
    "customers.label.ViewTickets": "View Tickets",
    "customers.label.TicketHistory": "Ticket History",
    "customers.label.ReopenTicket": "Reopen Ticket",
    "customers.label.SelectInvoiceType": "Select Invoice Type",
    "customers.label.SelectCategory": "Select Category",
    "customers.label.SelectSubCategory": "Select Subcategory",
    "customers.label.SelectSource": "Select Source",
    "customers.label.TicketHistory": "Ticket History",
    "customers.label.ViewSpendCap": "View Spend Cap",
    "customers.label.ResponseMessage": "Response Message",
    "customers.label.AddPlan": "Add Plan",
    "customers.label.Basket": "Basket",
    "customers.label.TotalPrice": "Total Price",
    "customers.label.Send_Link_to_Customer_to_Complete_Payment":
      "Send Link to Customer to Complete Payment",
    "customers.label.CheckPaymentStatus": "Check Payment Status",
    "customers.label.Are_you_sure_you_want_to_terminate?":
      "Are you sure you want to terminate?",
    "customers.label.Unlimited": "Unlimited",
    "customers.label.days_left": "days left",
    "customers.label.search": "Search",
    "customers.label.JobTitle": "Job Title",
    "customers.label.SelectDocumentType": "Select Document Type",
    "customers.label.SelectEvents": "Select Events",
    "customers.label.SelectFormatType": "Select Format Type",
    "customers.label.SelectAdjustmentType": "Select Adjustment Type",
    "customers.label.card_number": "Card Number",
    "customers.label.Select_OPT_Type": "Select OPT Type",
    "customers.label.StartDate": "Start Date",
    "customers.label.EndDate": "End Date",
    "customers.label.Cancel": "Cancel",
    "customers.label.Set": "Set",
    "customers.label.PaymentDetails": "Payment Details",
    "customers.label.PaymentReceipt": "Payment Receipt",
    "customers.label.Status": "Status",
    "customers.label.PaymentAmount": "Payment Amount",
    "customers.label.Transaction": "Transaction",
    "customers.label.PaymentPage": "Payment Page",
    "customers.label.ItemCode": "Item Code",
    "customers.label.StartDate": "Start Date",
    "customers.label.English": "English",
    "customers.label.SelectIdProof": "Select ID Proof",
    "customers.label.SelectAdjustementCode": "Select Adjustment Code",
    "customers.label.SelectAdjustmentType": "Select Adjustment Type",
    "customers.label.SelectFormat": "Select Format",
    "customers.label.AreYouSure?": "Are You Sure?",
    "customers.label.ChargeId": "Charge ID",
    "customers.label.ChargeDescription": "Charge Description",
    "customers.label.DiscountAmount": "Discount Amount",
    "customers.label.NetChargeAmount": "Net Charge Amount",
    "customers.label.TaxDescription": "Tax Description",
    "customers.label.TaxAmount": "Tax Amount",
    "customers.label.SelectDate": "Select Date",
    "customers.label.SelectPriority": "Select Priority",
    "customers.label.SelectCategory": "Select Category",
    "customers.label.SelectSubCategory": "Select Subcategory",
    "customers.label.SelectSource": "Select Source",
    "customers.label.ViewSpendCap": "View Spend Cap",
    "customers.label.Amount": "Amount",
    "customers.label.PlanCode": "Plan Code",
    "customers.label.Price": "Price",
    "customers.label.Status": "Status",
    "customers.label.EndDate": "End Date",
    "customers.label.ContractPeriod": "Contract Period",
    "customers.label.AutoRenew": "Auto Renew",
    "customers.label.Description": "Description",
    "customers.label.ThankYou": "Thank You!",
    "customers.label.ConnectionActivated":
      "The connection has been activated successfully with Account Number",
    "customers.label.GoToCustomerDetail": "Go to Customer Detail",
    "customers.label.Payment": "Payment",
    "customers.label.CustomerToPay": "Customer to Pay:",
    "customers.label.MonthlyPayment": "Monthly Payment",
    "customers.label.SetupWithDirectDebitOrCreditCard":
      "Setup with Direct Debit or Credit Card",
    "customers.label.SendLinkToCustomerToCompletePayment":
      "Send Link to Customer to Complete Payment",
    "customers.label.CheckPaymentStatus": "Check Payment Status",
    "customers.label.ThisNumberIsReservedFor": "This number is reserved for",
    "customers.label.YouSelected": "You Selected",
    "customers.label.SerialNo": "Serial No",
    "customers.label.PhoneNo": "Phone No",
    "customers.label.ActivatingCustomer": "Activating customer...",
    "customers.label.LoadingOrderStatus": "Loading Order Status...",
    "customers.label.OrderStatus": "Order Status:",
    "customers.label.Failed": "Failed",
    "customers.label.RoamingOutsideEEA": "Roaming outside the EEA",
    "customers.label.TariffTermsDetails":
      "Please see our Tariff Terms and Website for more details about specific tariffs and Charges outside your Allowance.",
    "customers.label.PaymentTerms":
      "We will debit the amount you need to pay us from your account by SEPA direct debit. Unless we have agreed otherwise with you. The invoice will show the date on which date we will debit the invoice amount. We may ask you to pay one-off fees and subscription fees in advance. In special cases we may charge interim amounts. For example, if in a short period of time you have you have used a certain service above average in a short period. If you are paying by credit or debit card you authorise the payment card company to give us and, on a strictly confidential basis, to our sub-contractors and/or agents, details about your payment card account if it's necessary in connection with the Agreement. You also authorise them to let us know if your payment account is terminated or suspended at any time.",
    "customers.label.ServiceAgreementTerms":
      "Duration, renewal and termination of the Services Agreement",
    "customers.label.Duration": "Duration",
    "customers.label.Renewal": "Renewal",
    "customers.label.ContractTermsAndConditions":
      "Contract terms and conditions",
    "customers.label.TermsAndConditions": "Terms & Conditions",
    "customers.label.CustomerExplanation":
      "I have provided the customer with a detailed explanation of the",
    "customers.label.CustomerAgreement":
      "and they have agreed to proceed with the order.",
    "customers.label.NumberReservedFor": "This number is reserved for",
    "customers.label.YouSelected": "You Selected",
    "customers.label.SerialNo": "Serial No",
    "customers.label.PhoneNo": "Phone No",
    "customers.label.TotalPrice": "Total Price",
    "customers.label.FeaturesForEndUsersWithDisabilities":
      "Features for end-users with disabilities",
    "customers.label.InformationSupportServices":
      "Information in support of our services is available in alternative formats. If you would like access to information from us in an alternative format, please call us via your Lycamobile SIM on 1200 or visit",
    "customers.label.HowWeUseYourInformation": "How we use your information",
    "customers.label.InformationUsageDetails":
      "We will collect information about how you use our Services and third-party services you use in conjunction with our Services, including for example your location and account activity, to enhance your overall experience with us and make it more relevant to you. We may use and analyze your personal details to help us run your Service(s) and account, including for credit checking and fraud prevention. We may share and combine that data and your information with carefully selected third parties for all those same reasons. Your information is treated in accordance with our Privacy Policy, which can be viewed at:",
    "customers.label.CustomerComplaints":
      "If you are not content with the speed, quality or other elements of the service, and wish to make a complaint, please contact Customer Services. You can find out more about our complaints process in our Customer Complaints Code of Practice which can be found at",
    "customers.label.DisputeResolution":
      "If we are unable to resolve your complaint, you may submit your complaint within 12 months to the Telecommunications Services Disputes Committee. You may also file a complaint on the online dispute resolution platform of the European Commission or file a lawsuit in civil court.",
    "customers.label.costsEuro": "costs €",
    "customers.label.thereafterEuro": "thereafter €",
    "customers.label.forTheFirst": "for the first",
    "customers.label.perMonthInclusiveVAT":
      "per month, inclusive of VAT (subject to annual increases of CPI+ 3.9%). See Website for more details.",
    "customers.label.additionalAddOns":
      "Additional Add-ons may be available for your Plan and will be charged separately on your bill.",
    "customers.label.paymentTerms":
      "You must pay the Charges for the Services you subscribe to and/or use every month by the date on your bill. We may charge fees if you're late in paying. We may ask you to pay a deposit before we'll let you use the Services. Please see our Tariff Terms and Website for more details about specific tariffs and Charges outside your Allowances.",
    "customers.label.durationRenewalTermination":
      "Duration, renewal and termination",
    "customers.label.minimumPeriod":
      "has a Minimum Period of 1 months and will continue after that period monthly until termination by you on 30 days' notice (unless any other statutory or regulatory rules apply) and you will have to pay Charges incurred during this Notice period.",
    "customers.label.cancellationCoolingOff":
      "If you change your mind about the Services purchased directly from us, you've bought from us, you may be entitled to cancel the Services Agreement within the 14-day Cooling-Off Period.",
    "customers.label.earlyTerminationCharge":
      "You agree that Services will begin immediately if you already have a SIM Card or when you receive a SIM Card. If you want to end the Services Agreement during the Minimum Period or we end the Services Agreement as a result of your material breach, then you will have to pay an Early Termination Charge which amounts to no more than your Monthly Subscription Charges multiplied by the number of months left in your Minimum Period, including VAT (calculated at the prevailing rate) minus a percentage for a single final payment. You'll also have to pay for any calls, texts, data and other Charges you've incurred, including during the Cooling-Off Period.",
    "customers.label.ContractSummarys":
      "This contract summary and our Abonnement offer of Large International services for 1 month that enables you to make and receive voice calls, to send and receive SMS, data, and access the Internet, all by means of the Network, along with any optional Add-On Services we agree to provide and which you elect to receive.",
    "customers.label.The": "The",
    "customers.label.ComesWith": "comes with:",
    "customers.label.MobileDataSpeeds": "Speeds of the mobile data service",
    "customers.label.DataServiceDescription":
      "The data service and associated minimum and maximum speeds available via the Lycamobile network are based on the technology accessible e.g. 2G, Edge, 3G, 4G, 5G at your location, the device used and the type of plan you have purchased.",
    "customers.label.DataSpeedVariation":
      "The speed of your mobile data service may vary and is dependent on your location, the environment around you (weather, tree cover, materials used in buildings you are in or near and the number of people using the network) and the device used to connect to the network.",
    "customers.label.LycamobileBV": "Lycamobile B.V.",
    "customers.label.Robijnlaan17": "Robijnlaan 17,",
    "customers.label.2132WXHoofddorp": "2132WX Hoofddorp,",
    "customers.label.TheNetherlands": "The Netherlands",
    "customers.label.ContractSummary": "Contract Summary",
    "customers.label.ContractSummaryDescription1":
      "This contract summary provides the main elements of this service offer as required by law.",
    "customers.label.ContractSummaryDescription2":
      "It helps to make a comparison between service offers.",
    "customers.label.ContractSummaryDescription3":
      "Complete information about the service is provided in other documents.",
    "customers.label.ContractSummaryValidity":
      "This Contract Summary is valid until checkout expiry on",
    "customers.label.AcceptOffer":
      "If this offer is suitable, you can accept it via the checkout page. Please keep a copy of this document for your records.",
    "customers.label.Services": "Services",
    "customers.label.TermsConditions":
      "Under the Terms and Conditions of the Services Agreement, if we break a material term of the Agreement which completely restricts our ability to provide you with data as part of our Service and we don't correct it within 7 days of receiving your complaint through Lycamobile Customer Services, you can end the agreement.",
    "customers.label.EmergencyOrganisations":
      "Emergency organisations and caller location information",
    "customers.label.EmergencyCallInstructions":
      "If you need to make an emergency/112/999 call when Lycamobile's Network is down or unavailable, for any reason, your mobile device should be capable of connecting to 2G, 3G, 4G or 5G radio networks and can select a competitor's network that has coverage to access emergency calls.",
    "customers.label.EmergencyCallAvailability":
      "Emergency calls can only be made where there is a radio network available.",
    "customers.label.PlanName": "Plan Name",
    "customers.label.EuropeanOnlineDisputeResolution":
      "The European Online Dispute Resolution site",
    "customers.label.ECWebsite": "ec.europa.eu/consumers/odr",
    "customers.label.DisputeResolutionDetails":
      "allows consumers to submit disputes relating to online purchases with us. You can check our website for a copy of our Code of Practice on complaints and for our latest information on alternative dispute resolutions. We are here to help. If something goes wrong, we want to put it right. You can find out more about our complaints process in our Customer Complaints Code of Practice which can be found at.",
    "customers.label.NetherlandsLawCompliance":
      "In the event of continuous and or regularly recurring discrepancy between the actual performance of the internet access service regarding speed, in accordance with the laws of the Netherlands, Lycamobile will provide repeat performance within a reasonable time. Where repeat performance is impossible, Lycamobile will reasonably reduce the price the Customer pays for the Service. If the Customer has already paid, Lycamobile shall reimburse the Customer for any values paid above that amount.",
    "customers.label.DirectoryServiceInfo":
      "You can ask us to include your mobile phone number in a telephone directory and/or a directory enquiry service. However, you should know that if you request this service your number will be visible to companies that compile information for marketing purposes. If you're worried about this, you can stop the unsolicited marketing calls by choosing to opt-out or through using your right of objection. If you want your mobile phone number to be included in a directory and/or a directory enquiry service, please tell our Customer Services team.",
    "customers.label.RemediesComplaints":
      "Remedies, complaints handling and dispute resolution",
    "customers.label.ContactCustomerService":
      "If you need to contact Customer Service, please visit the Website and click on 'Contact Us'. If you want to complain about our Service, contact Customer Services. If you are still unhappy you can write for an impartial review to:",
    "customers.label.IncludeMobileNumber":
      "Please include your mobile phone number if you write to us. If we are unable to resolve your complaint, you may submit your complaint within 24 months to the De Geschillencommissie ( Postbus 90600, 2509 LP, Den Haag ).",
    "customers.label.Termination": "Termination",
    "customers.label.TerminationNotice":
      "After the Minimum Period, you can end the Agreement by giving us Notice (unless any other statutory or regulatory rules apply) and you will have to pay Charges incurred during this Notice period.",
    "customers.label.EarlyTerminationCharge":
      "Unless specified otherwise (such as in your Tariff Terms), if you want to end the Services Agreement during the Minimum Period or we end the Services Agreement as a result of your material breach, then you will have to pay an Early Termination Charge which amounts to no more than your Monthly Subscription Charges multiplied by the number of months left in your Minimum Period, including VAT (calculated at the prevailing rate).",
    "customers.label.OptionalAddOnTermination":
      "Any Optional Add-On Services will be terminated independently of any Monthly Bundle Plan.",
    "customers.label.CancellationInfo":
      "Information If you change your mind or need to cancel You are entitled to cancel your acceptance of our Terms and Conditions at any time up to 14 days after placing your order for the Service (the Cooling-Off Period), provided that you cancel in accordance with our cancellation policy or giving Notice to Lycamobile. This does not affect your statutory rights.",
    "customers.label.Security": "Security",
    "customers.label.SecurityPolicy":
      "All security events we become aware of will be analysed for classification, containment, recovery, analysis and resolution. Timely notifications shall be sent to any affected customers based on applicable regulatory and contractual requirement. Security Incidents requiring forensic investigations shall be conducted by Lycamobile or where appropriate shall involve a suitably qualified third party with a view to resolution and future prevention.",
    "customers.label.DataProtection": "Data Protection",
    "customers.label.DataProtectionPolicy":
      "Without prejudice to data protection legislation, Lycamobile requires personal information from the customer to perform the Services, such as: name, address, account number and Mobile Phone number and payment details. Your information is treated in accordance with our Privacy Policy which sets out how we collect, use and share your information, who we share it with and why, describes your rights and explains how you can exercise them.",
    "customers.label.TariffTerms":
      "Please see our Tariff Terms and Website for more details about specific tariffs and Charges outside your Allowance.",
    "customers.label.DeliveryOfService": "Delivery of Service",
    "customers.label.PaymentTerms":
      "We will debit the amount you need to pay us from your account by SEPA direct debit. Unless we have agreed otherwise with you...",
    "customers.label.ServiceStartDate":
      "The date on which Lycamobile will provide the services is the date you register with Lycamobile.",
    "customers.label.ContractDuration":
      "Duration, renewal and termination of the Services Agreement",
    "customers.label.MinimumPeriod":
      "Your Subscription has a minimum term called a Minimum Period, which could be as short as 1 month for Monthly Bundles and 24 months for Fixed-Term Contracts.",
    "customers.label.ContractRenewal":
      "To renew the contract, you must give Notice to Lycamobile during the term of your previous contract, consenting to renew the contract.",
    "customers.label.DataCostDetails":
      "The {40 GB Data} costs € {18.90} for the first {3 months}, thereafter {27.00} per month, inclusive of VAT (subject to annual increases of CPI + 3.9%). See our website for more details.",
    "customers.label.AdditionalAddons":
      "Additional Add-ons may be available for your Plan and will be charged separately.",
    "customers.label.SpendingLimits": "Spending Limits",
    "customers.label.SpendingLimitDetails":
      "Lycamobile will set spending limits on your Account in accordance with your preferences to a maximum of € 250",
    "customers.label.PremiumCharges":
      "Premium and short number calls or SMS-texts and international voice calls are not included in the Allowances and will be charged at the specific tariffs.",
    "customers.label.InternationalRates":
      "Calls and texts from the Netherlands to any other countries will be charged at our standard international rates:",
    "customers.label.RoamingInEEA": "Roaming in the EEA",
    "customers.label.RoamingOutsideEEA": "Roaming Outside the EEA",
    "customers.label.RoamingCharges":
      "Using your phone (calls, texts, and data) while roaming outside the Netherlands or the EEA and selected destinations are charged at our international roaming rates:",
    "customers.label.Any_Out_of_bundle_charges_can_be_found_at":
      "Any out-of-bundle charges can be found at:",
    "customers.label.Exclusions_for_voice_international_voice_SMS_Data_Roaming_can_be_found_at":
      "Exclusions for voice, international voice, SMS, Data Roaming can be found at:",
    "customers.label.Our_Services_availability":
      "Our Services aren't available everywhere in the Netherlands, the EEA, or other selected destinations. The acceptable use of our Services is included in our Domestic and Roaming Fair Use Policy at:",
    "customers.label.Lycamobile_network_speeds":
      "The data service and associated minimum and maximum speeds available via the Lycamobile network are based on the technology accessible e.g. 2G, Edge, 3G, 4G, 5G at your location, the device used and the type of plan you have purchased.",
    "customers.label.Mobile_data_speed_variation":
      "The speed of your mobile data service may vary and is dependent on your location, the environment around you (weather, tree cover, materials used in buildings you are in or near and the number of people using the network) and the device used to connect to the network.",
    "customers.label.Price": "Price",
    "customers.label.ContractReview": "Contract Review",
    "customers.label.Terms&Conditions": "Terms & Conditions",
    "customers.label.ReviewThisContract": "Review This Contract",
    "customers.label.We_have_sent_these_to": "We have sent these to",
    "customers.label.DownloadContractInformation":
      "Download Contract Information",
    "customers.label.DownloadContractSummary": "Download Contract Summary",
    "customers.label.ContractInformation": "Contract Information",
    "customers.label.ContactDetails": "Contact Details",
    "customers.label.Description_of_Services": "Description of Services",
    "customers.label.This_contract_summary_and_our_Abonnement_offer_of":
      "This contract summary and our Abonnement offer of",
    "customers.label.an_airtime_service_for": "an airtime service for",
    "customers.label.comes_with:": "comes with:",
    "customers.label.Any_Out_of_bundle_charges_can_be_found_at:":
      "Any Out-of-bundle charges can be found at:",
    "customers.label.service_description":
      "that enables you to make and receive voice calls, to send and receive SMS, data, and access the Internet, all by means of the Network, along with any optional Add-On Services we agree to provide and which you elect to receive.",
    "customers.label.YouHaveChosenNoCap":
      "You have chosen no cap. This means you'll be able to use your phone for things like calls, texts, international minutes, roaming and data outside of your monthly allowance. You will be billed up to €60 for these.",
    "customers.label.SelectDate":
      "Select Date [The monthly payment will be debited from your account 14 days after your chosen bill generation date] *",
    "customers.label.billing_cycle": "Billing Cycle",
    "customers.label.SelectBilling": "Select Billing",
    "customers.label.I_Agree_To": "I Agree To",
    "customers.label.TermsAndConditions": "Terms & Conditions",
    "customers.label.ThisNumberIsReservedFor": "This number is reserved for",
    "customers.label.TotalPrice": "Total Price:",
    "customers.label.CustomerInfo": "Customer Info",
    "customers.label.title": "Title",
    "customers.label.SelectTitle": "Select Title",
    "customers.label.initials": "Initials",
    "customers.label.Basket": "Basket",
    "customers.label.first_name": "First Name",
    "customers.label.last_name": "Last Name",
    "customers.label.email_address": "Email Address",
    "customers.label.contact_number": "Contact Number",
    "customers.label.date_of_birth": "Date of Birth",
    "customers.label.select_language": "Select Language",
    "customers.label.how_did_you_hear": "How Did You Hear?",
    "customers.label.postal_code": "Postal Code",
    "customers.label.country": "Country",
    "customers.label.Enter_address_manually": "Enter Address Manually",
    "customers.label.Find_address": "Find Address",
    "customers.label.Select_Address": "Select Address",
    "customers.label.Select_an_address": "Select an Address",
    "customers.label.Enter_address_dynamically": "Enter Address Dynamically",
    "customers.label.address_number": "Address Number",
    "customers.label.street": "Street",
    "customers.label.state": "State",
    "customers.label.city": "City",
    "customers.label.resident_period": "Resident Period",
    "customers.label.Spend_Cap_Amount": "Spend Cap Amount",
    "customers.label.I_don’t_want_a_Spend_Cap": "I don’t want a Spend Cap",
    "customers.label.Monthly_Bill_Generation_Date":
      "Monthly Bill Generation Date",
    "customers.label.Select_a_Monthly_Plan": "Select a Monthly Plan",
    "customers.label.Search_plans": "Search plans...",
    "customers.label.search": "Search",
    "customers.label.Select_a_plan": "Select a plan",
    "customers.label.Basket": "Basket",
    "customers.label.This_number_is_reserved_for":
      "This number is reserved for",
    "customers.label.ViewT&C": "View T&C",
    "customers.label.TransferringFromPreviousNetwork":
      "Transferring from Previous Network (Bring your Old Number)",
    "customers.label.SIM_Information": "SIM Information",
    "customers.label.Prepaid": "Prepaid",
    "customers.label.Postpaid": "Postpaid",
    "customers.label.Physical_SIM": "Physical SIM",
    "customers.label.eSIM": "eSIM",
    "customers.label.SelectCustomerType": "Select Customer Type",
    "customers.label.New_to_Lyca": "New to Lyca",
    "customers.label.Convert_Lyca_Prepaid_to_Postpaid":
      "Convert Lyca Prepaid to Postpaid",
    "customers.label.Existing_customer_is_going_to_be_sent_a_secure_link_to_confirm_that_they_wish_to_move_from_prepaid_to_abonnement.":
      "Existing customer is going to be sent a secure link to confirm that they wish to move from prepaid to abonnement.",
    "customers.label.Customer_to_receive_an_SMS": "Customer to receive an SMS",
    "customers.label.Lyca_Mobile_Number": "Lyca Mobile Number",
    "customers.label.Enter_the_Lyca_Mobile_Number":
      "Enter the Lyca Mobile Number",
    "customers.label.Nationality": "Nationality",
    "customers.label.Send_Secure_link": "Send Secure link",
    "customers.label.New_to_Lyca_Mobile": "New to Lyca Mobile",
    "customers.label.serial_number": "Serial Number",
    "customers.label.Serial_Number": "Serial Number (Last 4 Digits)",
    "customers.label.PUK_Code": "PUK Code",
    "customers.label.PUK_Code_is_not_matched": "PUK Code is not matched",
    "customers.label.Switching_to_Lyca_Mobile": "Switching to Lyca Mobile",
    "customers.label.Enter_the_PUK_Code": "Enter the PUK Code",
    "customers.label.Basket": "Basket",
    "customers.label.Gender": "Gender",
    "customers.label.business_name": "Business Name",
    "customers.label.phone_number": "Phone Number",
    "customers.label.Date_of_Birth": "Date of Birth",
    "customers.label.VIP": "VIP",
    "customers.label.Disability": "Disability",
    "customers.label.District": "District",
    "customers.label.Is_your_billing_address_same_as_primary_address":
      "Is your billing address same as primary address?",
    "customers.label.Supressbill": "Suppress Bill",
    "customers.label.SelectCategory": "Select Category",
    "customers.label.SelectGender": "Select Gender",
    "customers.label.SelectPreferences": "Select Preferences",
    "customers.label.SelectNationality": "Select Nationality",
    "customers.label.SelectVIP": "Select VIP",
    "customers.label.SelectDisability": "Select Disability",
    "customers.label.SelectCity": "Select City",
    "customers.label.SelectBillDay": "Select Bill Day",
    "customers.label.SelectType": "Select Type",
    "customers.label.SelectFiscalYear": "Select Fiscal Year",
    "customers.label.SelectFiscalQuarter": "Select Fiscal Quarter",
    "customers.label.SelectBillMode": "Select Bill Mode",
    "customers.label.SelectInvoiceType": "Select Invoice Type",
    "customers.label.IMSI": "IMSI",
    "customers.label.SalesMotion": "Sales Motion",
    "customers.label.SpendCap": "Spend Cap",
    "customers.label.ActivationDate": "Activation Date",
    "customers.label.ExpiryDate": "Expiry Date",
    "customers.label.NextRenewalDate": "Next Renewal Date",
    "customers.label.BalanceTransfer": "Balance Transfer",
    "customers.label.RecieverClientId": "Receiver Client ID",
    "customers.label.Amount": "Amount",
    "customers.label.EnterTopUpAmount": "Enter Top-Up Amount",
    "customers.label.ResponseId": "Response ID",
    "customers.label.BalanceName": "Balance Name",
    "customers.label.Allowance": "Allowance",
    "customers.label.Consumption": "Consumption",
    "customers.label.AvailableBalance": "Available Balance",
    "customers.label.DaysLeft": "Days Left",
    "customers.label.Discount": "Discount",
    "customers.label.postal_code": "Postal Code",
    "customers.label.address_number": "Address Number",
    "customers.label.city": "City",
    "customers.label.state": "State",
    "customers.label.country": "Country",
    "customers.label.resident_period": "Resident Period",
    "customers.label.postcode": "Postcode",
    "customers.label.how_did_you_hear": "How Did You Hear About Us?",
    "customers.label.select_language": "Select Language",
    "customers.label.email_address": "Email Address",
    "customers.label.contact_number": "Contact Number",
    "customers.label.initials": "Initials",
    "customers.label.communication_type": "Communication Type",
    "customers.label.BuySIM": "Buy SIM",
    "customers.label.origination": "Origination",
    "customers.label.address": "Address",
    "customers.label.destination_address": "Destination Address",
    "customers.label.event": "Event",
    "customers.label.charge_party": "Charge Party",
    "customers.label.service_subs_type": "Service Subs Type",
    "customers.label.calling_party": "Calling Party",
    "customers.label.called_party": "Called Party",
    "customers.label.usage": "Usage",
    "customers.label.monetary_charge": "Monetary Charge",
    "customers.label.result_code": "Result Code",
    "customers.label.generation_time": "Generation Time",
    "customer.label.generationdatetime": "Generation Date and Time",
    "customers.label.transaction_id": "Transaction ID",
    "customers.label.application_transaction_id": "Application Transaction ID",
    "customers.label.application_name": "Application Name",
    "customers.label.recharge_value": "Recharge Value",
    "customers.label.interface": "Interface",
    "customers.label.result": "Result",
    "customers.label.comment": "Comment",
    "customers.label.recharge": "Recharge",
    "customers.label.cdr": "CDR",
    "customers.label.notifications": "Notifications",
    "customers.label.mobile_no": "Mobile No",
    "customers.label.email_id": "Email Id",
    "customers.label.serial_number": "Serial No",
    "customers.label.msisdn": "MSISDN",
    "customers.label.digital_content": "Digital Content",
    "customers.label.buySim": "Buy Sim",
    "customers.label.outstanding_due": "Outstanding Due",
    "customers.label.due_date": "Due Date",
    "customers.label.unbilled_amount": "Unbilled Amount",
    "customers.label.next_bill_day": "Next Bill Day",
    "customers.label.view_service_details": "View Service Details",
    "customers.label.view_allowances": "View Allowances",
    "customers.label.spend_limit": "Spend Limit",
    "customers.label.topup_balance": "Topup Balance",
    "customers.label.next_renewal_date": "Next Renewal Date",
    "customers.label.allowance": "Allowance",
    "customers.label.ViewDocumentUpload": "View Document Upload",
    "customers.label.total_net_amount": "Total Net Amount",
    "customers.label.cancelRemark": "Cancel Remark",
    "customers.label.cancelPayment": "Cancel Payment",
    "customers.label.all": "All",
    "customers.label.created_by": "Created By",
    "customers.label.created_on": "Created On",
    "customers.label.credit_limit": "Credit Limit",
    "customers.label.transaction_history": "Transaction History",
    "customers.label.external_activity_log": "External Activity Log",
    "customers.label.settings": "Settings",
    "system.label.currency_noncurrency": "Currency Non-Currency",
    "entity.label.configure": "Configure",
    "customers.label.billProfile": "Bill Profile",
    "customers.label.charges": "Charges",
    "customers.label.customers": "Customers",
    "customers.label.search_for_clients": "Search for Clients",
    "customers.label.advance_search": "Advance Search",
    "customers.label.customer_activation": "Customer Activation",
    "customers.label.create_customer": "Create Customer",
    "customers.label.account_no": "Account No",
    "customers.label.customer_name": "Customer Name",
    "customers.label.business_entity": "Business Entity",
    "customers.label.balance": "Balance",
    "customers.label.valid_from": "Valid From",
    "customers.label.valid_to": "Valid To",
    "customers.label.non_currency_details": "Non-Currency Details",
    "customers.label.view_details": "View Details",
    "customers.label.status": "Status",
    "customers.label.collection_status": "Collection Status",
    "customers.label.first_name": "First Name",
    "customers.label.price_discount": "Price & Discount",
    "customers.label.last_name": "Last Name",
    "customers.label.city_area": "City/Area",
    "customers.label.email": "Email",
    "customers.label.phone": "Phone",
    "customers.label.cafid": "CAF Id",
    "customers.label.enter_business_entity": "Enter Business Entity",
    "customers.label.select": "Select",
    "customers.label.refund": "Refund",
    "customers.label.refund_id": "Refund Id",
    "customers.label.refund_amount": "Refund Amount",
    "customers.label.select_category_type": "Select Category Type",
    "customers.label.clear": "Clear",
    "customers.label.search": "Search",
    "customers.label.customer_details": "Customer Details",
    "customers.label.loc": "LOC",
    "customers.label.customer_category": "Customer Category",
    "customers.label.service_details": "Service Details",
    "customers.label.name": "Name",
    "customers.label.add_service": "Add Service",
    "customers.label.network_node": "Network Node",
    "customers.label.item": "Item",
    "customers.label.discount_code": "Discount Code",
    "customers.label.total_price": "Total Price",
    "customers.label.device_details": "Device Details",
    "customers.label.plan_details": "Plan Details",
    "customers.label.payment_details": "Payment Details",
    "customers.label.plan_list": "Plan List",
    "customers.label.plan": "Plan",
    "customers.label.bill_item_details": "Bill Item Details",
    "customers.label.charge_id": "Charge Id",
    "customers.label.order_id": "Order Id",
    "customers.label.item_tax_details": "Item Tax Details",
    "customers.label.discount_details": "Discount Details",
    "customers.label.sale_date": "Sale Date",
    "customers.label.contract_period": "Contract Period",
    "customers.label.charge_cycle": "Charge Cycle",
    "customers.label.cancel": "Cancel",
    "customers.label.next": "Next",
    "customers.label.done": "Done",
    "customers.label.reopen": "Reopen",
    "customers.label.submit": "Submit",
    "customers.label.view_customer": "View Customer",
    "customers.label.account_number": "Account Number",
    "customers.label.serial_no": "Paired Serial No",
    "customers.label.office_hierarchy": "Office Hierarchy",
    "customers.label.account_type": "Account Type",
    // "customers.label.balance": "Balance",
    "customers.label.stb_serial_no": "Serial No",
    "customers.label.non_currency_balance": "Non-Currency Balance",
    "customers.label.service_orders": "Service Orders",
    "customers.label.more_info": "More Info",
    "customers.label.notes": "Notes",
    "customers.label.device": "Device",
    "customers.label.tickets": "Tickets",
    "customers.label.on_demand": "On Demand",
    "customers.label.on_demand_billing": "On Demand Billing",
    "customers.label.payments": "Payments",
    "customers.label.invoice": "Invoice",
    "customers.label.contact_information": "Contact Information",
    "customers.label.address_information": "Address Information",
    "customers.label.billing_information": "Billing Information",
    "customers.label.balance_information": "Balance Information",
    // "customers.label.customer_name": "Customer Name",
    "customers.label.parent_child": "Parent/Child",
    "customers.label.created_date": "Created Date",
    "customers.label.district": "District",
    "customers.label.pincode": "PinCode",
    "customers.label.last_bill_amount": "Last Bill Amount",
    "customers.label.last_bill_date": "Last Bill Date",
    "customers.label.last_bill_paid": "Last Bill Paid",
    "customers.label.last_paid_amount": "Last Paid Amount",
    "customers.label.last_payment_date": "Last Payment Date",
    "customers.label.next_bill_date": "Next Bill Date",
    "customers.label.service_overview": "Service Overview",
    "customers.label.service_without_device": "Service Without Device",
    "customers.label.create_ticket": "Create Ticket",
    "customers.label.service_activation": "Service Activation",
    "customers.label.order_charging": "Order Charging",
    "customers.label.top_up": "Top Up",
    "customers.label.redeem": "Redeem",
    "customers.label.collection_name": "Collection Name",
    "customers.label.redeem_voucher": "Redeem Voucher",
    "customers.label.service_id": "Service ID",
    "customers.label.service_code": "Service Code",
    "customers.label.start_date": "Start Date",
    "customers.label.modified_date": "Modified Date",
    "customers.label.info": "Info",
    "customers.label.action": "Actions",
    "customers.label.add_device": "Add Device",
    "customers.label.add_plans": "Add Plans",
    "customers.label.suspend": "Suspend",
    "customers.label.reactivate": "Reactivate",
    "customers.label.terminate": "Terminate",
    "customers.label.command_center": "Command Center",
    "customers.label.retrack": "Retrack",
    "customers.label.cancel_plans": "Cancel Plans",
    "customers.label.device_overview": "Device Overview",
    "customers.label.orders_overview": "Orders Overview",
    "customers.label.end_date": "End Date",
    "customers.label.price": "Price",
    "customers.label.add_note": "Add Note",
    "customers.label.note": "Note",
    "customers.label.sale_type": "Sale Type",
    "customers.label.charge_code": "Charge Code",
    "customers.label.quantity": "Quantity",
    "customers.label.warranty_date": "Warranty Date",
    "customers.label.allocate": "Allocate",
    "customers.label.contact_info": "Contact Info",
    "customers.label.edit_customer": "Edit Customer",
    "customers.label.lco": "LCO",
    "customers.label.title": "Title",
    // "customers.label.customer_category": "Customer Category",
    "customers.label.middle_name": "Middle Name",
    "customers.label.caf_id": "CAF Id",
    "customers.label.landline_number": "Landline Number",
    "customers.label.user_name": "User Name",
    "customers.label.customer_photo": "Customer Photo",
    "customers.label.id_proof": "Id Proof",
    "customers.label.id_proof_value": "Id Proof Value",
    "customers.label.save": "Save",
    "customers.label.close_customer": "Close Customer",
    "customers.label.payment_type": "Payment Type",
    "customers.label.closure_date": "Closure Date",
    "customers.label.closure_reason": "Closure Reason",
    "customers.label.close": "Close",
    "customers.label.address_info": "Address Info",
    "customers.label.edit_address": "Edit Address",
    "customers.label.address_no": "Address No",
    "customers.label.street": "Street",
    "customers.label.building": "Building",
    "customers.label.zipcode": "Zipcode",
    "customers.label.billing": "Billing",
    "customers.label.same_as_primary": "Same as Primary",
    "customers.label.building_code": "Building Code",
    "customers.label.add_address": "Add Address",
    "customers.label.address_type": "Address Type",
    "customers.label.billing_info": "Billing Info",
    "customers.label.create_adjustment": "Create Adjustment",
    "customers.label.created_adjustment": "Created Adjustment",
    "customers.label.create_order": "Create Order",
    "customers.label.sale_catalog": "Sale Catalog",
    "customers.label.auto_renew": "Auto Renew",
    "customers.label.renew_plan": "Renew Plan",
    // "customers.label.search": "Search",
    "customers.label.entity_name": "Entity Name",
    "customers.label.discount": "Discount",
    "customers.label.provisioning_commands": "Provisioning Commands",
    "customers.label.command": "Command",
    "customers.label.plans": "Plans",
    "customers.label.client_service_detail": "Client Service Detail",
    "customers.label.id": "Id",
    "customers.label.parameter_name": "Parameter Name",
    "customers.label.parameter_value": "Parameter Value",
    "customers.label.request_type": "Request Type",
    "customers.label.client_info": "Client Info",
    "customers.label.service_info": "Service Info",
    "customers.label.new_device_info": "New Device Info",
    "customers.label.task_list": "Task List",
    "customers.label.provisioning_detail": "Provisioning Detail",
    "customers.label.provisioning_id": "Provisioning Id",
    "customers.label.task_id": "Task Id",
    "customers.label.sent_message": "Sent Message",
    "customers.label.available_plans": "Available Plans",
    "customers.label.item_code": "Item Code",
    "customers.label.disconnect_order": "Disconnect Order",
    "customers.label.reason": "Reason",
    "customers.label.short_description": "Short Description",
    "customers.label.description": "Description",
    "customers.label.change_plan": "Change Plan",
    "customers.label.swap_sim": "Swap SIM",
    "customers.label.addons": "Addons",
    "customers.label.porting_out": "Porting Out",
    "customers.label.prepaid_to_postpaid": "Prepaid To Postpaid",
    "customers.label.postpaid_to_prepaid": "Postpaid To Prepaid",
    "customers.label.select_date": "Select Date",
    "customers.label.order_date": "Order Date",
    "customers.label.priority": "Priority",
    "customers.label.ticket_date": "Ticket Date",
    "customers.label.comment_date": "Comment Date",
    "customers.label.ticket_time": "Ticket Time",
    "customers.label.category": "Category",
    "customers.label.sub_category": "Sub Category",
    "customers.label.team": "Team",
    "customers.label.team_user": "Team User",
    "customers.label.source": "Source",
    "customers.label.due_time": "Due Time",
    "customers.label.device_swap": "Device Swap",
    // "customers.label.terminate": "Terminate",
    "customers.label.confirm": "Confirm",
    "customers.label.continue": "Continue",
    "customers.label.process_date": "Process Date",
    "customers.label.pin_number": "Pin Number",
    "customers.label.renewal": "Renewal",
    // "customers.label.create_customer": "Create Customer",
    "customers.label.individual": "Individual",
    "customers.label.corporate": "Corporate",
    "customers.label.corporate_details": "Corporate Details",
    "customers.label.contact_person": "Contact Person",
    "customers.label.entity": "Entity",
    "customers.label.client_category": "Client Category",
    "customers.label.preferences": "Preferences",
    "customers.label.parent_id": "Parent Id",
    "customers.label.child": "Child",
    "customers.label.villege_street": "Villege/Street",
    "customers.label.billing_address": "Billing Address",
    "customers.label.bill_information": "Bill Information",
    "customers.label.bill_day_of_month": "Bill Day of Month",
    "customers.label.fiscal_year": "Fiscal Year",
    "customers.label.fiscal_quater": "Fiscal Quarter",
    "customers.label.bill_mode": "Bill Mode",
    "customers.label.invoice_type": "Invoice Type",
    "customers.label.payment_information": "Payment Information",
    "customers.label.funder_name": "Funder Name",
    "customers.label.funder_address": "Funder Address",
    "customers.label.funder_id": "Funder Id",
    "customers.label.po_number": "PO Number",
    "customers.label.payment_term": "Payment Term",
    "customers.label.customer_created_successfully":
      "Customer Created Successfully",
    "customers.label.go_to_customer": "Go to Customer",
    "customers.label.view_order": "View Order",
    "customers.label.disconnect": "Disconnect",
    "customers.label.apply_promo": "Apply Promo",
    // "customers.label.order_id": "Order Id",
    "customers.label.order_type": "Order Type",
    "customers.label.billing_cycle": "Billing Cycle",
    "customers.label.plan_name": "Plan Name",
    "customers.label.user_action": "User Action",
    "customers.label.invoice_till_date": "Invoice Till Date",
    "customers.label.order_services": "Order Services",
    "customers.label.service_type": "Service Type",
    "customers.label.service_description": "Service Description",
    "customers.label.bill_start_date": "Bill Start Date",
    "customers.label.bill_end_date": "Bill End Date",
    // "customers.label.invoice_till_date": "Invoice Till Date",
    "customers.label.charge_type": "Charge Type",
    "customers.label.rate_uom": "Rate/UOM",
    "customers.label.discount_description": "Discount Description",
    "customers.label.discount_type": "Discount Type",
    "customers.label.discount_start_date": "Discount Start Date",
    "customers.label.discount_end_date": "Discount End Date",
    "customers.label.discount_amount": "Discount Amount",
    "customers.label.order_transaction": "Order Transaction",
    "customers.label.user": "User",
    "customers.label.transaction_date": "Transaction Date",
    "customers.label.transaction_type": "Transaction Type",
    "customers.label.actual_date": "Actual Date",
    "customers.label.promo": "Promo",
    "customers.label.promotion": "Promotion",
    "customers.label.disconnection_date": "Disconnection Date",
    "customers.label.disconnection_reason": "Disconnection Reason",
    "customers.label.problem_code": "Problem Code",
    "customers.label.assign_to": "Assign To",
    "customers.label.last_comment": "Last Comment",
    "customers.label.file_name": "File Name",
    "customers.label.edit_ticket": "Edit Ticket",
    "customers.label.close_ticket": "Close Ticket",
    "customers.label.resolution_description": "Resolution Description",
    "customers.label.ticket_history": "Ticket History",
    // "customers.label.last_comment": "Last Comment",
    "customers.label.problem_description": "Problem Description",
    "customers.label.generate": "Generate",
    "customers.label.bill_date": "Bill Date",
    "customers.label.amount": "Amount",
    "customers.label.statement": "Statement",
    // "customers.label.due_date": "Due Date",
    "customers.label.promotional_message": "Promotional Message",
    "customers.label.download": "Download",
    "customers.label.due_amount": "Due Amount",
    "customers.label.transactions": "Transactions",
    "customers.label.file": "File",
    "customers.label.reset": "Reset",
    "customers.label.order_details": "Order Details",
    "customers.label.make_payment": "Make Payment",
    "customers.label.credit_amount": "Credit Amount",
    "customers.label.debit_amount": "Debit Amount",
    "customers.label.cancel_remark": "Cancel Remark",
    "customers.label.pay_invoice": "Pay Invoice",
    "customers.label.account": "Account",
    "customers.label.deposit": "Deposit",
    "customers.label.payment_date": "Payment Date",
    "customers.label.receipt_no": "Receipt No",
    "customers.label.cheque_no": "Cheque No",
    "customers.label.bank_name": "Bank Name",
    "customers.label.branch_name": "Branch Name",
    "customers.label.cheque_date": "Cheque Date",
    "customers.label.invoice_id": "Invoice Id",
    "customers.label.invoice_date": "Invoice Date",
    "customers.label.invoice_amount": "Invoice Amount",
    // "customers.label.due_amount": "Due Amount",
    "customers.label.payment_reversal": "Payment Reversal",
    "customers.label.date_filter": "Date Filter",
    "customers.label.add_event_order": "Add Event Order",
    "customers.label.event_order": "Event Order",
    "customers.label.eventdate": "Event Date",
    "customers.label.serviceAddress": "Service Address",
    "customers.label.event_name": "Event Name",
    "customers.label.booked_date": "Booked Date",
    "customers.label.event_price": "Event Price",
    "customers.label.events": "Events",
    "customers.label.format_type": "Format Type",
    "customers.label.opt_type": "OPT Type",
    "customers.label.client_bill_profile": "Client Bill Profile",
    "customers.label.edit": "Edit",
    "customers.label.type": "Type",
    "customers.label.client_id": "Client Id",
    "customers.label.bill_currency": "Bill Currency",
    "customers.label.bill_frequency": "Bill Frequency",
    "customers.label.bill_segment": "Bill Segment",
    // "customers.label.next_bill_day": "Next Bill Day",
    "customers.label.last_bill_day": "Last Bill Day",
    "customers.label.last_bill_no": "Last Bill No",
    "customers.label.bill_suppression_flag": "Bill Suppression Flag",
    "customers.label.bill_suppression_id": "Bill Suppression Id",
    "customers.label.first_bill": "First Bill",
    "customers.label.hot_bill": "Hot Bill",
    "customers.label.edit_bill_profile": "Edit Bill Profile",
    "customers.label.bill_suppression": "Bill Suppression",
    // "customers.label.more_info": "More Info",
    "customers.label.identities": "Identities",
    "customers.label.add_client_identities": "Add Client Identities",
    "customers.label.unique_identification": "Unique Identification",
    "customers.label.identity_documents": "Identity Documents",
    "customers.label.additional_info": "Additional Info",
    "customers.label.nationality": "Nationality",
    "customers.label.date_of_birth": "Date of Birth",
    "customers.label.preferred_language": "Preferred Language",
    "customers.label.finance_id": "Finance ID",
    "customers.label.remarks": "Remarks",
    "customers.label.preferred_communication": "Preferred Communication",
    "customers.label.add_client_identifier": "Add Client Identifier",
    "customers.label.document_type": "Document Type",
    "customers.label.document_uploads": "Document Uploads",
    "customers.label.select_file": "Select File",
    "customers.label.credit_card_details": "Credit Card Details",
    "customers.label.card_holder_name": "Card Holder Name",
    "customers.label.bank_account_holder_name": "Bank Account Holder Name",
    "customers.label.bank_account_number": "Bank Account Number",
    // "customers.label.bank_name": "Bank Name",
    // "customers.label.account_type": "Account Type",
    "customers.label.each_card_routing_number": "Each Card Routing Number",
    "customers.label.card_number": "Card Number",
    "customers.label.cvv": "CVV",
    "customers.label.card_type": "Card Type",
    "customers.label.expiry_date": "Expiry Date",
    "customers.label.ach_card": "ACH Card",
    "customers.label.ach_card_routing_number": "ACH Card Routing Number",
    // "customers.label.bank_account_number": "Bank Account Number",
    "customers.label.childs": "Childs",
    "customers.label.cell_phone": "Cell Phone",
    "customers.label.create_client_additional_info":
      "Create Client Additional Info",
    "customers.label.gender": "Gender",
    "customers.label.id_type": "Id Type",
    // "customers.label.nationality": "Nationality",
    "customers.label.id_number": "Id Number",
    "customers.label.job_title": "Job Title",
    "customers.label.age_group": "Age Group",
    "customers.label.uts_customer_id": "UTS Customer Id",
    "customers.label.ach_card_name": "ACH Card Name",
    "customers.label.adjustment": "Adjustment",
    // "customers.label.created_adjustment": "Created Adjustment",
    "customers.label.adjustment_date": "Adjustment Date",
    "customers.label.adjustment_code": "Adjustment Code",
    "customers.label.adjustment_amount": "Adjustment Amount",
    "customers.label.adjustment_type": "Adjustment Type",
    "customers.label.activity_log": "Activity Log",
    "customers.label.office_id": "Office Id",
    "customers.label.history": "History",
    "customers.label.filter_by_date": "Filter by Date",
    "customers.label.view_usage_details": "View Usage Details",
    "customers.label.units": "Units",
    "customers.label.tax": "Tax",
    "customers.label.total_amount": "Total Amount",
    "customers.label.account_transaction": "Account Transaction",
    "customers.label.csv_pdf": "CSV/PDF",
    "customers.label.charge_description": "Charge Description",
    "customers.label.journals": "Journals",
    "customers.label.download_financial_summary_data":
      "Download Financial Summary Data",
    "customers.label.select_from_date": "From Date",
    "customers.label.select_to_date": "To Date",
    "customers.label.village_street": "Village/Street",
    "customers.label.previous": "Previous",
    "customers.label.book_order": "Book Order",
    "customers.label.Disconnect": "Disconnect",
    "customers.label.ApplyPromo": "Apply Promo",
    "customers.label.Service": "Service",
    "customers.label.Product": "Product",
    "customers.label.CreditCard": "Credit Card",
    "customers.label.Paypal": "Paypal",
    "customers.label.BusinessEntity": "Business Entity",
    "customers.label.Plan": "Plan",
    "customers.label.Phone": "Phone",
    "customers.label.TaxExemption": "Tax Exemption",
    "customers.label.YES": "YES",
    "customers.label.NO": "NO",
    "customers.label.Resolution": "Resolution",
    "customers.label.AccountNo": "Account No",
    "customers.label.ChipId": "Chip Id",
    "customers.label.MobileNo": "Mobile No",
    "customers.label.EmailId": "Email Id",
    "customers.label.SerialNo": "Serial No",
    "customers.label.LegacyNo": "Legacy No",
    "customers.label.searchclient": "Search Client",
    "customers.label.PrimaryAddress": "Primary Address",
    "customers.label.BillingAddress": "Billing Address",
    // "customers.label.lco": "lco",
    "customers.label.EventDate": "Event Date",
    "customers.label.CreateAdjustment": "Create Adjustment",
    "customers.label.full_name": "Full Name",
    "customers.label.bill_collection_action": "Bill Collection Action",
    "customers.label.collection_actions": "Collection Actions",
    "customers.label.action_name": "Action Name",
    "customers.label.action_date": "Action Date",
    "customers.label.balance_due": "Balance Due",
    "customers.label.bill_id": "Bill Id",
    "customers.label.view_goods_receipt": "View Goods Receipt",
    "customers.label.payinfo": "Pay Info",
    "customers.label.cardtoken": "Card Token",
    "customers.label.autopay": "Auto Pay",
    "customers.label.paynow": "Pay Now",
    "customers.label.featureList": "Feature List",
    "customers.label.consumed": "consumed",
    "customers.label.updateCreditLimt": "Update Credit Limit",
    "customers.label.PendingForApproval": "Pending For Approval",

    "customers.label.SpendCapHistory": "Spend Cap History",
    "customers.label.DateTime": "Date & Time",
    "customers.label.SpendCapEventName": "Spend Cap Event Name",
    "customers.label.SpendingLimit": "Spending Limit",
    "customers.label.ConsumedLimit": "Consumed Limit",
    "customers.label.EventId": "Event Id",
    "customers.label.collectionStatus": "Collection Status",
  },
  fr: {
    "customers.label.temporaryBlock": "Blocage temporaire",
    "customers.label.unBlock": "Débloquer",
    "customers.label.feedback": "Retour d'information",
    "customers.label.event_id": "ID de l'événement",
    "customers.label.slc_state_history": "Historique de l'état SLC",
    "customers.label.slc": "SLC",
    "customers.label.state_Change_Time": "Heure de changement d'état",
    "customers.label.event": "Événement",
    "customers.label.previous_state": "État précédent",
    "customers.label.resolution_date": "Date de résolution",
    "customers.label.current_state": "État actuel",
    "customers.label.created_time": "Heure de création",
    "customers.label.creation_time": "Heure de création",
    "customers.label.Promotion": "Promotion",
    "customers.label.slc_status": "SLC Status",
    "customers.label.update_slc_status": "Update SLC Status",
    "customers.label.temporary_block": "Temporary Block",
    "customers.label.workflow_id": "ID de workflow",
    "customers.label.externalPromoId": "ID Promo Externe",
    "customers.label.externalPromoName": "Nom Promo Externe",
    "customers.label.promoCode": "Code Promo",
    "customers.label.promoDescription": "Description de la Promotion",
    "customers.label.ScheduleOrder": "Planifier la commande",
    "customers.label.ScheduledDate": "Date prévue",
    "customers.label.ViewRateLimit": "Afficher la limite de débit",
    "customers.label.SelectType": "Sélectionner le type",
    "customers.label.search": "Rechercher",
    "customers.label.SelectTaxExemption": "Sélectionnez l'exonération fiscale",
    "customers.label.ViewTickets": "Voir les tickets",
    "customers.label.TicketHistory": "Historique des tickets",
    "customers.label.ReopenTicket": "Rouvrir le ticket",
    "customers.label.SelectInvoiceType": "Sélectionner le type de facture",
    "customers.label.SelectCategory": "Sélectionner une catégorie",
    "customers.label.SelectSubCategory": "Sélectionner une sous-catégorie",
    "customers.label.SelectSource": "Sélectionner une source",
    "customers.label.TicketHistory": "Historique des tickets",
    "customers.label.ViewSpendCap": "Voir la limite de dépenses",
    "customers.label.ResponseMessage": "Message de réponse",
    "customers.label.AddPlan": "Ajouter un plan",
    "customers.label.Basket": "Panier",
    "customers.label.TotalPrice": "Prix total",
    "customers.label.Send_Link_to_Customer_to_Complete_Payment":
      "Envoyer le lien au client pour finaliser le paiement",
    "customers.label.CheckPaymentStatus": "Vérifier le statut du paiement",
    "customers.label.Are_you_sure_you_want_to_terminate?":
      "Êtes-vous sûr de vouloir résilier ?",
    "customers.label.Unlimited": "Illimité",
    "customers.label.days_left": "jours restants",
    "customers.label.search": "Rechercher",
    "customers.label.JobTitle": "Intitulé du poste",
    "customers.label.SelectDocumentType": "Sélectionner le type de document",
    "customers.label.SelectEvents": "Sélectionner des événements",
    "customers.label.SelectFormatType": "Sélectionner le type de format",
    "customers.label.SelectAdjustmentType": "Sélectionner le type d'ajustement",
    "customers.label.card_number": "Numéro de carte",
    "customers.label.Select_OPT_Type": "Sélectionner le type OPT",
    "customers.label.StartDate": "Date de début",
    "customers.label.EndDate": "Date de fin",
    "customers.label.Cancel": "Annuler",
    "customers.label.Set": "Définir",
    "customers.label.PaymentDetails": "Détails du paiement",
    "customers.label.PaymentReceipt": "Reçu de paiement",
    "customers.label.Status": "Statut",
    "customers.label.PaymentAmount": "Montant du paiement",
    "customers.label.Transaction": "Transaction",
    "customers.label.PaymentPage": "Page de paiement",
    "customers.label.ItemCode": "Code de l'article",
    "customers.label.StartDate": "Date de début",
    "customers.label.English": "Anglais",
    "customers.label.SelectIdProof": "Sélectionner une preuve d'identité",
    "customers.label.SelectAdjustementCode":
      "Sélectionner le code d'ajustement",
    "customers.label.SelectAdjustmentType": "Sélectionner le type d'ajustement",
    "customers.label.SelectFormat": "Sélectionner le format",
    "customers.label.AreYouSure?": "Êtes-vous sûr?",
    "customers.label.ChargeId": "ID de la charge",
    "customers.label.ChargeDescription": "Description de la charge",
    "customers.label.DiscountAmount": "Montant de la remise",
    "customers.label.NetChargeAmount": "Montant net de la charge",
    "customers.label.TaxDescription": "Description de la taxe",
    "customers.label.TaxAmount": "Montant de la taxe",
    "customers.label.SelectDate": "Sélectionner une date",
    "customers.label.SelectPriority": "Sélectionner une priorité",
    "customers.label.SelectCategory": "Sélectionner une catégorie",
    "customers.label.SelectSubCategory": "Sélectionner une sous-catégorie",
    "customers.label.SelectSource": "Sélectionner une source",
    "customers.label.ViewSpendCap": "Voir le plafond de dépenses",
    "customers.label.Amount": "Montant",
    "customers.label.PlanCode": "Code du plan",
    "customers.label.Price": "Prix",
    "customers.label.Status": "Statut",
    "customers.label.EndDate": "Date de fin",
    "customers.label.ContractPeriod": "Période de contrat",
    "customers.label.AutoRenew": "Renouvellement automatique",
    "customers.label.Description": "Description",
    "customers.label.ThankYou": "Merci !",
    "customers.label.ConnectionActivated":
      "La connexion a été activée avec succès avec le numéro de compte",
    "customers.label.GoToCustomerDetail": "Aller aux détails du client",
    "customers.label.Payment": "Paiement",
    "customers.label.CustomerToPay": "Client à payer :",
    "customers.label.MonthlyPayment": "Paiement mensuel",
    "customers.label.SetupWithDirectDebitOrCreditCard":
      "Configurer avec prélèvement automatique ou carte de crédit",
    "customers.label.SendLinkToCustomerToCompletePayment":
      "Envoyer un lien au client pour compléter le paiement",
    "customers.label.CheckPaymentStatus": "Vérifier l'état du paiement",
    "customers.label.ThisNumberIsReservedFor": "Ce numéro est réservé pour",
    "customers.label.YouSelected": "Vous avez sélectionné",
    "customers.label.SerialNo": "Numéro de série",
    "customers.label.PhoneNo": "Numéro de téléphone",
    "customers.label.ActivatingCustomer": "Activation du client...",
    "customers.label.LoadingOrderStatus":
      "Chargement du statut de la commande...",
    "customers.label.OrderStatus": "Statut de la commande :",
    "customers.label.Failed": "Échec",
    "customers.label.RoamingOutsideEEA": "Itinérance en dehors de l'EEE",
    "customers.label.TariffTermsDetails":
      "Veuillez consulter nos Conditions tarifaires et notre site Web pour plus de détails sur les tarifs spécifiques et les frais en dehors de votre allocation.",
    "customers.label.PaymentTerms":
      "Nous débiterons le montant que vous devez nous payer de votre compte par prélèvement SEPA, sauf accord contraire. La facture indiquera la date à laquelle nous débiterons le montant. Nous pouvons demander le paiement des frais uniques et abonnements à l'avance. Dans des cas spéciaux, nous pouvons facturer des montants intermédiaires. Par exemple, si vous avez utilisé un service de manière excessive en peu de temps. En cas de paiement par carte bancaire, vous autorisez la société de paiement à nous fournir, ainsi qu'à nos sous-traitants et agents, les détails de votre compte de manière strictement confidentielle si cela est nécessaire pour l'accord. Vous les autorisez également à nous informer en cas de résiliation ou suspension de votre compte de paiement.",
    "customers.label.ServiceAgreementTerms":
      "Durée, renouvellement et résiliation du contrat de services",
    "customers.label.Duration": "Durée",
    "customers.label.Renewal": "Renouvellement",
    "customers.label.ContractTermsAndConditions":
      "Conditions générales du contrat",
    "customers.label.TermsAndConditions": "Termes et Conditions",
    "customers.label.CustomerExplanation":
      "J'ai fourni au client une explication détaillée de",
    "customers.label.CustomerAgreement":
      "et ils ont accepté de procéder à la commande.",
    "customers.label.NumberReservedFor": "Ce numéro est réservé pour",
    "customers.label.YouSelected": "Vous avez sélectionné",
    "customers.label.SerialNo": "Numéro de série",
    "customers.label.PhoneNo": "Numéro de téléphone",
    "customers.label.TotalPrice": "Prix total",
    "customers.label.FeaturesForEndUsersWithDisabilities":
      "Fonctionnalités pour les utilisateurs finaux handicapés",
    "customers.label.InformationSupportServices":
      "Les informations à l'appui de nos services sont disponibles sous des formats alternatifs. Si vous souhaitez accéder à des informations sous un format alternatif, veuillez nous appeler via votre SIM Lycamobile au 1200 ou visiter",
    "customers.label.HowWeUseYourInformation":
      "Comment nous utilisons vos informations",
    "customers.label.InformationUsageDetails":
      "Nous collectons des informations sur votre utilisation de nos Services et des services tiers que vous utilisez en conjonction avec nos Services, y compris, par exemple, votre localisation et l'activité de votre compte, afin d'améliorer votre expérience avec nous et de la rendre plus pertinente pour vous. Nous pouvons utiliser et analyser vos informations personnelles pour gérer votre service et votre compte, y compris pour la vérification de crédit et la prévention de la fraude. Nous pouvons partager et combiner ces données avec des tiers soigneusement sélectionnés pour les mêmes raisons. Vos informations sont traitées conformément à notre politique de confidentialité, disponible à l'adresse :",
    "customers.label.CustomerComplaints":
      "Si vous n'êtes pas satisfait de la vitesse, de la qualité ou d'autres éléments du service et souhaitez déposer une plainte, veuillez contacter le service client. Vous pouvez en savoir plus sur notre processus de réclamation dans notre Code de Pratique des Réclamations Clients, disponible à l'adresse",
    "customers.label.DisputeResolution":
      "Si nous ne pouvons pas résoudre votre plainte, vous pouvez la soumettre dans un délai de 12 mois au Comité des Litiges des Services de Télécommunications. Vous pouvez également déposer une plainte sur la plateforme de règlement en ligne des litiges de la Commission européenne ou intenter une action en justice devant un tribunal civil.",
    "customers.label.costsEuro": "coûte €",
    "customers.label.thereafterEuro": "ensuite €",
    "customers.label.forTheFirst": "pour le premier",
    "customers.label.perMonthInclusiveVAT":
      "par mois, TVA incluse (sous réserve d'augmentations annuelles de l'IPC + 3,9 %). Voir le site Web pour plus de détails.",
    "customers.label.additionalAddOns":
      "Des modules complémentaires supplémentaires peuvent être disponibles pour votre plan et seront facturés séparément sur votre facture.",
    "customers.label.paymentTerms":
      "Vous devez payer les frais des services auxquels vous vous abonnez et/ou que vous utilisez chaque mois avant la date indiquée sur votre facture. Des frais peuvent être facturés en cas de retard de paiement. Un dépôt peut être demandé avant d'utiliser les services. Veuillez consulter nos Conditions tarifaires et notre site Web pour plus de détails sur les tarifs spécifiques et les frais hors forfait.",
    "customers.label.durationRenewalTermination":
      "Durée, renouvellement et résiliation",
    "customers.label.minimumPeriod":
      "a une période minimale de 1 mois et se poursuivra après cette période sur une base mensuelle jusqu'à résiliation par vous avec un préavis de 30 jours (sauf si d'autres règles légales ou réglementaires s'appliquent). Vous devrez payer les frais engagés pendant cette période de préavis.",
    "customers.label.cancellationCoolingOff":
      "Si vous changez d'avis sur les services achetés directement chez nous, vous pouvez avoir le droit d'annuler le contrat de services dans un délai de rétractation de 14 jours.",
    "customers.label.earlyTerminationCharge":
      "Vous acceptez que les services commencent immédiatement si vous possédez déjà une carte SIM ou lorsque vous recevez une carte SIM. Si vous souhaitez mettre fin au contrat de services pendant la période minimale ou si nous y mettons fin en raison d'une violation grave de votre part, vous devrez payer des frais de résiliation anticipée correspondant à un maximum de vos frais d'abonnement mensuels multipliés par le nombre de mois restants dans votre période minimale, TVA incluse (calculée au taux en vigueur), moins un pourcentage pour un paiement final unique. Vous devrez également payer les appels, messages, données et autres frais engagés, y compris pendant la période de rétractation.",
    "customers.label.ContractSummarys":
      "Ce résumé de contrat et notre offre d'Abonnement aux services internationaux étendus pour 1 mois vous permettent de passer et recevoir des appels vocaux, d'envoyer et recevoir des SMS, d'utiliser des données et d'accéder à Internet, tout cela via le Réseau, ainsi que tout service complémentaire optionnel que nous acceptons de fournir et que vous choisissez de recevoir.",
    "customers.label.The": "Le",
    "customers.label.ComesWith": "comprend :",
    "customers.label.MobileDataSpeeds":
      "Vitesses du service de données mobiles",
    "customers.label.DataServiceDescription":
      "Le service de données et les vitesses minimales et maximales associées disponibles via le réseau Lycamobile dépendent de la technologie accessible, par ex. 2G, Edge, 3G, 4G, 5G à votre emplacement, de l'appareil utilisé et du type de forfait acheté.",
    "customers.label.DataSpeedVariation":
      "La vitesse de votre service de données mobiles peut varier et dépend de votre emplacement, de l'environnement autour de vous (météo, couverture végétale, matériaux des bâtiments à proximité et nombre d'utilisateurs du réseau) et de l'appareil utilisé pour se connecter au réseau.",
    "customers.label.LycamobileBV": "Lycamobile B.V.",
    "customers.label.Robijnlaan17": "Robijnlaan 17,",
    "customers.label.2132WXHoofddorp": "2132WX Hoofddorp,",
    "customers.label.TheNetherlands": "Les Pays-Bas",
    "customers.label.ContractSummary": "Résumé du contrat",
    "customers.label.ContractSummaryDescription1":
      "Ce résumé de contrat fournit les principaux éléments de cette offre de service comme l'exige la loi.",
    "customers.label.ContractSummaryDescription2":
      "Il aide à comparer les offres de service.",
    "customers.label.ContractSummaryDescription3":
      "Des informations complètes sur le service sont fournies dans d'autres documents.",
    "customers.label.ContractSummaryValidity":
      "Ce résumé du contrat est valable jusqu'à l'expiration du paiement le",
    "customers.label.AcceptOffer":
      "Si cette offre vous convient, vous pouvez l'accepter via la page de paiement. Veuillez conserver une copie de ce document pour vos dossiers.",
    "customers.label.Services": "Services",
    "customers.label.TermsConditions":
      "Selon les termes et conditions de l'Accord de services, si nous violons une condition essentielle de l'Accord qui restreint complètement notre capacité à vous fournir des données dans le cadre de notre Service et que nous ne la corrigeons pas dans les 7 jours suivant la réception de votre plainte via le service client Lycamobile, vous pouvez mettre fin à l'accord.",
    "customers.label.EmergencyOrganisations":
      "Organisations d'urgence et informations sur la localisation des appelants",
    "customers.label.EmergencyCallInstructions":
      "Si vous devez passer un appel d'urgence/112/999 lorsque le réseau Lycamobile est en panne ou indisponible, pour quelque raison que ce soit, votre appareil mobile doit être capable de se connecter aux réseaux radio 2G, 3G, 4G ou 5G et peut sélectionner le réseau d'un concurrent disposant d'une couverture pour accéder aux appels d'urgence.",
    "customers.label.EmergencyCallAvailability":
      "Les appels d'urgence ne peuvent être passés que lorsqu'un réseau radio est disponible.",
    "customers.label.PlanName": "Nom du plan",
    "customers.label.EuropeanOnlineDisputeResolution":
      "Le site européen de règlement en ligne des litiges",
    "customers.label.ECWebsite": "ec.europa.eu/consumers/odr",
    "customers.label.DisputeResolutionDetails":
      "permet aux consommateurs de soumettre des litiges liés aux achats en ligne avec nous. Vous pouvez consulter notre site Web pour obtenir une copie de notre Code de bonnes pratiques sur les plaintes et pour nos dernières informations sur les modes alternatifs de règlement des litiges. Nous sommes là pour vous aider. Si quelque chose ne va pas, nous voulons le corriger. Vous pouvez en savoir plus sur notre processus de réclamation dans notre Code de bonnes pratiques en matière de plaintes des clients, qui est disponible à.",
    "customers.label.NetherlandsLawCompliance":
      "En cas de divergence continue et/ou récurrente entre la performance réelle du service d'accès à Internet en matière de vitesse, conformément aux lois des Pays-Bas, Lycamobile effectuera une nouvelle exécution dans un délai raisonnable. Lorsque la nouvelle exécution est impossible, Lycamobile réduira raisonnablement le prix que le Client paie pour le Service. Si le Client a déjà payé, Lycamobile remboursera au Client toute somme payée au-delà de ce montant.",
    "customers.label.DirectoryServiceInfo":
      "Vous pouvez nous demander d'inclure votre numéro de téléphone mobile dans un annuaire téléphonique et/ou un service de renseignements téléphoniques. Cependant, sachez que si vous demandez ce service, votre numéro sera visible par les entreprises qui collectent des informations à des fins marketing. Si cela vous inquiète, vous pouvez arrêter les appels de marketing non sollicités en choisissant de vous désinscrire ou en exerçant votre droit d'opposition. Si vous souhaitez que votre numéro de téléphone mobile soit inclus dans un annuaire et/ou un service de renseignements, veuillez en informer notre équipe du service client.",
    "customers.label.RemediesComplaints":
      "Recours, traitement des plaintes et résolution des litiges",
    "customers.label.ContactCustomerService":
      "Si vous devez contacter le service client, veuillez visiter le site Web et cliquer sur 'Nous contacter'. Si vous souhaitez vous plaindre de notre service, contactez le service client. Si vous n'êtes toujours pas satisfait, vous pouvez écrire pour un examen impartial à :",
    "customers.label.IncludeMobileNumber":
      "Veuillez inclure votre numéro de téléphone mobile si vous nous écrivez. Si nous ne parvenons pas à résoudre votre plainte, vous pouvez la soumettre dans un délai de 24 mois à De Geschillencommissie ( Postbus 90600, 2509 LP, Den Haag ).",
    "customers.label.Termination": "Résiliation",
    "customers.label.TerminationNotice":
      "Après la période minimale, vous pouvez mettre fin à l'accord en nous donnant un préavis (sauf si d'autres règles légales ou réglementaires s'appliquent) et vous devrez payer les frais engagés pendant cette période de préavis.",
    "customers.label.EarlyTerminationCharge":
      "Sauf indication contraire (comme dans les conditions de votre tarif), si vous souhaitez mettre fin à l'accord de services pendant la période minimale ou si nous mettons fin à l'accord en raison d'une violation grave de votre part, vous devrez payer des frais de résiliation anticipée équivalant à vos frais d'abonnement mensuels multipliés par le nombre de mois restants dans votre période minimale, TVA incluse (calculée au taux en vigueur).",
    "customers.label.OptionalAddOnTermination":
      "Tout service supplémentaire optionnel sera résilié indépendamment de tout plan mensuel groupé.",
    "customers.label.CancellationInfo":
      "Si vous changez d'avis ou avez besoin d'annuler, vous avez le droit d'annuler votre acceptation de nos termes et conditions à tout moment jusqu'à 14 jours après avoir passé votre commande pour le service (la période de rétractation), à condition que vous annuliez conformément à notre politique d'annulation ou en donnant un préavis à Lycamobile. Cela n'affecte pas vos droits légaux.",
    "customers.label.Security": "Sécurité",
    "customers.label.SecurityPolicy":
      "Tous les événements de sécurité dont nous avons connaissance seront analysés pour classification, confinement, récupération, analyse et résolution. Des notifications opportunes seront envoyées aux clients affectés conformément aux exigences réglementaires et contractuelles applicables. Les incidents de sécurité nécessitant des enquêtes médico-légales seront menés par Lycamobile ou, le cas échéant, impliqueront un tiers qualifié en vue d'une résolution et d'une prévention future.",
    "customers.label.DataProtection": "Protection des données",
    "customers.label.DataProtectionPolicy":
      "Sans préjudice de la législation sur la protection des données, Lycamobile exige des informations personnelles du client pour fournir les services, telles que : nom, adresse, numéro de compte, numéro de téléphone mobile et détails de paiement. Vos informations sont traitées conformément à notre politique de confidentialité, qui définit comment nous collectons, utilisons et partageons vos informations, avec qui et pourquoi, décrit vos droits et explique comment vous pouvez les exercer.",
    "customers.label.TariffTerms":
      "Veuillez consulter nos Conditions tarifaires et notre site Web pour plus de détails sur les tarifs spécifiques et les frais en dehors de votre forfait.",
    "customers.label.DeliveryOfService": "Livraison du service",
    "customers.label.PaymentTerms":
      "Nous débiterons le montant que vous devez nous payer de votre compte par prélèvement SEPA, sauf accord contraire...",
    "customers.label.ServiceStartDate":
      "La date à laquelle Lycamobile fournira les services est la date à laquelle vous vous inscrivez chez Lycamobile.",
    "customers.label.ContractDuration":
      "Durée, renouvellement et résiliation du contrat de services",
    "customers.label.MinimumPeriod":
      "Votre abonnement a une durée minimale appelée période minimale, qui peut être d'un mois pour les forfaits mensuels et de 24 mois pour les contrats à durée déterminée.",
    "customers.label.ContractRenewal":
      "Pour renouveler le contrat, vous devez en informer Lycamobile pendant la durée de votre contrat précédent, en acceptant de renouveler le contrat.",
    "customers.label.DataCostDetails":
      "Les {40 Go de données} coûtent {18,90 €} pour les {3 premiers mois}, puis {27,00 €} par mois, TVA incluse (soumis à des augmentations annuelles de l'IPC + 3,9 %). Voir notre site Web pour plus de détails.",
    "customers.label.AdditionalAddons":
      "Des compléments supplémentaires peuvent être disponibles pour votre forfait et seront facturés séparément.",
    "customers.label.SpendingLimits": "Limites de dépenses",
    "customers.label.SpendingLimitDetails":
      "Lycamobile fixera des limites de dépenses sur votre compte conformément à vos préférences jusqu'à un maximum de 250 €.",
    "customers.label.PremiumCharges":
      "Les appels premium, les numéros courts, les SMS et les appels internationaux ne sont pas inclus dans les forfaits et seront facturés selon les tarifs spécifiques.",
    "customers.label.InternationalRates":
      "Les appels et SMS des Pays-Bas vers d'autres pays seront facturés aux tarifs internationaux standards :",
    "customers.label.RoamingInEEA": "Itinérance dans l'EEE",
    "customers.label.RoamingOutsideEEA": "Itinérance en dehors de l'EEE",
    "customers.label.RoamingCharges":
      "L'utilisation de votre téléphone (appels, SMS et données) en itinérance en dehors des Pays-Bas ou de l'EEE et dans certaines destinations sélectionnées sera facturée à nos tarifs internationaux.",
    "customers.label.Any_Out_of_bundle_charges_can_be_found_at":
      "Tous les frais hors forfait peuvent être trouvés à :",
    "customers.label.Exclusions_for_voice_international_voice_SMS_Data_Roaming_can_be_found_at":
      "Les exclusions pour la voix, la voix internationale, les SMS, l'itinérance des données peuvent être trouvées à :",
    "customers.label.Our_Services_availability":
      "Nos services ne sont pas disponibles partout aux Pays-Bas, dans l'EEE ou dans d'autres destinations sélectionnées. L'utilisation acceptable de nos services est incluse dans notre politique d'utilisation équitable nationale et en itinérance à :",
    "customers.label.Lycamobile_network_speeds":
      "Le service de données et les vitesses minimales et maximales associées disponibles via le réseau Lycamobile dépendent de la technologie accessible, par exemple 2G, Edge, 3G, 4G, 5G à votre emplacement, de l'appareil utilisé et du type de forfait acheté.",
    "customers.label.Mobile_data_speed_variation":
      "La vitesse de votre service de données mobiles peut varier et dépend de votre emplacement, de l'environnement autour de vous (météo, couverture végétale, matériaux utilisés dans les bâtiments à proximité et du nombre de personnes utilisant le réseau) et de l'appareil utilisé pour se connecter au réseau.",
    "customers.label.Price": "Prix",
    "customers.label.ContractReview": "Révision du contrat",
    "customers.label.Terms&Conditions": "Termes et conditions",
    "customers.label.ReviewThisContract": "Examiner ce contrat",
    "customers.label.We_have_sent_these_to": "Nous les avons envoyés à",
    "customers.label.DownloadContractInformation":
      "Télécharger les informations du contrat",
    "customers.label.DownloadContractSummary":
      "Télécharger le résumé du contrat",
    "customers.label.ContractInformation": "Informations du contrat",
    "customers.label.ContactDetails": "Détails du contact",
    "customers.label.Description_of_Services": "Description des services",
    "customers.label.This_contract_summary_and_our_Abonnement_offer_of":
      "Ce résumé du contrat et notre offre d’abonnement de",
    "customers.label.an_airtime_service_for":
      "un service de temps d’antenne pour",
    "customers.label.comes_with:": "comprend :",
    "customers.label.Any_Out_of_bundle_charges_can_be_found_at:":
      "Tous les frais hors forfait peuvent être trouvés à :",
    "customers.label.service_description":
      "qui vous permet de passer et recevoir des appels vocaux, d’envoyer et recevoir des SMS, des données et d’accéder à Internet, le tout via le réseau, ainsi que tout service supplémentaire facultatif que nous acceptons de fournir et que vous choisissez de recevoir.",
    "customers.label.YouHaveChosenNoCap":
      "Vous avez choisi aucune limite. Cela signifie que vous pourrez utiliser votre téléphone pour des appels, SMS, minutes internationales, itinérance et données hors de votre forfait mensuel. Vous serez facturé jusqu'à 60 € pour cela.",
    "customers.label.SelectDate":
      "Sélectionner la date [Le paiement mensuel sera débité de votre compte 14 jours après la date de génération de la facture choisie] *",
    "customers.label.billing_cycle": "Cycle de facturation",
    "customers.label.SelectBilling": "Sélectionner la facturation",
    "customers.label.I_Agree_To": "J'accepte",
    "customers.label.TermsAndConditions": "Termes et Conditions",
    "customers.label.ThisNumberIsReservedFor": "Ce numéro est réservé pour",
    "customers.label.TotalPrice": "Prix total:",
    "customers.label.CustomerInfo": "Informations Client",
    "customers.label.title": "Titre",
    "customers.label.SelectTitle": "Sélectionnez un titre",
    "customers.label.initials": "Initiales",
    "customers.label.Basket": "Panier",
    "customers.label.first_name": "Prénom",
    "customers.label.last_name": "Nom de famille",
    "customers.label.email_address": "Adresse e-mail",
    "customers.label.contact_number": "Numéro de contact",
    "customers.label.date_of_birth": "Date de naissance",
    "customers.label.select_language": "Sélectionnez la langue",
    "customers.label.how_did_you_hear":
      "Comment avez-vous entendu parler de nous ?",
    "customers.label.postal_code": "Code postal",
    "customers.label.country": "Pays",
    "customers.label.Enter_address_manually": "Entrer l'adresse manuellement",
    "customers.label.Find_address": "Trouver l'adresse",
    "customers.label.Select_Address": "Sélectionnez une adresse",
    "customers.label.Select_an_address": "Sélectionnez une adresse",
    "customers.label.Enter_address_dynamically":
      "Entrer l'adresse dynamiquement",
    "customers.label.address_number": "Numéro d'adresse",
    "customers.label.street": "Rue",
    "customers.label.state": "État",
    "customers.label.city": "Ville",
    "customers.label.resident_period": "Période de résidence",
    "customers.label.Spend_Cap_Amount": "Montant du plafond de dépenses",
    "customers.label.I_don’t_want_a_Spend_Cap":
      "Je ne veux pas de plafond de dépenses",
    "customers.label.Monthly_Bill_Generation_Date":
      "Date de génération de la facture mensuelle",
    "customers.label.Select_a_Monthly_Plan": "Sélectionner un forfait mensuel",
    "customers.label.Search_plans": "Rechercher des forfaits...",
    "customers.label.search": "Rechercher",
    "customers.label.Select_a_plan": "Sélectionner un forfait",
    "customers.label.Basket": "Panier",
    "customers.label.This_number_is_reserved_for": "Ce numéro est réservé pour",
    "customers.label.ViewT&C": "Voir les conditions générales",
    "customers.label.TransferringFromPreviousNetwork":
      "Transfert depuis le réseau précédent (Conservez votre ancien numéro)",
    "customers.label.SIM_Information": "Informations SIM",
    "customers.label.Prepaid": "Prépayé",
    "customers.label.Postpaid": "Postpayé",
    "customers.label.Physical_SIM": "SIM Physique",
    "customers.label.eSIM": "eSIM",
    "customers.label.SelectCustomerType": "Sélectionner le type de client",
    "customers.label.New_to_Lyca": "Nouveau chez Lyca",
    "customers.label.Convert_Lyca_Prepaid_to_Postpaid":
      "Convertir Lyca Prépayé en Postpayé",
    "customers.label.Existing_customer_is_going_to_be_sent_a_secure_link_to_confirm_that_they_wish_to_move_from_prepaid_to_abonnement.":
      "Un client existant recevra un lien sécurisé pour confirmer son passage du prépayé à l’abonnement.",
    "customers.label.Customer_to_receive_an_SMS": "Le client recevra un SMS",
    "customers.label.Lyca_Mobile_Number": "Numéro Lyca Mobile",
    "customers.label.Enter_the_Lyca_Mobile_Number":
      "Entrez le numéro Lyca Mobile",
    "customers.label.Nationality": "Nationalité",
    "customers.label.Send_Secure_link": "Envoyer le lien sécurisé",
    "customers.label.New_to_Lyca_Mobile": "Nouveau chez Lyca Mobile",
    "customers.label.serial_number": "Numéro de série",
    "customers.label.Serial_Number": "Numéro de série (4 derniers chiffres)",
    "customers.label.PUK_Code": "Code PUK",
    "customers.label.PUK_Code_is_not_matched": "Le code PUK ne correspond pas",
    "customers.label.Switching_to_Lyca_Mobile": "Passage à Lyca Mobile",
    "customers.label.Enter_the_PUK_Code": "Entrez le code PUK",
    "customers.label.Basket": "Panier",
    "customers.label.Gender": "Genre",
    "customers.label.business_name": "Nom de l'entreprise",
    "customers.label.phone_number": "Numéro de téléphone",
    "customers.label.Date_of_Birth": "Date de naissance",
    "customers.label.VIP": "VIP",
    "customers.label.Disability": "Handicap",
    "customers.label.District": "District",
    "customers.label.Is_your_billing_address_same_as_primary_address":
      "Votre adresse de facturation est-elle la même que l'adresse principale ?",
    "customers.label.Supressbill": "Supprimer la facture",
    "customers.label.SelectCategory": "Sélectionner une catégorie",
    "customers.label.SelectGender": "Sélectionner le genre",
    "customers.label.SelectPreferences": "Sélectionner les préférences",
    "customers.label.SelectNationality": "Sélectionner la nationalité",
    "customers.label.SelectVIP": "Sélectionner VIP",
    "customers.label.SelectDisability": "Sélectionner un handicap",
    "customers.label.SelectCity": "Sélectionner une ville",
    "customers.label.SelectBillDay": "Sélectionner un jour de facturation",
    "customers.label.SelectType": "Sélectionner un type",
    "customers.label.SelectFiscalYear": "Sélectionner une année fiscale",
    "customers.label.SelectFiscalQuarter": "Sélectionner un trimestre fiscal",
    "customers.label.SelectBillMode": "Sélectionner un mode de facturation",
    "customers.label.SelectInvoiceType": "Sélectionner un type de facture",
    "customers.label.IMSI": "IMSI",
    "customers.label.SalesMotion": "Mouvement des ventes",
    "customers.label.SpendCap": "Plafond de dépenses",
    "customers.label.ActivationDate": "Date d'activation",
    "customers.label.ExpiryDate": "Date d'expiration",
    "customers.label.NextRenewalDate": "Date de renouvellement",
    "customers.label.BalanceTransfer": "Transfert de solde",
    "customers.label.RecieverClientId": "ID du client destinataire",
    "customers.label.Amount": "Montant",
    "customers.label.EnterTopUpAmount": "Entrez le montant de la recharge",
    "customers.label.ResponseId": "ID de réponse",
    "customers.label.BalanceName": "Nom du solde",
    "customers.label.Allowance": "Allocation",
    "customers.label.Consumption": "Consommation",
    "customers.label.AvailableBalance": "Solde disponible",
    "customers.label.DaysLeft": "Jours restants",
    "customers.label.Discount": "Remise",
    "customers.label.postal_code": "Code postal",
    "customers.label.address_number": "Numéro d'adresse",
    "customers.label.city": "Ville",
    "customers.label.state": "État",
    "customers.label.country": "Pays",
    "customers.label.resident_period": "Période de résidence",
    "customers.label.postcode": "Code postal",
    "customers.label.how_did_you_hear":
      "Comment avez-vous entendu parler de nous?",
    "customers.label.select_language": "Sélectionner la langue",
    "customers.label.email_address": "Adresse e-mail",
    "customers.label.contact_number": "Numéro de contact",
    "customers.label.initials": "Initiales",
    "customers.label.comment_date": "Date du commentaire",
    "customers.label.communication_type": "Type de Communication",
    "customers.label.BuySIM": "Acheter une carte SIM",
    "customers.label.origination": "Origine",
    "customers.label.address": "Adresse",
    "customers.label.destination_address": "Adresse de Destination",
    "customers.label.event": "Événement",
    "customers.label.charge_party": "Partie Facturée",
    "customers.label.service_subs_type": "Type d'Abonnement de Service",
    "customers.label.calling_party": "Partie Appelante",
    "customers.label.called_party": "Partie Appelée",
    "customers.label.usage": "Utilisation",
    "customers.label.monetary_charge": "Frais Monétaires",
    "customers.label.result_code": "Code Résultat",
    "customers.label.generation_time": "Temps de Génération",
    "customer.label.generationdatetime": "Date et Heure de Génération",
    "customers.label.transaction_id": "ID de Transaction",
    "customers.label.application_transaction_id":
      "ID de Transaction de l'Application",
    "customers.label.application_name": "Nom de l'Application",
    "customers.label.recharge_value": "Valeur de Recharge",
    "customers.label.interface": "Interface",
    "customers.label.result": "Résultat",
    "customers.label.comment": "Commentaire",
    "customers.label.recharge": "Recharger",
    "customers.label.cdr": "CDR",
    "customers.label.notifications": "Notifications",
    "customers.label.mobile_no": "Enter Mobile No",
    "customers.label.email_id": "Enter Email Id",
    "customers.label.serial_number": "Serial No",
    "customers.label.digital_content": "Contenu Numérique",
    "customers.label.buySim": "Acheter une carte SIM",
    "customers.label.outstanding_due": "Montant Dû",
    "customers.label.due_date": "Date d'Échéance",
    "customers.label.unbilled_amount": "Montant Non Facturé",
    "customers.label.next_bill_day": "Prochaine Date de Facturation",
    "customers.label.view_allowances": "Voir les Allocations",
    "customers.label.view_service_details": "Afficher les détails du service",
    "customers.label.spend_limit": "Limite de Dépenses",
    "customers.label.topup_balance": "Recharger le Solde",
    "customers.label.next_renewal_date": "Prochaine Date de Renouvellement",
    "customers.label.allowance": "Allocation",
    "customers.label.ViewDocumentUpload": "Voir le téléchargement de documents",
    "customers.label.total_net_amount": "Montant Net Total",
    "customers.label.cancelRemark": "Annuler la remarque",
    "customers.label.cancelPayment": "Annuler le paiement",
    "customers.label.all": "Tout",
    "customers.label.billProfile": "Profil de Facturation",
    "customers.label.charges": "Frais",
    "customers.label.book_order": "Commande de Livre",
    "customers.label.customers": "Clients",
    "customers.label.search_for_clients": "Rechercher des clients",
    "customers.label.advance_search": "Recherche avancée",
    "customers.label.customer_activation": "Activation du client",
    "customers.label.create_customer": "Créer un client",
    "customers.label.account_no": "Numéro de compte",
    "customers.label.customer_name": "Nom du client",
    "customers.label.business_entity": "Entité commerciale",
    "customers.label.serial_no": "Numéro de série",
    "customers.label.balance": "Solde",
    "customers.label.created_by": "Créé par",
    "customers.label.created_on": "Créé le",
    "customers.label.credit_limit": "Limite de crédit",
    "customers.label.transaction_history": "Historique des transactions",
    "customers.label.external_activity_log": "Journal d'activité externe",
    "customers.label.settings": "Paramètres",
    "system.label.currency_noncurrency": "Devise Non-Devise",
    "entity.label.configure": "Configurer",

    "customers.label.valid_from": "Valide à partir de",
    "customers.label.valid_to": "Valide jusqu'à",
    "customers.label.non_currency_details": "Détails non monétaires",
    "customers.label.view_details": "Voir les détails",
    "customers.label.status": "Statut",
    "customers.label.first_name": "Prénom",
    "customers.label.price_discount": "Prix et Remise",
    "customers.label.collection_status": "Statut de la collecte",
    "customers.label.last_name": "Nom de famille",
    "customers.label.city_area": "Ville/Quartier",
    "customers.label.email": "E-mail",
    "customers.label.phone": "Téléphone",
    "customers.label.cafid": "CAF Id",
    "customers.label.enter_business_entity": "Entrez l'entité commerciale",
    "customers.label.select": "Sélectionner",
    "customers.label.refund": "Remboursement",
    "customers.label.refund_id": "Identifiant du remboursement",
    "customers.label.refund_amount": "Montant du remboursement",
    "customers.label.select_category_type": "Sélectionnez le Type de Catégorie",
    "customers.label.clear": "Effacer",
    "customers.label.search": "Chercher",
    "customers.label.customer_details": "Détails du Client",
    "customers.label.loc": "LOC",
    "customers.label.customer_category": "Catégorie de Client",
    "customers.label.service_details": "Détails du Service",
    "customers.label.name": "Nom",
    "customers.label.add_service": "Ajouter un Service",
    "customers.label.network_node": "Nœud de Réseau",
    "customers.label.device_details": "Détails de l'Appareil",
    "customers.label.item": "Article",
    "customers.label.discount_code": "Code de Réduction",
    "customers.label.total_price": "Prix Total",
    // "customers.label.device_details": "Détails de l'appareil",
    "customers.label.plan_details": "Détails du plan",
    "customers.label.payment_details": "Détails de paiement",
    "customers.label.plan_list": "Liste des plans",
    "customers.label.plan": "Plan",
    "customers.label.bill_item_details": "Détails de l'article de facture",
    "customers.label.charge_id": "Identifiant de la charge",
    "customers.label.order_id": "Identifiant de la commande",
    "customers.label.item_tax_details": "Détails de la taxe de l'article",
    "customers.label.discount_details": "Détails de la remise",
    "customers.label.sale_date": "Date de vente",
    "customers.label.contract_period": "Période de contrat",
    "customers.label.charge_cycle": "Cycle de charge",
    "customers.label.cancel": "Annuler",
    "customers.label.next": "Suivant",
    "customers.label.done": "Terminé",
    "customers.label.reopen": "Rouvrir",
    "customers.label.submit": "Soumettre",
    "customers.label.view_customer": "Voir client",
    "customers.label.account_number": "Numéro de compte",
    "customers.label.office_hierarchy": "Hiérarchie de bureau",
    "customers.label.account_type": "Type de compte",
    // "customers.label.balance": "Solde",
    "customers.label.stb_serial_no": "Numéro de série STB",
    "customers.label.non_currency_balance": "Solde non monétaire",
    "customers.label.service_orders": "Ordres de service",
    "customers.label.more_info": "Plus d'infos",
    "customers.label.notes": "Remarques",
    "customers.label.device": "Dispositif",
    "customers.label.tickets": "Tickets",
    "customers.label.on_demand": "Sur demande",
    "customers.label.on_demand_billing": "Facturation à la demande",
    "customers.label.account_transaction": "Transaction de compte",
    "customers.label.payments": "Paiements",
    "customers.label.invoice": "Facture",
    "customers.label.activity_log": "Journal des activités",
    "customers.label.contact_information": "Informations de contact",
    "customers.label.address_information": "Informations d'adresse",
    "customers.label.billing_information": "Informations de facturation",
    "customers.label.balance_information": "Informations sur le solde",
    // "customers.label.customer_name": "Nom du client",
    "customers.label.parent_child": "Parent/Enfant",
    "customers.label.created_date": "Date de création",
    "customers.label.district": "District",
    "customers.label.pincode": "Code postal",
    "customers.label.last_bill_amount": "Montant de la dernière facture",
    "customers.label.last_bill_date": "Date de la dernière facture",
    "customers.label.last_bill_paid": "Dernière facture payée",
    "customers.label.last_paid_amount": "Montant payé la dernière fois",
    "customers.label.last_payment_date": "Date du dernier paiement",
    "customers.label.next_bill_date": "Date de la prochaine facture",
    "customers.label.service_overview": "Aperçu du service",
    "customers.label.service_without_device": "Service sans appareil",
    "customers.label.create_ticket": "Créer un ticket",
    "customers.label.service_activation": "Activation du service",
    "customers.label.order_charging": "Facturation de commande",
    "customers.label.top_up": "Recharger",
    "customers.label.redeem": "Racheter",
    "customers.label.collection_name": "Nom de la collection",
    "customers.label.redeem_voucher": "Utiliser le bon",
    "customers.label.service_id": "Identifiant du service",
    "customers.label.service_code": "Code de service",
    "customers.label.start_date": "Date de début",
    "customers.label.modified_date": "Date de modification",
    // "customers.label.status": "Statut",
    "customers.label.info": "Info",
    "customers.label.action": "Action",
    "customers.label.add_device": "Ajouter un appareil",
    "customers.label.add_plans": "Ajouter des plans",
    "customers.label.suspend": "Suspendre",
    "customers.label.reactivate": "Réactiver",
    "customers.label.terminate": "Résilier",
    "customers.label.command_center": "Centre de commande",
    "customers.label.retrack": "Refaire le suivi",
    "customers.label.cancel_plans": "Annuler les plans",
    "customers.label.device_overview": "Vue d'ensemble de l'appareil",
    "customers.label.item_code": "Code d'article",
    "customers.label.orders_overview": "Aperçu des commandes",
    // "customers.label.plan": "Plan",
    "customers.label.end_date": "Date de fin",
    "customers.label.price": "Prix",
    "customers.label.short_description": "Brève description",
    "customers.label.description": "Description",
    "customers.label.add_note": "Ajouter une note",
    "customers.label.note": "Note",
    "customers.label.sale_type": "Type de vente",
    "customers.label.charge_code": "Code de charge",
    "customers.label.quantity": "Quantité",
    // "customers.label.total_price": "Prix total",
    "customers.label.warranty_date": "Date de garantie",
    "customers.label.allocate": "Allouer",
    "customers.label.contact_info": "Infos de contact",
    "customers.label.edit_customer": "Modifier le client",
    "customers.label.lco": "LCO",
    "customers.label.title": "Titre",
    // "customers.label.customer_category": "Catégorie de client",
    "customers.label.middle_name": "Deuxième Prénom",
    "customers.label.caf_id": "Identifiant CAF",
    "customers.label.landline_number": "Numéro de téléphone fixe",
    "customers.label.user_name": "Nom d'utilisateur",
    "customers.label.customer_photo": "Photo du client",
    "customers.label.id_proof": "Preuve d'identité",
    "customers.label.id_proof_value": "Valeur de la preuve d'identité",
    "customers.label.save": "Enregistrer",
    "customers.label.close_customer": "Fermer le client",
    "customers.label.closure_date": "Date de fermeture",
    "customers.label.closure_reason": "Raison de la fermeture",
    "customers.label.close": "Fermer",
    "customers.label.address_info": "Infos Adresse",
    "customers.label.edit_address": "Modifier l'adresse",
    "customers.label.address_no": "Numéro d'adresse",
    "customers.label.street": "Rue",
    "customers.label.building": "Bâtiment",
    "customers.label.zipcode": "Code postal",
    "customers.label.billing": "Facturation",
    "customers.label.same_as_primary": "Identique au Principal",
    "customers.label.building_code": "Code du bâtiment",
    "customers.label.add_address": "Ajouter une adresse",
    "customers.label.address_type": "Type d'adresse",
    "customers.label.billing_info": "Informations de facturation",
    "customers.label.created_adjustment": "Ajustement créé",
    "customers.label.create_order": "Créer une commande",
    "customers.label.sale_catalog": "Catalogue de vente",
    "customers.label.renew_plan": "Renouveler le forfait",
    "customers.label.auto_renew": "Renouvellement automatique",
    // "customers.label.search": "Rechercher",
    "customers.label.entity_name": "Nom de l'entité",
    "customers.label.discount": "Remise",
    "customers.label.provisioning_commands": "Commandes de provisionnement",
    "customers.label.command": "Commande",
    "customers.label.plans": "Plans",
    "customers.label.client_service_detail": "Détail du service client",
    "customers.label.id": "Identifiant",
    "customers.label.parameter_name": "Nom du paramètre",
    "customers.label.parameter_value": "Valeur du paramètre",
    "customers.label.request_type": "Type de demande",
    "customers.label.client_info": "Informations sur le client",
    "customers.label.service_info": "Informations sur le service",
    "customers.label.new_device_info":
      "Informations sur le nouveau périphérique",
    "customers.label.task_list": "Liste des tâches",
    "customers.label.provisioning_detail": "Détail de la provision",
    "customers.label.provisioning_id": "ID de provisionnement",
    "customers.label.task_id": "ID de tâche",
    "customers.label.sent_message": "Message envoyé",
    "customers.label.available_plans": "Plans disponibles",
    "customers.label.disconnect_order": "Commande de déconnexion",
    "customers.label.reason": "Raison",
    "customers.label.porting_out": "Portage",
    "customers.label.prepaid_to_postpaid": "Prépayé à postpayé",
    "customers.label.postpaid_to_prepaid": "Postpayé à prépayé",
    "customers.label.addons": "Modules complémentaires",
    "customers.label.change_plan": "Changer de plan",
    "customers.label.swap_sim": "Remplacer la carte SIM",
    "customers.label.select_date": "Sélectionner une date",
    "customers.label.order_date": "Date de commande",
    "customers.label.priority": "Priorité",
    "customers.label.ticket_date": "Date du ticket",
    "customers.label.category": "Catégorie",
    "customers.label.sub_category": "Sous-catégorie",
    "customers.label.team": "Équipe",
    "customers.label.team_user": "Utilisateur de l'équipe",
    "customers.label.source": "Source",
    "customers.label.due_time": "Heure due",
    "customers.label.device_swap": "Échange de périphérique",
    // "customers.label.terminate": "Terminer",
    "customers.label.confirm": "Confirmer",
    "customers.label.continue": "Continuer",
    "customers.label.process_date": "Date de traitement",
    "customers.label.pin_number": "Numéro de PIN",
    "customers.label.renewal": "Renouvellement",
    // "customers.label.create_customer": "Créer un client",
    "customers.label.individual": "Individuel",
    "customers.label.corporate": "Entreprise",
    "customers.label.corporate_details": "Détails de l'entreprise",
    "customers.label.contact_person": "Personne de contact",
    "customers.label.entity": "Entité",
    "customers.label.client_category": "Catégorie du client",
    "customers.label.preferences": "Préférences",
    "customers.label.parent_id": "Identifiant parent",
    "customers.label.child": "Enfant",
    "customers.label.villege_street": "Village/Rue",
    "customers.label.billing_address": "Adresse de facturation",
    "customers.label.bill_information": "Informations de facturation",
    "customers.label.bill_day_of_month": "Jour de facturation du mois",
    "customers.label.fiscal_year": "Exercice fiscal",
    "customers.label.fiscal_quater": "Trimestre fiscal",
    "customers.label.bill_mode": "Mode de facturation",
    "customers.label.invoice_type": "Type de facture",
    "customers.label.payment_information": "Informations de paiement",
    "customers.label.funder_name": "Nom du bailleur de fonds",
    "customers.label.funder_id": "ID du bailleur de fonds",
    "customers.label.po_number": "Numéro de commande",
    "customers.label.payment_term": "Modalité de paiement",
    "customers.label.customer_created_successfully": "Client créé avec succès",
    "customers.label.go_to_customer": "Aller au client",
    "customers.label.view_order": "Voir la commande",
    "customers.label.disconnect": "Déconnecter",
    "customers.label.apply_promo": "Appliquer la promotion",
    // "customers.label.order_id": "Identifiant de commande",
    "customers.label.order_type": "Type de commande",
    "customers.label.billing_cycle": "Cycle de facturation",
    "customers.label.plan_name": "Nom du plan",
    "customers.label.user_action": "Action de l'utilisateur",
    "customers.label.invoice_till_date": "Facture jusqu'à la date",
    "customers.label.order_services": "Services de commande",
    "customers.label.service_type": "Type de service",
    "customers.label.service_description": "Description du service",
    "customers.label.bill_start_date": "Date de début de la facturation",
    "customers.label.bill_end_date": "Date de fin de la facturation",
    // "customers.label.invoice_till_date": "Facture jusqu'à la date",
    "customers.label.charge_type": "Type de charge",
    "customers.label.rate_uom": "Taux/UOM",
    "customers.label.discount_description": "Description de la remise",
    "customers.label.discount_type": "Type de remise",
    "customers.label.discount_start_date": "Date de début de la remise",
    "customers.label.discount_end_date": "Date de fin de la remise",
    "customers.label.discount_amount": "Montant de la remise",
    "customers.label.order_transaction": "Transaction de commande",
    "customers.label.user": "Utilisateur",
    "customers.label.transaction_date": "Date de transaction",
    "customers.label.transaction_type": "Type de transaction",
    "customers.label.actual_date": "Date réelle",
    "customers.label.promo": "Promo",
    "customers.label.promotion": "Promotion",
    "customers.label.disconnection_date": "Date de déconnexion",
    "customers.label.disconnection_reason": "Raison de la déconnexion",
    "customers.label.problem_code": "Code de problème",
    "customers.label.assign_to": "Assigner à",
    "customers.label.last_comment": "Dernier commentaire",
    "customers.label.file_name": "Nom de fichier",
    "customers.label.edit_ticket": "Modifier le ticket",
    "customers.label.close_ticket": "Fermer le ticket",
    "customers.label.resolution_description": "Description de la résolution",
    "customers.label.ticket_history": "Historique du ticket",
    // "customers.label.last_comment": "Dernier commentaire",
    "customers.label.problem_description": "Description du problème",
    "customers.label.generate": "Générer",
    "customers.label.bill_date": "Date de facturation",
    "customers.label.amount": "Montant",
    "customers.label.statement": "Déclaration",
    // "customers.label.due_date": "Date d'échéance",
    "customers.label.promotional_message": "Message promotionnel",
    "customers.label.download": "Télécharger",
    "customers.label.due_amount": "Montant dû",
    "customers.label.transactions": "Transactions",
    "customers.label.file": "Fichier",
    "customers.label.reset": "Réinitialiser",
    "customers.label.order_details": "Détails de la commande",
    "customers.label.make_payment": "Effectuer un paiement",
    "customers.label.credit_amount": "Montant crédité",
    "customers.label.debit_amount": "Montant débité",
    "customers.label.cancel_remark": "Remarque d'annulation",
    "customers.label.pay_invoice": "Payer la facture",
    "customers.label.account": "Compte",
    "customers.label.deposit": "Dépôt",
    "customers.label.payment_date": "Date de paiement",
    "customers.label.payment_type": "Type de paiement",
    "customers.label.receipt_no": "Numéro de reçu",
    "customers.label.cheque_no": "Numéro de chèque",
    "customers.label.bank_name": "Nom de la banque",
    "customers.label.branch_name": "Nom de la succursale",
    "customers.label.cheque_date": "Date du chèque",
    "customers.label.invoice_id": "Identifiant de facture",
    "customers.label.invoice_date": "Date de facture",
    "customers.label.invoice_amount": "Montant de la facture",
    // "customers.label.due_amount": "Montant dû",
    "customers.label.payment_reversal": "Annulation de paiement",
    "customers.label.date_filter": "Filtre de date",
    "customers.label.add_event_order": "Ajouter un ordre d'événement",
    "customers.label.event_order": "Commande d'événement",
    "customers.label.eventdate": "Date de l'événement",
    "customers.label.serviceAddress": "Adresse de service",
    "customers.label.event_name": "Nom de l'événement",
    "customers.label.booked_date": "Date de réservation",
    "customers.label.event_price": "Prix de l'événement",
    "customers.label.events": "Événements",
    "customers.label.format_type": "Type de format",
    "customers.label.opt_type": "Type OPT",
    "customers.label.client_bill_profile": "Profil de facturation du client",
    "customers.label.edit": "Éditer",
    "customers.label.type": "Type",
    "customers.label.client_id": "Identifiant du client",
    "customers.label.bill_frequency": "Fréquence de facturation",
    "customers.label.bill_segment": "Segment de facturation",
    // "customers.label.next_bill_day": "Prochain jour de facturation",
    "customers.label.last_bill_day": "Dernier jour de facturation",
    "customers.label.last_bill_no": "Numéro de dernière facture",
    "customers.label.bill_suppression_flag":
      "Indicateur de suppression de facture",
    "customers.label.bill_suppression_id":
      "Identifiant de suppression de facture",
    "customers.label.first_bill": "Première facture",
    "customers.label.hot_bill": "Facture urgente",
    "customers.label.edit_bill_profile": "Modifier le profil de facturation",
    "customers.label.bill_currency": "Devise de facturation",
    "customers.label.bill_suppression": "Suppression de facture",
    // "customers.label.more_info": "Plus d'informations",
    "customers.label.identities": "Identités",
    "customers.label.add_client_identities": "Ajouter des identités client",
    "customers.label.unique_identification": "Identification unique",
    "customers.label.identity_documents": "Documents d'identité",
    "customers.label.additional_info": "Informations supplémentaires",
    "customers.label.nationality": "Nationalité",
    "customers.label.date_of_birth": "Date de naissance",
    "customers.label.preferred_language": "Langue préférée",
    "customers.label.finance_id": "ID de finance",
    "customers.label.remarks": "Remarques",
    "customers.label.preferred_communication": "Communication préférée",
    "customers.label.add_client_identifier": "Ajouter un identifiant client",
    "customers.label.document_type": "Type de document",
    "customers.label.document_uploads": "Téléchargements de documents",
    "customers.label.select_file": "Sélectionner un fichier",
    "customers.label.credit_card_details": "Détails de la carte de crédit",
    "customers.label.card_number": "Numéro de carte",
    "customers.label.cvv": "CVV",
    "customers.label.card_type": "Type de carte",
    "customers.label.expiry_date": "Date d'expiration",
    "customers.label.ach_card": "Carte ACH",
    "customers.label.ach_card_routing_number":
      "Numéro de routage de la carte ACH",
    "customers.label.bank_account_number": "Numéro de compte bancaire",
    "customers.label.childs": "Enfants",
    "customers.label.cell_phone": "Téléphone portable",
    "customers.label.create_client_additional_info":
      "Créer des informations supplémentaires sur le client",
    "customers.label.gender": "Genre",
    "customers.label.id_type": "Type d'identifiant",
    // "customers.label.nationality": "Nationalité",
    "customers.label.id_number": "Numéro d'identification",
    "customers.label.job_title": "Titre du poste",
    "customers.label.age_group": "Tranche d'âge",
    "customers.label.uts_customer_id": "Identifiant client UTS",
    "customers.label.ach_card_name": "Nom de la carte ACH",
    "customers.label.adjustment": "Ajustement",
    // "customers.label.created_adjustment": "Ajustement créé",
    "customers.label.adjustment_date": "Date d'ajustement",
    "customers.label.adjustment_code": "Code d'ajustement",
    "customers.label.adjustment_amount": "Montant de l'ajustement",
    "customers.label.adjustment_type": "Type d'ajustement",
    "customers.label.office_id": "ID du bureau",
    "customers.label.history": "Historique",
    "customers.label.filter_by_date": "Filtrer par date",
    "customers.label.view_usage_details": "Voir les détails d'utilisation",
    "customers.label.units": "Unités",
    "customers.label.tax": "Taxe",
    "customers.label.total_amount": "Montant total",
    "customers.label.csv_pdf": "CSV/PDF",
    "customers.label.charge_description": "Description de la charge",
    "customers.label.journals": "Journaux",
    "customers.label.download_financial_summary_data":
      "Télécharger les données de synthèse financière",
    "customers.label.select_from_date": "Sélectionner à partir de la date",
    "customers.label.select_to_date": "Sélectionner jusqu'à la date",
    "customers.label.village_street": "Village/Rue",
    "customers.label.previous": "Précédent",
    "customers.label.Disconnect": "Déconnecter",
    "customers.label.ApplyPromo": "Appliquer la Promo",
    "customers.label.Service": "Service",
    "customers.label.Product": "Produit",
    "customers.label.CreditCard": "Carte de Crédit",
    "customers.label.Paypal": "Paypal",
    "customers.label.BusinessEntity": "Entité Commerciale",
    "customers.label.Plan": "Plan",
    "customers.label.Phone": "Téléphone",
    "customers.label.TaxExemption": "Exonération Fiscale",
    "customers.label.YES": "OUI",
    "customers.label.NO": "NON",
    "customers.label.Resolution": "Résolution",
    "customers.label.AccountNo": "Numéro de Compte",
    "customers.label.ChipId": "Id de Puce",
    "customers.label.MobileNo": "Numéro de Mobile",
    "customers.label.EmailId": "Id Email",
    "customers.label.SerialNo": "Numéro de Série",
    "customers.label.LegacyNo": "Numéro Hérité",
    "customers.label.searchclient": "Rechercher Client",
    "customers.label.PrimaryAddress": "Adresse Principale",
    "customers.label.BillingAddress": "Adresse de Facturation",
    // "customers.label.lco": "lco",
    "customers.label.EventDate": "Date de l'Événement",
    "customers.label.CreateAdjustment": "Créer un Ajustement",
    "customers.label.full_name": "Nom complet",
    "customers.label.bill_collection_action": "Action de collecte de factures",
    "customers.label.collection_actions": "Actions de collecte",
    "customers.label.action_name": "Nom de l'action",
    "customers.label.action_date": "Date de l'action",
    "customers.label.balance_due": "Solde dû",
    "customers.label.bill_id": "ID de la facture",
    "customers.label.view_goods_receipt": "Voir le bon de réception",
    "customers.label.payinfo": "Informations de Paiement",
    "customers.label.cardtoken": "Jeton de Carte",
    "customers.label.autopay": "Paiement Automatique",
    "customers.label.paynow": "Payer Maintenant",
    "customers.label.featureList": "Liste des Fonctionnalités",
    "customers.label.consumed": "Consommé",
    "customers.label.updateCreditLimt": "Mettre à Jour la Limite de Crédit",
    "customers.label.PendingForApproval": "En attente d'approbation",

    "customers.label.SpendCapHistory": "Historique du plafond de dépenses",
    "customers.label.DateTime": "Date et heure",
    "customers.label.SpendCapEventName": "Nom de l'événement de plafond",
    "customers.label.SpendingLimit": "Limite de dépenses",
    "customers.label.ConsumedLimit": "Limite consommée",
    "customers.label.EventId": "ID de l'événement",
    "customer.label.collectionStatus" : "Statut de la collecte"
  },
  es: {
    "customers.label.temporaryBlock": "Bloqueo temporal",
    "customers.label.unBlock": "Desbloquear",
    "customers.label.feedback": "Comentarios",
    "customers.label.event_id": "ID del evento",
    "customers.label.slc_state_history": "Historial del estado SLC",
    "customers.label.slc": "SLC",
    "customers.label.state_Change_Time": "Hora de cambio de estado",
    "customers.label.event": "Evento",
    "customers.label.previous_state": "Estado anterior",
    "customers.label.resolution_date": "Fecha de resolución",
    "customers.label.current_state": "Estado actual",
    "customers.label.created_time": "Hora de creación",
    "customers.label.creation_time": "Hora de creación",
    "customers.label.Promotion": "Promoción",
    "customers.label.slc_status": "Estado SLC",
    "customers.label.update_slc_status": "Actualizar estado SLC",
    "customers.label.temporary_block": "Bloqueo temporal",
    "customers.label.workflow_id": "ID de flujo de trabajo",
    "customers.label.externalPromoId": "ID Promo Externa",
    "customers.label.externalPromoName": "Nombre Promo Externa",
    "customers.label.promoCode": "Código Promocional",
    "customers.label.promoDescription": "Descripción de la Promoción",
    "customers.label.ScheduleOrder": "Programar pedido",
    "customers.label.ScheduledDate": "Fecha programada",
    "customers.label.ViewRateLimit": "Ver límite de velocidad",
    "customers.label.SelectType": "Seleccionar tipo",
    "customers.label.search": "Buscar",
    "customers.label.SelectTaxExemption": "Seleccionar exención de impuestos",
    "customers.label.ViewTickets": "Ver tickets",
    "customers.label.TicketHistory": "Historial de tickets",
    "customers.label.ReopenTicket": "Reabrir ticket",
    "customers.label.SelectInvoiceType": "Seleccionar tipo de factura",
    "customers.label.SelectCategory": "Seleccionar categoría",
    "customers.label.SelectSubCategory": "Seleccionar subcategoría",
    "customers.label.SelectSource": "Seleccionar fuente",
    "customers.label.TicketHistory": "Historial de tickets",
    "customers.label.ViewSpendCap": "Ver límite de gasto",
    "customers.label.ResponseMessage": "Mensaje de respuesta",
    "customers.label.AddPlan": "Agregar plan",
    "customers.label.Basket": "Cesta",
    "customers.label.TotalPrice": "Precio total",
    "customers.label.Send_Link_to_Customer_to_Complete_Payment":
      "Enviar enlace al cliente para completar el pago",
    "customers.label.CheckPaymentStatus": "Verificar estado de pago",
    "customers.label.Are_you_sure_you_want_to_terminate?":
      "¿Está seguro de que desea finalizar?",
    "customers.label.Unlimited": "Ilimitado",
    "customers.label.days_left": "días restantes",
    "customers.label.search": "Buscar",
    "customers.label.JobTitle": "Título del trabajo",
    "customers.label.SelectDocumentType": "Seleccionar tipo de documento",
    "customers.label.SelectEvents": "Seleccionar eventos",
    "customers.label.SelectFormatType": "Seleccionar tipo de formato",
    "customers.label.SelectAdjustmentType": "Seleccionar tipo de ajuste",
    "customers.label.card_number": "Número de tarjeta",
    "customers.label.Select_OPT_Type": "Seleccionar tipo de OPT",
    "customers.label.StartDate": "Fecha de inicio",
    "customers.label.EndDate": "Fecha de finalización",
    "customers.label.Cancel": "Cancelar",
    "customers.label.Set": "Establecer",
    "customers.label.PaymentDetails": "Detalles del pago",
    "customers.label.PaymentReceipt": "Recibo de pago",
    "customers.label.Status": "Estado",
    "customers.label.PaymentAmount": "Monto del pago",
    "customers.label.Transaction": "Transacción",
    "customers.label.PaymentPage": "Página de pago",
    "customers.label.ItemCode": "Código del artículo",
    "customers.label.StartDate": "Fecha de inicio",
    "customers.label.English": "Inglés",
    "customers.label.SelectIdProof": "Seleccionar prueba de identidad",
    "customers.label.SelectAdjustementCode": "Seleccionar código de ajuste",
    "customers.label.SelectAdjustmentType": "Seleccionar tipo de ajuste",
    "customers.label.SelectFormat": "Seleccionar formato",
    "customers.label.AreYouSure?": "¿Estás seguro?",
    "customers.label.ChargeId": "ID de cargo",
    "customers.label.ChargeDescription": "Descripción del cargo",
    "customers.label.DiscountAmount": "Monto del descuento",
    "customers.label.NetChargeAmount": "Monto neto del cargo",
    "customers.label.TaxDescription": "Descripción del impuesto",
    "customers.label.TaxAmount": "Monto del impuesto",
    "customers.label.SelectDate": "Seleccionar fecha",
    "customers.label.SelectPriority": "Seleccionar prioridad",
    "customers.label.SelectCategory": "Seleccionar categoría",
    "customers.label.SelectSubCategory": "Seleccionar subcategoría",
    "customers.label.SelectSource": "Seleccionar fuente",
    "customers.label.ViewSpendCap": "Ver límite de gasto",
    "customers.label.Amount": "Monto",
    "customers.label.PlanCode": "Código del plan",
    "customers.label.Price": "Precio",
    "customers.label.Status": "Estado",
    "customers.label.EndDate": "Fecha de finalización",
    "customers.label.ContractPeriod": "Periodo de contrato",
    "customers.label.AutoRenew": "Renovación automática",
    "customers.label.Description": "Descripción",
    "customers.label.ThankYou": "¡Gracias!",
    "customers.label.ConnectionActivated":
      "La conexión se ha activado correctamente con el número de cuenta",
    "customers.label.GoToCustomerDetail": "Ir a los detalles del cliente",
    "customers.label.Payment": "Pago",
    "customers.label.CustomerToPay": "Cliente a pagar:",
    "customers.label.MonthlyPayment": "Pago mensual",
    "customers.label.SetupWithDirectDebitOrCreditCard":
      "Configurar con débito directo o tarjeta de crédito",
    "customers.label.SendLinkToCustomerToCompletePayment":
      "Enviar enlace al cliente para completar el pago",
    "customers.label.CheckPaymentStatus": "Verificar estado del pago",
    "customers.label.ThisNumberIsReservedFor":
      "Este número está reservado para",
    "customers.label.YouSelected": "Usted seleccionó",
    "customers.label.SerialNo": "Número de serie",
    "customers.label.PhoneNo": "Número de teléfono",
    "customers.label.ActivatingCustomer": "Activando cliente...",
    "customers.label.LoadingOrderStatus": "Cargando estado del pedido...",
    "customers.label.OrderStatus": "Estado del pedido:",
    "customers.label.Failed": "Fallido",
    "customers.label.RoamingOutsideEEA": "Roaming fuera del EEE",
    "customers.label.TariffTermsDetails":
      "Consulte nuestros Términos de tarifas y nuestro sitio web para obtener más detalles sobre tarifas específicas y cargos fuera de su asignación.",
    "customers.label.PaymentTerms":
      "Debitarémos el importe que debe pagarnos de su cuenta mediante domiciliación SEPA, salvo que hayamos acordado lo contrario. La factura indicará la fecha en la que se realizará el débito. Podemos solicitar el pago de tarifas únicas y suscripciones por adelantado. En casos especiales, podemos cobrar montos intermedios, por ejemplo, si en un corto período de tiempo ha utilizado un servicio de manera superior al promedio. Si paga con tarjeta de crédito o débito, autoriza a la empresa emisora a proporcionarnos y, de manera estrictamente confidencial, a nuestros subcontratistas y/o agentes, los detalles de su cuenta de pago si es necesario en relación con el acuerdo. También les autoriza a informarnos si su cuenta de pago se cancela o suspende en cualquier momento.",
    "customers.label.ServiceAgreementTerms":
      "Duración, renovación y terminación del contrato de servicios",
    "customers.label.Duration": "Duración",
    "customers.label.Renewal": "Renovación",
    "customers.label.ContractTermsAndConditions":
      "Términos y condiciones del contrato",
    "customers.label.TermsAndConditions": "Términos y Condiciones",
    "customers.label.CustomerExplanation":
      "He proporcionado al cliente una explicación detallada de",
    "customers.label.CustomerAgreement":
      "y han aceptado proceder con el pedido.",
    "customers.label.NumberReservedFor": "Este número está reservado para",
    "customers.label.YouSelected": "Usted ha seleccionado",
    "customers.label.SerialNo": "Número de serie",
    "customers.label.PhoneNo": "Número de teléfono",
    "customers.label.TotalPrice": "Precio total",
    "customers.label.FeaturesForEndUsersWithDisabilities":
      "Funciones para usuarios finales con discapacidades",
    "customers.label.InformationSupportServices":
      "La información de soporte de nuestros servicios está disponible en formatos alternativos. Si desea acceder a la información en un formato alternativo, llámenos a través de su SIM de Lycamobile al 1200 o visite",
    "customers.label.HowWeUseYourInformation": "Cómo usamos su información",
    "customers.label.InformationUsageDetails":
      "Recopilaremos información sobre cómo utiliza nuestros Servicios y los servicios de terceros que utiliza junto con nuestros Servicios, incluyendo, por ejemplo, su ubicación y actividad de cuenta, para mejorar su experiencia general con nosotros y hacerla más relevante para usted. Podemos usar y analizar sus datos personales para administrar su(s) servicio(s) y cuenta, incluyendo la verificación de crédito y la prevención de fraudes. Podemos compartir y combinar esos datos con terceros cuidadosamente seleccionados por las mismas razones. Su información se trata de acuerdo con nuestra Política de Privacidad, que puede consultarse en:",
    "customers.label.CustomerComplaints":
      "Si no está satisfecho con la velocidad, calidad u otros elementos del servicio y desea presentar una queja, comuníquese con el Servicio de Atención al Cliente. Puede obtener más información sobre nuestro proceso de quejas en nuestro Código de Prácticas de Quejas de Clientes, disponible en",
    "customers.label.DisputeResolution":
      "Si no podemos resolver su queja, puede enviarla en un plazo de 12 meses al Comité de Disputas de Servicios de Telecomunicaciones. También puede presentar una queja en la plataforma de resolución de disputas en línea de la Comisión Europea o presentar una demanda en un tribunal civil.",
    "customers.label.costsEuro": "cuesta €",
    "customers.label.thereafterEuro": "después €",
    "customers.label.forTheFirst": "para el primero",
    "customers.label.perMonthInclusiveVAT":
      "por mes, incluido el IVA (sujeto a aumentos anuales del IPC + 3,9%). Consulte el sitio web para más detalles.",
    "customers.label.additionalAddOns":
      "Pueden estar disponibles complementos adicionales para su plan y se cobrarán por separado en su factura.",
    "customers.label.paymentTerms":
      "Debe pagar los cargos por los servicios a los que se suscribe y/o utiliza cada mes antes de la fecha de su factura. Podemos cobrar tarifas si se retrasa en el pago. Podemos solicitar un depósito antes de permitirle utilizar los servicios. Consulte nuestros Términos de Tarifa y el sitio web para obtener más detalles sobre tarifas específicas y cargos fuera de su asignación.",
    "customers.label.durationRenewalTermination":
      "Duración, renovación y terminación",
    "customers.label.minimumPeriod":
      "tiene un período mínimo de 1 mes y continuará después de ese período mensualmente hasta la terminación por su parte con un aviso de 30 días (a menos que se apliquen otras reglas legales o reglamentarias), y deberá pagar los cargos incurridos durante este período de aviso.",
    "customers.label.cancellationCoolingOff":
      "Si cambia de opinión sobre los servicios comprados directamente a nosotros, puede tener derecho a cancelar el acuerdo de servicios dentro del período de reflexión de 14 días.",
    "customers.label.earlyTerminationCharge":
      "Usted acepta que los servicios comenzarán inmediatamente si ya tiene una tarjeta SIM o cuando reciba una tarjeta SIM. Si desea finalizar el acuerdo de servicios durante el período mínimo o si lo finalizamos debido a un incumplimiento material, deberá pagar un cargo por terminación anticipada que no excederá sus cargos de suscripción mensual multiplicados por la cantidad de meses restantes en su período mínimo, incluido el IVA (calculado a la tasa vigente) menos un porcentaje para un único pago final. También deberá pagar por cualquier llamada, mensaje, datos y otros cargos incurridos, incluso durante el período de reflexión.",
    "customers.label.ContractSummarys":
      "Este resumen del contrato y nuestra oferta de Abono de servicios internacionales amplios por 1 mes le permiten realizar y recibir llamadas de voz, enviar y recibir SMS, usar datos y acceder a Internet, todo a través de la Red, junto con cualquier servicio adicional opcional que acordemos proporcionar y que usted elija recibir.",
    "customers.label.The": "El",
    "customers.label.ComesWith": "viene con:",
    "customers.label.MobileDataSpeeds":
      "Velocidades del servicio de datos móviles",
    "customers.label.DataServiceDescription":
      "El servicio de datos y las velocidades mínima y máxima asociadas disponibles a través de la red de Lycamobile dependen de la tecnología accesible, por ejemplo, 2G, Edge, 3G, 4G, 5G en su ubicación, el dispositivo utilizado y el tipo de plan que haya adquirido.",
    "customers.label.DataSpeedVariation":
      "La velocidad de su servicio de datos móviles puede variar y depende de su ubicación, el entorno que le rodea (clima, cobertura de árboles, materiales utilizados en los edificios cercanos y la cantidad de personas que usan la red) y el dispositivo utilizado para conectarse a la red.",
    "customers.label.LycamobileBV": "Lycamobile B.V.",
    "customers.label.Robijnlaan17": "Robijnlaan 17,",
    "customers.label.2132WXHoofddorp": "2132WX Hoofddorp,",
    "customers.label.TheNetherlands": "Países Bajos",
    "customers.label.ContractSummary": "Resumen del contrato",
    "customers.label.ContractSummaryDescription1":
      "Este resumen del contrato proporciona los elementos principales de esta oferta de servicio según lo exige la ley.",
    "customers.label.ContractSummaryDescription2":
      "Ayuda a comparar las ofertas de servicio.",
    "customers.label.ContractSummaryDescription3":
      "La información completa sobre el servicio se proporciona en otros documentos.",
    "customers.label.ContractSummaryValidity":
      "Este resumen del contrato es válido hasta el vencimiento del pago el",
    "customers.label.AcceptOffer":
      "Si esta oferta es adecuada, puede aceptarla a través de la página de pago. Por favor, conserve una copia de este documento para sus registros.",
    "customers.label.Services": "Servicios",
    "customers.label.TermsConditions":
      "Según los términos y condiciones del Acuerdo de Servicios, si incumplimos un término material del Acuerdo que restrinja completamente nuestra capacidad de proporcionarle datos como parte de nuestro Servicio y no lo corregimos dentro de los 7 días posteriores a la recepción de su queja a través del servicio de atención al cliente de Lycamobile, puede finalizar el acuerdo.",
    "customers.label.EmergencyOrganisations":
      "Organizaciones de emergencia e información de ubicación del llamante",
    "customers.label.EmergencyCallInstructions":
      "Si necesita realizar una llamada de emergencia/112/999 cuando la red de Lycamobile esté caída o no disponible, por cualquier motivo, su dispositivo móvil debe ser capaz de conectarse a redes de radio 2G, 3G, 4G o 5G y puede seleccionar la red de un competidor que tenga cobertura para acceder a las llamadas de emergencia.",
    "customers.label.EmergencyCallAvailability":
      "Las llamadas de emergencia solo pueden realizarse cuando haya una red de radio disponible.",
    "customers.label.PlanName": "Nombre del plan",
    "customers.label.EuropeanOnlineDisputeResolution":
      "El sitio europeo de resolución de disputas en línea",
    "customers.label.ECWebsite": "ec.europa.eu/consumers/odr",
    "customers.label.DisputeResolutionDetails":
      "permite a los consumidores presentar disputas relacionadas con compras en línea con nosotros. Puede consultar nuestro sitio web para obtener una copia de nuestro Código de Prácticas sobre reclamaciones y para obtener nuestra información más reciente sobre resoluciones alternativas de disputas. Estamos aquí para ayudar. Si algo sale mal, queremos solucionarlo. Puede obtener más información sobre nuestro proceso de reclamaciones en nuestro Código de Prácticas de Reclamaciones de Clientes, que se puede encontrar en.",
    "customers.label.NetherlandsLawCompliance":
      "En caso de discrepancia continua y/o recurrente entre el rendimiento real del servicio de acceso a Internet con respecto a la velocidad, de acuerdo con las leyes de los Países Bajos, Lycamobile proporcionará una nueva ejecución en un plazo razonable. Cuando la nueva ejecución sea imposible, Lycamobile reducirá razonablemente el precio que el Cliente paga por el Servicio. Si el Cliente ya ha pagado, Lycamobile reembolsará al Cliente cualquier cantidad pagada en exceso.",
    "customers.label.DirectoryServiceInfo":
      "Puede solicitarnos que incluyamos su número de teléfono móvil en un directorio telefónico y/o en un servicio de consultas de directorios. Sin embargo, debe saber que si solicita este servicio, su número será visible para empresas que recopilan información con fines de marketing. Si le preocupa esto, puede detener las llamadas de marketing no solicitadas optando por excluirse o ejerciendo su derecho de objeción. Si desea que su número de teléfono móvil se incluya en un directorio y/o un servicio de consultas de directorios, comuníquese con nuestro equipo de atención al cliente.",
    "customers.label.RemediesComplaints":
      "Recursos, gestión de quejas y resolución de disputas",
    "customers.label.ContactCustomerService":
      "Si necesita contactar con el servicio de atención al cliente, visite el sitio web y haga clic en 'Contáctenos'. Si desea presentar una queja sobre nuestro servicio, comuníquese con atención al cliente. Si aún no está satisfecho, puede escribir para una revisión imparcial a:",
    "customers.label.IncludeMobileNumber":
      "Incluya su número de teléfono móvil si nos escribe. Si no podemos resolver su queja, puede enviarla dentro de los 24 meses a De Geschillencommissie ( Postbus 90600, 2509 LP, Den Haag ).",
    "customers.label.Termination": "Terminación",
    "customers.label.TerminationNotice":
      "Después del período mínimo, puede finalizar el acuerdo notificándonos (a menos que se apliquen otras reglas legales o reglamentarias) y deberá pagar los cargos incurridos durante este período de notificación.",
    "customers.label.EarlyTerminationCharge":
      "A menos que se especifique lo contrario (como en los términos de su tarifa), si desea finalizar el acuerdo de servicios durante el período mínimo o si lo finalizamos debido a un incumplimiento grave de su parte, deberá pagar un cargo por terminación anticipada equivalente a sus cargos mensuales de suscripción multiplicados por el número de meses restantes en su período mínimo, incluyendo el IVA (calculado a la tasa vigente).",
    "customers.label.OptionalAddOnTermination":
      "Cualquier servicio adicional opcional se cancelará independientemente de cualquier plan mensual grupal.",
    "customers.label.CancellationInfo":
      "Si cambia de opinión o necesita cancelar, tiene derecho a cancelar su aceptación de nuestros términos y condiciones en cualquier momento hasta 14 días después de realizar su pedido del servicio (el período de enfriamiento), siempre que lo haga de acuerdo con nuestra política de cancelación o notificando a Lycamobile. Esto no afecta sus derechos legales.",
    "customers.label.Security": "Seguridad",
    "customers.label.SecurityPolicy":
      "Todos los eventos de seguridad de los que tengamos conocimiento serán analizados para su clasificación, contención, recuperación, análisis y resolución. Se enviarán notificaciones oportunas a los clientes afectados según los requisitos reglamentarios y contractuales aplicables. Los incidentes de seguridad que requieran investigaciones forenses serán llevados a cabo por Lycamobile o, cuando corresponda, por un tercero calificado con miras a su resolución y prevención futura.",
    "customers.label.DataProtection": "Protección de datos",
    "customers.label.DataProtectionPolicy":
      "Sin perjuicio de la legislación de protección de datos, Lycamobile requiere información personal del cliente para proporcionar los servicios, como: nombre, dirección, número de cuenta, número de teléfono móvil y detalles de pago. Su información se trata de acuerdo con nuestra política de privacidad, que establece cómo recopilamos, usamos y compartimos su información, con quién y por qué, describe sus derechos y explica cómo puede ejercerlos.",
    "customers.label.TariffTerms":
      "Consulte nuestros Términos de Tarifa y nuestro sitio web para obtener más detalles sobre tarifas específicas y cargos fuera de su paquete.",
    "customers.label.DeliveryOfService": "Entrega del servicio",
    "customers.label.PaymentTerms":
      "Debitaríamos el monto que debe pagarnos de su cuenta mediante domiciliación SEPA, a menos que hayamos acordado lo contrario con usted...",
    "customers.label.ServiceStartDate":
      "La fecha en la que Lycamobile proporcionará los servicios es la fecha en la que se registre con Lycamobile.",
    "customers.label.ContractDuration":
      "Duración, renovación y terminación del acuerdo de servicios",
    "customers.label.MinimumPeriod":
      "Su suscripción tiene un período mínimo denominado Período Mínimo, que puede ser tan corto como 1 mes para paquetes mensuales y 24 meses para contratos de duración determinada.",
    "customers.label.ContractRenewal":
      "Para renovar el contrato, debe notificar a Lycamobile durante la vigencia de su contrato anterior, consintiendo en renovar el contrato.",
    "customers.label.DataCostDetails":
      "Los {40 GB de datos} cuestan {18,90 €} durante los {3 primeros meses}, luego {27,00 €} por mes, IVA incluido (sujeto a aumentos anuales del IPC + 3,9 %). Consulte nuestro sitio web para más detalles.",
    "customers.label.AdditionalAddons":
      "Pueden estar disponibles complementos adicionales para su plan y se cobrarán por separado.",
    "customers.label.SpendingLimits": "Límites de gasto",
    "customers.label.SpendingLimitDetails":
      "Lycamobile establecerá límites de gasto en su cuenta de acuerdo con sus preferencias hasta un máximo de 250 €.",
    "customers.label.PremiumCharges":
      "Las llamadas premium, los números cortos, los mensajes SMS y las llamadas internacionales no están incluidos en las asignaciones y se cobrarán a tarifas específicas.",
    "customers.label.InternationalRates":
      "Las llamadas y mensajes desde los Países Bajos a otros países se cobrarán a nuestras tarifas internacionales estándar:",
    "customers.label.RoamingInEEA": "Itinerancia en el EEE",
    "customers.label.RoamingOutsideEEA": "Itinerancia fuera del EEE",
    "customers.label.RoamingCharges":
      "El uso de su teléfono (llamadas, mensajes y datos) en itinerancia fuera de los Países Bajos o del EEE y en destinos seleccionados se cobrará a nuestras tarifas de itinerancia internacional.",
    "customers.label.Any_Out_of_bundle_charges_can_be_found_at":
      "Cualquier cargo fuera del paquete se puede encontrar en:",
    "customers.label.Exclusions_for_voice_international_voice_SMS_Data_Roaming_can_be_found_at":
      "Las exclusiones para voz, voz internacional, SMS y roaming de datos se pueden encontrar en:",
    "customers.label.Our_Services_availability":
      "Nuestros servicios no están disponibles en todas partes de los Países Bajos, el EEE u otros destinos seleccionados. El uso aceptable de nuestros servicios está incluido en nuestra Política de Uso Justo Nacional y de Roaming en:",
    "customers.label.Lycamobile_network_speeds":
      "El servicio de datos y las velocidades mínimas y máximas asociadas disponibles a través de la red de Lycamobile dependen de la tecnología accesible, por ejemplo, 2G, Edge, 3G, 4G, 5G en su ubicación, el dispositivo utilizado y el tipo de plan que ha comprado.",
    "customers.label.Mobile_data_speed_variation":
      "La velocidad de su servicio de datos móviles puede variar y depende de su ubicación, el entorno que lo rodea (clima, cobertura de árboles, materiales utilizados en los edificios cercanos y la cantidad de personas que usan la red) y el dispositivo utilizado para conectarse a la red.",
    "customers.label.Price": "Precio",
    "customers.label.ContractReview": "Revisión del contrato",
    "customers.label.Terms&Conditions": "Términos y condiciones",
    "customers.label.ReviewThisContract": "Revisar este contrato",
    "customers.label.We_have_sent_these_to": "Los hemos enviado a",
    "customers.label.DownloadContractInformation":
      "Descargar información del contrato",
    "customers.label.DownloadContractSummary": "Descargar resumen del contrato",
    "customers.label.ContractInformation": "Información del contrato",
    "customers.label.ContactDetails": "Detalles de contacto",
    "customers.label.Description_of_Services": "Descripción de los servicios",
    "customers.label.This_contract_summary_and_our_Abonnement_offer_of":
      "Este resumen del contrato y nuestra oferta de suscripción de",
    "customers.label.an_airtime_service_for": "un servicio de tiempo aire para",
    "customers.label.comes_with:": "incluye:",
    "customers.label.Any_Out_of_bundle_charges_can_be_found_at:":
      "Cualquier cargo fuera del paquete se puede encontrar en:",
    "customers.label.service_description":
      "que le permite realizar y recibir llamadas de voz, enviar y recibir SMS, datos y acceder a Internet, todo a través de la red, junto con cualquier servicio adicional opcional que acordemos proporcionar y que elija recibir.",
    "customers.label.YouHaveChosenNoCap":
      "Ha elegido sin límite. Esto significa que podrá usar su teléfono para llamadas, mensajes, minutos internacionales, roaming y datos fuera de su asignación mensual. Se le cobrará hasta 60 € por esto.",
    "customers.label.SelectDate":
      "Seleccionar fecha [El pago mensual se debitará de su cuenta 14 días después de la fecha de generación de la factura elegida] *",
    "customers.label.billing_cycle": "Ciclo de facturación",
    "customers.label.SelectBilling": "Seleccionar facturación",
    "customers.label.I_Agree_To": "Estoy de acuerdo con",
    "customers.label.TermsAndConditions": "Términos y Condiciones",
    "customers.label.ThisNumberIsReservedFor":
      "Este número está reservado para",
    "customers.label.TotalPrice": "Precio total:",
    "customers.label.CustomerInfo": "Información del Cliente",
    "customers.label.title": "Título",
    "customers.label.SelectTitle": "Seleccionar título",
    "customers.label.initials": "Iniciales",
    "customers.label.Basket": "Cesta",
    "customers.label.first_name": "Nombre",
    "customers.label.last_name": "Apellido",
    "customers.label.email_address": "Correo electrónico",
    "customers.label.contact_number": "Número de contacto",
    "customers.label.date_of_birth": "Fecha de nacimiento",
    "customers.label.select_language": "Seleccionar idioma",
    "customers.label.how_did_you_hear": "¿Cómo se enteró de nosotros?",
    "customers.label.postal_code": "Código postal",
    "customers.label.country": "País",
    "customers.label.Enter_address_manually": "Ingresar dirección manualmente",
    "customers.label.Find_address": "Buscar dirección",
    "customers.label.Select_Address": "Seleccionar dirección",
    "customers.label.Select_an_address": "Seleccionar una dirección",
    "customers.label.Enter_address_dynamically":
      "Ingresar dirección dinámicamente",
    "customers.label.address_number": "Número de dirección",
    "customers.label.street": "Calle",
    "customers.label.state": "Estado",
    "customers.label.city": "Ciudad",
    "customers.label.resident_period": "Período de residencia",
    "customers.label.Spend_Cap_Amount": "Monto del límite de gasto",
    "customers.label.I_don’t_want_a_Spend_Cap": "No quiero un límite de gasto",
    "customers.label.Monthly_Bill_Generation_Date":
      "Fecha de generación de factura mensual",
    "customers.label.Select_a_Monthly_Plan": "Seleccionar un plan mensual",
    "customers.label.Search_plans": "Buscar planes...",
    "customers.label.search": "Buscar",
    "customers.label.Select_a_plan": "Seleccionar un plan",
    "customers.label.Basket": "Cesta",
    "customers.label.This_number_is_reserved_for":
      "Este número está reservado para",
    "customers.label.ViewT&C": "Ver términos y condiciones",
    "customers.label.TransferringFromPreviousNetwork":
      "Transferencia desde la red anterior (Trae tu número antiguo)",
    "customers.label.SIM_Information": "Información de SIM",
    "customers.label.Prepaid": "Prepago",
    "customers.label.Postpaid": "Pospago",
    "customers.label.Physical_SIM": "SIM Física",
    "customers.label.eSIM": "eSIM",
    "customers.label.SelectCustomerType": "Seleccionar tipo de cliente",
    "customers.label.New_to_Lyca": "Nuevo en Lyca",
    "customers.label.Convert_Lyca_Prepaid_to_Postpaid":
      "Convertir Lyca Prepago a Pospago",
    "customers.label.Existing_customer_is_going_to_be_sent_a_secure_link_to_confirm_that_they_wish_to_move_from_prepaid_to_abonnement.":
      "Se enviará un enlace seguro al cliente existente para confirmar que desea pasar de prepago a suscripción.",
    "customers.label.Customer_to_receive_an_SMS": "El cliente recibirá un SMS",
    "customers.label.Lyca_Mobile_Number": "Número de Lyca Mobile",
    "customers.label.Enter_the_Lyca_Mobile_Number":
      "Ingrese el número de Lyca Mobile",
    "customers.label.Nationality": "Nacionalidad",
    "customers.label.Send_Secure_link": "Enviar enlace seguro",
    "customers.label.New_to_Lyca_Mobile": "Nuevo en Lyca Mobile",
    "customers.label.serial_number": "Número de serie",
    "customers.label.Serial_Number": "Número de serie (últimos 4 dígitos)",
    "customers.label.PUK_Code": "Código PUK",
    "customers.label.PUK_Code_is_not_matched": "El código PUK no coincide",
    "customers.label.Switching_to_Lyca_Mobile": "Cambio a Lyca Mobile",
    "customers.label.Enter_the_PUK_Code": "Ingrese el código PUK",
    "customers.label.Basket": "Cesta",
    "customers.label.Gender": "Género",
    "customers.label.business_name": "Nombre de la empresa",
    "customers.label.phone_number": "Número de teléfono",
    "customers.label.Date_of_Birth": "Fecha de nacimiento",
    "customers.label.VIP": "VIP",
    "customers.label.Disability": "Discapacidad",
    "customers.label.District": "Distrito",
    "customers.label.Is_your_billing_address_same_as_primary_address":
      "¿Su dirección de facturación es la misma que la dirección principal?",
    "customers.label.Supressbill": "Suprimir factura",
    "customers.label.SelectCategory": "Seleccionar categoría",
    "customers.label.SelectGender": "Seleccionar género",
    "customers.label.SelectPreferences": "Seleccionar preferencias",
    "customers.label.SelectNationality": "Seleccionar nacionalidad",
    "customers.label.SelectVIP": "Seleccionar VIP",
    "customers.label.SelectDisability": "Seleccionar discapacidad",
    "customers.label.SelectCity": "Seleccionar ciudad",
    "customers.label.SelectBillDay": "Seleccionar día de facturación",
    "customers.label.SelectType": "Seleccionar tipo",
    "customers.label.SelectFiscalYear": "Seleccionar año fiscal",
    "customers.label.SelectFiscalQuarter": "Seleccionar trimestre fiscal",
    "customers.label.SelectBillMode": "Seleccionar modo de facturación",
    "customers.label.SelectInvoiceType": "Seleccionar tipo de factura",
    "customers.label.IMSI": "IMSI",
    "customers.label.SalesMotion": "Movimiento de ventas",
    "customers.label.SpendCap": "Límite de gasto",
    "customers.label.ActivationDate": "Fecha de activación",
    "customers.label.ExpiryDate": "Fecha de vencimiento",
    "customers.label.NextRenewalDate": "Fecha de renovación",
    "customers.label.BalanceTransfer": "Transferencia de saldo",
    "customers.label.RecieverClientId": "ID del cliente receptor",
    "customers.label.Amount": "Monto",
    "customers.label.EnterTopUpAmount": "Ingrese el monto de recarga",
    "customers.label.ResponseId": "ID de respuesta",
    "customers.label.BalanceName": "Nombre del saldo",
    "customers.label.Allowance": "Subsidio",
    "customers.label.Consumption": "Consumo",
    "customers.label.AvailableBalance": "Saldo disponible",
    "customers.label.DaysLeft": "Días restantes",
    "customers.label.Discount": "Descuento",
    "customers.label.postal_code": "Código postal",
    "customers.label.address_number": "Número de dirección",
    "customers.label.city": "Ciudad",
    "customers.label.state": "Estado",
    "customers.label.country": "País",
    "customers.label.resident_period": "Período de residencia",
    "customers.label.postcode": "Código postal",
    "customers.label.comment_date": "Fecha del comentario",
    "customers.label.how_did_you_hear": "¿Cómo supiste de nosotros?",
    "customers.label.select_language": "Seleccionar idioma",
    "customers.label.email_address": "Dirección de correo electrónico",
    "customers.label.contact_number": "Número de contacto",
    "customers.label.initials": "Iniciales",
    "customers.label.communication_type": "Tipo de Comunicación",
    "customers.label.BuySIM": "Comprar SIM",
    "customers.label.origination": "Origen",
    "customers.label.address": "Dirección",
    "customers.label.destination_address": "Dirección de Destino",
    "customers.label.event": "Evento",
    "customers.label.charge_party": "Parte Cobrada",
    "customers.label.service_subs_type": "Tipo de Suscripción de Servicio",
    "customers.label.calling_party": "Parte Llamante",
    "customers.label.called_party": "Parte Llamada",
    "customers.label.usage": "Uso",
    "customers.label.monetary_charge": "Cargo Monetario",
    "customers.label.result_code": "Código de Resultado",
    "customers.label.generation_time": "Tiempo de Generación",
    "customer.label.generationdatetime": "Fecha y Hora de Generación",
    "customers.label.transaction_id": "ID de Transacción",
    "customers.label.application_transaction_id":
      "ID de Transacción de la Aplicación",
    "customers.label.application_name": "Nombre de la Aplicación",
    "customers.label.recharge_value": "Valor de Recarga",
    "customers.label.interface": "Interfaz",
    "customers.label.result": "Resultado",
    "customers.label.comment": "Comentario",
    "customers.label.recharge": "Recargar",
    "customers.label.cdr": "CDR",
    "customers.label.notifications": "Notificaciones",
    "customers.label.mobile_no": "Enter Mobile No",
    "customers.label.email_id": "Enter Email Id",
    "customers.label.serial_number": "Serial No",
    "customers.label.digital_content": "Contenido Digital",
    "customers.label.buySim": "Comprar SIM",
    "customers.label.outstanding_due": "Saldo Pendiente",
    "customers.label.due_date": "Fecha de Vencimiento",
    "customers.label.unbilled_amount": "Cantidad No Facturada",
    "customers.label.next_bill_day": "Próximo Día de Facturación",
    "customers.label.view_allowances": "Ver Permisos",
    "customers.label.view_service_details": "Ver detalles del servicio",
    "customers.label.spend_limit": "Límite de Gasto",
    "customers.label.topup_balance": "Recargar Saldo",
    "customers.label.next_renewal_date": "Próxima Fecha de Renovación",
    "customers.label.allowance": "Asignación",
    "customers.label.ViewDocumentUpload": "Ver carga de documentos",
    "customers.label.total_net_amount": "Monto Neto Total",
    "customers.label.cancelRemark": "Cancelar comentario",
    "customers.label.cancelPayment": "Cancelar pago",
    "customers.label.all": "Todo",
    "customers.label.billProfile": "Perfil de Facturación",
    "customers.label.charges": "Cargos",
    "customers.label.book_order": "Pedido de Libro",
    "customers.label.customers": "Clientes",
    "customers.label.search_for_clients": "Buscar clientes",
    "customers.label.advance_search": "Búsqueda avanzada",
    "customers.label.create_customer": "Crear cliente",
    "customers.label.account_no": "Número de cuenta",
    "customers.label.customer_name": "Nombre del cliente",
    "customers.label.business_entity": "Entidad comercial",
    "customers.label.serial_no": "Número de serie",
    "customers.label.balance": "Saldo",
    "customers.label.created_by": "Creado por",
    "customers.label.created_on": "Creado el",
    "customers.label.credit_limit": "Límite de crédito",
    "customers.label.transaction_history": "Historial de transacciones",
    "customers.label.external_activity_log": "Registro de actividad externa",
    "customers.label.settings": "Configuraciones",
    "system.label.currency_noncurrency": "Divisa No-Divisa",
    "entity.label.configure": "Configurar",

    "customers.label.valid_from": "Válido desde",
    "customers.label.valid_to": "Válido hasta",
    "customers.label.non_currency_details": "Detalles no monetarios",
    "customers.label.view_details": "Ver detalles",
    "customers.label.status": "Estado",
    "customers.label.first_name": "Nombre",
    "customers.label.price_discount": "Precio y Descuento",
    "customers.label.collection_status": "Estado de la colección",
    "customers.label.last_name": "Apellido",
    "customers.label.city_area": "Ciudad/Zona",
    "customers.label.email": "Correo electrónico",
    "customers.label.phone": "Teléfono",
    "customers.label.cafid": "CAF Id",
    "customers.label.enter_business_entity": "Ingresar entidad comercial",
    "customers.label.select": "Seleccionar",
    "customers.label.refund": "Reembolso",
    "customers.label.refund_id": "ID de reembolso",
    "customers.label.refund_amount": "Monto del reembolso",
    "customers.label.select_category_type": "Seleccionar Tipo de Categoría",
    "customers.label.clear": "Limpiar",
    "customers.label.search": "Buscar",
    "customers.label.customer_activation": "Activación del Cliente",
    "customers.label.customer_details": "Detalles del Cliente",
    "customers.label.loc": "LOC",
    "customers.label.customer_category": "Categoría del Cliente",
    "customers.label.service_details": "Detalles del Servicio",
    "customers.label.name": "Nombre",
    "customers.label.add_service": "Agregar Servicio",
    "customers.label.network_node": "Nodo de Red",
    "customers.label.device_details": "Detalles del Dispositivo",
    "customers.label.item": "Artículo",
    "customers.label.discount_code": "Código de Descuento",
    "customers.label.total_price": "Precio Total",
    // "customers.label.device_details": "Detalles del dispositivo",
    "customers.label.plan_details": "Detalles del plan",
    "customers.label.payment_details": "Detalles del pago",
    "customers.label.plan_list": "Lista de planes",
    "customers.label.plan": "Plan",
    "customers.label.contract_period": "Período de contrato",
    "customers.label.charge_cycle": "Ciclo de carga",
    "customers.label.cancel": "Cancelar",
    "customers.label.next": "Siguiente",
    "customers.label.done": "Hecho",
    "customers.label.reopen": "Reabrir",
    "customers.label.submit": "Enviar",
    "customers.label.view_customer": "Ver cliente",
    "customers.label.account_number": "Número de cuenta",
    "customers.label.office_hierarchy": "Jerarquía de oficina",
    "customers.label.account_type": "Tipo de cuenta",
    // "customers.label.balance": "Saldo",
    "customers.label.stb_serial_no": "Número de serie STB",
    "customers.label.non_currency_balance": "Saldo no monetario",
    "customers.label.service_orders": "Órdenes de servicio",
    "customers.label.more_info": "Más información",
    "customers.label.notes": "Notas",
    "customers.label.device": "Dispositivo",
    "customers.label.tickets": "Boletos",
    "customers.label.on_demand": "A petición",
    "customers.label.on_demand_billing": "Facturación bajo demanda",
    "customers.label.account_transaction": "Transacción de cuenta",
    "customers.label.payments": "Pagos",
    "customers.label.invoice": "Factura",
    "customers.label.contact_information": "Información de contacto",
    "customers.label.address_information": "Información de dirección",
    "customers.label.billing_information": "Información de facturación",
    "customers.label.balance_information": "Información de saldo",
    // "customers.label.customer_name": "Nombre del cliente",
    "customers.label.parent_child": "Padre/Hijo",
    "customers.label.created_date": "Fecha de creación",
    "customers.label.district": "Distrito",
    "customers.label.pincode": "Código postal",
    "customers.label.last_bill_amount": "Último importe de la factura",
    "customers.label.last_bill_date": "Fecha de la última factura",
    "customers.label.last_bill_paid": "Última factura pagada",
    "customers.label.last_paid_amount": "Último importe pagado",
    "customers.label.last_payment_date": "Fecha del último pago",
    "customers.label.next_bill_date": "Fecha de la próxima factura",
    "customers.label.service_overview": "Resumen del servicio",
    "customers.label.service_without_device": "Servicio sin dispositivo",
    "customers.label.create_ticket": "Crear ticket",
    "customers.label.service_activation": "Activación del servicio",
    "customers.label.order_charging": "Carga de pedido",
    "customers.label.top_up": "Completar",
    "customers.label.redeem": "Canjear",
    "customers.label.collection_name": "Nombre de la colección",
    "customers.label.redeem_voucher": "Canjear cupón",
    "customers.label.service_id": "ID del servicio",
    "customers.label.service_code": "Código de servicio",
    "customers.label.start_date": "Fecha de inicio",
    "customers.label.modified_date": "Fecha de modificación",
    // "customers.label.status": "Estado",
    "customers.label.info": "Información",
    "customers.label.action": "Acción",
    "customers.label.add_device": "Agregar dispositivo",
    "customers.label.add_plans": "Agregar planes",
    "customers.label.suspend": "Suspender",
    "customers.label.reactivate": "Reactivar",
    "customers.label.terminate": "Terminar",
    "customers.label.command_center": "Centro de comando",
    "customers.label.retrack": "Rehacer el seguimiento",
    "customers.label.cancel_plans": "Cancelar planes",
    "customers.label.device_overview": "Resumen del dispositivo",
    "customers.label.item_code": "Código del artículo",
    "customers.label.orders_overview": "Resumen de pedidos",
    // "customers.label.plan": "Plan",
    "customers.label.end_date": "Fecha de finalización",
    "customers.label.price": "Precio",
    "customers.label.short_description": "Breve descripción",
    "customers.label.description": "Descripción",
    "customers.label.add_note": "Agregar nota",
    "customers.label.note": "Nota",
    "customers.label.sale_type": "Tipo de venta",
    "customers.label.bill_item_details": "Detalles del artículo de la factura",
    "customers.label.charge_id": "ID de cargo",
    "customers.label.order_id": "ID de pedido",
    "customers.label.item_tax_details": "Detalles del impuesto del artículo",
    "customers.label.discount_details": "Detalles del descuento",
    "customers.label.sale_date": "Fecha de venta",
    "customers.label.charge_code": "Código de carga",
    "customers.label.quantity": "Cantidad",
    // "customers.label.total_price": "Precio total",
    "customers.label.warranty_date": "Fecha de garantía",
    "customers.label.allocate": "Asignar",
    "customers.label.contact_info": "Información de contacto",
    "customers.label.edit_customer": "Editar cliente",
    "customers.label.lco": "LCO",
    "customers.label.title": "Título",
    // "customers.label.customer_category": "Categoría del cliente",
    "customers.label.middle_name": "Segundo Nombre",
    "customers.label.caf_id": "ID CAF",
    "customers.label.landline_number": "Número de teléfono fijo",
    "customers.label.user_name": "Nombre de usuario",
    "customers.label.customer_photo": "Foto del cliente",
    "customers.label.id_proof": "Prueba de identidad",
    "customers.label.id_proof_value": "Valor de la prueba de identidad",
    "customers.label.save": "Guardar",
    "customers.label.close_customer": "Cerrar cliente",
    "customers.label.closure_date": "Fecha de cierre",
    "customers.label.closure_reason": "Motivo de cierre",
    "customers.label.close": "Cerrar",
    "customers.label.address_info": "Información de dirección",
    "customers.label.edit_address": "Editar dirección",
    "customers.label.address_no": "Número de dirección",
    "customers.label.street": "Calle",
    "customers.label.building": "Edificio",
    "customers.label.zipcode": "Código postal",
    "customers.label.billing": "Facturación",
    "customers.label.same_as_primary": "Igual que el Primario",
    "customers.label.building_code": "Código de Edificio",
    "customers.label.add_address": "Agregar dirección",
    "customers.label.address_type": "Tipo de dirección",
    "customers.label.billing_info": "Información de facturación",
    "customers.label.created_adjustment": "Ajuste creado",
    "customers.label.create_order": "Crear orden",
    "customers.label.sale_catalog": "Catálogo de ventas",
    "customers.label.renew_plan": "Renovar Plan",
    "customers.label.auto_renew": "Renovación automática",
    // "customers.label.search": "Buscar",
    "customers.label.entity_name": "Nombre de la entidad",
    "customers.label.discount": "Descuento",
    "customers.label.provisioning_commands": "Comandos de aprovisionamiento",
    "customers.label.command": "Comando",
    "customers.label.plans": "Planes",
    "customers.label.client_service_detail": "Detalle del servicio al cliente",
    "customers.label.id": "Id",
    "customers.label.parameter_name": "Nombre del parámetro",
    "customers.label.parameter_value": "Valor del parámetro",
    "customers.label.request_type": "Tipo de solicitud",
    "customers.label.client_info": "Información del cliente",
    "customers.label.service_info": "Información del servicio",
    "customers.label.new_device_info": "Información del nuevo dispositivo",
    "customers.label.task_list": "Lista de tareas",
    "customers.label.provisioning_detail": "Detalle de aprovisionamiento",
    "customers.label.provisioning_id": "ID de aprovisionamiento",
    "customers.label.task_id": "ID de tarea",
    "customers.label.sent_message": "Mensaje enviado",
    "customers.label.available_plans": "Planes disponibles",
    "customers.label.disconnect_order": "Orden de desconexión",
    "customers.label.reason": "Razón",
    "customers.label.porting_out": "Portando",
    "customers.label.prepaid_to_postpaid": "Prepago a pospago",
    "customers.label.postpaid_to_prepaid": "De pospago a prepago",
    "customers.label.addons": "Complementos",
    "customers.label.change_plan": "Cambiar plan",
    "customers.label.swap_sim": "Cambiar la SIM",
    "customers.label.select_date": "Seleccionar fecha",
    "customers.label.order_date": "Fecha de pedido",
    "customers.label.priority": "Prioridad",
    "customers.label.ticket_date": "Fecha del ticket",
    "customers.label.category": "Categoría",
    "customers.label.sub_category": "Subcategoría",
    "customers.label.team": "Equipo",
    "customers.label.team_user": "Usuario del equipo",
    "customers.label.source": "Fuente",
    "customers.label.due_time": "Hora de vencimiento",
    "customers.label.device_swap": "Intercambio de dispositivo",
    // "customers.label.terminate": "Terminar",
    "customers.label.confirm": "Confirmar",
    "customers.label.continue": "Continuar",
    "customers.label.process_date": "Fecha de proceso",
    "customers.label.pin_number": "Número de PIN",
    "customers.label.renewal": "Renovación",
    // "customers.label.create_customer": "Crear cliente",
    "customers.label.individual": "Individual",
    "customers.label.corporate": "Corporativo",
    "customers.label.corporate_details": "Detalles corporativos",
    "customers.label.contact_person": "Persona de contacto",
    "customers.label.entity": "Entidad",
    "customers.label.client_category": "Categoría de cliente",
    "customers.label.preferences": "Preferencias",
    "customers.label.parent_id": "ID Padre",
    "customers.label.child": "Hijo",
    "customers.label.villege_street": "Pueblo/Calle",
    "customers.label.billing_address": "Dirección de facturación",
    "customers.label.bill_information": "Información de factura",
    "customers.label.bill_day_of_month": "Día de la factura del mes",
    "customers.label.fiscal_year": "Año fiscal",
    "customers.label.fiscal_quater": "Trimestre fiscal",
    "customers.label.bill_mode": "Modo de factura",
    "customers.label.invoice_type": "Tipo de factura",
    "customers.label.payment_information": "Información de pago",
    "customers.label.funder_name": "Nombre del financiador",
    "customers.label.funder_id": "ID del financiador",
    "customers.label.po_number": "Número de orden de compra",
    "customers.label.payment_term": "Término de pago",
    "customers.label.customer_created_successfully":
      "Cliente creado exitosamente",
    "customers.label.go_to_customer": "Ir al cliente",
    "customers.label.view_order": "Ver orden",
    "customers.label.disconnect": "Desconectar",
    "customers.label.apply_promo": "Aplicar promoción",
    // "customers.label.order_id": "ID de pedido",
    "customers.label.order_type": "Tipo de pedido",
    "customers.label.billing_cycle": "Ciclo de facturación",
    "customers.label.plan_name": "Nombre del plan",
    "customers.label.user_action": "Acción del usuario",
    "customers.label.invoice_till_date": "Factura hasta la fecha",
    "customers.label.order_services": "Servicios del pedido",
    "customers.label.service_type": "Tipo de servicio",
    "customers.label.service_description": "Descripción del servicio",
    "customers.label.bill_start_date": "Fecha de inicio de la factura",
    "customers.label.bill_end_date": "Fecha de finalización de la factura",
    // "customers.label.invoice_till_date": "Factura hasta la fecha",
    "customers.label.charge_type": "Tipo de cargo",
    "customers.label.rate_uom": "Tarifa/UOM",
    "customers.label.discount_description": "Descripción del descuento",
    "customers.label.discount_type": "Tipo de descuento",
    "customers.label.discount_start_date": "Fecha de inicio del descuento",
    "customers.label.discount_end_date": "Fecha de finalización del descuento",
    "customers.label.discount_amount": "Cantidad del descuento",
    "customers.label.order_transaction": "Transacción de pedido",
    "customers.label.user": "Usuario",
    "customers.label.transaction_date": "Fecha de transacción",
    "customers.label.transaction_type": "Tipo de transacción",
    "customers.label.actual_date": "Fecha real",
    "customers.label.promo": "Promo",
    "customers.label.promotion": "Promoción",
    "customers.label.disconnection_date": "Fecha de desconexión",
    "customers.label.disconnection_reason": "Motivo de la desconexión",
    "customers.label.problem_code": "Código de problema",
    "customers.label.assign_to": "Asignar a",
    "customers.label.last_comment": "Último comentario",
    "customers.label.file_name": "Nombre de archivo",
    "customers.label.edit_ticket": "Editar ticket",
    "customers.label.close_ticket": "Cerrar ticket",
    "customers.label.resolution_description": "Descripción de la resolución",
    "customers.label.ticket_history": "Historial de tickets",
    // "customers.label.last_comment": "Último comentario",
    "customers.label.problem_description": "Descripción del problema",
    "customers.label.generate": "Generar",
    "customers.label.bill_date": "Fecha de factura",
    "customers.label.amount": "Cantidad",
    "customers.label.statement": "Declaración",
    // "customers.label.due_date": "Fecha de vencimiento",
    "customers.label.promotional_message": "Mensaje promocional",
    "customers.label.download": "Descargar",
    "customers.label.due_amount": "Cantidad debida",
    "customers.label.transactions": "Transacciones",
    "customers.label.file": "Archivo",
    "customers.label.reset": "Restablecer",
    "customers.label.order_details": "Detalles del pedido",
    "customers.label.make_payment": "Realizar pago",
    "customers.label.credit_amount": "Monto acreditado",
    "customers.label.debit_amount": "Monto debitado",
    "customers.label.cancel_remark": "Observación de cancelación",
    "customers.label.pay_invoice": "Pagar factura",
    "customers.label.account": "Cuenta",
    "customers.label.deposit": "Depósito",
    "customers.label.payment_date": "Fecha de pago",
    "customers.label.receipt_no": "Número de recibo",
    "customers.label.cheque_no": "Número de cheque",
    "customers.label.bank_name": "Nombre del banco",
    "customers.label.branch_name": "Nombre de la sucursal",
    "customers.label.cheque_date": "Fecha del cheque",
    "customers.label.invoice_id": "ID de factura",
    "customers.label.invoice_date": "Fecha de factura",
    "customers.label.invoice_amount": "Importe de la factura",
    // "customers.label.due_amount": "Importe adeudado",
    "customers.label.payment_reversal": "Reversión de pago",
    "customers.label.date_filter": "Filtro de fecha",
    "customers.label.add_event_order": "Agregar orden de evento",
    "customers.label.event_order": "Orden de Evento",
    "customers.label.eventdate": "Fecha del evento",
    "customers.label.serviceAddress": "Dirección de servicio",
    "customers.label.event_name": "Nombre del evento",
    "customers.label.booked_date": "Fecha reservada",
    "customers.label.event_price": "Precio del evento",
    "customers.label.events": "Eventos",
    "customers.label.format_type": "Tipo de formato",
    "customers.label.opt_type": "Tipo OPT",
    "customers.label.client_bill_profile": "Perfil de factura del cliente",
    "customers.label.edit": "Editar",
    "customers.label.type": "Tipo",
    "customers.label.client_id": "ID de cliente",
    "customers.label.bill_frequency": "Frecuencia de facturación",
    "customers.label.bill_segment": "Segmento de facturación",
    // "customers.label.next_bill_day": "Próximo día de facturación",
    "customers.label.last_bill_day": "Último día de facturación",
    "customers.label.last_bill_no": "Número de última factura",
    "customers.label.bill_suppression_flag":
      "Indicador de supresión de factura",
    "customers.label.bill_suppression_id": "ID de supresión de factura",
    "customers.label.first_bill": "Primera factura",
    "customers.label.hot_bill": "Factura urgente",
    "customers.label.edit_bill_profile": "Editar perfil de factura",
    "customers.label.bill_currency": "Moneda de la factura",
    "customers.label.bill_suppression": "Supresión de factura",
    // "customers.label.more_info": "Más información",
    "customers.label.identities": "Identidades",
    "customers.label.add_client_identities": "Agregar identidades del cliente",
    "customers.label.unique_identification": "Identificación única",
    "customers.label.identity_documents": "Documentos de identidad",
    "customers.label.additional_info": "Información adicional",
    "customers.label.nationality": "Nacionalidad",
    "customers.label.date_of_birth": "Fecha de nacimiento",
    "customers.label.preferred_language": "Idioma preferido",
    "customers.label.finance_id": "ID financiero",
    "customers.label.remarks": "Observaciones",
    "customers.label.preferred_communication": "Comunicación preferida",
    "customers.label.add_client_identifier": "Agregar identificador de cliente",
    "customers.label.document_type": "Tipo de documento",
    "customers.label.document_uploads": "Cargas de documentos",
    "customers.label.select_file": "Seleccionar archivo",
    "customers.label.credit_card_details": "Detalles de la tarjeta de crédito",
    "customers.label.card_number": "Número de tarjeta",
    "customers.label.cvv": "CVV",
    "customers.label.card_type": "Tipo de tarjeta",
    "customers.label.expiry_date": "Fecha de vencimiento",
    "customers.label.ach_card": "Tarjeta ACH",
    "customers.label.ach_card_routing_number":
      "Número de enrutamiento de tarjeta ACH",
    "customers.label.bank_account_number": "Número de cuenta bancaria",
    "customers.label.childs": "Hijos",
    "customers.label.cell_phone": "Teléfono celular",
    "customers.label.create_client_additional_info":
      "Crear información adicional del cliente",
    "customers.label.gender": "Género",
    "customers.label.id_type": "Tipo de identificación",
    // "customers.label.nationality": "Nacionalidad",
    "customers.label.id_number": "Número de identificación",
    "customers.label.job_title": "Cargo",
    "customers.label.age_group": "Grupo de edad",
    "customers.label.uts_customer_id": "ID de cliente de UTS",
    "customers.label.ach_card_name": "Nombre de la tarjeta ACH",
    "customers.label.adjustment": "Ajuste",
    // "customers.label.created_adjustment": "Ajuste creado",
    "customers.label.adjustment_date": "Fecha de ajuste",
    "customers.label.adjustment_code": "Código de ajuste",
    "customers.label.adjustment_amount": "Monto del ajuste",
    "customers.label.adjustment_type": "Tipo de ajuste",
    "customers.label.activity_log": "Registro de actividad",
    "customers.label.office_id": "ID de oficina",
    "customers.label.history": "Historia",
    "customers.label.filter_by_date": "Filtrar por fecha",
    "customers.label.view_usage_details": "Ver detalles de uso",
    "customers.label.units": "Unidades",
    "customers.label.tax": "Impuesto",
    "customers.label.total_amount": "Monto total",
    "customers.label.csv_pdf": "CSV/PDF",
    "customers.label.charge_description": "Descripción del cargo",
    "customers.label.journals": "Diarios",
    "customers.label.download_financial_summary_data":
      "Descargar datos resumidos financieros",
    "customers.label.select_from_date": "Seleccionar desde la fecha",
    "customers.label.select_to_date": "Seleccionar hasta la fecha",
    "customers.label.village_street": "Aldea/Calle",
    "customers.label.previous": "Anterior",
    "customers.label.Disconnect": "Desconectar",
    "customers.label.ApplyPromo": "Aplicar Promoción",
    "customers.label.Service": "Servicio",
    "customers.label.Product": "Producto",
    "customers.label.CreditCard": "Tarjeta de Crédito",
    "customers.label.Paypal": "Paypal",
    "customers.label.BusinessEntity": "Entidad Comercial",
    "customers.label.Plan": "Plan",
    "customers.label.Phone": "Teléfono",
    "customers.label.TaxExemption": "Exención de Impuestos",
    "customers.label.YES": "SÍ",
    "customers.label.NO": "NO",
    "customers.label.Resolution": "Resolución",
    "customers.label.AccountNo": "Número de Cuenta",
    "customers.label.ChipId": "Id de Chip",
    "customers.label.MobileNo": "Número de Móvil",
    "customers.label.EmailId": "Id de Correo Electrónico",
    "customers.label.SerialNo": "Número de Serie",
    "customers.label.LegacyNo": "Número Heredado",
    "customers.label.searchclient": "Buscar Cliente",
    "customers.label.PrimaryAddress": "Dirección Principal",
    "customers.label.BillingAddress": "Dirección de Facturación",
    // "customers.label.lco": "lco",
    "customers.label.EventDate": "Fecha del Evento",
    "customers.label.CreateAdjustment": "Crear Ajuste",
    "customers.label.full_name": "Nombre completo",
    "customers.label.bill_collection_action": "Acción de Cobro de Factura",
    "customers.label.collection_actions": "Acciones de Cobro",
    "customers.label.action_name": "Nombre de la Acción",
    "customers.label.action_date": "Fecha de la Acción",
    "customers.label.balance_due": "Saldo Pendiente",
    "customers.label.bill_id": "ID de Factura",
    "customers.label.view_goods_receipt": "Ver recibo de mercancías",
    "customers.label.payinfo": "Información de Pago",
    "customers.label.cardtoken": "Token de Tarjeta",
    "customers.label.autopay": "Pago Automático",
    "customers.label.paynow": "Pagar Ahora",
    "customers.label.featureList": "Lista de Características",
    "customers.label.consumed": "Consumido",
    "customers.label.updateCreditLimt": "Actualizar Límite de Crédito",
    "customers.label.PendingForApproval": "Pendiente de Aprobación",

    "customers.label.SpendCapHistory": "Historial del límite de gasto",
    "customers.label.DateTime": "Fecha y hora",
    "customers.label.SpendCapEventName": "Nombre del evento de gasto",
    "customers.label.SpendingLimit": "Límite de gasto",
    "customers.label.ConsumedLimit": "Límite consumido",
    "customers.label.EventId": "ID del evento",
    "customer.label.collectionStatus": "Estado de la colección",
  },
  pt: {
    "customers.label.temporaryBlock": "Bloqueio Temporário",
    "customers.label.unBlock": "Desbloquear",
    "customers.label.feedback": "Feedback",
    "customers.label.event_id": "ID do evento",
    "customers.label.slc_state_history": "Histórico do estado SLC",
    "customers.label.slc": "SLC",
    "customers.label.state_Change_Time": "Hora de mudança de estado",
    "customers.label.event": "Evento",
    "customers.label.previous_state": "Estado anterior",
    "customers.label.resolution_date": "Data de resolução",
    "customers.label.current_state": "Estado atual",
    "customers.label.created_time": "Hora de criação",
    "customers.label.creation_time": "Hora de criação",
    "customers.label.Promotion": "Promoção",
    "customers.label.slc_status": "Status SLC",
    "customers.label.update_slc_status": "Atualizar status SLC",
    "customers.label.temporary_block": "Bloqueio temporário",
    "customers.label.workflow_id": "ID do fluxo de trabalho",
    "customers.label.externalPromoId": "ID Promo Externa",
    "customers.label.externalPromoName": "Nome Promo Externa",
    "customers.label.promoCode": "Código Promocional",
    "customers.label.promoDescription": "Descrição da Promoção",
    "customers.label.ScheduleOrder": "Agendar pedido",
    "customers.label.ScheduledDate": "Data agendada",
    "customers.label.ViewRateLimit": "Ver limite de taxa",
    "customers.label.SelectType": "Selecionar tipo",
    "customers.label.search": "Pesquisar",
    "customers.label.SelectTaxExemption": "Selecionar isenção de impostos",
    "customers.label.ViewTickets": "Ver bilhetes",
    "customers.label.TicketHistory": "Histórico de bilhetes",
    "customers.label.ReopenTicket": "Reabrir bilhete",
    "customers.label.SelectInvoiceType": "Selecionar tipo de fatura",
    "customers.label.SelectCategory": "Selecionar categoria",
    "customers.label.SelectSubCategory": "Selecionar subcategoria",
    "customers.label.SelectSource": "Selecionar fonte",
    "customers.label.TicketHistory": "Histórico de tickets",
    "customers.label.ViewSpendCap": "Ver limite de gastos",
    "customers.label.ResponseMessage": "Mensagem de resposta",
    "customers.label.AddPlan": "Adicionar plano",
    "customers.label.Basket": "Cesta",
    "customers.label.TotalPrice": "Preço total",
    "customers.label.Send_Link_to_Customer_to_Complete_Payment":
      "Enviar link para o cliente concluir o pagamento",
    "customers.label.CheckPaymentStatus": "Verificar status do pagamento",
    "customers.label.Are_you_sure_you_want_to_terminate?":
      "Tem certeza de que deseja encerrar?",
    "customers.label.Unlimited": "Ilimitado",
    "customers.label.days_left": "dias restantes",
    "customers.label.search": "Pesquisar",
    "customers.label.JobTitle": "Título do trabalho",
    "customers.label.SelectDocumentType": "Selecionar tipo de documento",
    "customers.label.SelectEvents": "Selecionar eventos",
    "customers.label.SelectFormatType": "Selecionar tipo de formato",
    "customers.label.SelectAdjustmentType": "Selecionar tipo de ajuste",
    "customers.label.card_number": "Número do cartão",
    "customers.label.Select_OPT_Type": "Selecionar tipo de OPT",
    "customers.label.StartDate": "Data de início",
    "customers.label.EndDate": "Data de término",
    "customers.label.Cancel": "Cancelar",
    "customers.label.Set": "Definir",
    "customers.label.PaymentDetails": "Detalhes do pagamento",
    "customers.label.PaymentReceipt": "Recibo de pagamento",
    "customers.label.Status": "Status",
    "customers.label.PaymentAmount": "Valor do pagamento",
    "customers.label.Transaction": "Transação",
    "customers.label.PaymentPage": "Página de pagamento",
    "customers.label.ItemCode": "Código do Item",
    "customers.label.StartDate": "Data de Início",
    "customers.label.English": "Inglês",
    "customers.label.SelectIdProof": "Selecionar Comprovante de Identidade",
    "customers.label.SelectAdjustementCode": "Selecionar Código de Ajuste",
    "customers.label.SelectAdjustmentType": "Selecionar Tipo de Ajuste",
    "customers.label.SelectFormat": "Selecionar Formato",
    "customers.label.AreYouSure?": "Tem certeza?",
    "customers.label.ChargeId": "ID de Cobrança",
    "customers.label.ChargeDescription": "Descrição da Cobrança",
    "customers.label.DiscountAmount": "Valor do Desconto",
    "customers.label.NetChargeAmount": "Valor Líquido da Cobrança",
    "customers.label.TaxDescription": "Descrição do Imposto",
    "customers.label.TaxAmount": "Valor do Imposto",
    "customers.label.SelectDate": "Selecionar data",
    "customers.label.SelectPriority": "Selecionar prioridade",
    "customers.label.SelectCategory": "Selecionar categoria",
    "customers.label.SelectSubCategory": "Selecionar subcategoria",
    "customers.label.SelectSource": "Selecionar fonte",
    "customers.label.ViewSpendCap": "Visualizar limite de gastos",
    "customers.label.Amount": "Montante",
    "customers.label.PlanCode": "Código do plano",
    "customers.label.Price": "Preço",
    "customers.label.Status": "Status",
    "customers.label.EndDate": "Data de término",
    "customers.label.ContractPeriod": "Período do contrato",
    "customers.label.AutoRenew": "Renovação automática",
    "customers.label.Description": "Descrição",
    "customers.label.ThankYou": "Obrigado!",
    "customers.label.ConnectionActivated":
      "A conexão foi ativada com sucesso com o número da conta",
    "customers.label.GoToCustomerDetail": "Ir para detalhes do cliente",
    "customers.label.Payment": "Pagamento",
    "customers.label.CustomerToPay": "Cliente a pagar:",
    "customers.label.MonthlyPayment": "Pagamento mensal",
    "customers.label.SetupWithDirectDebitOrCreditCard":
      "Configurar com débito direto ou cartão de crédito",
    "customers.label.SendLinkToCustomerToCompletePayment":
      "Enviar link para o cliente completar o pagamento",
    "customers.label.CheckPaymentStatus": "Verificar status do pagamento",
    "customers.label.ThisNumberIsReservedFor":
      "Este número está reservado para",
    "customers.label.YouSelected": "Você selecionou",
    "customers.label.SerialNo": "Número de série",
    "customers.label.PhoneNo": "Número de telefone",
    "customers.label.ActivatingCustomer": "Ativando cliente...",
    "customers.label.LoadingOrderStatus": "Carregando status do pedido...",
    "customers.label.OrderStatus": "Status do pedido:",
    "customers.label.Failed": "Falhou",
    "customers.label.RoamingOutsideEEA": "Roaming fora do EEE",
    "customers.label.TariffTermsDetails":
      "Consulte nossos Termos de Tarifas e nosso site para mais detalhes sobre tarifas específicas e encargos fora da sua franquia.",
    "customers.label.PaymentTerms":
      "Debitamos o valor que você precisa nos pagar de sua conta por débito direto SEPA, a menos que tenhamos acordado o contrário. A fatura mostrará a data em que o valor será debitado. Podemos solicitar o pagamento antecipado de taxas únicas e assinaturas. Em casos especiais, podemos cobrar valores intermediários. Por exemplo, se em um curto período de tempo você utilizou um determinado serviço acima da média. Se você estiver pagando com cartão de crédito ou débito, autoriza a empresa emissora a nos fornecer, e de forma estritamente confidencial aos nossos subcontratados e/ou agentes, detalhes sobre sua conta de pagamento se necessário no âmbito do contrato. Você também os autoriza a nos informar se sua conta de pagamento for encerrada ou suspensa a qualquer momento.",
    "customers.label.ServiceAgreementTerms":
      "Duração, renovação e término do contrato de serviços",
    "customers.label.Duration": "Duração",
    "customers.label.Renewal": "Renovação",
    "customers.label.ContractTermsAndConditions":
      "Termos e condições do contrato",
    "customers.label.TermsAndConditions": "Termos e Condições",
    "customers.label.CustomerExplanation":
      "Forneci ao cliente uma explicação detalhada de",
    "customers.label.CustomerAgreement":
      "e eles concordaram em prosseguir com o pedido.",
    "customers.label.NumberReservedFor": "Este número está reservado para",
    "customers.label.YouSelected": "Você selecionou",
    "customers.label.SerialNo": "Número de série",
    "customers.label.PhoneNo": "Número de telefone",
    "customers.label.TotalPrice": "Preço total",
    "customers.label.FeaturesForEndUsersWithDisabilities":
      "Recursos para usuários finais com deficiência",
    "customers.label.InformationSupportServices":
      "As informações de suporte aos nossos serviços estão disponíveis em formatos alternativos. Se desejar acessar informações em um formato alternativo, ligue para nós através do seu SIM Lycamobile no 1200 ou visite",
    "customers.label.HowWeUseYourInformation": "Como usamos suas informações",
    "customers.label.InformationUsageDetails":
      "Coletaremos informações sobre como você usa nossos Serviços e serviços de terceiros que utiliza em conjunto com nossos Serviços, incluindo, por exemplo, sua localização e atividade da conta, para melhorar sua experiência geral conosco e torná-la mais relevante para você. Podemos usar e analisar seus dados pessoais para gerenciar seu(s) Serviço(s) e conta, incluindo verificação de crédito e prevenção de fraudes. Podemos compartilhar e combinar esses dados com terceiros selecionados por essas mesmas razões. Suas informações são tratadas de acordo com nossa Política de Privacidade, que pode ser consultada em:",
    "customers.label.CustomerComplaints":
      "Se você não estiver satisfeito com a velocidade, qualidade ou outros elementos do serviço e desejar fazer uma reclamação, entre em contato com o Atendimento ao Cliente. Você pode obter mais informações sobre nosso processo de reclamações em nosso Código de Práticas de Reclamações de Clientes, disponível em",
    "customers.label.DisputeResolution":
      "Se não conseguirmos resolver sua reclamação, você pode enviá-la dentro de 12 meses para o Comitê de Disputas de Serviços de Telecomunicações. Você também pode registrar uma reclamação na plataforma de resolução de disputas on-line da Comissão Europeia ou entrar com uma ação em um tribunal civil.",
    "customers.label.costsEuro": "custa €",
    "customers.label.thereafterEuro": "depois €",
    "customers.label.forTheFirst": "para o primeiro",
    "customers.label.perMonthInclusiveVAT":
      "por mês, incluindo IVA (sujeito a aumentos anuais do IPC + 3,9%). Veja o site para mais detalhes.",
    "customers.label.additionalAddOns":
      "Complementos adicionais podem estar disponíveis para o seu plano e serão cobrados separadamente na sua fatura.",
    "customers.label.paymentTerms":
      "Você deve pagar os encargos pelos serviços que assina e/ou usa todos os meses antes da data na sua fatura. Podemos cobrar taxas se houver atraso no pagamento. Podemos exigir um depósito antes de permitir que você use os serviços. Consulte nossos Termos Tarifários e o site para mais detalhes sobre tarifas específicas e encargos fora da sua franquia.",
    "customers.label.durationRenewalTermination":
      "Duração, renovação e rescisão",
    "customers.label.minimumPeriod":
      "tem um período mínimo de 1 mês e continuará após esse período mensalmente até ser rescindido por você com um aviso prévio de 30 dias (a menos que outras regras legais ou regulatórias se apliquem) e você terá que pagar os encargos incorridos durante esse período de aviso.",
    "customers.label.cancellationCoolingOff":
      "Se mudar de ideia sobre os serviços comprados diretamente de nós, você pode ter o direito de cancelar o contrato de serviços dentro do período de arrependimento de 14 dias.",
    "customers.label.earlyTerminationCharge":
      "Você concorda que os serviços começarão imediatamente se já tiver um cartão SIM ou quando receber um. Se desejar encerrar o contrato de serviços durante o período mínimo ou se o encerrarmos devido a uma violação material, você terá que pagar uma taxa de rescisão antecipada, que será no máximo igual aos seus encargos de assinatura mensal multiplicados pelo número de meses restantes no seu período mínimo, incluindo IVA (calculado na taxa vigente), menos uma porcentagem para um pagamento final único. Você também terá que pagar por qualquer chamada, mensagem, dados e outros encargos incorridos, inclusive durante o período de arrependimento.",
    "customers.label.ContractSummarys":
      "Este resumo do contrato e nossa oferta de Assinatura de serviços internacionais amplos por 1 mês permitem que você faça e receba chamadas de voz, envie e receba SMS, use dados e acesse a Internet, tudo através da Rede, junto com quaisquer Serviços Adicionais opcionais que concordarmos em fornecer e que você optar por receber.",
    "customers.label.The": "O",
    "customers.label.ComesWith": "vem com:",
    "customers.label.MobileDataSpeeds":
      "Velocidades do serviço de dados móveis",
    "customers.label.DataServiceDescription":
      "O serviço de dados e as velocidades mínima e máxima associadas disponíveis através da rede Lycamobile dependem da tecnologia acessível, por exemplo, 2G, Edge, 3G, 4G, 5G na sua localização, do dispositivo usado e do tipo de plano que você adquiriu.",
    "customers.label.DataSpeedVariation":
      "A velocidade do seu serviço de dados móveis pode variar e depende da sua localização, do ambiente ao seu redor (clima, cobertura de árvores, materiais usados em edifícios próximos e o número de pessoas usando a rede) e do dispositivo usado para se conectar à rede.",
    "customers.label.LycamobileBV": "Lycamobile B.V.",
    "customers.label.Robijnlaan17": "Robijnlaan 17,",
    "customers.label.2132WXHoofddorp": "2132WX Hoofddorp,",
    "customers.label.TheNetherlands": "Países Baixos",
    "customers.label.ContractSummary": "Resumo do contrato",
    "customers.label.ContractSummaryDescription1":
      "Este resumo do contrato fornece os principais elementos desta oferta de serviço conforme exigido por lei.",
    "customers.label.ContractSummaryDescription2":
      "Ajuda a comparar as ofertas de serviço.",
    "customers.label.ContractSummaryDescription3":
      "As informações completas sobre o serviço são fornecidas em outros documentos.",
    "customers.label.ContractSummaryValidity":
      "Este resumo do contrato é válido até o vencimento do pagamento em",
    "customers.label.AcceptOffer":
      "Se esta oferta for adequada, você pode aceitá-la através da página de pagamento. Por favor, mantenha uma cópia deste documento para seus registros.",
    "customers.label.Services": "Serviços",
    "customers.label.TermsConditions":
      "De acordo com os Termos e Condições do Acordo de Serviços, se violarmos um termo material do Acordo que restrinja completamente nossa capacidade de fornecer dados como parte de nosso Serviço e não o corrigirmos dentro de 7 dias após receber sua reclamação através do Atendimento ao Cliente da Lycamobile, você pode encerrar o acordo.",
    "customers.label.EmergencyOrganisations":
      "Organizações de emergência e informações de localização do chamador",
    "customers.label.EmergencyCallInstructions":
      "Se precisar fazer uma chamada de emergência/112/999 quando a Rede da Lycamobile estiver indisponível, por qualquer motivo, seu dispositivo móvel deve ser capaz de se conectar às redes de rádio 2G, 3G, 4G ou 5G e pode selecionar a rede de um concorrente que tenha cobertura para acessar chamadas de emergência.",
    "customers.label.EmergencyCallAvailability":
      "As chamadas de emergência só podem ser feitas onde houver uma rede de rádio disponível.",
    "customers.label.PlanName": "Nome do plano",
    "customers.label.EuropeanOnlineDisputeResolution":
      "O site europeu de resolução de disputas online",
    "customers.label.ECWebsite": "ec.europa.eu/consumers/odr",
    "customers.label.DisputeResolutionDetails":
      "permite aos consumidores apresentar disputas relacionadas a compras online conosco. Você pode verificar nosso site para obter uma cópia do nosso Código de Prática sobre reclamações e para obter nossas informações mais recentes sobre resoluções alternativas de disputas. Estamos aqui para ajudar. Se algo der errado, queremos corrigir. Você pode saber mais sobre nosso processo de reclamações em nosso Código de Prática de Reclamações de Clientes, que pode ser encontrado em.",
    "customers.label.NetherlandsLawCompliance":
      "Em caso de discrepância contínua e/ou recorrente entre o desempenho real do serviço de acesso à Internet em relação à velocidade, de acordo com as leis dos Países Baixos, a Lycamobile fornecerá uma nova execução dentro de um prazo razoável. Quando a nova execução for impossível, a Lycamobile reduzirá razoavelmente o preço que o Cliente paga pelo Serviço. Se o Cliente já tiver pago, a Lycamobile reembolsará ao Cliente qualquer valor pago acima desse montante.",
    "customers.label.DirectoryServiceInfo":
      "Você pode nos pedir para incluir seu número de telefone móvel em um diretório telefônico e/ou um serviço de consulta de diretório. No entanto, você deve saber que, se solicitar este serviço, seu número ficará visível para empresas que compilam informações para fins de marketing. Se estiver preocupado com isso, pode interromper chamadas de marketing não solicitadas optando pela exclusão ou exercendo seu direito de objeção. Se deseja que seu número de telefone móvel seja incluído em um diretório e/ou um serviço de consulta de diretório, informe nossa equipe de atendimento ao cliente.",
    "customers.label.RemediesComplaints":
      "Recursos, tratamento de reclamações e resolução de disputas",
    "customers.label.ContactCustomerService":
      "Se precisar entrar em contato com o atendimento ao cliente, visite o site e clique em 'Fale Conosco'. Se deseja registrar uma reclamação sobre nosso serviço, entre em contato com o atendimento ao cliente. Se ainda estiver insatisfeito, pode escrever para uma revisão imparcial para:",
    "customers.label.IncludeMobileNumber":
      "Inclua seu número de telefone móvel se nos escrever. Se não conseguirmos resolver sua reclamação, você pode enviá-la dentro de 24 meses para De Geschillencommissie ( Postbus 90600, 2509 LP, Den Haag ).",
    "customers.label.Termination": "Rescisão",
    "customers.label.TerminationNotice":
      "Após o período mínimo, você pode encerrar o contrato nos notificando (a menos que outras regras legais ou regulamentares se apliquem) e terá que pagar as cobranças incorridas durante este período de notificação.",
    "customers.label.EarlyTerminationCharge":
      "A menos que especificado de outra forma (como nos termos da sua tarifa), se você quiser encerrar o contrato de serviços durante o período mínimo ou se encerrarmos o contrato devido a uma violação grave de sua parte, você terá que pagar uma taxa de rescisão antecipada equivalente às suas taxas mensais de assinatura multiplicadas pelo número de meses restantes no seu período mínimo, incluindo o IVA (calculado na taxa vigente).",
    "customers.label.OptionalAddOnTermination":
      "Qualquer serviço adicional opcional será encerrado independentemente de qualquer plano mensal agrupado.",
    "customers.label.CancellationInfo":
      "Se você mudar de ideia ou precisar cancelar, tem direito a cancelar sua aceitação de nossos termos e condições a qualquer momento até 14 dias após fazer seu pedido do serviço (o período de reflexão), desde que o faça de acordo com nossa política de cancelamento ou notificando a Lycamobile. Isso não afeta seus direitos legais.",
    "customers.label.Security": "Segurança",
    "customers.label.SecurityPolicy":
      "Todos os eventos de segurança dos quais tivermos conhecimento serão analisados para classificação, contenção, recuperação, análise e resolução. Notificações oportunas serão enviadas a clientes afetados conforme os requisitos regulamentares e contratuais aplicáveis. Incidentes de segurança que requeiram investigações forenses serão conduzidos pela Lycamobile ou, quando apropriado, por terceiros qualificados visando a resolução e prevenção futura.",
    "customers.label.DataProtection": "Proteção de dados",
    "customers.label.DataProtectionPolicy":
      "Sem prejuízo da legislação de proteção de dados, a Lycamobile requer informações pessoais do cliente para fornecer os serviços, como: nome, endereço, número da conta, número do telefone móvel e detalhes de pagamento. Suas informações são tratadas de acordo com nossa política de privacidade, que define como coletamos, usamos e compartilhamos suas informações, com quem e por que, descreve seus direitos e explica como pode exercê-los.",
    "customers.label.TariffTerms":
      "Consulte nossos Termos Tarifários e nosso site para mais detalhes sobre tarifas específicas e cobranças fora de sua franquia.",
    "customers.label.DeliveryOfService": "Entrega do serviço",
    "customers.label.PaymentTerms":
      "Debitamos o valor que você precisa nos pagar de sua conta por débito direto SEPA, a menos que tenhamos acordado o contrário...",
    "customers.label.ServiceStartDate":
      "A data em que a Lycamobile fornecerá os serviços é a data em que você se registra na Lycamobile.",
    "customers.label.ContractDuration":
      "Duração, renovação e rescisão do contrato de serviços",
    "customers.label.MinimumPeriod":
      "Sua assinatura tem um período mínimo chamado Período Mínimo, que pode ser de apenas 1 mês para pacotes mensais e 24 meses para contratos de prazo fixo.",
    "customers.label.ContractRenewal":
      "Para renovar o contrato, você deve notificar a Lycamobile durante o prazo do seu contrato anterior, consentindo na renovação do contrato.",
    "customers.label.DataCostDetails":
      "Os {40 GB de dados} custam {18,90 €} nos primeiros {3 meses}, depois {27,00 €} por mês, incluindo IVA (sujeito a aumentos anuais do IPC + 3,9%). Veja nosso site para mais detalhes.",
    "customers.label.AdditionalAddons":
      "Add-ons adicionais podem estar disponíveis para seu plano e serão cobrados separadamente.",
    "customers.label.SpendingLimits": "Limites de gastos",
    "customers.label.SpendingLimitDetails":
      "A Lycamobile definirá limites de gastos na sua conta de acordo com suas preferências até um máximo de 250 €.",
    "customers.label.PremiumCharges":
      "Chamadas premium, números curtos, SMS e chamadas internacionais não estão incluídos nas franquias e serão cobrados conforme as tarifas específicas.",
    "customers.label.InternationalRates":
      "Chamadas e mensagens da Holanda para outros países serão cobradas nas nossas tarifas internacionais padrão:",
    "customers.label.RoamingInEEA": "Roaming no EEE",
    "customers.label.RoamingOutsideEEA": "Roaming fora do EEE",
    "customers.label.RoamingCharges":
      "Usar seu telefone (chamadas, mensagens e dados) em roaming fora da Holanda ou do EEE e destinos selecionados será cobrado conforme nossas tarifas internacionais de roaming.",
    "customers.label.Any_Out_of_bundle_charges_can_be_found_at":
      "Quaisquer encargos fora do pacote podem ser encontrados em:",
    "customers.label.Exclusions_for_voice_international_voice_SMS_Data_Roaming_can_be_found_at":
      "As exclusões para voz, voz internacional, SMS e roaming de dados podem ser encontradas em:",
    "customers.label.Our_Services_availability":
      "Nossos serviços não estão disponíveis em todos os lugares nos Países Baixos, no EEE ou em outros destinos selecionados. O uso aceitável de nossos serviços está incluído em nossa Política de Uso Justo Doméstico e de Roaming em:",
    "customers.label.Lycamobile_network_speeds":
      "O serviço de dados e as velocidades mínimas e máximas associadas disponíveis na rede Lycamobile dependem da tecnologia acessível, por exemplo, 2G, Edge, 3G, 4G, 5G em sua localização, o dispositivo usado e o tipo de plano adquirido.",
    "customers.label.Mobile_data_speed_variation":
      "A velocidade do seu serviço de dados móveis pode variar e depende da sua localização, do ambiente ao seu redor (clima, cobertura de árvores, materiais utilizados nos edifícios próximos e do número de pessoas usando a rede) e do dispositivo usado para se conectar à rede.",
    "customers.label.Price": "Preço",
    "customers.label.ContractReview": "Revisão do contrato",
    "customers.label.Terms&Conditions": "Termos e condições",
    "customers.label.ReviewThisContract": "Revisar este contrato",
    "customers.label.We_have_sent_these_to": "Enviamos isto para",
    "customers.label.DownloadContractInformation":
      "Baixar informações do contrato",
    "customers.label.DownloadContractSummary": "Baixar resumo do contrato",
    "customers.label.ContractInformation": "Informações do contrato",
    "customers.label.ContactDetails": "Detalhes de contato",
    "customers.label.Description_of_Services": "Descrição dos serviços",
    "customers.label.This_contract_summary_and_our_Abonnement_offer_of":
      "Este resumo do contrato e nossa oferta de assinatura de",
    "customers.label.an_airtime_service_for":
      "um serviço de tempo de antena para",
    "customers.label.comes_with:": "inclui:",
    "customers.label.Any_Out_of_bundle_charges_can_be_found_at:":
      "Quaisquer cobranças fora do pacote podem ser encontradas em:",
    "customers.label.service_description":
      "que permite fazer e receber chamadas de voz, enviar e receber SMS, dados e acessar a Internet, tudo por meio da rede, juntamente com quaisquer serviços opcionais adicionais que concordamos em fornecer e que você optar por receber.",
    "customers.label.YouHaveChosenNoCap":
      "Você escolheu sem limite. Isso significa que poderá usar seu telefone para chamadas, mensagens, minutos internacionais, roaming e dados fora de sua franquia mensal. Você será cobrado até 60 € por isso.",
    "customers.label.SelectDate":
      "Selecionar data [O pagamento mensal será debitado de sua conta 14 dias após a data escolhida para a geração da fatura] *",
    "customers.label.billing_cycle": "Ciclo de faturamento",
    "customers.label.SelectBilling": "Selecionar faturamento",
    "customers.label.I_Agree_To": "Eu concordo com",
    "customers.label.TermsAndConditions": "Termos e Condições",
    "customers.label.ThisNumberIsReservedFor":
      "Este número está reservado para",
    "customers.label.TotalPrice": "Preço total:",
    "customers.label.CustomerInfo": "Informações do Cliente",
    "customers.label.title": "Título",
    "customers.label.SelectTitle": "Selecionar título",
    "customers.label.initials": "Iniciais",
    "customers.label.Basket": "Cesta",
    "customers.label.first_name": "Nome",
    "customers.label.last_name": "Sobrenome",
    "customers.label.email_address": "Endereço de e-mail",
    "customers.label.contact_number": "Número de contato",
    "customers.label.date_of_birth": "Data de nascimento",
    "customers.label.select_language": "Selecionar idioma",
    "customers.label.how_did_you_hear": "Como você nos conheceu?",
    "customers.label.postal_code": "Código postal",
    "customers.label.country": "País",
    "customers.label.Enter_address_manually": "Inserir endereço manualmente",
    "customers.label.Find_address": "Encontrar endereço",
    "customers.label.Select_Address": "Selecionar endereço",
    "customers.label.Select_an_address": "Selecionar um endereço",
    "customers.label.Enter_address_dynamically":
      "Inserir endereço dinamicamente",
    "customers.label.address_number": "Número do endereço",
    "customers.label.street": "Rua",
    "customers.label.state": "Estado",
    "customers.label.city": "Cidade",
    "customers.label.resident_period": "Período de residência",
    "customers.label.Spend_Cap_Amount": "Montante do limite de gastos",
    "customers.label.I_don’t_want_a_Spend_Cap": "Não quero um limite de gastos",
    "customers.label.Monthly_Bill_Generation_Date":
      "Data de geração da fatura mensal",
    "customers.label.Select_a_Monthly_Plan": "Selecionar um plano mensal",
    "customers.label.Search_plans": "Pesquisar planos...",
    "customers.label.search": "Pesquisar",
    "customers.label.Select_a_plan": "Selecionar um plano",
    "customers.label.Basket": "Cesta",
    "customers.label.This_number_is_reserved_for":
      "Este número está reservado para",
    "customers.label.ViewT&C": "Ver termos e condições",
    "customers.label.TransferringFromPreviousNetwork":
      "Transferindo da rede anterior (Traga seu número antigo)",
    "customers.label.SIM_Information": "Informação do SIM",
    "customers.label.Prepaid": "Pré-pago",
    "customers.label.Postpaid": "Pós-pago",
    "customers.label.Physical_SIM": "SIM Físico",
    "customers.label.eSIM": "eSIM",
    "customers.label.SelectCustomerType": "Selecionar Tipo de Cliente",
    "customers.label.New_to_Lyca": "Novo na Lyca",
    "customers.label.Convert_Lyca_Prepaid_to_Postpaid":
      "Converter Lyca Pré-pago para Pós-pago",
    "customers.label.Existing_customer_is_going_to_be_sent_a_secure_link_to_confirm_that_they_wish_to_move_from_prepaid_to_abonnement.":
      "O cliente existente receberá um link seguro para confirmar que deseja mudar de pré-pago para assinatura.",
    "customers.label.Customer_to_receive_an_SMS": "O cliente receberá um SMS",
    "customers.label.Lyca_Mobile_Number": "Número Lyca Mobile",
    "customers.label.Enter_the_Lyca_Mobile_Number":
      "Digite o número Lyca Mobile",
    "customers.label.Nationality": "Nacionalidade",
    "customers.label.Send_Secure_link": "Enviar link seguro",
    "customers.label.New_to_Lyca_Mobile": "Novo na Lyca Mobile",
    "customers.label.serial_number": "Número de Série",
    "customers.label.Serial_Number": "Número de Série (Últimos 4 Dígitos)",
    "customers.label.PUK_Code": "Código PUK",
    "customers.label.PUK_Code_is_not_matched": "Código PUK não corresponde",
    "customers.label.Switching_to_Lyca_Mobile": "Mudando para Lyca Mobile",
    "customers.label.Enter_the_PUK_Code": "Digite o código PUK",
    "customers.label.Basket": "Cesta",
    "customers.label.Gender": "Gênero",
    "customers.label.business_name": "Nome da empresa",
    "customers.label.phone_number": "Número de telefone",
    "customers.label.Date_of_Birth": "Data de nascimento",
    "customers.label.VIP": "VIP",
    "customers.label.Disability": "Deficiência",
    "customers.label.District": "Distrito",
    "customers.label.Is_your_billing_address_same_as_primary_address":
      "O endereço de cobrança é o mesmo que o endereço principal?",
    "customers.label.Supressbill": "Suprimir fatura",
    "customers.label.SelectCategory": "Selecionar categoria",
    "customers.label.SelectGender": "Selecionar gênero",
    "customers.label.SelectPreferences": "Selecionar preferências",
    "customers.label.SelectNationality": "Selecionar nacionalidade",
    "customers.label.SelectVIP": "Selecionar VIP",
    "customers.label.SelectDisability": "Selecionar deficiência",
    "customers.label.SelectCity": "Selecionar cidade",
    "customers.label.SelectBillDay": "Selecionar dia de faturamento",
    "customers.label.SelectType": "Selecionar tipo",
    "customers.label.SelectFiscalYear": "Selecionar ano fiscal",
    "customers.label.SelectFiscalQuarter": "Selecionar trimestre fiscal",
    "customers.label.SelectBillMode": "Selecionar modo de faturamento",
    "customers.label.SelectInvoiceType": "Selecionar tipo de fatura",
    "customers.label.IMSI": "IMSI",
    "customers.label.SalesMotion": "Movimento de Vendas",
    "customers.label.SpendCap": "Limite de Gastos",
    "customers.label.ActivationDate": "Data de Ativação",
    "customers.label.ExpiryDate": "Data de Expiração",
    "customers.label.NextRenewalDate": "Próxima Data de Renovação",
    "customers.label.BalanceTransfer": "Transferência de Saldo",
    "customers.label.RecieverClientId": "ID do Cliente Receptor",
    "customers.label.Amount": "Quantidade",
    "customers.label.EnterTopUpAmount": "Digite o Valor da Recarga",
    "customers.label.ResponseId": "ID de Resposta",
    "customers.label.BalanceName": "Nome do Saldo",
    "customers.label.Allowance": "Permissão",
    "customers.label.Consumption": "Consumo",
    "customers.label.AvailableBalance": "Saldo Disponível",
    "customers.label.DaysLeft": "Dias Restantes",
    "customers.label.Discount": "Desconto",
    "customers.label.postal_code": "Código postal",
    "customers.label.address_number": "Número do endereço",
    "customers.label.city": "Cidade",
    "customers.label.state": "Estado",
    "customers.label.country": "País",
    "customers.label.resident_period": "Período de residência",
    "customers.label.postcode": "Código postal",
    "customers.label.how_did_you_hear": "Como você ouviu falar de nós?",
    "customers.label.select_language": "Selecionar idioma",
    "customers.label.comment_date": "Data do comentário",
    "customers.label.email_address": "Endereço de e-mail",
    "customers.label.contact_number": "Número de contato",
    "customers.label.initials": "Iniciais",
    "customers.label.communication_type": "Tipo de Comunicação",
    "customers.label.BuySIM": "Comprar SIM",
    "customers.label.origination": "Originação",
    "customers.label.address": "Endereço",
    "customers.label.destination_address": "Endereço de Destino",
    "customers.label.event": "Evento",
    "customers.label.charge_party": "Parte Cobrada",
    "customers.label.service_subs_type": "Tipo de Assinatura de Serviço",
    "customers.label.calling_party": "Parte Chamadora",
    "customers.label.called_party": "Parte Chamada",
    "customers.label.usage": "Uso",
    "customers.label.monetary_charge": "Cobrança Monetária",
    "customers.label.result_code": "Código de Resultado",
    "customers.label.generation_time": "Tempo de Geração",
    "customer.label.generationdatetime": "Data e Hora de Geração",
    "customers.label.transaction_id": "ID da Transação",
    "customers.label.application_transaction_id":
      "ID da Transação da Aplicação",
    "customers.label.application_name": "Nome da Aplicação",
    "customers.label.recharge_value": "Valor de Recarga",
    "customers.label.interface": "Interface",
    "customers.label.result": "Resultado",
    "customers.label.comment": "Comentário",
    "customers.label.recharge": "Recarregar",
    "customers.label.cdr": "CDR",
    "customers.label.notifications": "Notificações",
    "customers.label.mobile_no": "Enter Mobile No",
    "customers.label.email_id": "Enter Email Id",
    "customers.label.serial_number": "Serial No",
    "customers.label.digital_content": "Conteúdo Digital",
    "customers.label.buySim": "Comprar SIM",
    "customers.label.outstanding_due": "Saldo Devido",
    "customers.label.due_date": "Data de Vencimento",
    "customers.label.unbilled_amount": "Valor Não Faturado",
    "customers.label.next_bill_day": "Próximo Dia de Cobrança",
    "customers.label.view_allowances": "Ver Benefícios",
    "customers.label.view_service_details": "Ver detalhes do serviço",
    "customers.label.spend_limit": "Limite de Gastos",
    "customers.label.topup_balance": "Recarregar Saldo",
    "customers.label.next_renewal_date": "Próxima Data de Renovação",
    "customers.label.allowance": "Benefício",
    "customers.label.ViewDocumentUpload": "Visualizar upload de documento",
    "customers.label.total_net_amount": "Montante Líquido Total",
    "customers.label.cancelRemark": "Cancelar observação",
    "customers.label.cancelPayment": "Cancelar pagamento",
    "customers.label.all": "Todos",
    "customers.label.billProfile": "Perfil de Cobrança",
    "customers.label.charges": "Encargos",
    "customers.label.book_order": "Encomenda de Livro",
    "customers.label.customers": "Clientes",
    "customers.label.search_for_clients": "Procurar por Clientes",
    "customers.label.advance_search": "Pesquisa Avançada",
    "customers.label.create_customer": "Criar Cliente",
    "customers.label.created_by": "Criado por",
    "customers.label.created_on": "Criado em",
    "customers.label.credit_limit": "Limite de crédito",
    "customers.label.transaction_history": "Histórico de transações",
    "customers.label.external_activity_log": "Registro de atividade externa",
    "customers.label.settings": "Configurações",
    "system.label.currency_noncurrency": "Moeda Não-Moeda",
    "entity.label.configure": "Configurar",

    "customers.label.account_no": "Número da Conta",
    "customers.label.customer_name": "Nome do Cliente",
    "customers.label.business_entity": "Entidade Empresarial",
    "customers.label.serial_no": "Número de Série",
    "customers.label.balance": "Saldo",
    "customers.label.valid_from": "Válido a partir de",
    "customers.label.valid_to": "Válido até",
    "customers.label.non_currency_details": "Detalhes não monetários",
    "customers.label.view_details": "Ver detalhes",
    "customers.label.status": "Estado",
    "customers.label.first_name": "Nome",
    "customers.label.price_discount": "Preço e Desconto",
    "customers.label.collection_status": "Status da coleta",
    "customers.label.last_name": "Sobrenome",
    "customers.label.city_area": "Cidade/Área",
    "customers.label.email": "E-mail",
    "customers.label.phone": "Telefone",
    "customers.label.cafid": "CAF Id",
    "customers.label.enter_business_entity": "Insira a entidade comercial",
    "customers.label.select": "Selecionar",
    "customers.label.refund": "Reembolso",
    "customers.label.refund_id": "ID do reembolso",
    "customers.label.refund_amount": "Valor do reembolso",
    "customers.label.select_category_type": "Selecionar Tipo de Categoria",
    "customers.label.clear": "Limpar",
    "customers.label.search": "Pesquisar",
    "customers.label.customer_activation": "Ativação do Cliente",
    "customers.label.customer_details": "Detalhes do Cliente",
    "customers.label.loc": "LOC",
    "customers.label.customer_category": "Categoria do Cliente",
    "customers.label.service_details": "Detalhes do Serviço",
    "customers.label.name": "Nome",
    "customers.label.add_service": "Adicionar Serviço",
    "customers.label.network_node": "Nó de Rede",
    "customers.label.device_details": "Detalhes do Dispositivo",
    "customers.label.item": "Item",
    "customers.label.discount_code": "Código de Desconto",
    "customers.label.total_price": "Preço Total",
    // "customers.label.device_details": "Detalhes do dispositivo",
    "customers.label.plan_details": "Detalhes do plano",
    "customers.label.payment_details": "Detalhes do pagamento",
    "customers.label.plan_list": "Lista de planos",
    "customers.label.plan": "Plano",
    "customers.label.contract_period": "Período de contrato",
    "customers.label.charge_cycle": "Ciclo de cobrança",
    "customers.label.cancel": "Cancelar",
    "customers.label.next": "Próximo",
    "customers.label.done": "Concluído",
    "customers.label.reopen": "Reabrir",
    "customers.label.submit": "Enviar",
    "customers.label.view_customer": "Ver cliente",
    "customers.label.account_number": "Número da conta",
    "customers.label.office_hierarchy": "Hierarquia do escritório",
    "customers.label.account_type": "Tipo de conta",
    // "customers.label.balance": "Saldo",
    "customers.label.stb_serial_no": "Número de série STB",
    "customers.label.non_currency_balance": "Saldo não monetário",
    "customers.label.service_orders": "Ordens de serviço",
    "customers.label.more_info": "Mais informações",
    "customers.label.notes": "Notas",
    "customers.label.device": "Dispositivo",
    "customers.label.tickets": "Bilhetes",
    "customers.label.on_demand": "Sob demanda",
    "customers.label.on_demand_billing": "Faturamento sob demanda",
    "customers.label.payments": "Pagamentos",
    "customers.label.invoice": "Fatura",
    "customers.label.activity_log": "Registro de atividades",
    "customers.label.contact_information": "Informações de contato",
    "customers.label.address_information": "Informações de endereço",
    "customers.label.billing_information": "Informações de faturamento",
    "customers.label.balance_information": "Informações de saldo",
    // "customers.label.customer_name": "Nome do cliente",
    "customers.label.parent_child": "Pai/Filho",
    "customers.label.created_date": "Data de criação",
    "customers.label.district": "Distrito",
    "customers.label.pincode": "Código Postal",
    "customers.label.last_bill_amount": "Último valor da fatura",
    "customers.label.last_bill_date": "Data da última fatura",
    "customers.label.last_bill_paid": "Última fatura paga",
    "customers.label.last_paid_amount": "Último valor pago",
    "customers.label.last_payment_date": "Data do último pagamento",
    "customers.label.next_bill_date": "Data da próxima fatura",
    "customers.label.service_overview": "Visão geral do serviço",
    "customers.label.service_without_device": "Serviço sem dispositivo",
    "customers.label.create_ticket": "Criar ticket",
    "customers.label.service_activation": "Ativação do serviço",
    "customers.label.order_charging": "Cobrança do pedido",
    "customers.label.top_up": "Recarregar",
    "customers.label.redeem": "Resgatar",
    "customers.label.collection_name": "Nome da coleção",
    "customers.label.redeem_voucher": "Resgatar voucher",
    "customers.label.service_id": "ID do serviço",
    "customers.label.service_code": "Código do serviço",
    "customers.label.service_description": "Descrição do serviço",
    "customers.label.start_date": "Data de início",
    "customers.label.modified_date": "Data modificada",
    // "customers.label.status": "Status",
    "customers.label.info": "Informação",
    "customers.label.action": "Ação",
    "customers.label.add_device": "Adicionar dispositivo",
    "customers.label.add_plans": "Adicionar planos",
    "customers.label.suspend": "Suspender",
    "customers.label.reactivate": "Reativar",
    "customers.label.terminate": "Terminar",
    "customers.label.command_center": "Centro de comando",
    "customers.label.retrack": "Refazer o rastreamento",
    "customers.label.cancel_plans": "Cancelar planos",
    "customers.label.device_overview": "Visão geral do dispositivo",
    "customers.label.item_code": "Código do item",
    "customers.label.orders_overview": "Visão geral dos pedidos",
    // "customers.label.plan": "Plano",
    "customers.label.end_date": "Data de término",
    "customers.label.price": "Preço",
    "customers.label.short_description": "Breve descrição",
    "customers.label.description": "Descrição",
    "customers.label.add_note": "Adicionar Nota",
    "customers.label.note": "Nota",
    "customers.label.sale_type": "Tipo de Venda",
    "customers.label.bill_item_details": "Detalhes do item da fatura",
    "customers.label.charge_id": "ID de cobrança",
    "customers.label.order_id": "ID do pedido",
    "customers.label.item_tax_details": "Detalhes do imposto do item",
    "customers.label.discount_details": "Detalhes do desconto",
    "customers.label.sale_date": "Data de Venda",
    "customers.label.charge_code": "Código de Cobrança",
    "customers.label.quantity": "Quantidade",
    // "customers.label.total_price": "Preço Total",
    "customers.label.warranty_date": "Data de Garantia",
    "customers.label.allocate": "Alocar",
    "customers.label.contact_info": "Informações de contato",
    "customers.label.edit_customer": "Editar Cliente",
    "customers.label.lco": "LCO",
    "customers.label.title": "Título",
    // "customers.label.customer_category": "Categoria do Cliente",
    "customers.label.middle_name": "Nome do Meio",
    "customers.label.caf_id": "ID CAF",
    "customers.label.landline_number": "Número de telefone fixo",
    "customers.label.user_name": "Nome de Usuário",
    "customers.label.customer_photo": "Foto do Cliente",
    "customers.label.id_proof": "Prova de Identidade",
    "customers.label.id_proof_value": "Valor da Prova de Identidade",
    "customers.label.save": "Salvar",
    "customers.label.close_customer": "Fechar Cliente",
    "customers.label.closure_date": "Data de Fechamento",
    "customers.label.closure_reason": "Motivo do Fechamento",
    "customers.label.close": "Fechar",
    "customers.label.address_info": "Informações de Endereço",
    "customers.label.edit_address": "Editar Endereço",
    "customers.label.address_no": "Número do Endereço",
    "customers.label.street": "Rua",
    "customers.label.building": "Edifício",
    "customers.label.zipcode": "Código Postal",
    "customers.label.billing": "Faturamento",
    "customers.label.same_as_primary": "Mesmo que o Principal",
    "customers.label.building_code": "Código do Edifício",
    "customers.label.add_address": "Adicionar Endereço",
    "customers.label.address_type": "Tipo de Endereço",
    "customers.label.billing_info": "Informações de Faturamento",
    "customers.label.created_adjustment": "Ajuste Criado",
    "customers.label.create_order": "Criar Pedido",
    "customers.label.sale_catalog": "Catálogo de Vendas",
    "customers.label.renew_plan": "Renovar Plano",
    "customers.label.auto_renew": "Renovação Automática",
    // "customers.label.search": "Pesquisar",
    "customers.label.entity_name": "Nome da entidade",
    "customers.label.discount": "Desconto",
    "customers.label.provisioning_commands": "Comandos de provisionamento",
    "customers.label.command": "Comando",
    "customers.label.plans": "Planos",
    "customers.label.client_service_detail": "Detalhe do serviço ao cliente",
    "customers.label.id": "Id",
    "customers.label.parameter_name": "Nome do parâmetro",
    "customers.label.parameter_value": "Valor do parâmetro",
    "customers.label.request_type": "Tipo de solicitação",
    "customers.label.client_info": "Informações do cliente",
    "customers.label.service_info": "Informações do serviço",
    "customers.label.new_device_info": "Informações do novo dispositivo",
    "customers.label.task_list": "Lista de tarefas",
    "customers.label.provisioning_detail": "Detalhes da provisão",
    "customers.label.provisioning_id": "ID de provisão",
    "customers.label.task_id": "ID de tarefa",
    "customers.label.sent_message": "Mensagem enviada",
    "customers.label.available_plans": "Planos disponíveis",
    "customers.label.disconnect_order": "Ordem de desconexão",
    "customers.label.reason": "Razão",
    "customers.label.porting_out": "Portando",
    "customers.label.prepaid_to_postpaid": "Pré-pago para pós-pago",
    "customers.label.postpaid_to_prepaid": "Pós-pago para pré-pago",
    "customers.label.addons": "Complementos",
    "customers.label.change_plan": "Alterar plano",
    "customers.label.swap_sim": "Trocar o SIM",
    "customers.label.select_date": "Selecionar data",
    "customers.label.order_date": "Data do Pedido",
    "customers.label.priority": "Prioridade",
    "customers.label.ticket_date": "Data do Ticket",
    "customers.label.category": "Categoria",
    "customers.label.sub_category": "Subcategoria",
    "customers.label.team": "Equipe",
    "customers.label.team_user": "Usuário da Equipe",
    "customers.label.source": "Origem",
    "customers.label.due_time": "Hora de Vencimento",
    "customers.label.device_swap": "Troca de Dispositivo",
    // "customers.label.terminate": "Terminar",
    "customers.label.confirm": "Confirmar",
    "customers.label.continue": "Continuar",
    "customers.label.process_date": "Data de Processo",
    "customers.label.pin_number": "Número PIN",
    "customers.label.renewal": "Renovação",
    // "customers.label.create_customer": "Criar Cliente",
    "customers.label.individual": "Individual",
    "customers.label.corporate": "Corporativo",
    "customers.label.corporate_details": "Detalhes Corporativos",
    "customers.label.contact_person": "Pessoa de Contato",
    "customers.label.entity": "Entidade",
    "customers.label.client_category": "Categoria do Cliente",
    "customers.label.preferences": "Preferências",
    "customers.label.parent_id": "ID Pai",
    "customers.label.child": "Filho",
    "customers.label.villege_street": "Vila/Rua",
    "customers.label.billing_address": "Endereço de Faturamento",
    "customers.label.bill_information": "Informações da fatura",
    "customers.label.bill_day_of_month": "Dia da fatura do mês",
    "customers.label.fiscal_year": "Ano fiscal",
    "customers.label.fiscal_quater": "Trimestre fiscal",
    "customers.label.bill_mode": "Modo de faturamento",
    "customers.label.invoice_type": "Tipo de fatura",
    "customers.label.payment_information": "Informações de pagamento",
    "customers.label.funder_name": "Nome do financiador",
    "customers.label.funder_id": "ID do financiador",
    "customers.label.po_number": "Número do pedido",
    "customers.label.payment_term": "Termo de pagamento",
    "customers.label.customer_created_successfully":
      "Cliente criado com sucesso",
    "customers.label.go_to_customer": "Ir para o cliente",
    "customers.label.view_order": "Ver pedido",
    "customers.label.disconnect": "Desconectar",
    "customers.label.apply_promo": "Aplicar promoção",
    // "customers.label.order_id": "ID do pedido",
    "customers.label.order_type": "Tipo de pedido",
    "customers.label.billing_cycle": "Ciclo de faturação",
    "customers.label.plan_name": "Nome do plano",
    "customers.label.user_action": "Ação do usuário",
    "customers.label.invoice_till_date": "Fatura até a data",
    "customers.label.order_services": "Serviços do pedido",
    "customers.label.service_type": "Tipo de serviço",
    "customers.label.bill_start_date": "Data de início da fatura",
    "customers.label.bill_end_date": "Data de término da fatura",
    // "customers.label.invoice_till_date": "Fatura até a data",
    "customers.label.charge_type": "Tipo de cobrança",
    "customers.label.rate_uom": "Taxa/UOM",
    "customers.label.discount_description": "Descrição do desconto",
    "customers.label.discount_type": "Tipo de desconto",
    "customers.label.discount_start_date": "Data de início do desconto",
    "customers.label.discount_end_date": "Data de término do desconto",
    "customers.label.discount_amount": "Valor do desconto",
    "customers.label.order_transaction": "Transação de pedido",
    "customers.label.user": "Usuário",
    "customers.label.transaction_date": "Data da transação",
    "customers.label.transaction_type": "Tipo de transação",
    "customers.label.actual_date": "Data real",
    "customers.label.promo": "Promo",
    "customers.label.promotion": "Promoção",
    "customers.label.disconnection_date": "Data de desconexão",
    "customers.label.disconnection_reason": "Motivo da desconexão",
    "customers.label.problem_code": "Código do problema",
    "customers.label.assign_to": "Atribuir a",
    "customers.label.last_comment": "Último comentário",
    "customers.label.file_name": "Nome do arquivo",
    "customers.label.edit_ticket": "Editar ticket",
    "customers.label.close_ticket": "Fechar ticket",
    "customers.label.resolution_description": "Descrição da resolução",
    "customers.label.ticket_history": "Histórico do ticket",
    // "customers.label.last_comment": "Último comentário",
    "customers.label.problem_description": "Descrição do problema",
    "customers.label.generate": "Gerar",
    "customers.label.bill_date": "Data de fatura",
    "customers.label.amount": "Quantia",
    "customers.label.statement": "Declaração",
    // "customers.label.due_date": "Data de vencimento",
    "customers.label.promotional_message": "Mensagem promocional",
    "customers.label.download": "Baixar",
    "customers.label.due_amount": "Valor devido",
    "customers.label.transactions": "Transações",
    "customers.label.file": "Arquivo",
    "customers.label.reset": "Redefinir",
    "customers.label.order_details": "Detalhes do pedido",
    "customers.label.make_payment": "Efetuar pagamento",
    "customers.label.credit_amount": "Valor creditado",
    "customers.label.debit_amount": "Valor debitado",
    "customers.label.cancel_remark": "Observação de cancelamento",
    "customers.label.pay_invoice": "Pagar fatura",
    "customers.label.account": "Conta",
    "customers.label.deposit": "Depósito",
    "customers.label.payment_date": "Data de pagamento",
    "customers.label.payment_type": "Tipo de pagamento",
    "customers.label.receipt_no": "Número do recibo",
    "customers.label.cheque_no": "Número do cheque",
    "customers.label.bank_name": "Nome do banco",
    "customers.label.branch_name": "Nome da agência",
    "customers.label.cheque_date": "Data do cheque",
    "customers.label.invoice_id": "ID da fatura",
    "customers.label.invoice_date": "Data da fatura",
    "customers.label.invoice_amount": "Valor da fatura",
    // "customers.label.due_amount": "Valor devido",
    "customers.label.payment_reversal": "Estorno de pagamento",
    "customers.label.date_filter": "Filtro de data",
    "customers.label.add_event_order": "Adicionar Ordem de Evento",
    "customers.label.event_order": "Pedido de Evento",
    "customers.label.eventdate": "Data do evento",
    "customers.label.serviceAddress": "Endereço de Serviço",
    "customers.label.event_name": "Nome do Evento",
    "customers.label.booked_date": "Data Reservada",
    "customers.label.event_price": "Preço do Evento",
    "customers.label.events": "Eventos",
    "customers.label.format_type": "Tipo de Formato",
    "customers.label.opt_type": "Tipo OPT",
    "customers.label.client_bill_profile": "Perfil de fatura do cliente",
    "customers.label.edit": "Editar",
    "customers.label.type": "Tipo",
    "customers.label.client_id": "ID do cliente",
    "customers.label.bill_currency": "Moeda da fatura",
    "customers.label.bill_frequency": "Frequência de faturamento",
    "customers.label.bill_segment": "Segmento de faturamento",
    // "customers.label.next_bill_day": "Próximo dia de faturamento",
    "customers.label.last_bill_day": "Último dia de faturamento",
    "customers.label.last_bill_no": "Número da última fatura",
    "customers.label.bill_suppression_flag": "Indicador de supressão de fatura",
    "customers.label.bill_suppression_id": "ID de supressão de fatura",
    "customers.label.first_bill": "Primeira fatura",
    "customers.label.hot_bill": "Fatura urgente",
    "customers.label.edit_bill_profile": "Editar perfil de fatura",
    "customers.label.bill_suppression": "Supressão de fatura",
    // "customers.label.more_info": "Mais informações",
    "customers.label.identities": "Identidades",
    "customers.label.add_client_identities": "Adicionar identidades do cliente",
    "customers.label.unique_identification": "Identificação única",
    "customers.label.identity_documents": "Documentos de identidade",
    "customers.label.additional_info": "Informações adicionais",
    "customers.label.nationality": "Nacionalidade",
    "customers.label.date_of_birth": "Data de nascimento",
    "customers.label.preferred_language": "Idioma preferido",
    "customers.label.finance_id": "ID Financeiro",
    "customers.label.remarks": "Observações",
    "customers.label.preferred_communication": "Comunicação preferida",
    "customers.label.add_client_identifier":
      "Adicionar identificador do cliente",
    "customers.label.document_type": "Tipo de documento",
    "customers.label.document_uploads": "Uploads de documento",
    "customers.label.select_file": "Selecionar arquivo",
    "customers.label.credit_card_details": "Detalhes do cartão de crédito",
    "customers.label.card_number": "Número do cartão",
    "customers.label.cvv": "CVV",
    "customers.label.card_type": "Tipo de cartão",
    "customers.label.expiry_date": "Data de validade",
    "customers.label.ach_card": "Cartão ACH",
    "customers.label.ach_card_routing_number":
      "Número de roteamento do cartão ACH",
    "customers.label.bank_account_number": "Número da conta bancária",
    "customers.label.childs": "Crianças",
    "customers.label.cell_phone": "Celular",
    "customers.label.create_client_additional_info":
      "Criar informações adicionais do cliente",
    "customers.label.gender": "Gênero",
    "customers.label.id_type": "Tipo de ID",
    // "customers.label.nationality": "Nacionalidade",
    "customers.label.id_number": "Número de ID",
    "customers.label.job_title": "Cargo",
    "customers.label.age_group": "Faixa etária",
    "customers.label.uts_customer_id": "ID do cliente UTS",
    "customers.label.ach_card_name": "Nome do cartão ACH",
    "customers.label.adjustment": "Ajuste",
    // "customers.label.created_adjustment": "Ajuste criado",
    "customers.label.adjustment_date": "Data do ajuste",
    "customers.label.adjustment_code": "Código do ajuste",
    "customers.label.adjustment_amount": "Valor do ajuste",
    "customers.label.adjustment_type": "Tipo de ajuste",
    "customers.label.office_id": "ID do escritório",
    "customers.label.history": "Histórico",
    "customers.label.filter_by_date": "Filtrar por data",
    "customers.label.view_usage_details": "Ver detalhes de uso",
    "customers.label.units": "Unidades",
    "customers.label.tax": "Imposto",
    "customers.label.total_amount": "Valor total",
    "customers.label.account_transaction": "Transação da conta",
    "customers.label.csv_pdf": "CSV/PDF",
    "customers.label.charge_description": "Descrição da cobrança",
    "customers.label.journals": "Diários",
    "customers.label.download_financial_summary_data":
      "Baixar dados resumidos financeiros",
    "customers.label.select_from_date": "Selecionar a partir da data",
    "customers.label.select_to_date": "Selecionar até a data",
    "customers.label.village_street": "Aldeia/Rua",
    "customers.label.previous": "Anterior",
    "customers.label.Disconnect": "Desconectar",
    "customers.label.ApplyPromo": "Aplicar Promoção",
    "customers.label.Service": "Serviço",
    "customers.label.Product": "Produto",
    "customers.label.CreditCard": "Cartão de Crédito",
    "customers.label.Paypal": "Paypal",
    "customers.label.BusinessEntity": "Entidade Comercial",
    "customers.label.Plan": "Plano",
    "customers.label.Phone": "Telefone",
    "customers.label.TaxExemption": "Isenção de Impostos",
    "customers.label.YES": "SIM",
    "customers.label.NO": "NÃO",
    "customers.label.Resolution": "Resolução",
    "customers.label.AccountNo": "Número de Conta",
    "customers.label.ChipId": "Id do Chip",
    "customers.label.MobileNo": "Número de Celular",
    "customers.label.EmailId": "Id do Email",
    "customers.label.SerialNo": "Número de Série",
    "customers.label.LegacyNo": "Número Legado",
    "customers.label.searchclient": "Procurar Cliente",
    "customers.label.PrimaryAddress": "Endereço Principal",
    "customers.label.BillingAddress": "Endereço de Cobrança",
    // "customers.label.lco": "lco",
    "customers.label.EventDate": "Data do Evento",
    "customers.label.CreateAdjustment": "Criar Ajuste",
    "customers.label.full_name": "Nome completo",
    "customers.label.bill_collection_action": "Ação de Cobrança de Fatura",
    "customers.label.collection_actions": "Ações de Cobrança",
    "customers.label.action_name": "Nome da Ação",
    "customers.label.action_date": "Data da Ação",
    "customers.label.balance_due": "Saldo Devido",
    "customers.label.bill_id": "ID da Fatura",
    "customers.label.view_goods_receipt": "Ver recibo de mercadorias",
    "customers.label.payinfo": "Informações de Pagamento",
    "customers.label.cardtoken": "Token do Cartão",
    "customers.label.autopay": "Pagamento Automático",
    "customers.label.paynow": "Pagar Agora",
    "customers.label.featureList": "Lista de Recursos",
    "customers.label.consumed": "Consumido",
    "customers.label.updateCreditLimt": "Atualizar Limite de Crédito",
    "customers.label.PendingForApproval": "Pendente de Aprovação",

    "customers.label.SpendCapHistory": "Histórico de limite de gastos",
    "customers.label.DateTime": "Data e hora",
    "customers.label.SpendCapEventName": "Nome do evento de limite",
    "customers.label.SpendingLimit": "Limite de gastos",
    "customers.label.ConsumedLimit": "Limite consumido",
    "customers.label.EventId": "ID do evento",
    "customer.label.collectionStatus": "Status da Coleção",
  },
  zh_CN: {
    "customers.label.temporaryBlock": "临时封锁",
    "customers.label.unBlock": "解封",
    "customers.label.feedback": "反馈",
    "customers.label.event_id": "事件ID",
    "customers.label.slc_state_history": "SLC状态历史记录",
    "customers.label.slc": "SLC",
    "customers.label.state_Change_Time": "状态变更时间",
    "customers.label.event": "事件",
    "customers.label.previous_state": "前一个状态",
    "customers.label.resolution_date": "解决日期",
    "customers.label.current_state": "当前状态",
    "customers.label.created_time": "创建时间",
    "customers.label.creation_time": "创建时间",
    "customers.label.Promotion": "促销",
    "customers.label.slc_status": "SLC 状态",
    "customers.label.update_slc_status": "更新 SLC 状态",
    "customers.label.temporary_block": "临时封锁",
    "customers.label.workflow_id": "工作流ID",
    "customers.label.externalPromoId": "外部促销ID",
    "customers.label.externalPromoName": "外部促销名称",
    "customers.label.promoCode": "促销代码",
    "customers.label.promoDescription": "促销描述",
    "customers.label.ScheduleOrder": "安排订单",
    "customers.label.ScheduledDate": "预定日期",
    "customers.label.ViewRateLimit": "查看速率限制",
    "customers.label.SelectType": "选择类型",
    "customers.label.search": "搜索",
    "customers.label.SelectTaxExemption": "选择免税",
    "customers.label.ViewTickets": "查看工单",
    "customers.label.TicketHistory": "工单历史",
    "customers.label.ReopenTicket": "重新打开工单",
    "customers.label.SelectInvoiceType": "选择发票类型",
    "customers.label.SelectCategory": "选择类别",
    "customers.label.SelectSubCategory": "选择子类别",
    "customers.label.SelectSource": "选择来源",
    "customers.label.TicketHistory": "工单历史",
    "customers.label.ViewSpendCap": "查看支出上限",
    "customers.label.ResponseMessage": "响应消息",
    "customers.label.AddPlan": "添加计划",
    "customers.label.Basket": "购物篮",
    "customers.label.TotalPrice": "总价",
    "customers.label.Send_Link_to_Customer_to_Complete_Payment":
      "发送链接给客户完成付款",
    "customers.label.CheckPaymentStatus": "检查付款状态",
    "customers.label.Are_you_sure_you_want_to_terminate?": "您确定要终止吗？",
    "customers.label.Unlimited": "无限制",
    "customers.label.days_left": "剩余天数",
    "customers.label.search": "搜索",
    "customers.label.JobTitle": "职位名称",
    "customers.label.SelectDocumentType": "选择文件类型",
    "customers.label.SelectEvents": "选择事件",
    "customers.label.SelectFormatType": "选择格式类型",
    "customers.label.SelectAdjustmentType": "选择调整类型",
    "customers.label.card_number": "卡号",
    "customers.label.Select_OPT_Type": "选择OPT类型",
    "customers.label.StartDate": "开始日期",
    "customers.label.EndDate": "结束日期",
    "customers.label.Cancel": "取消",
    "customers.label.Set": "设置",
    "customers.label.PaymentDetails": "付款详情",
    "customers.label.PaymentReceipt": "付款收据",
    "customers.label.Status": "状态",
    "customers.label.PaymentAmount": "付款金额",
    "customers.label.Transaction": "交易",
    "customers.label.PaymentPage": "付款页面",
    "customers.label.ItemCode": "项目代码",
    "customers.label.StartDate": "开始日期",
    "customers.label.English": "英语",
    "customers.label.SelectIdProof": "选择身份证明",
    "customers.label.SelectAdjustementCode": "选择调整代码",
    "customers.label.SelectAdjustmentType": "选择调整类型",
    "customers.label.SelectFormat": "选择格式",
    "customers.label.AreYouSure?": "你确定吗？",
    "customers.label.ChargeId": "收费编号",
    "customers.label.ChargeDescription": "收费描述",
    "customers.label.DiscountAmount": "折扣金额",
    "customers.label.NetChargeAmount": "净收费金额",
    "customers.label.TaxDescription": "税务描述",
    "customers.label.TaxAmount": "税额",
    "customers.label.SelectDate": "选择日期",
    "customers.label.SelectPriority": "选择优先级",
    "customers.label.SelectCategory": "选择类别",
    "customers.label.SelectSubCategory": "选择子类别",
    "customers.label.SelectSource": "选择来源",
    "customers.label.ViewSpendCap": "查看支出上限",
    "customers.label.Amount": "金额",
    "customers.label.PlanCode": "计划代码",
    "customers.label.Price": "价格",
    "customers.label.Status": "状态",
    "customers.label.EndDate": "结束日期",
    "customers.label.ContractPeriod": "合同期限",
    "customers.label.AutoRenew": "自动续订",
    "customers.label.Description": "描述",
    "customers.label.ThankYou": "谢谢！",
    "customers.label.ConnectionActivated": "连接已成功激活，账户号码为",
    "customers.label.GoToCustomerDetail": "前往客户详情",
    "customers.label.Payment": "支付",
    "customers.label.CustomerToPay": "客户支付：",
    "customers.label.MonthlyPayment": "每月付款",
    "customers.label.SetupWithDirectDebitOrCreditCard":
      "使用直接借记或信用卡设置",
    "customers.label.SendLinkToCustomerToCompletePayment":
      "发送链接给客户完成支付",
    "customers.label.CheckPaymentStatus": "检查支付状态",
    "customers.label.ThisNumberIsReservedFor": "此号码保留给",
    "customers.label.YouSelected": "您选择了",
    "customers.label.SerialNo": "序列号",
    "customers.label.PhoneNo": "电话号码",
    "customers.label.ActivatingCustomer": "正在激活客户...",
    "customers.label.LoadingOrderStatus": "正在加载订单状态...",
    "customers.label.OrderStatus": "订单状态：",
    "customers.label.Failed": "失败",
    "customers.label.RoamingOutsideEEA": "欧洲经济区（EEA）以外的漫游",
    "customers.label.TariffTermsDetails":
      "请查看我们的资费条款和网站，了解有关超出您套餐的特定资费和收费的更多详细信息。",
    "customers.label.PaymentTerms":
      "我们将通过 SEPA 直接扣款从您的账户中扣除您需要支付的金额，除非另有协议。发票将显示我们扣款的日期。我们可能会要求您提前支付一次性费用和订阅费。在特殊情况下，我们可能会收取中期费用。例如，如果您在短时间内使用某项服务超出平均水平。如果您使用信用卡或借记卡付款，您授权支付卡公司向我们及我们的分包商和/或代理人提供有关您的支付账户的信息，并严格保密。如果您的支付账户被终止或暂停，您也授权他们通知我们。",
    "customers.label.ServiceAgreementTerms": "服务协议的期限、续约和终止",
    "customers.label.Duration": "期限",
    "customers.label.Renewal": "续约",
    "customers.label.ContractTermsAndConditions": "合同条款和条件",
    "customers.label.TermsAndConditions": "条款和条件",
    "customers.label.CustomerExplanation": "我已向客户详细解释",
    "customers.label.CustomerAgreement": "并且他们同意继续订单。",
    "customers.label.NumberReservedFor": "此号码已保留给",
    "customers.label.YouSelected": "您选择了",
    "customers.label.SerialNo": "序列号",
    "customers.label.PhoneNo": "电话号码",
    "customers.label.TotalPrice": "总价",
    "customers.label.FeaturesForEndUsersWithDisabilities":
      "为残疾用户提供的功能",
    "customers.label.InformationSupportServices":
      "支持我们服务的信息可提供替代格式。如果您希望以替代格式访问我们的信息，请通过您的 Lycamobile SIM 拨打 1200 或访问",
    "customers.label.HowWeUseYourInformation": "我们如何使用您的信息",
    "customers.label.InformationUsageDetails":
      "我们将收集您使用我们的服务以及与我们的服务一起使用的第三方服务的信息，包括您的位置和账户活动，以提升您的整体体验，使其更符合您的需求。我们可能会使用和分析您的个人详细信息来管理您的服务和账户，包括信用检查和欺诈预防。我们可能会与经过严格筛选的第三方共享和合并这些数据和信息，以实现相同的目的。您的信息将按照我们的隐私政策处理，您可以在以下地址查看：",
    "customers.label.CustomerComplaints":
      "如果您对服务的速度、质量或其他方面不满意，并希望提出投诉，请联系客户服务。您可以在我们的客户投诉行为准则中了解更多信息，该准则可在以下地址找到",
    "customers.label.DisputeResolution":
      "如果我们无法解决您的投诉，您可以在 12 个月内将投诉提交给电信服务争议委员会。您还可以在欧盟委员会的在线争议解决平台上提交投诉，或向民事法院提起诉讼。",
    "customers.label.costsEuro": "费用 €",
    "customers.label.thereafterEuro": "之后 €",
    "customers.label.forTheFirst": "前",
    "customers.label.perMonthInclusiveVAT":
      "每月，包括增值税（受CPI+ 3.9%年度增长的影响）。详情请查看网站。",
    "customers.label.additionalAddOns":
      "您的套餐可能提供额外的附加服务，并将单独计费。",
    "customers.label.paymentTerms":
      "您必须在账单到期日之前支付所订阅或使用的服务费用。如逾期付款，我们可能会收取费用。我们可能会要求您支付押金，以便使用服务。请参阅我们的资费条款和网站，了解特定资费和超出套餐范围的收费详情。",
    "customers.label.durationRenewalTermination": "期限、续订和终止",
    "customers.label.minimumPeriod":
      "最低期限为1个月，之后每月自动续订，直至您提前30天通知终止（除非适用其他法律或监管规则），并且您需要支付通知期内产生的费用。",
    "customers.label.cancellationCoolingOff":
      "如果您改变主意并直接从我们这里购买的服务，您可能有权在14天冷静期内取消服务协议。",
    "customers.label.earlyTerminationCharge":
      "您同意，如果您已有SIM卡或在收到SIM卡后，服务将立即开始。如果您希望在最低期限内终止服务协议，或者由于您的严重违反协议导致我们终止协议，则您需要支付提前终止费用，该费用不会超过您的月度订阅费用乘以最低期限剩余的月数（包含适用的增值税），扣除一定比例的单笔最终支付。您还需支付您产生的所有通话、短信、数据及其他费用，包括冷静期内的费用。",
    "customers.label.ContractSummarys":
      "本合同摘要以及我们提供的1个月大型国际服务订阅，使您能够通过网络进行语音通话、发送和接收短信、使用数据以及访问互联网，同时包括我们同意提供且您选择接收的任何可选附加服务。",
    "customers.label.The": "该",
    "customers.label.ComesWith": "包含：",
    "customers.label.MobileDataSpeeds": "移动数据服务速度",
    "customers.label.DataServiceDescription":
      "Lycamobile网络提供的数据服务及其最小和最大速度取决于您的位置可用的技术，例如2G、Edge、3G、4G、5G，您所使用的设备以及您购买的套餐类型。",
    "customers.label.DataSpeedVariation":
      "您的移动数据服务速度可能会有所不同，具体取决于您的位置、周围环境（天气、树木覆盖、建筑材料以及使用网络的人数）和用于连接网络的设备。",
    "customers.label.LycamobileBV": "Lycamobile B.V.",
    "customers.label.Robijnlaan17": "Robijnlaan 17,",
    "customers.label.2132WXHoofddorp": "2132WX Hoofddorp,",
    "customers.label.TheNetherlands": "荷兰",
    "customers.label.ContractSummary": "合同摘要",
    "customers.label.ContractSummaryDescription1":
      "本合同摘要提供此服务优惠的主要元素，符合法律要求。",
    "customers.label.ContractSummaryDescription2":
      "它有助于比较不同的服务优惠。",
    "customers.label.ContractSummaryDescription3":
      "完整的服务信息可在其他文件中找到。",
    "customers.label.ContractSummaryValidity": "本合同摘要有效期至结账截止日期",
    "customers.label.AcceptOffer":
      "如果此优惠适合您，可以通过结账页面接受。请保留本文件的副本以供记录。",
    "customers.label.Services": "服务",
    "customers.label.TermsConditions":
      "根据服务协议的条款和条件，如果我们违反协议中的重要条款，导致无法向您提供服务中的数据，并且在收到您通过 Lycamobile 客户服务的投诉后 7 天内未能纠正，您可以终止协议。",
    "customers.label.EmergencyOrganisations": "紧急机构和来电者位置信息",
    "customers.label.EmergencyCallInstructions":
      "如果您需要拨打 112/999 紧急电话，而 Lycamobile 网络因任何原因宕机或不可用，您的移动设备应能够连接到 2G、3G、4G 或 5G 无线电网络，并可选择覆盖范围内的竞争对手网络以拨打紧急电话。",
    "customers.label.EmergencyCallAvailability":
      "紧急电话只能在有无线电网络的情况下拨打。",
    "customers.label.PlanName": "套餐名称",
    "customers.label.EuropeanOnlineDisputeResolution": "欧洲在线争议解决网站",
    "customers.label.ECWebsite": "ec.europa.eu/consumers/odr",
    "customers.label.DisputeResolutionDetails":
      "允许消费者提交与我们在线购买相关的争议。您可以访问我们的网站，获取投诉行为准则的副本以及我们关于替代争议解决的最新信息。我们随时为您提供帮助。如果出现问题，我们希望能够解决。您可以在我们的客户投诉行为准则中了解更多信息，该准则可在。",
    "customers.label.NetherlandsLawCompliance":
      "如果互联网接入服务的实际速度表现与承诺的速度存在持续或经常性的差异，根据荷兰法律，Lycamobile将在合理的时间内提供再次服务。如果再次服务不可能，Lycamobile将合理地降低客户支付的服务费用。如果客户已经付款，Lycamobile将退还超出金额的部分。",
    "customers.label.DirectoryServiceInfo":
      "您可以要求我们将您的手机号码包含在电话簿和/或电话查询服务中。但是，您应该知道，如果您申请此服务，您的号码将对用于营销目的的信息收集公司可见。如果您担心这一点，可以选择退出或使用您的反对权来阻止未经请求的营销电话。如果您希望您的手机号码包含在目录和/或查询服务中，请告诉我们的客户服务团队。",
    "customers.label.RemediesComplaints": "补救措施、投诉处理和争议解决",
    "customers.label.ContactCustomerService":
      "如果您需要联系客户服务，请访问网站并点击“联系我们”。如果您想投诉我们的服务，请联系客户服务。如果您仍然不满意，可以写信进行公正审查至：",
    "customers.label.IncludeMobileNumber":
      "如果您写信给我们，请包含您的手机号码。如果我们无法解决您的投诉，您可以在 24 个月内向 De Geschillencommissie（Postbus 90600, 2509 LP, Den Haag）提交您的投诉。",
    "customers.label.Termination": "终止",
    "customers.label.TerminationNotice":
      "在最低期限之后，您可以通过通知我们来终止协议（除非适用其他法律或监管规定），并且您需要支付该通知期内产生的费用。",
    "customers.label.EarlyTerminationCharge":
      "除非另有规定（例如您的资费条款中），如果您希望在最低期限内终止服务协议，或者由于您的重大违规行为我们终止服务协议，则您需要支付提前终止费用，该费用不会超过您的月度订阅费乘以剩余的最低期限月份数，并包括增值税（按现行税率计算）。",
    "customers.label.OptionalAddOnTermination":
      "任何可选附加服务将独立于任何月度套餐计划终止。",
    "customers.label.CancellationInfo":
      "如果您改变主意或需要取消，您有权在下单后的 14 天内取消对我们的条款和条件的接受（冷静期），前提是您按照我们的取消政策或通知 Lycamobile 进行取消。这不会影响您的法定权利。",
    "customers.label.Security": "安全",
    "customers.label.SecurityPolicy":
      "我们知悉的所有安全事件都将被分析以进行分类、控制、恢复、分析和解决。根据适用的监管和合同要求，将及时通知受影响的客户。需要进行取证调查的安全事件将由 Lycamobile 或适当情况下的合格第三方进行调查，以期解决和防止未来发生类似事件。",
    "customers.label.DataProtection": "数据保护",
    "customers.label.DataProtectionPolicy":
      "在不违反数据保护法律的前提下，Lycamobile 需要客户的个人信息以提供服务，例如：姓名、地址、账户号码、手机号码和付款详情。您的信息将根据我们的隐私政策进行处理，该政策规定了我们如何收集、使用和共享您的信息，与谁共享以及原因，同时描述您的权利并解释如何行使这些权利。",
    "customers.label.TariffTerms":
      "请查看我们的资费条款和网站，以获取有关特定资费和套餐外费用的更多详细信息。",
    "customers.label.DeliveryOfService": "服务交付",
    "customers.label.PaymentTerms":
      "我们将通过 SEPA 直接借记从您的账户中扣除您需要支付的金额，除非我们另有约定...",
    "customers.label.ServiceStartDate":
      "Lycamobile 提供服务的日期是您注册 Lycamobile 的日期。",
    "customers.label.ContractDuration": "服务协议的期限、续订和终止",
    "customers.label.MinimumPeriod":
      "您的订阅有一个称为最低期限的最短期限，可能为 1 个月（月套餐）或 24 个月（固定期限合同）。",
    "customers.label.ContractRenewal":
      "要续签合同，您必须在上一份合同期内通知 Lycamobile，并同意续约。",
    "customers.label.DataCostDetails":
      "{40GB数据}的费用为前{3个月} {18.90欧元}，之后每月{27.00欧元}，含增值税（受CPI + 3.9%年度增长的影响）。详情请参见我们的网站。",
    "customers.label.AdditionalAddons":
      "您的套餐可能有额外附加组件，并将单独收费。",
    "customers.label.SpendingLimits": "消费限制",
    "customers.label.SpendingLimitDetails":
      "Lycamobile 将根据您的偏好在您的账户上设置最高250欧元的消费限制。",
    "customers.label.PremiumCharges":
      "高级号码、短号码通话或短信以及国际语音通话不包含在套餐内，将按特定费率收费。",
    "customers.label.InternationalRates":
      "从荷兰拨打到其他国家的电话和短信将按照我们的标准国际费率收费：",
    "customers.label.RoamingInEEA": "EEA 内漫游",
    "customers.label.RoamingOutsideEEA": "EEA 外漫游",
    "customers.label.RoamingCharges":
      "在荷兰或欧洲经济区 (EEA) 以外的目的地使用手机（通话、短信和数据）将按照我们的国际漫游费率收费：",
    "customers.label.Any_Out_of_bundle_charges_can_be_found_at":
      "任何超出套餐的费用可在以下位置找到：",
    "customers.label.Exclusions_for_voice_international_voice_SMS_Data_Roaming_can_be_found_at":
      "语音、国际语音、短信、数据漫游的排除项可在以下位置找到：",
    "customers.label.Our_Services_availability":
      "我们的服务并非在荷兰、欧洲经济区或其他选定目的地的所有地方都可用。我们的国内和漫游公平使用政策包括对我们服务的可接受使用：",
    "customers.label.Lycamobile_network_speeds":
      "Lycamobile 网络的数据服务及相关的最小和最大速度取决于可访问的技术，例如您的位置、所使用的设备以及购买的套餐类型（2G、Edge、3G、4G、5G）。",
    "customers.label.Mobile_data_speed_variation":
      "您的移动数据服务速度可能会有所变化，取决于您的位置、周围环境（天气、树木覆盖情况、建筑材料和使用该网络的人数）以及用于连接网络的设备。",
    "customers.label.Price": "价格",
    "customers.label.ContractReview": "合同审查",
    "customers.label.Terms&Conditions": "条款和条件",
    "customers.label.ReviewThisContract": "审查此合同",
    "customers.label.We_have_sent_these_to": "我们已将这些发送至",
    "customers.label.DownloadContractInformation": "下载合同信息",
    "customers.label.DownloadContractSummary": "下载合同摘要",
    "customers.label.ContractInformation": "合同信息",
    "customers.label.ContactDetails": "联系方式",
    "customers.label.Description_of_Services": "服务描述",
    "customers.label.This_contract_summary_and_our_Abonnement_offer_of":
      "此合同摘要及我们的订阅优惠",
    "customers.label.an_airtime_service_for": "一个用于的通话时间服务",
    "customers.label.comes_with:": "包含：",
    "customers.label.Any_Out_of_bundle_charges_can_be_found_at:":
      "任何超出套餐的费用可在此找到：",
    "customers.label.service_description":
      "该服务可让您拨打和接听语音电话、发送和接收短信、使用数据和访问互联网，所有这些均通过网络进行，同时包含任何我们同意提供并您选择接受的可选附加服务。",
    "customers.label.YouHaveChosenNoCap":
      "您选择了无限额。这意味着您可以使用手机进行通话、短信、国际分钟、漫游和超出每月套餐的数据。您将被收取最高 60 欧元的费用。",
    "customers.label.SelectDate":
      "选择日期 [月付款将在您选择的账单生成日期后 14 天从您的账户中扣除] *",
    "customers.label.billing_cycle": "账单周期",
    "customers.label.SelectBilling": "选择账单",
    "customers.label.I_Agree_To": "我同意",
    "customers.label.TermsAndConditions": "条款和条件",
    "customers.label.ThisNumberIsReservedFor": "此号码保留给",
    "customers.label.TotalPrice": "总价格：",
    "customers.label.CustomerInfo": "客户信息",
    "customers.label.title": "标题",
    "customers.label.SelectTitle": "选择标题",
    "customers.label.initials": "缩写",
    "customers.label.Basket": "购物篮",
    "customers.label.first_name": "名",
    "customers.label.last_name": "姓",
    "customers.label.email_address": "电子邮件地址",
    "customers.label.contact_number": "联系电话",
    "customers.label.date_of_birth": "出生日期",
    "customers.label.select_language": "选择语言",
    "customers.label.how_did_you_hear": "你是如何听说我们的？",
    "customers.label.postal_code": "邮政编码",
    "customers.label.country": "国家",
    "customers.label.Enter_address_manually": "手动输入地址",
    "customers.label.Find_address": "查找地址",
    "customers.label.Select_Address": "选择地址",
    "customers.label.Select_an_address": "选择一个地址",
    "customers.label.Enter_address_dynamically": "动态输入地址",
    "customers.label.address_number": "地址编号",
    "customers.label.street": "街道",
    "customers.label.state": "州/省",
    "customers.label.city": "城市",
    "customers.label.resident_period": "居住期限",
    "customers.label.Spend_Cap_Amount": "消费上限金额",
    "customers.label.I_don’t_want_a_Spend_Cap": "我不想要消费上限",
    "customers.label.Monthly_Bill_Generation_Date": "每月账单生成日期",
    "customers.label.Select_a_Monthly_Plan": "选择月度计划",
    "customers.label.Search_plans": "搜索计划...",
    "customers.label.search": "搜索",
    "customers.label.Select_a_plan": "选择计划",
    "customers.label.Basket": "购物篮",
    "customers.label.This_number_is_reserved_for": "此号码已保留给",
    "customers.label.ViewT&C": "查看条款和条件",
    "customers.label.TransferringFromPreviousNetwork":
      "从以前的网络转移（携号转网）",
    "customers.label.SIM_Information": "SIM信息",
    "customers.label.Prepaid": "预付费",
    "customers.label.Postpaid": "后付费",
    "customers.label.Physical_SIM": "实体SIM",
    "customers.label.eSIM": "电子SIM",
    "customers.label.SelectCustomerType": "选择客户类型",
    "customers.label.New_to_Lyca": "新用户",
    "customers.label.Convert_Lyca_Prepaid_to_Postpaid":
      "转换Lyca预付费为后付费",
    "customers.label.Existing_customer_is_going_to_be_sent_a_secure_link_to_confirm_that_they_wish_to_move_from_prepaid_to_abonnement.":
      "现有客户将收到安全链接以确认他们希望从预付费转换为订阅。",
    "customers.label.Customer_to_receive_an_SMS": "客户将收到短信",
    "customers.label.Lyca_Mobile_Number": "Lyca手机号码",
    "customers.label.Enter_the_Lyca_Mobile_Number": "输入Lyca手机号码",
    "customers.label.Nationality": "国籍",
    "customers.label.Send_Secure_link": "发送安全链接",
    "customers.label.New_to_Lyca_Mobile": "新加入Lyca Mobile",
    "customers.label.serial_number": "序列号",
    "customers.label.Serial_Number": "序列号（最后4位）",
    "customers.label.PUK_Code": "PUK码",
    "customers.label.PUK_Code_is_not_matched": "PUK码不匹配",
    "customers.label.Switching_to_Lyca_Mobile": "切换到Lyca Mobile",
    "customers.label.Enter_the_PUK_Code": "输入PUK码",
    "customers.label.Basket": "购物篮",
    "customers.label.Gender": "性别",
    "customers.label.business_name": "公司名称",
    "customers.label.phone_number": "电话号码",
    "customers.label.Date_of_Birth": "出生日期",
    "customers.label.VIP": "VIP",
    "customers.label.Disability": "残疾",
    "customers.label.District": "地区",
    "customers.label.Is_your_billing_address_same_as_primary_address":
      "您的账单地址是否与主要地址相同？",
    "customers.label.Supressbill": "隐藏账单",
    "customers.label.SelectCategory": "选择类别",
    "customers.label.SelectGender": "选择性别",
    "customers.label.SelectPreferences": "选择偏好",
    "customers.label.SelectNationality": "选择国籍",
    "customers.label.SelectVIP": "选择VIP",
    "customers.label.SelectDisability": "选择残疾",
    "customers.label.SelectCity": "选择城市",
    "customers.label.SelectBillDay": "选择账单日",
    "customers.label.SelectType": "选择类型",
    "customers.label.SelectFiscalYear": "选择财政年度",
    "customers.label.SelectFiscalQuarter": "选择财政季度",
    "customers.label.SelectBillMode": "选择账单模式",
    "customers.label.SelectInvoiceType": "选择发票类型",
    "customers.label.IMSI": "IMSI",
    "customers.label.SalesMotion": "销售动态",
    "customers.label.SpendCap": "消费上限",
    "customers.label.ActivationDate": "激活日期",
    "customers.label.ExpiryDate": "到期日期",
    "customers.label.NextRenewalDate": "下次续订日期",
    "customers.label.BalanceTransfer": "余额转账",
    "customers.label.RecieverClientId": "接收客户ID",
    "customers.label.Amount": "金额",
    "customers.label.EnterTopUpAmount": "输入充值金额",
    "customers.label.ResponseId": "响应ID",
    "customers.label.BalanceName": "余额名称",
    "customers.label.Allowance": "津贴",
    "customers.label.Consumption": "消费",
    "customers.label.AvailableBalance": "可用余额",
    "customers.label.DaysLeft": "剩余天数",
    "customers.label.Discount": "折扣",
    "customers.label.postal_code": "邮政编码",
    "customers.label.address_number": "地址编号",
    "customers.label.city": "城市",
    "customers.label.state": "州",
    "customers.label.country": "国家",
    "customers.label.resident_period": "居住期限",
    "customers.label.postcode": "邮政编码",
    "customers.label.comment_date": "评论日期",
    "customers.label.how_did_you_hear": "您是如何知道我们的？",
    "customers.label.select_language": "选择语言",
    "customers.label.email_address": "电子邮件地址",
    "customers.label.contact_number": "联系电话",
    "customers.label.initials": "首字母",
    "customers.label.communication_type": "通信类型",
    "customers.label.BuySIM": "购买SIM卡",
    "customers.label.origination": "起源",
    "customers.label.address": "地址",
    "customers.label.destination_address": "目的地地址",
    "customers.label.event": "事件",
    "customers.label.charge_party": "计费方",
    "customers.label.service_subs_type": "服务订阅类型",
    "customers.label.calling_party": "主叫方",
    "customers.label.called_party": "被叫方",
    "customers.label.usage": "使用量",
    "customers.label.monetary_charge": "货币费用",
    "customers.label.result_code": "结果代码",
    "customers.label.generation_time": "生成时间",
    "customer.label.generationdatetime": "生成日期和时间",
    "customers.label.transaction_id": "交易 ID",
    "customers.label.application_transaction_id": "应用交易 ID",
    "customers.label.application_name": "应用名称",
    "customers.label.recharge_value": "充值金额",
    "customers.label.interface": "接口",
    "customers.label.result": "结果",
    "customers.label.comment": "评论",
    "customers.label.recharge": "充值",
    "customers.label.cdr": "CDR",
    "customers.label.notifications": "通知",
    "customers.label.mobile_no": "Enter Mobile No",
    "customers.label.email_id": "Enter Email Id",
    "customers.label.serial_number": "Serial No",
    "customers.label.digital_content": "数字内容",
    "customers.label.buySim": "购买SIM",
    "customers.label.outstanding_due": "应付金额",
    "customers.label.due_date": "到期日期",
    "customers.label.unbilled_amount": "未计费金额",
    "customers.label.next_bill_day": "下一个账单日",
    "customers.label.view_allowances": "查看津贴",
    "customers.label.view_service_details": "查看服务详情",
    "customers.label.spend_limit": "消费限额",
    "customers.label.topup_balance": "充值余额",
    "customers.label.next_renewal_date": "下次续订日期",
    "customers.label.allowance": "津贴",
    "customers.label.ViewDocumentUpload": "查看文档上传",
    "customers.label.total_net_amount": "净总额",
    "customers.label.cancelRemark": "取消備註",
    "customers.label.cancelPayment": "取消付款",
    "customers.label.all": "全部",
    "customers.label.billProfile": "账单资料",
    "customers.label.charges": "费用",
    "customers.label.book_order": "图书订单",
    "customers.label.customers": "顾客",
    "customers.label.search_for_clients": "搜索客户",
    "customers.label.advance_search": "高级搜索",
    "customers.label.create_customer": "创建客户",
    "customers.label.account_no": "帐号",
    "customers.label.customer_name": "客户姓名",
    "customers.label.created_by": "创建者",
    "customers.label.created_on": "创建于",
    "customers.label.credit_limit": "信用额度",
    "customers.label.transaction_history": "交易历史",
    "customers.label.external_activity_log": "外部活动日志",
    "customers.label.settings": "设置",
    "system.label.currency_noncurrency": "货币 非货币",
    "entity.label.configure": "配置",

    "customers.label.business_entity": "业务实体",
    "customers.label.balance": "余额",
    "customers.label.valid_from": "有效期自",
    "customers.label.valid_to": "有效期至",
    "customers.label.non_currency_details": "非货币详情",
    "customers.label.view_details": "查看详情",
    "customers.label.status": "状态",
    "customers.label.first_name": "名字",
    "customers.label.price_discount": "价格与折扣",
    "customers.label.collection_status": "收集状态",
    "customers.label.last_name": "姓氏",
    "customers.label.city_area": "城市/地区",
    "customers.label.email": "电子邮件",
    "customers.label.phone": "电话",
    "customers.label.cafid": "CAF Id",
    "customers.label.enter_business_entity": "輸入商業實體",
    "customers.label.select": "选择",
    "customers.label.refund": "退款",
    "customers.label.refund_id": "退款编号",
    "customers.label.refund_amount": "退款金额",
    "customers.label.select_category_type": "选择类别类型",
    "customers.label.clear": "清除",
    "customers.label.search": "搜索",
    "customers.label.customer_activation": "客户激活",
    "customers.label.customer_details": "客户详情",
    "customers.label.loc": "LOC",
    "customers.label.customer_category": "客户类别",
    "customers.label.service_details": "服务详情",
    "customers.label.name": "名称",
    "customers.label.add_service": "添加服务",
    "customers.label.network_node": "网络节点",
    "customers.label.device_details": "设备详情",
    "customers.label.item": "物品",
    "customers.label.discount_code": "折扣代码",
    "customers.label.total_price": "总价格",
    // "customers.label.device_details": "设备详情",
    "customers.label.plan_details": "计划详情",
    "customers.label.payment_details": "付款詳情",
    "customers.label.plan_list": "计划列表",
    "customers.label.plan": "计划",
    "customers.label.contract_period": "合同期限",
    "customers.label.charge_cycle": "收费周期",
    "customers.label.cancel": "取消",
    "customers.label.next": "下一个",
    "customers.label.done": "完成",
    "customers.label.reopen": "重新開放",
    "customers.label.submit": "提交",
    "customers.label.view_customer": "查看客户",
    "customers.label.account_number": "账号",
    "customers.label.serial_no": "序列号",
    "customers.label.office_hierarchy": "办公室层次结构",
    "customers.label.account_type": "账户类型",
    // "customers.label.balance": "余额",
    "customers.label.stb_serial_no": "机顶盒序列号",
    "customers.label.non_currency_balance": "非货币余额",
    "customers.label.service_orders": "服务订单",
    "customers.label.more_info": "更多信息",
    "customers.label.notes": "备注",
    "customers.label.device": "设备",
    "customers.label.tickets": "票",
    "customers.label.on_demand": "按需",
    "customers.label.on_demand_billing": "按需计费",
    "customers.label.account_transaction": "帐户交易",
    "customers.label.payments": "付款",
    "customers.label.invoice": "发票",
    "customers.label.contact_information": "联系信息",
    "customers.label.address_information": "地址信息",
    "customers.label.billing_information": "结算信息",
    "customers.label.balance_information": "余额信息",
    // "customers.label.customer_name": "客户姓名",
    "customers.label.parent_child": "父母/子女",
    "customers.label.created_date": "创建日期",
    "customers.label.district": "区",
    "customers.label.pincode": "邮政编码",
    "customers.label.last_bill_amount": "上次账单金额",
    "customers.label.last_bill_date": "上次账单日期",
    "customers.label.last_bill_paid": "上次账单已支付",
    "customers.label.last_paid_amount": "上次支付金额",
    "customers.label.last_payment_date": "上次支付日期",
    "customers.label.next_bill_date": "下次账单日期",
    "customers.label.service_overview": "服务概览",
    "customers.label.service_without_device": "无设备服务",
    "customers.label.create_ticket": "创建工单",
    "customers.label.service_activation": "服务激活",
    "customers.label.order_charging": "订单收费",
    "customers.label.top_up": "充值",
    "customers.label.redeem": "兑换",
    "customers.label.collection_name": "收藏名称",
    "customers.label.redeem_voucher": "兑换优惠券",
    "customers.label.service_id": "服务ID",
    "customers.label.service_code": "服务代码",
    "customers.label.start_date": "开始日期",
    "customers.label.modified_date": "修改日期",
    // "customers.label.status": "状态",
    "customers.label.info": "信息",
    "customers.label.action": "操作",
    "customers.label.add_device": "添加设备",
    "customers.label.add_plans": "添加计划",
    "customers.label.suspend": "暂停",
    "customers.label.reactivate": "重新激活",
    "customers.label.terminate": "终止",
    "customers.label.command_center": "命令中心",
    "customers.label.retrack": "重新跟踪",
    "customers.label.cancel_plans": "取消计划",
    "customers.label.device_overview": "设备概览",
    "customers.label.item_code": "物品代码",
    "customers.label.orders_overview": "订单概览",
    // "customers.label.plan": "计划",
    "customers.label.end_date": "结束日期",
    "customers.label.price": "价格",
    "customers.label.short_description": "簡短描述",
    "customers.label.description": "描述",
    "customers.label.add_note": "添加备注",
    "customers.label.note": "备注",
    "customers.label.sale_type": "销售类型",
    "customers.label.bill_item_details": "账单项目详情",
    "customers.label.charge_id": "收费编号",
    "customers.label.order_id": "订单编号",
    "customers.label.item_tax_details": "项目税务详情",
    "customers.label.discount_details": "折扣详情",
    "customers.label.sale_date": "销售日期",
    "customers.label.charge_code": "收费代码",
    "customers.label.quantity": "数量",
    // "customers.label.total_price": "总价",
    "customers.label.warranty_date": "保修日期",
    "customers.label.allocate": "分配",
    "customers.label.contact_info": "联系信息",
    "customers.label.edit_customer": "编辑客户",
    "customers.label.lco": "LCO",
    "customers.label.title": "标题",
    // "customers.label.customer_category": "客户类别",
    "customers.label.middle_name": "中间名",
    "customers.label.caf_id": "CAF Id",
    "customers.label.landline_number": "固定電話號碼",
    "customers.label.user_name": "用户名",
    "customers.label.customer_photo": "客户照片",
    "customers.label.id_proof": "身份证明",
    "customers.label.id_proof_value": "身份证明价值",
    "customers.label.save": "保存",
    "customers.label.close_customer": "关闭客户",
    "customers.label.closure_date": "关闭日期",
    "customers.label.closure_reason": "关闭原因",
    "customers.label.close": "关闭",
    "customers.label.address_info": "地址信息",
    "customers.label.edit_address": "编辑地址",
    "customers.label.address_no": "地址编号",
    "customers.label.street": "街道",
    "customers.label.building": "建筑物",
    "customers.label.zipcode": "邮政编码",
    "customers.label.billing": "账单",
    "customers.label.same_as_primary": "与主要相同",
    "customers.label.building_code": "建筑物代码",
    "customers.label.add_address": "添加地址",
    "customers.label.address_type": "地址类型",
    "customers.label.billing_info": "结算信息",
    "customers.label.created_adjustment": "创建调整",
    "customers.label.create_order": "创建订单",
    "customers.label.sale_catalog": "销售目录",
    "customers.label.renew_plan": "更新计划",
    "customers.label.auto_renew": "自动续订",
    // "customers.label.search": "搜索",
    "customers.label.entity_name": "实体名称",
    "customers.label.discount": "折扣",
    "customers.label.provisioning_commands": "配置命令",
    "customers.label.command": "命令",
    "customers.label.plans": "计划",
    "customers.label.client_service_detail": "客户服务详细信息",
    "customers.label.id": "身份证",
    "customers.label.parameter_name": "参数名称",
    "customers.label.parameter_value": "参数值",
    "customers.label.request_type": "请求类型",
    "customers.label.client_info": "客户端信息",
    "customers.label.service_info": "服务信息",
    "customers.label.new_device_info": "新设备信息",
    "customers.label.task_list": "任务列表",
    "customers.label.provisioning_detail": "配置详情",
    "customers.label.provisioning_id": "配置ID",
    "customers.label.task_id": "任务ID",
    "customers.label.sent_message": "已发送消息",
    "customers.label.available_plans": "可用计划",
    "customers.label.disconnect_order": "断开订单",
    "customers.label.reason": "原因",
    "customers.label.porting_out": "移植出来",
    "customers.label.prepaid_to_postpaid": "预付费转后付费",
    "customers.label.postpaid_to_prepaid": "后付费转预付费",
    "customers.label.addons": "插件",
    "customers.label.change_plan": "更改计划",
    "customers.label.swap_sim": "更换SIM卡",
    "customers.label.select_date": "选择日期",
    "customers.label.order_date": "订单日期",
    "customers.label.priority": "优先级",
    "customers.label.ticket_date": "工单日期",
    "customers.label.category": "类别",
    "customers.label.sub_category": "子类别",
    "customers.label.team": "团队",
    "customers.label.team_user": "团队用户",
    "customers.label.source": "来源",
    "customers.label.due_time": "截止时间",
    "customers.label.device_swap": "设备更换",
    // "customers.label.terminate": "终止",
    "customers.label.confirm": "确认",
    "customers.label.continue": "继续",
    "customers.label.process_date": "处理日期",
    "customers.label.pin_number": "PIN号码",
    "customers.label.renewal": "续约",
    // "customers.label.create_customer": "创建客户",
    "customers.label.individual": "个人",
    "customers.label.corporate": "公司",
    "customers.label.corporate_details": "公司详情",
    "customers.label.contact_person": "联系人",
    "customers.label.entity": "实体",
    "customers.label.client_category": "客户类别",
    "customers.label.preferences": "偏好",
    "customers.label.parent_id": "父ID",
    "customers.label.child": "子",
    "customers.label.villege_street": "村/街道",
    "customers.label.billing_address": "账单地址",
    "customers.label.bill_information": "账单信息",
    "customers.label.bill_day_of_month": "每月账单日",
    "customers.label.fiscal_year": "财政年度",
    "customers.label.fiscal_quater": "财政季度",
    "customers.label.bill_mode": "账单模式",
    "customers.label.invoice_type": "发票类型",
    "customers.label.payment_information": "付款信息",
    "customers.label.funder_name": "资助方名称",
    "customers.label.funder_id": "资助方ID",
    "customers.label.po_number": "采购订单号",
    "customers.label.payment_term": "付款条件",
    "customers.label.customer_created_successfully": "客户创建成功",
    "customers.label.go_to_customer": "转到客户",
    "customers.label.view_order": "查看订单",
    "customers.label.disconnect": "断开连接",
    "customers.label.apply_promo": "申请促销",
    // "customers.label.order_id": "订单编号",
    "customers.label.order_type": "订单类型",
    "customers.label.billing_cycle": "计费周期",
    "customers.label.plan_name": "计划名称",
    "customers.label.user_action": "用户操作",
    "customers.label.invoice_till_date": "发票截止日期",
    "customers.label.order_services": "订单服务",
    "customers.label.service_type": "服务类型",
    "customers.label.service_description": "服务描述",
    "customers.label.bill_start_date": "账单开始日期",
    "customers.label.bill_end_date": "账单结束日期",
    // "customers.label.invoice_till_date": "发票截止日期",
    "customers.label.charge_type": "费用类型",
    "customers.label.rate_uom": "费率/UOM",
    "customers.label.discount_description": "折扣描述",
    "customers.label.discount_type": "折扣类型",
    "customers.label.discount_start_date": "折扣开始日期",
    "customers.label.discount_end_date": "折扣结束日期",
    "customers.label.discount_amount": "折扣金额",
    "customers.label.order_transaction": "订单交易",
    "customers.label.user": "用户",
    "customers.label.transaction_date": "交易日期",
    "customers.label.transaction_type": "交易类型",
    "customers.label.actual_date": "实际日期",
    "customers.label.promo": "促销",
    "customers.label.promotion": "促销",
    "customers.label.disconnection_date": "断开日期",
    "customers.label.disconnection_reason": "断开原因",
    "customers.label.problem_code": "问题代码",
    "customers.label.assign_to": "分配给",
    "customers.label.last_comment": "最后评论",
    "customers.label.file_name": "文件名",
    "customers.label.edit_ticket": "编辑工单",
    "customers.label.close_ticket": "关闭工单",
    "customers.label.resolution_description": "解决方案描述",
    "customers.label.ticket_history": "工单历史",
    // "customers.label.last_comment": "最后评论",
    "customers.label.problem_description": "问题描述",
    "customers.label.generate": "生成",
    "customers.label.bill_date": "账单日期",
    "customers.label.amount": "金额",
    "customers.label.statement": "报表",
    // "customers.label.due_date": "到期日期",
    "customers.label.promotional_message": "促销信息",
    "customers.label.download": "下载",
    "customers.label.due_amount": "到期金额",
    "customers.label.transactions": "交易",
    "customers.label.file": "文件",
    "customers.label.reset": "重置",
    "customers.label.order_details": "订单详情",
    "customers.label.make_payment": "进行支付",
    "customers.label.credit_amount": "信用金额",
    "customers.label.debit_amount": "借记金额",
    "customers.label.cancel_remark": "取消备注",
    "customers.label.pay_invoice": "支付发票",
    "customers.label.account": "账户",
    "customers.label.deposit": "存款",
    "customers.label.payment_date": "支付日期",
    "customers.label.receipt_no": "收据号",
    "customers.label.cheque_no": "支票号",
    "customers.label.bank_name": "银行名称",
    "customers.label.branch_name": "分行名称",
    "customers.label.cheque_date": "支票日期",
    "customers.label.invoice_id": "发票 ID",
    "customers.label.invoice_date": "发票日期",
    "customers.label.invoice_amount": "发票金额",
    // "customers.label.due_amount": "应付金额",
    "customers.label.payment_reversal": "支付撤销",
    "customers.label.date_filter": "日期过滤",
    "customers.label.add_event_order": "添加事件订单",
    "customers.label.event_order": "活动订单",
    "customers.label.eventdate": "活动日期",
    "customers.label.serviceAddress": "服务地址",
    "customers.label.event_name": "事件名称",
    "customers.label.booked_date": "预订日期",
    "customers.label.event_price": "事件价格",
    "customers.label.events": "事件",
    "customers.label.format_type": "格式类型",
    "customers.label.opt_type": "OPT 类型",
    "customers.label.client_bill_profile": "客户账单配置文件",
    "customers.label.edit": "编辑",
    "customers.label.type": "类型",
    "customers.label.client_id": "客户编号",
    "customers.label.bill_frequency": "账单频率",
    "customers.label.bill_segment": "账单段",
    // "customers.label.next_bill_day": "下一账单日",
    "customers.label.last_bill_day": "上次账单日",
    "customers.label.last_bill_no": "上次账单号",
    "customers.label.payment_type": "付款类型",
    "customers.label.bill_suppression_flag": "账单抑制标志",
    "customers.label.bill_suppression_id": "账单抑制ID",
    "customers.label.first_bill": "首张账单",
    "customers.label.hot_bill": "紧急账单",
    "customers.label.edit_bill_profile": "编辑账单配置文件",
    "customers.label.bill_currency": "账单货币",
    "customers.label.bill_suppression": "账单抑制",
    // "customers.label.more_info": "更多信息",
    "customers.label.identities": "身份",
    "customers.label.add_client_identities": "添加客户身份",
    "customers.label.unique_identification": "唯一标识",
    "customers.label.identity_documents": "身份文件",
    "customers.label.additional_info": "附加信息",
    "customers.label.nationality": "国籍",
    "customers.label.date_of_birth": "出生日期",
    "customers.label.preferred_language": "首选语言",
    "customers.label.finance_id": "金融 ID",
    "customers.label.remarks": "备注",
    "customers.label.preferred_communication": "首选通讯",
    "customers.label.add_client_identifier": "添加客户标识符",
    "customers.label.document_type": "文档类型",
    "customers.label.document_uploads": "文档上传",
    "customers.label.select_file": "选择文件",
    "customers.label.credit_card_details": "信用卡详情",
    "customers.label.card_number": "卡号",
    "customers.label.cvv": "CVV",
    "customers.label.card_type": "卡类型",
    "customers.label.expiry_date": "到期日期",
    "customers.label.ach_card": "ACH卡",
    "customers.label.ach_card_routing_number": "ACH卡路由号码",
    "customers.label.bank_account_number": "银行账号",
    "customers.label.childs": "子女",
    "customers.label.cell_phone": "手机",
    "customers.label.create_client_additional_info": "创建客户附加信息",
    "customers.label.gender": "性别",
    "customers.label.id_type": "ID类型",
    // "customers.label.nationality": "国籍",
    "customers.label.id_number": "身份证号码",
    "customers.label.job_title": "职称",
    "customers.label.age_group": "年龄段",
    "customers.label.uts_customer_id": "UTS客户ID",
    "customers.label.ach_card_name": "ACH卡名称",
    "customers.label.adjustment": "调整",
    // "customers.label.created_adjustment": "创建的调整",
    "customers.label.adjustment_date": "调整日期",
    "customers.label.adjustment_code": "调整代码",
    "customers.label.adjustment_amount": "调整金额",
    "customers.label.adjustment_type": "调整类型",
    "customers.label.activity_log": "活动日志",
    "customers.label.office_id": "办公室ID",
    "customers.label.history": "历史记录",
    "customers.label.filter_by_date": "按日期筛选",
    "customers.label.view_usage_details": "查看使用详情",
    "customers.label.units": "单位",
    "customers.label.tax": "税",
    "customers.label.total_amount": "总金额",
    "customers.label.csv_pdf": "CSV/PDF",
    "customers.label.charge_description": "费用说明",
    "customers.label.journals": "期刊",
    "customers.label.download_financial_summary_data": "下载财务摘要数据",
    "customers.label.select_from_date": "选择起始日期",
    "customers.label.select_to_date": "选择结束日期",
    "customers.label.village_street": "村/街道",
    "customers.label.previous": "以前",
    "customers.label.Disconnect": "断开",
    "customers.label.ApplyPromo": "应用促销",
    "customers.label.Service": "服务",
    "customers.label.Product": "产品",
    "customers.label.CreditCard": "信用卡",
    "customers.label.Paypal": "Paypal",
    "customers.label.BusinessEntity": "业务实体",
    "customers.label.Plan": "计划",
    "customers.label.Phone": "电话",
    "customers.label.TaxExemption": "免税",
    "customers.label.YES": "是",
    "customers.label.NO": "否",
    "customers.label.Resolution": "分辨率",
    "customers.label.AccountNo": "账号",
    "customers.label.ChipId": "芯片编号",
    "customers.label.MobileNo": "手机号",
    "customers.label.EmailId": "电子邮件ID",
    "customers.label.SerialNo": "序列号",
    "customers.label.LegacyNo": "遗留编号",
    "customers.label.searchclient": "搜索客户",
    "customers.label.PrimaryAddress": "主要地址",
    "customers.label.BillingAddress": "账单地址",
    // "customers.label.lco": "lco",
    "customers.label.EventDate": "事件日期",
    "customers.label.CreateAdjustment": "创建调整",
    "customers.label.full_name": "全名",
    "customers.label.bill_collection_action": "账单催收行动",
    "customers.label.collection_actions": "催收行动",
    "customers.label.action_name": "行动名称",
    "customers.label.action_date": "行动日期",
    "customers.label.balance_due": "应付余额",
    "customers.label.bill_id": "账单编号",
    "customers.label.view_goods_receipt": "查看货物收据",
    "customers.label.payinfo": "支付信息",
    "customers.label.cardtoken": "卡片令牌",
    "customers.label.autopay": "自动支付",
    "customers.label.paynow": "立即支付",
    "customers.label.featureList": "功能列表",
    "customers.label.consumed": "已消耗",
    "customers.label.updateCreditLimt": "更新信用额度",
    "customers.label.PendingForApproval": "待批准",

    "customers.label.SpendCapHistory": "消费上限历史",
    "customers.label.DateTime": "日期和时间",
    "customers.label.SpendCapEventName": "消费上限事件名称",
    "customers.label.SpendingLimit": "消费限额",
    "customers.label.ConsumedLimit": "已用限额",
    "customers.label.EventId": "事件ID",
    "customers.label.collectionStatus": "收集状态",
  },
  hi: {
    "customers.label.temporaryBlock": "अस्थायी अवरोध",
    "customers.label.unBlock": "अवरोध हटाएं",
    "customers.label.feedback": "प्रतिक्रिया",
    "customers.label.event_id": "इवेंट आईडी",
    "customers.label.slc_state_history": "SLC स्थिति इतिहास",
    "customers.label.slc": "SLC",
    "customers.label.state_Change_Time": "स्थिति परिवर्तन का समय",
    "customers.label.event": "घटना",
    "customers.label.previous_state": "पिछली स्थिति",
    "customers.label.resolution_date": "समाधान तिथि",
    "customers.label.current_state": "वर्तमान स्थिति",
    "customers.label.created_time": "बनाने का समय",
    "customers.label.creation_time": "निर्माण समय",
    "customers.label.Promotion": "प्रमोशन",
    "customers.label.slc_status": "SLC स्थिति",
    "customers.label.update_slc_status": "SLC स्थिति अपडेट करें",
    "customers.label.temporary_block": "अस्थायी अवरोध",
    "customers.label.workflow_id": "वर्कफ़्लो आईडी",
    "customers.label.externalPromoId": "बाहरी प्रोमो आईडी",
    "customers.label.externalPromoName": "बाहरी प्रोमो नाम",
    "customers.label.promoCode": "प्रोमो कोड",
    "customers.label.promoDescription": "प्रोमो विवरण",
    "customers.label.ScheduleOrder": "ऑर्डर निर्धारित करें",
    "customers.label.ScheduledDate": "निर्धारित तिथि",
    "customers.label.ViewRateLimit": "दर सीमा देखें",
    "customers.label.SelectType": "प्रकार चुनें",
    "customers.label.search": "खोजें",
    "customers.label.SelectTaxExemption": "कर छूट चुनें",
    "customers.label.ViewTickets": "टिकट देखें",
    "customers.label.TicketHistory": "टिकट इतिहास",
    "customers.label.ReopenTicket": "टिकट पुनः खोलें",
    "customers.label.SelectInvoiceType": "चालान प्रकार चुनें",
    "customers.label.SelectCategory": "श्रेणी चुनें",
    "customers.label.SelectSubCategory": "उप-श्रेणी चुनें",
    "customers.label.SelectSource": "स्रोत चुनें",
    "customers.label.TicketHistory": "टिकट इतिहास",
    "customers.label.ViewSpendCap": "खर्च सीमा देखें",
    "customers.label.ResponseMessage": "प्रतिक्रिया संदेश",
    "customers.label.AddPlan": "प्लान जोड़ें",
    "customers.label.Basket": "टोकरी",
    "customers.label.TotalPrice": "कुल मूल्य",
    "customers.label.Send_Link_to_Customer_to_Complete_Payment":
      "ग्राहक को भुगतान पूरा करने के लिए लिंक भेजें",
    "customers.label.CheckPaymentStatus": "भुगतान स्थिति जांचें",
    "customers.label.Are_you_sure_you_want_to_terminate?":
      "क्या आप वाकई समाप्त करना चाहते हैं?",
    "customers.label.Unlimited": "असीमित",
    "customers.label.days_left": "शेष दिन",
    "customers.label.search": "खोजें",
    "customers.label.JobTitle": "नौकरी का शीर्षक",
    "customers.label.SelectDocumentType": "दस्तावेज़ प्रकार चुनें",
    "customers.label.SelectEvents": "घटनाएँ चुनें",
    "customers.label.SelectFormatType": "प्रारूप प्रकार चुनें",
    "customers.label.SelectAdjustmentType": "समायोजन प्रकार चुनें",
    "customers.label.card_number": "कार्ड नंबर",
    "customers.label.Select_OPT_Type": "OPT प्रकार चुनें",
    "customers.label.StartDate": "प्रारंभ तिथि",
    "customers.label.EndDate": "समाप्ति तिथि",
    "customers.label.Cancel": "रद्द करें",
    "customers.label.Set": "सेट करें",
    "customers.label.PaymentDetails": "भुगतान विवरण",
    "customers.label.PaymentReceipt": "भुगतान रसीद",
    "customers.label.Status": "स्थिति",
    "customers.label.PaymentAmount": "भुगतान राशि",
    "customers.label.Transaction": "लेन-देन",
    "customers.label.PaymentPage": "भुगतान पृष्ठ",
    "customers.label.ItemCode": "आइटम कोड",
    "customers.label.StartDate": "प्रारंभ तिथि",
    "customers.label.English": "अंग्रेज़ी",
    "customers.label.SelectIdProof": "पहचान प्रमाण चुनें",
    "customers.label.SelectAdjustementCode": "समायोजन कोड चुनें",
    "customers.label.SelectAdjustmentType": "समायोजन प्रकार चुनें",
    "customers.label.SelectFormat": "प्रारूप चुनें",
    "customers.label.AreYouSure?": "क्या आपको यकीन है?",
    "customers.label.ChargeId": "शुल्क आईडी",
    "customers.label.ChargeDescription": "शुल्क विवरण",
    "customers.label.DiscountAmount": "छूट राशि",
    "customers.label.NetChargeAmount": "नेट चार्ज राशि",
    "customers.label.TaxDescription": "कर विवरण",
    "customers.label.TaxAmount": "कर राशि",
    "customers.label.SelectDate": "तारीख़ चुनें",
    "customers.label.SelectPriority": "प्राथमिकता चुनें",
    "customers.label.SelectCategory": "श्रेणी चुनें",
    "customers.label.SelectSubCategory": "उपश्रेणी चुनें",
    "customers.label.SelectSource": "स्रोत चुनें",
    "customers.label.ViewSpendCap": "व्यय सीमा देखें",
    "customers.label.Amount": "राशि",
    "customers.label.PlanCode": "योजना कोड",
    "customers.label.Price": "मूल्य",
    "customers.label.Status": "स्थिति",
    "customers.label.EndDate": "समाप्ति तिथि",
    "customers.label.ContractPeriod": "अनुबंध अवधि",
    "customers.label.AutoRenew": "स्वचालित नवीनीकरण",
    "customers.label.Description": "विवरण",
    "customers.label.ThankYou": "धन्यवाद!",
    "customers.label.ConnectionActivated":
      "खाता संख्या के साथ कनेक्शन सफलतापूर्वक सक्रिय कर दिया गया है",
    "customers.label.GoToCustomerDetail": "ग्राहक विवरण पर जाएं",
    "customers.label.Payment": "भुगतान",
    "customers.label.CustomerToPay": "ग्राहक को भुगतान:",
    "customers.label.MonthlyPayment": "मासिक भुगतान",
    "customers.label.SetupWithDirectDebitOrCreditCard":
      "डायरेक्ट डेबिट या क्रेडिट कार्ड के साथ सेटअप करें",
    "customers.label.SendLinkToCustomerToCompletePayment":
      "भुगतान पूरा करने के लिए ग्राहक को लिंक भेजें",
    "customers.label.CheckPaymentStatus": "भुगतान स्थिति जांचें",
    "customers.label.ThisNumberIsReservedFor": "यह नंबर आरक्षित है",
    "customers.label.YouSelected": "आपने चयन किया",
    "customers.label.SerialNo": "सीरियल नंबर",
    "customers.label.PhoneNo": "फ़ोन नंबर",
    "customers.label.ActivatingCustomer": "ग्राहक सक्रिय किया जा रहा है...",
    "customers.label.LoadingOrderStatus": "ऑर्डर स्थिति लोड हो रही है...",
    "customers.label.OrderStatus": "ऑर्डर स्थिति:",
    "customers.label.Failed": "असफल",
    "customers.label.RoamingOutsideEEA": "ईईए के बाहर रोमिंग",
    "customers.label.TariffTermsDetails":
      "कृपया हमारे टैरिफ शर्तें और वेबसाइट देखें ताकि विशिष्ट टैरिफ और आपके भत्ते के बाहर के शुल्कों के बारे में अधिक जानकारी प्राप्त कर सकें।",
    "customers.label.PaymentTerms":
      "हम आपके खाते से SEPA डायरेक्ट डेबिट द्वारा वह राशि काट लेंगे जो आपको हमें भुगतान करनी है, जब तक कि हमने अन्यथा सहमति नहीं दी है। चालान में वह तिथि दिखाई जाएगी जिस दिन हम चालान राशि काटेंगे। हम आपसे एकमुश्त शुल्क और सदस्यता शुल्क पहले ही भुगतान करने के लिए कह सकते हैं। विशेष मामलों में, हम अंतरिम राशि वसूल सकते हैं। उदाहरण के लिए, यदि आपने एक छोटी अवधि में औसत से अधिक किसी सेवा का उपयोग किया है। यदि आप क्रेडिट या डेबिट कार्ड से भुगतान कर रहे हैं, तो आप भुगतान कार्ड कंपनी को हमें और हमारे उप-ठेकेदारों और/या एजेंटों को आपके भुगतान खाते के बारे में जानकारी प्रदान करने के लिए अधिकृत करते हैं, यदि यह समझौते के संबंध में आवश्यक हो। आप उन्हें यह भी अधिकृत करते हैं कि यदि आपका भुगतान खाता समाप्त या निलंबित हो जाए तो हमें सूचित करें।",
    "customers.label.ServiceAgreementTerms":
      "सेवा समझौते की अवधि, नवीनीकरण और समाप्ति",
    "customers.label.Duration": "अवधि",
    "customers.label.Renewal": "नवीनीकरण",
    "customers.label.ContractTermsAndConditions": "अनुबंध की शर्तें और नीतियां",
    "customers.label.TermsAndConditions": "नियम और शर्तें",
    "customers.label.CustomerExplanation":
      "मैंने ग्राहक को विस्तार से समझाया है",
    "customers.label.CustomerAgreement":
      "और वे ऑर्डर जारी रखने के लिए सहमत हैं।",
    "customers.label.NumberReservedFor": "यह नंबर आरक्षित है",
    "customers.label.YouSelected": "आपने चुना",
    "customers.label.SerialNo": "सीरियल नंबर",
    "customers.label.PhoneNo": "फ़ोन नंबर",
    "customers.label.TotalPrice": "कुल मूल्य",
    "customers.label.FeaturesForEndUsersWithDisabilities":
      "विकलांग उपयोगकर्ताओं के लिए सुविधाएँ",
    "customers.label.InformationSupportServices":
      "हमारी सेवाओं के समर्थन में जानकारी वैकल्पिक प्रारूपों में उपलब्ध है। यदि आप वैकल्पिक प्रारूप में जानकारी तक पहुँच प्राप्त करना चाहते हैं, तो कृपया अपने Lycamobile सिम से 1200 पर कॉल करें या विज़िट करें",
    "customers.label.HowWeUseYourInformation":
      "हम आपकी जानकारी का उपयोग कैसे करते हैं",
    "customers.label.InformationUsageDetails":
      "हम आपके द्वारा हमारे सेवाओं और तृतीय-पक्ष सेवाओं के उपयोग से संबंधित जानकारी एकत्र करेंगे, जिसमें आपका स्थान और खाता गतिविधि शामिल है, ताकि आपकी समग्र अनुभव को बेहतर बना सकें और इसे आपके लिए अधिक प्रासंगिक बना सकें। हम आपके व्यक्तिगत विवरणों का उपयोग और विश्लेषण आपके सेवा(ओं) और खाते को संचालित करने में सहायता के लिए करेंगे, जिसमें क्रेडिट जाँच और धोखाधड़ी रोकथाम शामिल है। हम उन डेटा और आपकी जानकारी को सावधानीपूर्वक चुने गए तृतीय पक्षों के साथ साझा और संयोजित कर सकते हैं। आपकी जानकारी को हमारी गोपनीयता नीति के अनुसार माना जाता है, जिसे यहाँ देखा जा सकता है:",
    "customers.label.CustomerComplaints":
      "यदि आप सेवा की गति, गुणवत्ता या अन्य तत्वों से संतुष्ट नहीं हैं और शिकायत दर्ज करना चाहते हैं, तो कृपया ग्राहक सेवा से संपर्क करें। आप हमारे ग्राहक शिकायत संहिता में अधिक जानकारी प्राप्त कर सकते हैं, जो यहाँ उपलब्ध है",
    "customers.label.DisputeResolution":
      "यदि हम आपकी शिकायत का समाधान नहीं कर सकते हैं, तो आप इसे 12 महीनों के भीतर दूरसंचार सेवाओं विवाद समिति में प्रस्तुत कर सकते हैं। आप यूरोपीय आयोग के ऑनलाइन विवाद समाधान प्लेटफॉर्म पर भी शिकायत दर्ज कर सकते हैं या दीवानी अदालत में मुकदमा दायर कर सकते हैं।",
    "customers.label.costsEuro": "मूल्य €",
    "customers.label.thereafterEuro": "बाद में €",
    "customers.label.forTheFirst": "पहले के लिए",
    "customers.label.perMonthInclusiveVAT":
      "प्रति माह, VAT सहित (CPI + 3.9% वार्षिक वृद्धि के अधीन)। अधिक विवरण के लिए वेबसाइट देखें।",
    "customers.label.additionalAddOns":
      "आपकी योजना के लिए अतिरिक्त ऐड-ऑन उपलब्ध हो सकते हैं और आपके बिल में अलग से शुल्क लिया जाएगा।",
    "customers.label.paymentTerms":
      "आपको हर महीने अपनी सेवा के शुल्क का भुगतान करना होगा। भुगतान में देरी होने पर हम शुल्क लगा सकते हैं। सेवाओं का उपयोग करने से पहले हम आपसे एक जमा राशि का अनुरोध कर सकते हैं। विशिष्ट टैरिफ और भत्तों के बाहर के शुल्क के बारे में अधिक जानकारी के लिए हमारी वेबसाइट देखें।",
    "customers.label.durationRenewalTermination": "अवधि, नवीनीकरण और समाप्ति",
    "customers.label.minimumPeriod":
      "कम से कम 1 महीने की न्यूनतम अवधि है और उसके बाद यह मासिक रूप से जारी रहेगा जब तक कि आप 30 दिन की सूचना देकर इसे समाप्त नहीं करते। आपको इस अवधि में किए गए शुल्क का भुगतान करना होगा।",
    "customers.label.cancellationCoolingOff":
      "यदि आपने सीधे हमसे सेवा खरीदी है और अपना मन बदल लिया है, तो आप 14-दिन की कूलिंग-ऑफ अवधि के भीतर सेवा अनुबंध को रद्द करने के हकदार हो सकते हैं।",
    "customers.label.earlyTerminationCharge":
      "यदि आपके पास पहले से ही एक सिम कार्ड है या जब आपको एक सिम कार्ड प्राप्त होता है, तो सेवाएं तुरंत शुरू हो जाएंगी। यदि आप न्यूनतम अवधि के दौरान सेवा अनुबंध समाप्त करना चाहते हैं, तो आपको प्रारंभिक समाप्ति शुल्क देना होगा जो आपकी मासिक सदस्यता शुल्क से अधिक नहीं होगा।",
    "customers.label.ContractSummarys":
      "यह अनुबंध सारांश और हमारी 1 महीने की बड़ी अंतरराष्ट्रीय सेवाओं की सदस्यता आपको नेटवर्क के माध्यम से वॉयस कॉल करने और प्राप्त करने, एसएमएस भेजने और प्राप्त करने, डेटा उपयोग करने और इंटरनेट एक्सेस करने में सक्षम बनाती है, साथ ही कोई भी वैकल्पिक ऐड-ऑन सेवाएं जो हम प्रदान करने के लिए सहमत हैं और जिन्हें आप प्राप्त करना चुनते हैं।",
    "customers.label.The": "यह",
    "customers.label.ComesWith": "शामिल हैं:",
    "customers.label.MobileDataSpeeds": "मोबाइल डेटा सेवा की गति",
    "customers.label.DataServiceDescription":
      "Lycamobile नेटवर्क के माध्यम से उपलब्ध डेटा सेवा और न्यूनतम और अधिकतम गति आपके स्थान पर उपलब्ध तकनीक (जैसे 2G, Edge, 3G, 4G, 5G), उपयोग किए गए डिवाइस और खरीदी गई योजना के प्रकार पर निर्भर करती है।",
    "customers.label.DataSpeedVariation":
      "आपकी मोबाइल डेटा सेवा की गति भिन्न हो सकती है और यह आपके स्थान, आपके आसपास के पर्यावरण (मौसम, पेड़ों की आड़, इमारतों की सामग्री और नेटवर्क का उपयोग करने वाले लोगों की संख्या) और नेटवर्क से कनेक्ट करने के लिए उपयोग किए गए डिवाइस पर निर्भर करती है।",
    "customers.label.LycamobileBV": "Lycamobile B.V.",
    "customers.label.Robijnlaan17": "Robijnlaan 17,",
    "customers.label.2132WXHoofddorp": "2132WX Hoofddorp,",
    "customers.label.TheNetherlands": "नीदरलैंड",
    "customers.label.ContractSummary": "अनुबंध सारांश",
    "customers.label.ContractSummaryDescription1":
      "यह अनुबंध सारांश कानूनी आवश्यकताओं के अनुसार इस सेवा प्रस्ताव के मुख्य तत्व प्रदान करता है।",
    "customers.label.ContractSummaryDescription2":
      "यह सेवा प्रस्तावों की तुलना करने में सहायता करता है।",
    "customers.label.ContractSummaryDescription3":
      "सेवा की पूरी जानकारी अन्य दस्तावेज़ों में प्रदान की जाती है।",
    "customers.label.ContractSummaryValidity":
      "यह अनुबंध सारांश चेकआउट समाप्ति तक वैध है",
    "customers.label.AcceptOffer":
      "यदि यह प्रस्ताव उपयुक्त है, तो आप इसे चेकआउट पृष्ठ के माध्यम से स्वीकार कर सकते हैं। कृपया इस दस्तावेज़ की एक प्रति अपने रिकॉर्ड के लिए रखें।",
    "customers.label.Services": "सेवाएँ",
    "customers.label.TermsConditions":
      "सेवा समझौते की शर्तों और नियमों के अनुसार, यदि हम समझौते की किसी महत्वपूर्ण शर्त को तोड़ते हैं जो हमारे सेवा के हिस्से के रूप में आपको डेटा प्रदान करने की हमारी क्षमता को पूरी तरह से प्रतिबंधित करता है और हम आपकी शिकायत प्राप्त करने के 7 दिनों के भीतर इसे ठीक नहीं करते हैं, तो आप समझौते को समाप्त कर सकते हैं।",
    "customers.label.EmergencyOrganisations":
      "आपातकालीन संगठन और कॉलर स्थान जानकारी",
    "customers.label.EmergencyCallInstructions":
      "यदि आपको Lycamobile नेटवर्क के डाउन या अनुपलब्ध होने पर 112/999 आपातकालीन कॉल करनी हो, तो आपका मोबाइल डिवाइस 2G, 3G, 4G या 5G रेडियो नेटवर्क से कनेक्ट करने में सक्षम होना चाहिए और आपातकालीन कॉल का उपयोग करने के लिए कवरेज वाले किसी प्रतिस्पर्धी नेटवर्क को चुन सकता है।",
    "customers.label.EmergencyCallAvailability":
      "आपातकालीन कॉल केवल तभी की जा सकती हैं जब कोई रेडियो नेटवर्क उपलब्ध हो।",
    "customers.label.PlanName": "योजना नाम",
    "customers.label.EuropeanOnlineDisputeResolution":
      "यूरोपीय ऑनलाइन विवाद समाधान साइट",
    "customers.label.ECWebsite": "ec.europa.eu/consumers/odr",
    "customers.label.DisputeResolutionDetails":
      "उपभोक्ताओं को हमारे साथ ऑनलाइन खरीद से संबंधित विवाद जमा करने की अनुमति देता है। आप हमारी वेबसाइट पर हमारे शिकायत निवारण आचार संहिता की एक प्रति और वैकल्पिक विवाद समाधान पर नवीनतम जानकारी देख सकते हैं। हम आपकी सहायता के लिए यहाँ हैं। यदि कुछ गलत होता है, तो हम उसे ठीक करना चाहते हैं। आप हमारी ग्राहक शिकायत आचार संहिता में हमारे शिकायत प्रक्रिया के बारे में अधिक जान सकते हैं।",
    "customers.label.NetherlandsLawCompliance":
      "यदि इंटरनेट एक्सेस सेवा की वास्तविक गति में निरंतर और/या बार-बार भिन्नता होती है, तो नीदरलैंड्स के कानूनों के अनुसार, Lycamobile एक निश्चित समय में सेवा फिर से प्रदान करेगा। यदि सेवा फिर से प्रदान करना संभव नहीं है, तो Lycamobile ग्राहक द्वारा भुगतान की जाने वाली कीमत को उचित रूप से कम करेगा। यदि ग्राहक पहले ही भुगतान कर चुका है, तो Lycamobile अतिरिक्त भुगतान की गई राशि की वापसी करेगा।",
    "customers.label.DirectoryServiceInfo":
      "आप हमसे अनुरोध कर सकते हैं कि हम आपके मोबाइल फोन नंबर को एक टेलीफोन निर्देशिका और/या एक निर्देशिका पूछताछ सेवा में शामिल करें। हालाँकि, आपको यह जानना चाहिए कि यदि आप इस सेवा का अनुरोध करते हैं, तो आपका नंबर उन कंपनियों को दिखाई देगा जो विपणन उद्देश्यों के लिए जानकारी एकत्र करती हैं। यदि आप इससे चिंतित हैं, तो आप अपनी असहमति के अधिकार का उपयोग करके या ऑप्ट-आउट करके अवांछित विपणन कॉल को रोक सकते हैं। यदि आप चाहते हैं कि आपका मोबाइल फोन नंबर निर्देशिका और/या निर्देशिका पूछताछ सेवा में शामिल किया जाए, तो कृपया हमारी ग्राहक सेवा टीम को बताएं।",
    "customers.label.RemediesComplaints": "उपाय, शिकायत निवारण और विवाद समाधान",
    "customers.label.ContactCustomerService":
      "यदि आपको ग्राहक सेवा से संपर्क करने की आवश्यकता है, तो कृपया वेबसाइट पर जाएं और 'हमसे संपर्क करें' पर क्लिक करें। यदि आप हमारी सेवा के बारे में शिकायत करना चाहते हैं, तो ग्राहक सेवा से संपर्क करें। यदि आप अभी भी असंतुष्ट हैं, तो आप निष्पक्ष समीक्षा के लिए लिख सकते हैं:",
    "customers.label.IncludeMobileNumber":
      "यदि आप हमें लिखते हैं, तो कृपया अपना मोबाइल फोन नंबर शामिल करें। यदि हम आपकी शिकायत का समाधान नहीं कर सकते, तो आप 24 महीनों के भीतर अपनी शिकायत De Geschillencommissie (Postbus 90600, 2509 LP, Den Haag) को भेज सकते हैं।",
    "customers.label.Termination": "समाप्ति",
    "customers.label.TerminationNotice":
      "न्यूनतम अवधि के बाद, आप हमें सूचना देकर समझौते को समाप्त कर सकते हैं (जब तक कि कोई अन्य वैधानिक या नियामक नियम लागू न हों) और आपको इस सूचना अवधि के दौरान किए गए शुल्कों का भुगतान करना होगा।",
    "customers.label.EarlyTerminationCharge":
      "जब तक अन्यथा निर्दिष्ट न किया गया हो (जैसे आपकी टैरिफ शर्तों में), यदि आप न्यूनतम अवधि के दौरान सेवा समझौते को समाप्त करना चाहते हैं या यदि हम आपके गंभीर उल्लंघन के परिणामस्वरूप सेवा समझौते को समाप्त करते हैं, तो आपको एक पूर्व समाप्ति शुल्क का भुगतान करना होगा, जो आपकी मासिक सदस्यता शुल्क को न्यूनतम अवधि के शेष महीनों की संख्या से गुणा करने के बराबर होगा, जिसमें प्रचलित दर पर कर शामिल होगा।",
    "customers.label.OptionalAddOnTermination":
      "कोई भी वैकल्पिक ऐड-ऑन सेवाएँ किसी भी मासिक बंडल योजना से स्वतंत्र रूप से समाप्त हो जाएंगी।",
    "customers.label.CancellationInfo":
      "यदि आप अपना मन बदलते हैं या रद्द करने की आवश्यकता होती है, तो आपको सेवा के लिए अपना आदेश देने के 14 दिनों के भीतर हमारे नियम और शर्तों को स्वीकार करने को रद्द करने का अधिकार है (कूलिंग-ऑफ अवधि), बशर्ते कि आप इसे हमारी रद्द करने की नीति के अनुसार या लाइकामोबाइल को सूचना देकर रद्द करें। इससे आपके वैधानिक अधिकार प्रभावित नहीं होते हैं।",
    "customers.label.Security": "सुरक्षा",
    "customers.label.SecurityPolicy":
      "हमारे ध्यान में आने वाली सभी सुरक्षा घटनाओं का वर्गीकरण, नियंत्रण, पुनर्प्राप्ति, विश्लेषण और समाधान के लिए विश्लेषण किया जाएगा। लागू नियामक और अनुबंध आवश्यकताओं के आधार पर प्रभावित ग्राहकों को समय पर सूचनाएँ भेजी जाएंगी। फॉरेंसिक जांच की आवश्यकता वाली सुरक्षा घटनाएँ लाइकामोबाइल या उपयुक्त मामलों में एक योग्य तृतीय पक्ष द्वारा की जाएंगी, जिसका उद्देश्य समाधान और भविष्य की रोकथाम है।",
    "customers.label.DataProtection": "डेटा सुरक्षा",
    "customers.label.DataProtectionPolicy":
      "डेटा सुरक्षा कानून के प्रति पूर्वाग्रह के बिना, लाइकामोबाइल को सेवाएँ प्रदान करने के लिए ग्राहक की व्यक्तिगत जानकारी की आवश्यकता होती है, जैसे: नाम, पता, खाता संख्या, मोबाइल फोन नंबर और भुगतान विवरण। आपकी जानकारी को हमारी गोपनीयता नीति के अनुसार संभाला जाता है, जो यह निर्धारित करती है कि हम आपकी जानकारी कैसे एकत्र, उपयोग और साझा करते हैं, हम इसे किसके साथ और क्यों साझा करते हैं, आपके अधिकारों का वर्णन करती है और यह बताती है कि आप उन्हें कैसे लागू कर सकते हैं।",
    "customers.label.TariffTerms":
      "कृपया हमारे टैरिफ शर्तों और वेबसाइट को देखें ताकि विशिष्ट टैरिफ और आपके भत्ते के बाहर शुल्कों के बारे में अधिक जानकारी प्राप्त हो सके।",
    "customers.label.DeliveryOfService": "सेवा वितरण",
    "customers.label.PaymentTerms":
      "हम आपके खाते से SEPA डायरेक्ट डेबिट द्वारा आपके भुगतान की राशि डेबिट करेंगे, जब तक कि हमने अन्यथा सहमति नहीं की हो...",
    "customers.label.ServiceStartDate":
      "जिस तारीख को Lycamobile सेवाएं प्रदान करेगा, वह आपकी Lycamobile में पंजीकरण की तारीख होगी।",
    "customers.label.ContractDuration":
      "सेवा अनुबंध की अवधि, नवीनीकरण और समाप्ति",
    "customers.label.MinimumPeriod":
      "आपकी सदस्यता की न्यूनतम अवधि होती है, जिसे न्यूनतम अवधि कहा जाता है, जो मासिक बंडलों के लिए 1 महीने और फिक्स्ड-टर्म अनुबंधों के लिए 24 महीने तक हो सकती है।",
    "customers.label.ContractRenewal":
      "अनुबंध को नवीनीकृत करने के लिए, आपको अपने पिछले अनुबंध की अवधि के दौरान Lycamobile को सूचना देनी होगी और अनुबंध को नवीनीकृत करने की सहमति देनी होगी।",
    "customers.label.DataCostDetails":
      "{40 GB डेटा} की कीमत पहले {3 महीने} के लिए {18.90 €} है, उसके बाद {27.00 €} प्रति माह, जिसमें VAT शामिल है (CPI + 3.9% की वार्षिक वृद्धि के अधीन)। अधिक जानकारी के लिए हमारी वेबसाइट देखें।",
    "customers.label.AdditionalAddons":
      "आपकी योजना के लिए अतिरिक्त Add-ons उपलब्ध हो सकते हैं और इनकी अलग से शुल्क लिया जाएगा।",
    "customers.label.SpendingLimits": "खर्च की सीमा",
    "customers.label.SpendingLimitDetails":
      "Lycamobile आपकी पसंद के अनुसार आपके खाते पर अधिकतम €250 की खर्च सीमा तय करेगा।",
    "customers.label.PremiumCharges":
      "प्रीमियम और शॉर्ट नंबर कॉल या एसएमएस और अंतरराष्ट्रीय वॉयस कॉल इस योजना में शामिल नहीं हैं और इन्हें अलग-अलग शुल्क पर चार्ज किया जाएगा।",
    "customers.label.InternationalRates":
      "नीदरलैंड से अन्य देशों में कॉल और मैसेज हमारे मानक अंतरराष्ट्रीय दरों पर चार्ज किए जाएंगे।",
    "customers.label.RoamingInEEA": "EEA में रोमिंग",
    "customers.label.RoamingOutsideEEA": "EEA के बाहर रोमिंग",
    "customers.label.RoamingCharges":
      "नीदरलैंड या EEA और चयनित स्थानों के बाहर कॉल, संदेश और डेटा का उपयोग हमारे अंतरराष्ट्रीय रोमिंग दरों पर चार्ज किया जाएगा।",
    "customers.label.Any_Out_of_bundle_charges_can_be_found_at":
      "कोई भी अतिरिक्त शुल्क यहां पाया जा सकता है:",
    "customers.label.Exclusions_for_voice_international_voice_SMS_Data_Roaming_can_be_found_at":
      "वॉइस, अंतर्राष्ट्रीय वॉइस, एसएमएस, डेटा रोमिंग के लिए अपवाद यहां पाए जा सकते हैं:",
    "customers.label.Our_Services_availability":
      "हमारी सेवाएं नीदरलैंड, EEA, या अन्य चयनित गंतव्यों में हर जगह उपलब्ध नहीं हैं। हमारी घरेलू और रोमिंग उचित उपयोग नीति में स्वीकार्य उपयोग शामिल है:",
    "customers.label.Lycamobile_network_speeds":
      "Lycamobile नेटवर्क की डेटा सेवा और संबंधित न्यूनतम और अधिकतम गति आपके स्थान, उपयोग किए गए डिवाइस और आपके द्वारा खरीदे गए प्लान पर निर्भर करती है (जैसे 2G, Edge, 3G, 4G, 5G)।",
    "customers.label.Mobile_data_speed_variation":
      "आपकी मोबाइल डेटा सेवा की गति अलग-अलग हो सकती है और यह आपके स्थान, पर्यावरण (मौसम, पेड़, इमारत सामग्री, और नेटवर्क का उपयोग करने वाले लोगों की संख्या) और उपयोग किए गए डिवाइस पर निर्भर करती है।",
    "customers.label.Price": "मूल्य",
    "customers.label.ContractReview": "अनुबंध समीक्षा",
    "customers.label.Terms&Conditions": "नियम और शर्तें",
    "customers.label.ReviewThisContract": "इस अनुबंध की समीक्षा करें",
    "customers.label.We_have_sent_these_to": "हमने इसे भेजा है",
    "customers.label.DownloadContractInformation":
      "अनुबंध जानकारी डाउनलोड करें",
    "customers.label.DownloadContractSummary": "अनुबंध सारांश डाउनलोड करें",
    "customers.label.ContractInformation": "अनुबंध जानकारी",
    "customers.label.ContactDetails": "संपर्क विवरण",
    "customers.label.Description_of_Services": "सेवाओं का विवरण",
    "customers.label.This_contract_summary_and_our_Abonnement_offer_of":
      "इस अनुबंध सारांश और हमारी सदस्यता पेशकश",
    "customers.label.an_airtime_service_for": "के लिए एयरटाइम सेवा",
    "customers.label.comes_with:": "के साथ आता है:",
    "customers.label.Any_Out_of_bundle_charges_can_be_found_at:":
      "किसी भी अतिरिक्त शुल्क की जानकारी यहाँ प्राप्त करें:",
    "customers.label.service_description":
      "जो आपको वॉइस कॉल करने और प्राप्त करने, एसएमएस भेजने और प्राप्त करने, डेटा उपयोग करने और इंटरनेट तक पहुंचने की अनुमति देता है, यह सब नेटवर्क के माध्यम से होता है, साथ ही कोई भी वैकल्पिक ऐड-ऑन सेवाएं जो हम सहमति देते हैं और आप प्राप्त करने का निर्णय लेते हैं।",
    "customers.label.YouHaveChosenNoCap":
      "आपने कोई सीमा नहीं चुनी है। इसका अर्थ है कि आप कॉल, संदेश, अंतरराष्ट्रीय मिनट, रोमिंग और अपनी मासिक भत्ते के बाहर डेटा का उपयोग कर सकते हैं। इसके लिए आपको अधिकतम €60 तक का शुल्क देना होगा।",
    "customers.label.SelectDate":
      "तारीख़ चुनें [मासिक भुगतान आपकी चुनी हुई बिल जनरेशन तिथि के 14 दिनों बाद आपके खाते से डेबिट किया जाएगा] *",
    "customers.label.billing_cycle": "बिलिंग चक्र",
    "customers.label.SelectBilling": "बिलिंग चुनें",
    "customers.label.I_Agree_To": "मैं सहमत हूँ",
    "customers.label.TermsAndConditions": "नियम और शर्तें",
    "customers.label.ThisNumberIsReservedFor": "यह नंबर आरक्षित है",
    "customers.label.TotalPrice": "कुल मूल्य:",
    "customers.label.CustomerInfo": "ग्राहक जानकारी",
    "customers.label.title": "शीर्षक",
    "customers.label.SelectTitle": "शीर्षक चुनें",
    "customers.label.initials": "नामाक्षर",
    "customers.label.Basket": "टोकरी",
    "customers.label.first_name": "पहला नाम",
    "customers.label.last_name": "अंतिम नाम",
    "customers.label.email_address": "ईमेल पता",
    "customers.label.contact_number": "संपर्क नंबर",
    "customers.label.date_of_birth": "जन्म तिथि",
    "customers.label.select_language": "भाषा चुनें",
    "customers.label.how_did_you_hear": "आपने हमारे बारे में कैसे सुना?",
    "customers.label.postal_code": "पिन कोड",
    "customers.label.country": "देश",
    "customers.label.Enter_address_manually": "पता मैन्युअल रूप से दर्ज करें",
    "customers.label.Find_address": "पता खोजें",
    "customers.label.Select_Address": "पता चुनें",
    "customers.label.Select_an_address": "एक पता चुनें",
    "customers.label.Enter_address_dynamically":
      "डायनामिक रूप से पता दर्ज करें",
    "customers.label.address_number": "पता संख्या",
    "customers.label.street": "सड़क",
    "customers.label.state": "राज्य",
    "customers.label.city": "शहर",
    "customers.label.resident_period": "निवास अवधि",
    "customers.label.Spend_Cap_Amount": "खर्च सीमा राशि",
    "customers.label.I_don’t_want_a_Spend_Cap": "मैं खर्च सीमा नहीं चाहता",
    "customers.label.Monthly_Bill_Generation_Date": "मासिक बिल निर्माण तिथि",
    "customers.label.Select_a_Monthly_Plan": "मासिक योजना चुनें",
    "customers.label.Search_plans": "योजनाएं खोजें...",
    "customers.label.search": "खोजें",
    "customers.label.Select_a_plan": "योजना चुनें",
    "customers.label.Basket": "टोकरी",
    "customers.label.This_number_is_reserved_for": "यह नंबर आरक्षित है",
    "customers.label.ViewT&C": "नियम और शर्तें देखें",
    "customers.label.TransferringFromPreviousNetwork":
      "पिछले नेटवर्क से स्थानांतरित (अपना पुराना नंबर लाएं)",
    "customers.label.SIM_Information": "सिम जानकारी",
    "customers.label.Prepaid": "प्रीपेड",
    "customers.label.Postpaid": "पोस्टपेड",
    "customers.label.Physical_SIM": "भौतिक सिम",
    "customers.label.eSIM": "ई-सिम",
    "customers.label.SelectCustomerType": "ग्राहक प्रकार चुनें",
    "customers.label.New_to_Lyca": "नया लाइका उपयोगकर्ता",
    "customers.label.Convert_Lyca_Prepaid_to_Postpaid":
      "लाइका प्रीपेड को पोस्टपेड में बदलें",
    "customers.label.Existing_customer_is_going_to_be_sent_a_secure_link_to_confirm_that_they_wish_to_move_from_prepaid_to_abonnement.":
      "मौजूदा ग्राहक को एक सुरक्षित लिंक भेजा जाएगा ताकि वे पुष्टि कर सकें कि वे प्रीपेड से सब्सक्रिप्शन में बदलना चाहते हैं।",
    "customers.label.Customer_to_receive_an_SMS":
      "ग्राहक को एसएमएस प्राप्त होगा",
    "customers.label.Lyca_Mobile_Number": "लाइका मोबाइल नंबर",
    "customers.label.Enter_the_Lyca_Mobile_Number":
      "लाइका मोबाइल नंबर दर्ज करें",
    "customers.label.Nationality": "राष्ट्रीयता",
    "customers.label.Send_Secure_link": "सुरक्षित लिंक भेजें",
    "customers.label.New_to_Lyca_Mobile": "लाइका मोबाइल के लिए नया",
    "customers.label.serial_number": "सीरियल नंबर",
    "customers.label.Serial_Number": "सीरियल नंबर (अंतिम 4 अंक)",
    "customers.label.PUK_Code": "पीयूके कोड",
    "customers.label.PUK_Code_is_not_matched": "पीयूके कोड मेल नहीं खा रहा है",
    "customers.label.Switching_to_Lyca_Mobile":
      "लाइका मोबाइल पर स्विच कर रहा है",
    "customers.label.Enter_the_PUK_Code": "पीयूके कोड दर्ज करें",
    "customers.label.Basket": "टोकरी",
    "customers.label.Gender": "लिंग",
    "customers.label.business_name": "व्यवसाय का नाम",
    "customers.label.phone_number": "फोन नंबर",
    "customers.label.Date_of_Birth": "जन्म तिथि",
    "customers.label.VIP": "वीआईपी",
    "customers.label.Disability": "विकलांगता",
    "customers.label.District": "ज़िला",
    "customers.label.Is_your_billing_address_same_as_primary_address":
      "क्या आपका बिलिंग पता प्राथमिक पते के समान है?",
    "customers.label.Supressbill": "बिल दबाएं",
    "customers.label.SelectCategory": "श्रेणी चुनें",
    "customers.label.SelectGender": "लिंग चुनें",
    "customers.label.SelectPreferences": "पसंद चुनें",
    "customers.label.SelectNationality": "राष्ट्रीयता चुनें",
    "customers.label.SelectVIP": "वीआईपी चुनें",
    "customers.label.SelectDisability": "विकलांगता चुनें",
    "customers.label.SelectCity": "शहर चुनें",
    "customers.label.SelectBillDay": "बिल दिन चुनें",
    "customers.label.SelectType": "प्रकार चुनें",
    "customers.label.SelectFiscalYear": "वित्तीय वर्ष चुनें",
    "customers.label.SelectFiscalQuarter": "वित्तीय तिमाही चुनें",
    "customers.label.SelectBillMode": "बिलिंग मोड चुनें",
    "customers.label.SelectInvoiceType": "चालान प्रकार चुनें",
    "customers.label.IMSI": "IMSI",
    "customers.label.SalesMotion": "विक्रय गतिकी",
    "customers.label.SpendCap": "खर्च सीमा",
    "customers.label.ActivationDate": "सक्रियण तिथि",
    "customers.label.ExpiryDate": "समाप्ति तिथि",
    "customers.label.NextRenewalDate": "अगली नवीनीकरण तिथि",
    "customers.label.BalanceTransfer": "शेष राशि स्थानांतरण",
    "customers.label.RecieverClientId": "ग्राहक आईडी प्राप्तकर्ता",
    "customers.label.Amount": "राशि",
    "customers.label.EnterTopUpAmount": "टॉप-अप राशि दर्ज करें",
    "customers.label.ResponseId": "प्रतिक्रिया आईडी",
    "customers.label.BalanceName": "शेष राशि का नाम",
    "customers.label.Allowance": "भत्ता",
    "customers.label.Consumption": "खपत",
    "customers.label.AvailableBalance": "उपलब्ध शेष राशि",
    "customers.label.DaysLeft": "शेष दिन",
    "customers.label.Discount": "छूट",
    "customers.label.postal_code": "पिन कोड",
    "customers.label.address_number": "पता संख्या",
    "customers.label.city": "शहर",
    "customers.label.state": "राज्य",
    "customers.label.country": "देश",
    "customers.label.resident_period": "निवास अवधि",
    "customers.label.postcode": "पिन कोड",
    "customers.label.how_did_you_hear": "आपने हमारे बारे में कैसे सुना?",
    "customers.label.select_language": "भाषा चुनें",
    "customers.label.comment_date": "टिप्पणी की तारीख",
    "customers.label.email_address": "ईमेल पता",
    "customers.label.contact_number": "संपर्क नंबर",
    "customers.label.initials": "नाम के आद्याक्षर",
    "customers.label.communication_type": "संचार प्रकार",
    "customers.label.BuySIM": "सिम खरीदें",
    "customers.label.origination": "उत्पत्ति",
    "customers.label.address": "पता",
    "customers.label.destination_address": "गंतव्य पता",
    "customers.label.event": "घटना",
    "customers.label.charge_party": "चार्ज पार्टी",
    "customers.label.service_subs_type": "सेवा सदस्यता प्रकार",
    "customers.label.calling_party": "कॉल करने वाला",
    "customers.label.called_party": "कॉल रिसीवर",
    "customers.label.usage": "उपयोग",
    "customers.label.monetary_charge": "मौद्रिक शुल्क",
    "customers.label.result_code": "परिणाम कोड",
    "customers.label.generation_time": "जनरेशन समय",
    "customer.label.generationdatetime": "उत्पादन दिनांक और समय",
    "customers.label.transaction_id": "लेन-देन आईडी",
    "customers.label.application_transaction_id": "एप्लिकेशन लेन-देन आईडी",
    "customers.label.application_name": "एप्लिकेशन का नाम",
    "customers.label.recharge_value": "रिचार्ज मूल्य",
    "customers.label.interface": "इंटरफेस",
    "customers.label.result": "परिणाम",
    "customers.label.comment": "टिप्पणी",
    "customers.label.recharge": "रिचार्ज",
    "customers.label.cdr": "सीडीआर",
    "customers.label.notifications": "सूचनाएँ",
    "customers.label.mobile_no": "Enter Mobile No",
    "customers.label.email_id": "Enter Email Id",
    "customers.label.serial_number": "Serial No",
    "customers.label.digital_content": "डिजिटल सामग्री",
    "customers.label.buySim": "सिम खरीदें",
    "customers.label.outstanding_due": "बकाया राशि",
    "customers.label.due_date": "नियत तिथि",
    "customers.label.unbilled_amount": "बिना बिल की राशि",
    "customers.label.next_bill_day": "अगला बिल दिन",
    "customers.label.view_allowances": "भत्ते देखें",
    "customers.label.view_service_details": "सेवा विवरण देखें",
    "customers.label.spend_limit": "खर्च सीमा",
    "customers.label.topup_balance": "बैलेंस टॉपअप करें",
    "customers.label.next_renewal_date": "अगली नवीनीकरण तिथि",
    "customers.label.allowance": "भत्ता",
    "customers.label.ViewDocumentUpload": "दस्तावेज़ अपलोड देखें",
    "customers.label.total_net_amount": "कुल शुद्ध राशि",
    "customers.label.cancelRemark": "टिप्पणी रद्द करें",
    "customers.label.cancelPayment": "भुगतान रद्द करें",
    "customers.label.all": "सभी",
    "customers.label.billProfile": "बिल प्रोफ़ाइल",
    "customers.label.charges": "शुल्क",
    "customers.label.book_order": "पुस्तक आदेश",
    "customers.label.customers": "ग्राहक",
    "customers.label.search_for_clients": "ग्राहकों की खोज",
    "customers.label.advance_search": "उन्नत खोज",
    "customers.label.create_customer": "ग्राहक बनाएं",
    "customers.label.created_by": "द्वारा बनाया गया",
    "customers.label.created_on": "बनाया गया",
    "customers.label.credit_limit": "क्रेडिट सीमा",
    "customers.label.transaction_history": "लेन-देन इतिहास",
    "customers.label.external_activity_log": "बाहरी गतिविधि लॉग",
    "customers.label.settings": "सेटिंग्स",
    "system.label.currency_noncurrency": "मुद्रा गैर-मुद्रा",
    "entity.label.configure": "कॉन्फ़िगर",

    "customers.label.account_no": "खाता संख्या",
    "customers.label.customer_name": "ग्राहक का नाम",
    "customers.label.business_entity": "व्यापारिक एंटिटी",
    "customers.label.balance": "शेष",
    "customers.label.valid_from": "से मान्य",
    "customers.label.valid_to": "तक मान्य",
    "customers.label.non_currency_details": "गैर-मुद्रा विवरण",
    "customers.label.view_details": "विवरण देखें",
    "customers.label.status": "स्थिति",
    "customers.label.first_name": "पहला नाम",
    "customers.label.price_discount": "मूल्य और छूट",
    "customers.label.collection_status": "संग्रह स्थिति",
    "customers.label.last_name": "अंतिम नाम",
    "customers.label.city_area": "शहर/क्षेत्र",
    "customers.label.email": "ईमेल",
    "customers.label.phone": "फोन",
    "customers.label.cafid": "CAF Id",
    "customers.label.enter_business_entity": "व्यावसायिक इकाई दर्ज करें",
    "customers.label.select": "चुनें",
    "customers.label.refund": "रिफंड",
    "customers.label.refund_id": "रिफंड आईडी",
    "customers.label.refund_amount": "रिफंड राशि",
    "customers.label.select_category_type": "श्रेणी प्रकार का चयन करें",
    "customers.label.clear": "साफ करें",
    "customers.label.search": "खोज",
    "customers.label.customer_activation": "ग्राहक सक्रियण",
    "customers.label.customer_details": "ग्राहक विवरण",
    "customers.label.loc": "LOC",
    "customers.label.customer_category": "ग्राहक श्रेणी",
    "customers.label.service_details": "सेवा विवरण",
    "customers.label.name": "नाम",
    "customers.label.add_service": "सेवा जोड़ें",
    "customers.label.network_node": "नेटवर्क नोड",
    "customers.label.device_details": "उपकरण का विवरण",
    "customers.label.item": "आइटम",
    "customers.label.discount_code": "डिस्काउंट कोड",
    "customers.label.total_price": "कुल मूल्य",
    // "customers.label.device_details": "उपकरण विवरण",
    "customers.label.plan_details": "योजना विवरण",
    "customers.label.payment_details": "भुगतान विवरण",
    "customers.label.plan_list": "योजना सूची",
    "customers.label.plan": "योजना",
    "customers.label.contract_period": "अनुबंध अवधि",
    "customers.label.charge_cycle": "शुल्क चक्र",
    "customers.label.cancel": "रद्द करें",
    "customers.label.next": "अगला",
    "customers.label.done": "किया",
    "customers.label.reopen": "फिर से खोलना",
    "customers.label.submit": "प्रस्तुत करें",
    "customers.label.view_customer": "ग्राहक देखें",
    "customers.label.account_number": "खाता संख्या",
    "customers.label.serial_no": "क्रम संख्या",
    "customers.label.office_hierarchy": "कार्यालय वर्गीकरण",
    "customers.label.account_type": "खाता प्रकार",
    // "customers.label.balance": "शेष राशि",
    "customers.label.stb_serial_no": "STB क्रम संख्या",
    "customers.label.non_currency_balance": "गैर मुद्रा शेष",
    "customers.label.service_orders": "सेवा आदेश",
    "customers.label.more_info": "अधिक जानकारी",
    "customers.label.notes": "टिप्पणियाँ",
    "customers.label.device": "उपकरण",
    "customers.label.tickets": "टिकट",
    "customers.label.on_demand": "डिमांड पर",
    "customers.label.on_demand_billing": "ऑन डिमांड बिलिंग",
    "customers.label.account_transaction": "खाता लेन-देन",
    "customers.label.payments": "भुगतान",
    "customers.label.invoice": "चालान",
    "customers.label.contact_information": "संपर्क जानकारी",
    "customers.label.address_information": "पता जानकारी",
    "customers.label.billing_information": "बिलिंग जानकारी",
    "customers.label.balance_information": "शेष राशि की जानकारी",
    // "customers.label.customer_name": "ग्राहक का नाम",
    "customers.label.parent_child": "माता-पिता/बच्चा",
    "customers.label.created_date": "निर्माण तिथि",
    "customers.label.district": "जिला",
    "customers.label.pincode": "पिन कोड",
    "customers.label.last_bill_amount": "आखिरी बिल राशि",
    "customers.label.last_bill_date": "आखिरी बिल की तारीख",
    "customers.label.last_bill_paid": "आखिरी बिल भुगतान",
    "customers.label.last_paid_amount": "आखिरी भुगतान राशि",
    "customers.label.last_payment_date": "आखिरी भुगतान तिथि",
    "customers.label.next_bill_date": "अगले बिल की तारीख",
    "customers.label.service_overview": "सेवा का अवलोकन",
    "customers.label.service_without_device": "डिवाइस के बिना सेवा",
    "customers.label.create_ticket": "टिकट बनाएं",
    "customers.label.service_activation": "सेवा सक्रियण",
    "customers.label.order_charging": "आदेश चार्जिंग",
    "customers.label.top_up": "लबालब भरना",
    "customers.label.redeem": "मुक्त करें",
    "customers.label.collection_name": "संग्रह नाम",
    "customers.label.redeem_voucher": "रीडीम वाउचर",
    "customers.label.service_id": "सेवा आईडी",
    "customers.label.service_code": "सेवा कोड",
    "customers.label.start_date": "प्रारंभ तिथि",
    "customers.label.modified_date": "संशोधित तिथि",
    // "customers.label.status": "स्थिति",
    "customers.label.info": "जानकारी",
    "customers.label.action": "कार्रवाई",
    "customers.label.add_device": "डिवाइस जोड़ें",
    "customers.label.add_plans": "योजनाएं जोड़ें",
    "customers.label.suspend": "स्थगित करें",
    "customers.label.reactivate": "पुनर्सक्रिया",
    "customers.label.terminate": "समाप्त",
    "customers.label.command_center": "कमांड केंद्र",
    "customers.label.retrack": "पुनः ट्रैक",
    "customers.label.cancel_plans": "योजनाओं को रद्द करें",
    "customers.label.device_overview": "डिवाइस अवलोकन",
    "customers.label.orders_overview": "आदेश अवलोकन",
    // "customers.label.plan": "योजना",
    "customers.label.end_date": "समाप्ति तिथि",
    "customers.label.price": "मूल्य",
    "customers.label.short_description": "संक्षिप्त वर्णन",
    "customers.label.description": "विवरण",
    "customers.label.add_note": "नोट जोड़ें",
    "customers.label.note": "नोट",
    "customers.label.sale_type": "बिक्री प्रकार",
    "customers.label.bill_item_details": "बिल आइटम विवरण",
    "customers.label.charge_id": "चार्ज आईडी",
    "customers.label.order_id": "ऑर्डर आईडी",
    "customers.label.item_tax_details": "आइटम कर विवरण",
    "customers.label.discount_details": "छूट विवरण",
    "customers.label.sale_date": "बिक्री तिथि",
    "customers.label.charge_code": "शुल्क कोड",
    "customers.label.quantity": "मात्रा",
    // "customers.label.total_price": "कुल मूल्य",
    "customers.label.warranty_date": "वारंटी की तारीख",
    "customers.label.allocate": "समर्पित करें",
    "customers.label.contact_info": "संपर्क जानकारी",
    "customers.label.edit_customer": "ग्राहक संपादित करें",
    "customers.label.lco": "LCO",
    "customers.label.title": "शीर्षक",
    // "customers.label.customer_category": "ग्राहक श्रेणी",
    "customers.label.middle_name": "मध्य नाम",
    "customers.label.caf_id": "CAF आईडी",
    "customers.label.landline_number": "लैंडलाइन नंबर",
    "customers.label.user_name": "उपयोगकर्ता नाम",
    "customers.label.customer_photo": "ग्राहक फोटो",
    "customers.label.id_proof": "आईडी प्रूफ",
    "customers.label.id_proof_value": "आईडी प्रूफ मूल्य",
    "customers.label.save": "सहेजें",
    "customers.label.close_customer": "ग्राहक बंद करें",
    "customers.label.closure_date": "बंद करने की तारीख",
    "customers.label.closure_reason": "बंद करने का कारण",
    "customers.label.close": "बंद करें",
    "customers.label.address_info": "पता सूचना",
    "customers.label.edit_address": "पता संपादित करें",
    "customers.label.address_no": "पता संख्या",
    "customers.label.street": "सड़क",
    "customers.label.building": "इमारत",
    "customers.label.zipcode": "पिनकोड",
    "customers.label.billing": "बिलिंग",
    "customers.label.same_as_primary": "मुख्य के समान",
    "customers.label.building_code": "इमारत कोड",
    "customers.label.add_address": "पता जोड़ें",
    "customers.label.address_type": "पता प्रकार",
    "customers.label.billing_info": "बिलिंग जानकारी",
    "customers.label.created_adjustment": "निर्मित समायोजन",
    "customers.label.create_order": "आदेश बनाएं",
    "customers.label.sale_catalog": "बिक्री सूची",
    "customers.label.renew_plan": "नवीनीकरण योजना",
    "customers.label.auto_renew": "स्वचालित पुनर्नवीनीकरण",
    // "customers.label.search": "खोजें",
    "customers.label.entity_name": "संस्था का नाम",
    "customers.label.discount": "छूट",
    "customers.label.provisioning_commands": "प्रोविज़निंग कमांड्स",
    "customers.label.command": "कमांड",
    "customers.label.plans": "योजनाएँ",
    "customers.label.client_service_detail": "ग्राहक सेवा विवरण",
    "customers.label.id": "पहचान",
    "customers.label.parameter_name": "पैरामीटर का नाम",
    "customers.label.parameter_value": "पैरामीटर का मूल्य",
    "customers.label.request_type": "अनुरोध प्रकार",
    "customers.label.client_info": "ग्राहक सूचना",
    "customers.label.service_info": "सेवा सूचना",
    "customers.label.new_device_info": "नई डिवाइस सूचना",
    "customers.label.task_list": "कार्य सूची",
    "customers.label.provisioning_detail": "प्रोविजनिंग विवरण",
    "customers.label.provisioning_id": "प्रोविजनिंग आईडी",
    "customers.label.task_id": "कार्य आईडी",
    "customers.label.sent_message": "भेजी गई संदेश",
    "customers.label.available_plans": "उपलब्ध योजनाएं",
    "customers.label.item_code": "आइटम कोड",
    "customers.label.disconnect_order": "डिस्कनेक्ट आदेश",
    "customers.label.reason": "कारण",
    "customers.label.porting_out": "बाहर पोर्ट करना",
    "customers.label.prepaid_to_postpaid": "प्रीपेड से पोस्टपेड",
    "customers.label.postpaid_to_prepaid": "पोस्टपेड से प्रीपेड",
    "customers.label.addons": "ऐड-ऑन",
    "customers.label.change_plan": "योजना बदलें",
    "customers.label.swap_sim": "सिम बदलें",
    "customers.label.select_date": "तारीख चुनें",
    "customers.label.order_date": "आदेश की तारीख",
    "customers.label.priority": "प्राथमिकता",
    "customers.label.ticket_date": "टिकट की तारीख",
    "customers.label.category": "श्रेणी",
    "customers.label.sub_category": "उप-श्रेणी",
    "customers.label.team": "टीम",
    "customers.label.team_user": "टीम उपयोगकर्ता",
    "customers.label.source": "स्रोत",
    "customers.label.due_time": "नियत समय",
    "customers.label.device_swap": "उपकरण परिवर्तन",
    // "customers.label.terminate": "समाप्त",
    "customers.label.confirm": "पुष्टि करें",
    "customers.label.continue": "जारी रखना",
    "customers.label.process_date": "प्रक्रिया की तारीख",
    "customers.label.pin_number": "पिन नंबर",
    "customers.label.renewal": "नवीकरण",
    // "customers.label.create_customer": "ग्राहक बनाएं",
    "customers.label.individual": "व्यक्तिगत",
    "customers.label.corporate": "कॉर्पोरेट",
    "customers.label.corporate_details": "कॉर्पोरेट विवरण",
    "customers.label.contact_person": "संपर्क व्यक्ति",
    "customers.label.entity": "संस्था",
    "customers.label.client_category": "ग्राहक श्रेणी",
    "customers.label.preferences": "पसंद",
    "customers.label.parent_id": "माता पहचान",
    "customers.label.child": "बच्चा",
    "customers.label.villege_street": "गाँव/सड़क",
    "customers.label.billing_address": "बिलिंग पता",
    "customers.label.bill_information": "बिल की जानकारी",
    "customers.label.bill_day_of_month": "माह का बिल का दिन",
    "customers.label.fiscal_year": "वित्तीय वर्ष",
    "customers.label.fiscal_quater": "वित्तीय तिमाही",
    "customers.label.bill_mode": "बिल का मोड",
    "customers.label.invoice_type": "चालान का प्रकार",
    "customers.label.payment_information": "भुगतान की जानकारी",
    "customers.label.funder_name": "धारक का नाम",
    "customers.label.funder_id": "धारक आईडी",
    "customers.label.po_number": "पीओ संख्या",
    "customers.label.payment_term": "भुगतान की शर्त",
    "customers.label.customer_created_successfully":
      "ग्राहक सफलतापूर्वक बनाया गया",
    "customers.label.go_to_customer": "ग्राहक के पास जाएं",
    "customers.label.view_order": "आदेश देखें",
    "customers.label.disconnect": "डिस्कनेक्ट",
    "customers.label.apply_promo": "प्रोमो लागू करें",
    // "customers.label.order_id": "आदेश आईडी",
    "customers.label.order_type": "आदेश का प्रकार",
    "customers.label.billing_cycle": "बिलिंग साइकिल",
    "customers.label.plan_name": "योजना का नाम",
    "customers.label.user_action": "उपयोगकर्ता क्रिया",
    "customers.label.invoice_till_date": "तारीख तक चालान",
    "customers.label.order_services": "आदेश की सेवाएं",
    "customers.label.service_type": "सेवा का प्रकार",
    "customers.label.service_description": "सेवा का विवरण",
    "customers.label.bill_start_date": "बिल की शुरुआत की तारीख",
    "customers.label.bill_end_date": "बिल समाप्ति तिथि",
    // "customers.label.invoice_till_date": "तारीख तक चालान",
    "customers.label.charge_type": "शुल्क प्रकार",
    "customers.label.rate_uom": "दर/UOM",
    "customers.label.discount_description": "डिस्काउंट विवरण",
    "customers.label.discount_type": "डिस्काउंट प्रकार",
    "customers.label.discount_start_date": "डिस्काउंट प्रारंभ तिथि",
    "customers.label.discount_end_date": "डिस्काउंट समाप्ति तिथि",
    "customers.label.discount_amount": "डिस्काउंट राशि",
    "customers.label.order_transaction": "ऑर्डर लेन-देन",
    "customers.label.user": "उपयोगकर्ता",
    "customers.label.transaction_date": "लेनदेन की तारीख",
    "customers.label.transaction_type": "लेन-देन प्रकार",
    "customers.label.actual_date": "वास्तविक तारीख",
    "customers.label.promo": "प्रोमो",
    "customers.label.promotion": "प्रमोशन",
    "customers.label.disconnection_date": "डिस्कनेक्शन की तारीख",
    "customers.label.disconnection_reason": "डिस्कनेक्शन का कारण",
    "customers.label.problem_code": "समस्या कोड",
    "customers.label.assign_to": "सौंपना",
    "customers.label.last_comment": "अंतिम टिप्पणी",
    "customers.label.file_name": "फ़ाइल का नाम",
    "customers.label.edit_ticket": "टिकट संपादित करें",
    "customers.label.close_ticket": "टिकट बंद करें",
    "customers.label.resolution_description": "समाधान विवरण",
    "customers.label.ticket_history": "टिकट इतिहास",
    // "customers.label.last_comment": "अंतिम टिप्पणी",
    "customers.label.problem_description": "समस्या विवरण",
    "customers.label.generate": "उत्पन्न करें",
    "customers.label.bill_date": "बिल की तारीख",
    "customers.label.amount": "राशि",
    "customers.label.statement": "बयान",
    // "customers.label.due_date": "नियत तिथि",
    "customers.label.promotional_message": "प्रोमोशनल संदेश",
    "customers.label.download": "डाउनलोड",
    "customers.label.due_amount": "देय राशि",
    "customers.label.transactions": "लेन-देन",
    "customers.label.file": "फ़ाइल",
    "customers.label.reset": "रीसेट",
    "customers.label.order_details": "आदेश का विवरण",
    "customers.label.make_payment": "भुगतान करें",
    "customers.label.credit_amount": "क्रेडिट राशि",
    "customers.label.debit_amount": "डेबिट राशि",
    "customers.label.cancel_remark": "रद्द करने की टिप्पणी",
    "customers.label.pay_invoice": "चालान भुगतान करें",
    "customers.label.account": "खाता",
    "customers.label.deposit": "जमा",
    "customers.label.payment_date": "भुगतान की तारीख",
    "customers.label.receipt_no": "रसीद संख्या",
    "customers.label.cheque_no": "चेक संख्या",
    "customers.label.bank_name": "बैंक का नाम",
    "customers.label.branch_name": "शाखा का नाम",
    "customers.label.cheque_date": "चेक की तारीख",
    "customers.label.invoice_id": "चालान आईडी",
    "customers.label.invoice_date": "चालान की तारीख",
    "customers.label.invoice_amount": "चालान राशि",
    // "customers.label.due_amount": "देय राशि",
    "customers.label.payment_reversal": "भुगतान का पलटवार",
    "customers.label.date_filter": "तारीख का फ़िल्टर",
    "customers.label.add_event_order": "घटना आदेश जोड़ें",
    "customers.label.event_order": "ईवेंट आदेश",
    "customers.label.eventdate": "आयोजन की तारीख",
    "customers.label.serviceAddress": "सेवा पता",
    "customers.label.event_name": "घटना का नाम",
    "customers.label.booked_date": "बुक की गई तिथि",
    "customers.label.event_price": "घटना की कीमत",
    "customers.label.events": "घटनाएँ",
    "customers.label.format_type": "स्वरूप प्रकार",
    "customers.label.opt_type": "ओप्ट टाइप",
    "customers.label.client_bill_profile": "ग्राहक बिल प्रोफ़ाइल",
    "customers.label.edit": "संपादित करें",
    "customers.label.type": "प्रकार",
    "customers.label.client_id": "ग्राहक आईडी",
    "customers.label.bill_frequency": "बिल आवृत्ति",
    "customers.label.bill_segment": "बिल सेगमेंट",
    // "customers.label.next_bill_day": "अगला बिल दिन",
    "customers.label.last_bill_day": "अंतिम बिल दिन",
    "customers.label.last_bill_no": "अंतिम बिल नंबर",
    "customers.label.payment_type": "भुगतान प्रकार",
    "customers.label.bill_suppression_flag": "बिल निषेध ध्वज",
    "customers.label.bill_suppression_id": "बिल निषेध आईडी",
    "customers.label.first_bill": "पहला बिल",
    "customers.label.hot_bill": "ताज़ा बिल",
    "customers.label.edit_bill_profile": "बिल प्रोफ़ाइल संपादित करें",
    "customers.label.bill_currency": "बिल मुद्रा",
    "customers.label.bill_suppression": "बिल दबाव",
    // "customers.label.more_info": "अधिक जानकारी",
    "customers.label.identities": "पहचान",
    "customers.label.add_client_identities": "ग्राहक पहचान जोड़ें",
    "customers.label.unique_identification": "अद्वितीय पहचान",
    "customers.label.identity_documents": "पहचान दस्तावेज़",
    "customers.label.additional_info": "अतिरिक्त जानकारी",
    "customers.label.nationality": "राष्ट्रीयता",
    "customers.label.date_of_birth": "जन्म की तारीख",
    "customers.label.preferred_language": "पसंदीदा भाषा",
    "customers.label.finance_id": "वित्त आईडी",
    "customers.label.remarks": "टिप्पणियाँ",
    "customers.label.preferred_communication": "पसंदीदा संचार",
    "customers.label.add_client_identifier": "ग्राहक पहचानकर्ता जोड़ें",
    "customers.label.document_type": "दस्तावेज़ का प्रकार",
    "customers.label.document_uploads": "दस्तावेज़ अपलोड",
    "customers.label.select_file": "फ़ाइल का चयन करें",
    "customers.label.credit_card_details": "क्रेडिट कार्ड विवरण",
    "customers.label.card_number": "कार्ड नंबर",
    "customers.label.cvv": "CVV",
    "customers.label.card_type": "कार्ड का प्रकार",
    "customers.label.expiry_date": "समाप्ति तिथि",
    "customers.label.ach_card": "एचची कार्ड",
    "customers.label.ach_card_routing_number": "एचची कार्ड रूटिंग नंबर",
    "customers.label.bank_account_number": "बैंक खाता नंबर",
    "customers.label.childs": "बच्चे",
    "customers.label.cell_phone": "सेल फोन",
    "customers.label.create_client_additional_info":
      "ग्राहक अतिरिक्त जानकारी बनाएँ",
    "customers.label.gender": "लिंग",
    "customers.label.id_type": "आईडी प्रकार",
    // "customers.label.nationality": "राष्ट्रीयता",
    "customers.label.id_number": "आईडी नंबर",
    "customers.label.job_title": "नौकरी का खिताब",
    "customers.label.age_group": "आयु समूह",
    "customers.label.uts_customer_id": "यूटीएस ग्राहक आईडी",
    "customers.label.ach_card_name": "एचसीएच कार्ड नाम",
    "customers.label.adjustment": "समायोजन",
    // "customers.label.created_adjustment": "निर्मित समायोजन",
    "customers.label.adjustment_date": "समायोजन तिथि",
    "customers.label.adjustment_code": "समायोजन कोड",
    "customers.label.adjustment_amount": "समायोजन राशि",
    "customers.label.adjustment_type": "समायोजन प्रकार",
    "customers.label.activity_log": "गतिविधि लॉग",
    "customers.label.office_id": "कार्यालय आईडी",
    "customers.label.history": "इतिहास",
    "customers.label.filter_by_date": "तारीख अनुसार फिल्टर करें",
    "customers.label.view_usage_details": "उपयोग विवरण देखें",
    "customers.label.units": "इकाइयाँ",
    "customers.label.tax": "कर",
    "customers.label.total_amount": "कुल राशि",
    "customers.label.csv_pdf": "CSV/PDF",
    "customers.label.charge_description": "शुल्क विवरण",
    "customers.label.journals": "पत्रिकाएँ",
    "customers.label.download_financial_summary_data":
      "वित्तीय सारांश डेटा डाउनलोड करें",
    "customers.label.select_from_date": "तिथि से चुनें",
    "customers.label.select_to_date": "तिथि तक चुनें",
    "customers.label.village_street": "गाँव/सड़क",
    "customers.label.previous": "पिछला",
    "customers.label.Disconnect": "डिस्कनेक्ट करें",
    "customers.label.ApplyPromo": "प्रोमो लागू करें",
    "customers.label.Service": "सेवा",
    "customers.label.Product": "उत्पाद",
    "customers.label.CreditCard": "क्रेडिट कार्ड",
    "customers.label.Paypal": "पेपाल",
    "customers.label.BusinessEntity": "व्यावसायिक इकाई",
    "customers.label.Plan": "योजना",
    "customers.label.Phone": "फ़ोन",
    "customers.label.TaxExemption": "कर मुक्त",
    "customers.label.YES": "हाँ",
    "customers.label.NO": "नहीं",
    "customers.label.Resolution": "संकल्प",
    "customers.label.AccountNo": "खाता संख्या",
    "customers.label.ChipId": "चिप आईडी",
    "customers.label.MobileNo": "मोबाइल नंबर",
    "customers.label.EmailId": "ईमेल आईडी",
    "customers.label.SerialNo": "क्रमांक",
    "customers.label.LegacyNo": "विरासत संख्या",
    "customers.label.searchclient": "ग्राहक खोजें",
    "customers.label.PrimaryAddress": "प्राथमिक पता",
    "customers.label.BillingAddress": "बिलिंग पता",
    // "customers.label.lco": "lco",
    "customers.label.EventDate": "इवेंट की तारीख",
    "customers.label.CreateAdjustment": "समायोजन बनाएं",
    "customers.label.full_name": "पूरा नाम",
    "customers.label.bill_collection_action": "बिल संग्रह क्रिया",
    "customers.label.collection_actions": "संग्रह क्रियाएँ",
    "customers.label.action_name": "क्रिया का नाम",
    "customers.label.action_date": "क्रिया की तारीख",
    "customers.label.balance_due": "बकाया शेष",
    "customers.label.bill_id": "बिल आईडी",
    "customers.label.payinfo": "भुगतान जानकारी",
    "customers.label.cardtoken": "कार्ड टोकन",
    "customers.label.autopay": "स्वत: भुगतान",
    "customers.label.paynow": "अभी भुगतान करें",
    "customers.label.featureList": "विशेषताएँ सूची",
    "customers.label.consumed": "उपयोग किया गया",
    "customers.label.updateCreditLimt": "क्रेडिट लिमिट अपडेट करें",
    "customers.label.PendingForApproval": "अनुमोदन के लिए लंबित",

    "customers.label.SpendCapHistory": "खर्च सीमा इतिहास",
    "customers.label.DateTime": "तारीख़ और समय",
    "customers.label.SpendCapEventName": "खर्च सीमा घटना का नाम",
    "customers.label.SpendingLimit": "खर्च सीमा",
    "customers.label.ConsumedLimit": "उपयोग की गई सीमा",
    "customers.label.EventId": "घटना आईडी",
    "customers.label.collectionStatus": "संग्रह स्थिति",
  },
  ka: {
    "customers.label.temporaryBlock": "ತಾತ್ಕಾಲಿಕ ತಡೆ",
    "customers.label.unBlock": "ಅನ್‌ಬ್ಲಾಕ್",
    "customers.label.feedback": "ಪ್ರತಿಕ್ರಿಯೆ",
    "customers.label.event_id": "ღონისძიების ID",
    "customers.label.slc_state_history": "SLC მდგომარეობის ისტორია",
    "customers.label.slc": "SLC",
    "customers.label.state_Change_Time": "ಸ್ಥಿತಿಯ ಬದಲಾವಣೆಯ ಸಮಯ",
    "customers.label.event": "ಘಟನೆ",
    "customers.label.previous_state": "ಹಿಂದಿನ ಸ್ಥಿತಿ",
    "customers.label.resolution_date": "გადაწყვეტილების თარიღი",
    "customers.label.current_state": "ಪ್ರಸ್ತುತ ಸ್ಥಿತಿ",
    "customers.label.created_time": "შექმნის დრო",
    "customers.label.creation_time": "შექმნის დრო",
    "customers.label.Promotion": "ಪ್ರಮೋಶನ್",
    "customers.label.slc_status": "SLC სტატუსი",
    "customers.label.update_slc_status": "SLC სტატუსის განახლება",
    "customers.label.temporary_block": "დროებითი დაბლოკვა",
    "customers.label.workflow_id": "მუშაობის ნაკადის ID",
    "customers.label.externalPromoId": "ಬಾಹ್ಯ ಪ್ರೊಮೋ ಐಡಿ",
    "customers.label.externalPromoName": "ಬಾಹ್ಯ ಪ್ರೊಮೋ ಹೆಸರು",
    "customers.label.promoCode": "ಪ್ರೊಮೋ ಕೋಡ್",
    "customers.label.promoDescription": "ಪ್ರೊಮೋ ವಿವರಣೆ",
    "customers.label.ScheduleOrder": "შეკვეთის დაგეგმვა",
    "customers.label.ScheduledDate": "დაგეგმილი თარიღი",
    "customers.label.ViewRateLimit": "ნახე სიჩქარის ლიმიტი",
    "customers.label.SelectType": "აირჩიე ტიპი",
    "customers.label.search": "ძებნა",
    "customers.label.SelectTaxExemption": "აირჩიეთ საგადასახადო გამონაკლისი",
    "customers.label.ViewTickets": "ბილეთების ნახვა",
    "customers.label.TicketHistory": "ბილეთების ისტორია",
    "customers.label.ReopenTicket": "ბილეთის ხელახალი გახსნა",
    "customers.label.SelectInvoiceType": "აირჩიეთ ინვოისის ტიპი",
    "customers.label.SelectCategory": "აირჩიეთ კატეგორია",
    "customers.label.SelectSubCategory": "აირჩიეთ ქვეკატეგორია",
    "customers.label.SelectSource": "აირჩიეთ წყარო",
    "customers.label.TicketHistory": "ბილეთების ისტორია",
    "customers.label.ViewSpendCap": "ხარჯვის ზღვარის ნახვა",
    "customers.label.ResponseMessage": "პასუხის შეტყობინება",
    "customers.label.AddPlan": "გეგმაში დამატება",
    "customers.label.Basket": "კალათა",
    "customers.label.TotalPrice": "სრული ფასი",
    "customers.label.Send_Link_to_Customer_to_Complete_Payment":
      "გაგზავნეთ ბმული მომხმარებელთან გადახდის დასასრულებლად",
    "customers.label.CheckPaymentStatus": "შეამოწმეთ გადახდის სტატუსი",
    "customers.label.Are_you_sure_you_want_to_terminate?":
      "დარწმუნებული ხართ, რომ გსურთ გაუქმება?",
    "customers.label.Unlimited": "შეუზღუდავი",
    "customers.label.days_left": "დარჩენილი დღეები",
    "customers.label.search": "ძებნა",
    "customers.label.JobTitle": "სამუშაოს დასახელება",
    "customers.label.SelectDocumentType": "აირჩიეთ დოკუმენტის ტიპი",
    "customers.label.SelectEvents": "აირჩიეთ ღონისძიებები",
    "customers.label.SelectFormatType": "აირჩიეთ ფორმატის ტიპი",
    "customers.label.SelectAdjustmentType": "აირჩიეთ კორექტირების ტიპი",
    "customers.label.card_number": "ბარათის ნომერი",
    "customers.label.Select_OPT_Type": "აირჩიეთ OPT ტიპი",
    "customers.label.StartDate": "დაწყების თარიღი",
    "customers.label.EndDate": "დასრულების თარიღი",
    "customers.label.Cancel": "გაუქმება",
    "customers.label.Set": "დაყენება",
    "customers.label.PaymentDetails": "გადახდის დეტალები",
    "customers.label.PaymentReceipt": "გადახდის ქვითარი",
    "customers.label.Status": "სტატუსი",
    "customers.label.PaymentAmount": "გადახდის თანხა",
    "customers.label.Transaction": "ტრანსაქცია",
    "customers.label.PaymentPage": "გადახდის გვერდი",
    "customers.label.ItemCode": "საქონლის კოდი",
    "customers.label.StartDate": "დაწყების თარიღი",
    "customers.label.English": "ინგლისური",
    "customers.label.SelectIdProof":
      "აირჩიეთ პირადობის დამადასტურებელი დოკუმენტი",
    "customers.label.SelectAdjustementCode": "აირჩიეთ კორექტირების კოდი",
    "customers.label.SelectAdjustmentType": "აირჩიეთ კორექტირების ტიპი",
    "customers.label.SelectFormat": "აირჩიეთ ფორმატი",
    "customers.label.AreYouSure?": "დარწმუნებული ხართ?",
    "customers.label.ChargeId": "გადასახადის ID",
    "customers.label.ChargeDescription": "გადასახადის აღწერა",
    "customers.label.DiscountAmount": "ფასდაკლების ოდენობა",
    "customers.label.NetChargeAmount": "გადასახადის წმინდა თანხა",
    "customers.label.TaxDescription": "გადასახადის აღწერა",
    "customers.label.TaxAmount": "გადასახადის თანხა",
    "customers.label.SelectDate": "აირჩიეთ თარიღი",
    "customers.label.SelectPriority": "აირჩიეთ პრიორიტეტი",
    "customers.label.SelectCategory": "აირჩიეთ კატეგორია",
    "customers.label.SelectSubCategory": "აირჩიეთ ქვეკატეგორია",
    "customers.label.SelectSource": "აირჩიეთ წყარო",
    "customers.label.ViewSpendCap": "იხილეთ ხარჯვის ზღვარი",
    "customers.label.Amount": "თანხა",
    "customers.label.PlanCode": "გეგმის კოდი",
    "customers.label.Price": "ფასი",
    "customers.label.Status": "სტატუსი",
    "customers.label.EndDate": "დასრულების თარიღი",
    "customers.label.ContractPeriod": "კონტრაქტის პერიოდი",
    "customers.label.AutoRenew": "ავტომატური განახლება",
    "customers.label.Description": "აღწერა",
    "customers.label.ThankYou": "გმადლობთ!",
    "customers.label.ConnectionActivated":
      "კავშირი წარმატებით გააქტიურდა ანგარიშის ნომრით",
    "customers.label.GoToCustomerDetail": "გადასვლა მომხმარებლის დეტალებზე",
    "customers.label.Payment": "გადახდა",
    "customers.label.CustomerToPay": "კლიენტმა უნდა გადაიხადოს:",
    "customers.label.MonthlyPayment": "ყოველთვიური გადახდა",
    "customers.label.SetupWithDirectDebitOrCreditCard":
      "დაყენება პირდაპირი დებიტით ან საკრედიტო ბარათით",
    "customers.label.SendLinkToCustomerToCompletePayment":
      "გაუგზავნეთ ბმული კლიენტს გადახდის დასასრულებლად",
    "customers.label.CheckPaymentStatus": "გადახდის სტატუსის შემოწმება",
    "customers.label.ThisNumberIsReservedFor": "ეს ნომერი დაცულია",
    "customers.label.YouSelected": "თქვენ აირჩიეთ",
    "customers.label.SerialNo": "სერიული ნომერი",
    "customers.label.PhoneNo": "ტელეფონის ნომერი",
    "customers.label.ActivatingCustomer": "კლიენტის აქტივაცია...",
    "customers.label.LoadingOrderStatus": "შეკვეთის სტატუსის ჩატვირთვა...",
    "customers.label.OrderStatus": "შეკვეთის სტატუსი:",
    "customers.label.Failed": "მარცხი",
    "customers.label.RoamingOutsideEEA": "როამინგი EEA-ს გარეთ",
    "customers.label.TariffTermsDetails":
      "გთხოვთ, იხილოთ ჩვენი ტარიფების პირობები და ვებსაიტი, რათა მიიღოთ მეტი ინფორმაცია კონკრეტულ ტარიფებსა და თქვენს პაკეტს მიღმა ხარჯებზე.",
    "customers.label.PaymentTerms":
      "ჩვენ SEPA-ის პირდაპირი დებიტით ჩამოგაჭრით თანხას, რომელიც უნდა გადაიხადოთ, თუ სხვა რამ არ შევთანხმდით. ინვოისზე აღნიშნული იქნება თარიღი, როდესაც თანხას ჩამოვჭრით. შესაძლოა, ჩვენ ვთხოვოთ წინასწარ გადაიხადოთ ერთჯერადი და სააბონენტო გადასახადები. განსაკუთრებულ შემთხვევებში, შესაძლოა, დავაკისროთ შუალედური გადასახადები, მაგალითად, თუ მცირე დროში საშუალოზე მეტად მოიხმარეთ გარკვეული სერვისი. თუ იხდით საკრედიტო ან სადებეტო ბარათით, თქვენ აძლევთ უფლებას გადახდის ბარათის კომპანიას, მოგვაწოდოს ინფორმაცია თქვენი ანგარიშის შესახებ და, კონფიდენციალურად, ჩვენს ქვეკონტრაქტორებს და/ან აგენტებს, თუ ეს აუცილებელია ხელშეკრულების ფარგლებში. ასევე, მათ ანიჭებთ უფლებას შეგვატყობინონ, თუ თქვენი გადახდის ანგარიში შეწყვეტილია ან შეჩერებულია.",
    "customers.label.ServiceAgreementTerms":
      "სერვისის ხელშეკრულების ხანგრძლივობა, განახლება და შეწყვეტა",
    "customers.label.Duration": "ხანგრძლივობა",
    "customers.label.Renewal": "განახლება",
    "customers.label.ContractTermsAndConditions":
      "კონტრაქტის პირობები და პირობები",
    "customers.label.TermsAndConditions": "პირობები და წესები",
    "customers.label.CustomerExplanation": "მე მივაწოდე კლიენტს დეტალური ახსნა",
    "customers.label.CustomerAgreement":
      "და მათ დათანხმდნენ შეკვეთის გაგრძელებას.",
    "customers.label.NumberReservedFor": "ეს ნომერი დაცულია",
    "customers.label.YouSelected": "თქვენ აირჩიეთ",
    "customers.label.SerialNo": "სერიული ნომერი",
    "customers.label.PhoneNo": "ტელეფონის ნომერი",
    "customers.label.TotalPrice": "სრული ფასი",
    "customers.label.FeaturesForEndUsersWithDisabilities":
      "ფუნქციები შეზღუდული შესაძლებლობების მქონე მომხმარებლებისთვის",
    "customers.label.InformationSupportServices":
      "ჩვენი სერვისების მხარდამჭერი ინფორმაცია ხელმისაწვდომია ალტერნატიულ ფორმატებში. თუ გსურთ ჩვენი ინფორმაციის მიღება ალტერნატიულ ფორმატში, გთხოვთ, დაგვიკავშირდეთ თქვენი Lycamobile SIM-ით ნომერზე 1200 ან ეწვიეთ",
    "customers.label.HowWeUseYourInformation":
      "როგორ ვიყენებთ თქვენს ინფორმაციას",
    "customers.label.InformationUsageDetails":
      "ჩვენ შევაგროვებთ ინფორმაციას თქვენი სერვისების გამოყენების შესახებ, ასევე მესამე მხარის სერვისებზე, რომლებსაც იყენებთ ჩვენს სერვისებთან ერთად, მათ შორის, მაგალითად, თქვენი მდებარეობისა და ანგარიშის აქტივობების შესახებ, რათა გავაუმჯობესოთ თქვენი საერთო გამოცდილება ჩვენთან და გავხადოთ იგი თქვენთვის უფრო რელევანტური. ჩვენ შესაძლოა გამოვიყენოთ და გავაანალიზოთ თქვენი პერსონალური მონაცემები თქვენი სერვისებისა და ანგარიშის მართვისთვის, მათ შორის საკრედიტო შემოწმებისა და თაღლითობის პრევენციის მიზნით. ჩვენ შესაძლოა გავუზიაროთ და გავაერთიანოთ ეს მონაცემები გარკვეულად შერჩეულ მესამე პირებთან იგივე მიზეზების გამო. თქვენი ინფორმაცია მუშავდება ჩვენი კონფიდენციალურობის პოლიტიკის შესაბამისად, რომელსაც შეგიძლიათ გაეცნოთ:",
    "customers.label.CustomerComplaints":
      "თუ არ ხართ კმაყოფილი სერვისის სიჩქარით, ხარისხით ან სხვა ფაქტორებით და გსურთ საჩივრის შეტანა, გთხოვთ, დაუკავშირდეთ მომხმარებელთა მომსახურების ცენტრს. დამატებითი ინფორმაცია ჩვენი საჩივრების პროცესის შესახებ შეგიძლიათ იხილოთ ჩვენს მომხმარებელთა საჩივრების კოდექსში, რომელიც შეგიძლიათ იხილოთ",
    "customers.label.DisputeResolution":
      "თუ ჩვენ ვერ შევძელით თქვენი საჩივრის გადაწყვეტა, შეგიძლიათ 12 თვის განმავლობაში შეიტანოთ იგი ტელეკომუნიკაციების მომსახურების დავების განხილვის კომიტეტში. ასევე შეგიძლიათ შეიტანოთ საჩივარი ევროპის კომისიის ონლაინ დავების გადაწყვეტის პლატფორმაზე ან მიმართოთ სასამართლოს.",
    "customers.label.costsEuro": "ღირებულება €",
    "customers.label.thereafterEuro": "შემდეგ €",
    "customers.label.forTheFirst": "პირველისთვის",
    "customers.label.perMonthInclusiveVAT":
      "თვეში, დღგ-ს ჩათვლით (წლის განმავლობაში შესაძლებელია CPI+3.9%-ით გაზრდა). დამატებითი დეტალებისთვის იხილეთ ვებსაიტი.",
    "customers.label.additionalAddOns":
      "თქვენს გეგმაში შეიძლება იყოს დამატებითი სერვისები, რომლებიც ცალკე იქნება დარიცხული თქვენს ანგარიშზე.",
    "customers.label.paymentTerms":
      "თქვენ უნდა გადაიხადოთ თქვენს მიერ გამოწერილი და/ან გამოყენებული სერვისებისთვის ყოველთვიურად, თქვენს ანგარიშზე მითითებული ვადის დასრულებამდე. გადახდის დაგვიანების შემთხვევაში შესაძლოა დაგერიცხოთ დამატებითი საკომისიო. ჩვენ შეიძლება მოგვთხოვოთ დეპოზიტის გადახდა, სანამ მოგაწვდით სერვისებს. დამატებითი დეტალებისთვის იხილეთ ჩვენი ტარიფების წესები და ვებსაიტი.",
    "customers.label.durationRenewalTermination":
      "ხანგრძლივობა, განახლება და შეწყვეტა",
    "customers.label.minimumPeriod":
      "მინიმალური პერიოდი არის 1 თვე და ამის შემდეგ სერვისი გაგრძელდება ყოველთვიურად, სანამ არ შეწყვეტთ 30-დღიანი წინასწარი შეტყობინებით (თუ სხვა საკანონმდებლო ან რეგულატორული წესები არ ვრცელდება). ამ პერიოდის განმავლობაში თქვენ მოგიწევთ ყველა გადასახადის დაფარვა.",
    "customers.label.cancellationCoolingOff":
      "თუ გადაიფიქრეთ და გსურთ შეწყვიტოთ ჩვენგან პირდაპირ შეძენილი სერვისები, შესაძლოა გქონდეთ ამის უფლება 14-დღიანი გაცივების პერიოდის განმავლობაში.",
    "customers.label.earlyTerminationCharge":
      "თქვენ ეთანხმებით, რომ სერვისების გამოყენება დაიწყება დაუყოვნებლივ, თუ უკვე გაქვთ SIM ბარათი ან როცა მიიღებთ SIM ბარათს. თუ გადაწყვეტთ სერვისის შეწყვეტას მინიმალური პერიოდის განმავლობაში, ან თუ ჩვენ გავაუქმებთ სერვისს თქვენი მნიშვნელოვანი წესების დარღვევის გამო, თქვენ მოგიწევთ ადრე შეწყვეტის საფასურის გადახდა, რომელიც არ აღემატება თქვენს ყოველთვიურ სააბონენტო გადასახადს გამრავლებული დარჩენილ თვეებზე, დღგ-ს ჩათვლით (აქტუალური განაკვეთით), რაც შემცირდება ერთიანი საბოლოო გადახდისთვის განსაზღვრული პროცენტით. ასევე მოგიწევთ ყველა გამოყენებული ზარის, შეტყობინების, მონაცემების და სხვა ხარჯების დაფარვა, მათ შორის გაცივების პერიოდის განმავლობაში.",
    "customers.label.ContractSummarys":
      "ეს ხელშეკრულების შეჯამება და ჩვენი აბონენტური შეთავაზება დიდი საერთაშორისო სერვისებისთვის 1 თვის ვადით, რომელიც საშუალებას გაძლევთ განახორციელოთ და მიიღოთ ხმოვანი ზარები, გააგზავნოთ და მიიღოთ SMS, გამოიყენოთ მონაცემები და წვდომა ინტერნეტზე, ქსელის მეშვეობით, ასევე ნებისმიერი დამატებითი სერვისი, რომელზეც შევთანხმდებით და რომლის მიღებაც თქვენ აირჩევთ.",
    "customers.label.The": "ის",
    "customers.label.ComesWith": "მოყვება:",
    "customers.label.MobileDataSpeeds":
      "მობილური მონაცემთა სერვისის სიჩქარეები",
    "customers.label.DataServiceDescription":
      "მონაცემთა სერვისი და დაკავშირებული მინიმალური და მაქსიმალური სიჩქარეები, რომლებიც ხელმისაწვდომია Lycamobile ქსელის საშუალებით, დაფუძნებულია თქვენს მდებარეობაზე, მოწყობილობაზე და შეძენილი გეგმაზე (2G, Edge, 3G, 4G, 5G).",
    "customers.label.SpeedVariation":
      "თქვენი მობილური მონაცემთა სიჩქარე შეიძლება განსხვავდებოდეს და დამოკიდებულია თქვენს მდებარეობაზე, გარემოზე (ამინდი, ხეები, შენობების მასალები და ქსელის მომხმარებელთა რაოდენობა) და მოწყობილობაზე.",
    "customers.label.LycamobileBV": "Lycamobile B.V.",
    "customers.label.Robijnlaan17": "Robijnlaan 17,",
    "customers.label.2132WXHoofddorp": "2132WX Hoofddorp,",
    "customers.label.TheNetherlands": "ნიდერლანდები",
    "customers.label.ContractSummary": "ხელშეკრულების შეჯამება",
    "customers.label.ContractSummaryDescription1":
      "ეს ხელშეკრულების შეჯამება შეიცავს ამ მომსახურების შეთავაზების ძირითად ელემენტებს, როგორც ამას კანონი ითვალისწინებს.",
    "customers.label.ContractSummaryDescription2":
      "ეს ეხმარება მომსახურების შეთავაზებების შედარებაში.",
    "customers.label.ContractSummaryDescription3":
      "მომსახურების სრული ინფორმაცია მოცემულია სხვა დოკუმენტებში.",
    "customers.label.ContractSummaryValidity":
      "ეს ხელშეკრულების შეჯამება ძალაშია ჩექაუთის ვადის გასვლამდე",
    "customers.label.AcceptOffer":
      "თუ ეს შეთავაზება თქვენთვის მისაღებია, შეგიძლიათ მიიღოთ იგი ჩექაუთის გვერდზე. გთხოვთ, შეინახოთ ამ დოკუმენტის ასლი თქვენი ჩანაწერებისთვის.",
    "customers.label.Services": "მომსახურება",
    "customers.label.TermsConditions":
      "მომსახურების შეთანხმების წესებისა და პირობების მიხედვით, თუ ჩვენ დავარღვევთ შეთანხმების მნიშვნელოვან პუნქტს, რაც სრულად ზღუდავს ჩვენი მონაცემების მიწოდების შესაძლებლობას და არ გავასწორებთ მას 7 დღის განმავლობაში თქვენი საჩივრის მიღებიდან Lycamobile-ის მომხმარებელთა მომსახურების მეშვეობით, თქვენ შეგიძლიათ შეწყვიტოთ შეთანხმება.",
    "customers.label.EmergencyOrganisations":
      "გადაუდებელი შემთხვევების ორგანიზაციები და დამრეკავის მდებარეობის ინფორმაცია",
    "customers.label.EmergencyCallNetworkDown":
      "თუ საჭიროა გადაუდებელი ზარის განხორციელება (112/999), როდესაც Lycamobile-ის ქსელი არ მუშაობს ან მიუწვდომელია, თქვენს მოწყობილობას უნდა შეეძლოს 2G, 3G, 4G ან 5G ქსელთან დაკავშირება და ავტომატურად შეარჩიოს სხვა ოპერატორის ქსელი, რომელსაც აქვს დაფარვა.",
    "customers.label.EmergencyCallAvailability":
      "გადაუდებელი ზარების განხორციელება შესაძლებელია მხოლოდ იმ შემთხვევაში, თუ ხელმისაწვდომია რადიო ქსელი.",
    "customers.label.PlanName": "პლანის სახელი",
    "customers.label.EuropeanOnlineDisputeResolution":
      "ევროპის ონლაინ დავების გადაჭრის საიტი",
    "customers.label.ECWebsite": "ec.europa.eu/consumers/odr",
    "customers.label.DisputeResolutionDetails":
      "მომხმარებლებს საშუალებას აძლევს, გაგზავნონ დავები, რომლებიც დაკავშირებულია ჩვენს ონლაინ შესყიდვებთან. თქვენ შეგიძლიათ გაეცნოთ ჩვენს ვებსაიტს, რომ იხილოთ ჩვენი საჩივრების კოდექსის ასლი და ალტერნატიული დავების გადაჭრის შესახებ უახლესი ინფორმაცია. ჩვენ აქ ვართ, რათა დაგეხმაროთ. თუ რამე არასწორად წავიდა, ჩვენ გვინდა გამოვასწოროთ. შეგიძლიათ გაიგოთ მეტი ჩვენი საჩივრების პროცესის შესახებ ჩვენს მომხმარებელთა საჩივრების კოდექსში.",
    "customers.label.NetherlandsLawCompliance":
      "თუ ინტერნეტ სერვისის სიჩქარე მუდმივად ან რეგულარულად არ ემთხვევა ხელშეკრულებით განსაზღვრულ სიჩქარეს, ნიდერლანდების კანონმდებლობის შესაბამისად, Lycamobile უზრუნველჰყოფს მომსახურების ხელახლა შესრულებას გონივრულ ვადებში. თუ ხელახლა შესრულება შეუძლებელია, Lycamobile შეამცირებს მომსახურების ღირებულებას მომხმარებლისთვის გონივრულად. თუ მომხმარებელმა უკვე გადაიხადა, Lycamobile აუნაზღაურებს გადახდილ თანხას, რომელიც აღემატება რეალურ ღირებულებას.",
    "customers.label.DirectoryServiceInfo":
      "თქვენ შეგიძლიათ მოითხოვოთ, რომ თქვენი მობილური ტელეფონის ნომერი შევიდეს სატელეფონო ცნობარში და/ან ცნობარის გამოკითხვის სერვისში. თუმცა, უნდა იცოდეთ, რომ თუ ამ მომსახურებას მოითხოვთ, თქვენი ნომერი გამოჩნდება კომპანიებისთვის, რომლებიც აგროვებენ ინფორმაციას მარკეტინგული მიზნებისთვის. თუ ეს გაწუხებთ, შეგიძლიათ შეწყვიტოთ არასასურველი მარკეტინგული ზარები ოპტ-აუტის არჩევით ან თქვენი წინააღმდეგობის უფლების გამოყენებით. თუ გსურთ, რომ თქვენი მობილური ტელეფონის ნომერი შევიდეს ცნობარში და/ან ცნობარის გამოკითხვის სერვისში, გთხოვთ, აცნობოთ ჩვენს მომხმარებელთა მომსახურების გუნდს.",
    "customers.label.RemediesComplaints":
      "გამოსავალი, საჩივრების განხილვა და დავების გადაწყვეტა",
    "customers.label.ContactCustomerService":
      "თუ მომხმარებელთა მომსახურებასთან დაკავშირება გჭირდებათ, ეწვიეთ ვებსაიტს და დააწკაპუნეთ 'დაგვიკავშირდით'. თუ გსურთ ჩვენი სერვისის შესახებ საჩივრის შეტანა, დაუკავშირდით მომხმარებელთა მომსახურებას. თუ კვლავ უკმაყოფილო ხართ, შეგიძლიათ გაგზავნოთ წერილი მიუკერძოებელი განხილვისთვის:",
    "customers.label.IncludeMobileNumber":
      "გთხოვთ, მიუთითოთ თქვენი მობილური ტელეფონის ნომერი, თუ მოგვწერთ. თუ ჩვენ ვერ მოვაგვარებთ თქვენს საჩივარს, შეგიძლიათ 24 თვის განმავლობაში მიმართოთ De Geschillencommissie (Postbus 90600, 2509 LP, Den Haag).",
    "customers.label.Termination": "დასრულება",
    "customers.label.TerminationNotice":
      "მინიმალური პერიოდის შემდეგ, თქვენ შეგიძლიათ დაასრულოთ შეთანხმება ჩვენთან შეტყობინების გზით (თუ არ ვრცელდება სხვა საკანონმდებლო ან მარეგულირებელი წესები) და მოგიწევთ ამ შეტყობინების პერიოდის განმავლობაში დარიცხული გადასახადების გადახდა.",
    "customers.label.EarlyTerminationCharge":
      "თუ სხვა რამ არ არის მითითებული (მაგალითად, თქვენს ტარიფის პირობებში), თუ გსურთ მომსახურების ხელშეკრულების დასრულება მინიმალურ პერიოდში, ან თუ ჩვენ ვასრულებთ ხელშეკრულებას თქვენი სერიოზული დარღვევის გამო, მაშინ მოგიწევთ ვადაზე ადრე შეწყვეტის საფასურის გადახდა, რაც არ იქნება მეტი ვიდრე თქვენი თვიური სააბონენტო გადასახადი მინიმალური პერიოდის დარჩენილი თვეების რაოდენობით გამრავლებული, დღგ-ის ჩათვლით (მიმდინარე განაკვეთით დათვლილი).",
    "customers.label.OptionalAddOnTermination":
      "ნებისმიერი დამატებითი სერვისი დასრულდება დამოუკიდებლად ნებისმიერი თვიური პაკეტისგან.",
    "customers.label.CancellationInfo":
      "თუ გადაიფიქრებთ ან გჭირდებათ შეკვეთის გაუქმება, თქვენ გაქვთ უფლება გააუქმოთ ჩვენი წესებისა და პირობების მიღება შეკვეთის განთავსებიდან 14 დღის განმავლობაში (გადაწყვეტილების მიღების პერიოდი), თუ გაუქმება ხდება ჩვენი გაუქმების პოლიტიკის მიხედვით ან შესაბამისი შეტყობინებით.",
    "customers.label.Security": "უსაფრთხოება",
    "customers.label.SecurityPolicy":
      "ყველა უსაფრთხოების ინციდენტი კლასიფიცირებული, კონტროლირებადი, აღდგენადი, ანალიზირებადი და გადასაჭრელი იქნება. დროული შეტყობინებები გაიგზავნება დაზარალებულ მომხმარებლებს შესაბამისი მარეგულირებელი და კონტრაქტუალური მოთხოვნების მიხედვით.",
    "customers.label.DataProtection": "მონაცემთა დაცვა",
    "customers.label.DataProtectionPolicy":
      "მონაცემთა დაცვის კანონის ფარგლებში, ჩვენ გვჭირდება მომხმარებლის პერსონალური ინფორმაცია სერვისების გაწევისთვის, როგორიცაა: სახელი, მისამართი, ანგარიშის ნომერი, მობილური ტელეფონის ნომერი და გადახდის დეტალები. თქვენი ინფორმაცია მუშავდება ჩვენი კონფიდენციალურობის პოლიტიკის მიხედვით.",
    "customers.label.TariffTerms":
      "გთხოვთ, იხილოთ ჩვენი ტარიფების პირობები და ვებსაიტი კონკრეტული ტარიფებისა და თქვენი პაკეტის ფარგლებს გარეთ არსებული გადასახადების შესახებ დამატებითი ინფორმაციისთვის.",
    "customers.label.DeliveryOfService": "მომსახურების მიწოდება",
    "customers.label.PaymentTerms":
      "ჩვენ ჩამოგაჭრით საჭირო თანხას თქვენი ანგარიშიდან SEPA-ის პირდაპირი დებეტის მეშვეობით, თუ სხვა რამ არ შევთანხმებულვართ. ინვოისი გვიჩვენებს იმ თარიღს, როდესაც ჩამოიჭრება თანხა. ჩვენ შესაძლოა გთხოვოთ ერთჯერადი და სააბონენტო გადასახადების წინასწარ გადახდა. განსაკუთრებულ შემთხვევებში ჩვენ შესაძლოა შუალედური თანხები ჩამოგაჭრათ, მაგალითად, თუ მოკლე პერიოდში საშუალოზე მეტად გქონიათ მოხმარება. თუ იხდით საკრედიტო ან სადებეტო ბარათით, თქვენ აძლევთ უფლებას გადახდის ბარათის კომპანიას, მოგვაწოდოს ინფორმაცია თქვენი ბარათის ანგარიშის შესახებ, საჭიროების შემთხვევაში. ასევე გვაძლევთ უფლებას, შეგვატყობინონ, თუ თქვენი გადახდის ანგარიში შეჩერდება ან გაუქმდება.",
    "customers.label.ServiceStartDate":
      "თარიღი, როცა Lycamobile მოგაწვდით სერვისს, არის ის თარიღი, როდესაც რეგისტრირდებით Lycamobile-ზე.",
    "customers.label.ContractDuration":
      "მომსახურების ხელშეკრულების ხანგრძლივობა, განახლება და შეწყვეტა",
    "customers.label.MinimumPeriod":
      "თქვენს ხელშეკრულებას აქვს მინიმალური ვადა, რომელსაც ეწოდება მინიმალური პერიოდი, რომელიც შეიძლება იყოს 1 თვე ყოველთვიური პაკეტებისთვის და 24 თვე ფიქსირებული ვადიანობის კონტრაქტებისთვის.",
    "customers.label.ContractRenewal":
      "ხელშეკრულების გასაგრძელებლად, თქვენ უნდა აცნობოთ Lycamobile-ს თქვენი წინა კონტრაქტის მოქმედების პერიოდში, რომ თანახმა ხართ ხელშეკრულების განახლებაზე.",
    "customers.label.DataCostDetails":
      "{40 GB მონაცემები} ღირს {18.90 €} პირველ {3 თვეში}, შემდეგ {27.00 €} თვეში, მათ შორისაა VAT (წლიური ზრდა CPI + 3.9%). დეტალების გასაგებად იხილეთ ჩვენი ვებგვერდი।",
    "customers.label.AdditionalAddons":
      "თქვენს გეგმაში შეიძლება ხელმისაწვდომი იყოს დამატებითი Add-ons, რომლებიც ცალკე ფასით ჩამოიჭრება.",
    "customers.label.SpendingLimits": "ხარჯვის ლიმიტი",
    "customers.label.SpendingLimitDetails":
      "Lycamobile დააწესებს ხარჯვის ლიმიტს თქვენს ანგარიშზე თქვენს სურვილებზე დაყრდნობით, მაქსიმუმ €250-მდე.",
    "customers.label.PremiumCharges":
      "პრემიუმ ნომრებზე და საერთაშორისო ზარებზე ტარიფები არ შედის და ცალკე დაჯარიმდება.",
    "customers.label.InternationalRates":
      "ზარები და ტექსტური შეტყობინებები ნიდერლანდებიდან სხვა ქვეყნებში ჩვენი სტანდარტული საერთაშორისო ტარიფებით ჩამოიჭრება.",
    "customers.label.RoamingInEEA": "მიმოსვლა EEA-ში",
    "customers.label.RoamingOutsideEEA": "მიმოსვლა EEA-ის გარეთ",
    "customers.label.RoamingCharges":
      "ტელეფონის გამოყენება (ზარები, შეტყობინებები, მონაცემები) ნიდერლანდებს ან EEA-ის გარეთ და სხვა განსაზღვრულ ადგილებში, ჩამოიჭრება საერთაშორისო ტარიფების მიხედვით.",
    "customers.label.Any_Out_of_bundle_charges_can_be_found_at":
      "ყველა პაკეტის მიღმა გადასახადები შეგიძლიათ იხილოთ აქ:",
    "customers.label.Exclusions_for_voice_international_voice_SMS_Data_Roaming_can_be_found_at":
      "ხმის, საერთაშორისო ზარების, SMS-ისა და მონაცემთა როუმინგის გამონაკლისები შეგიძლიათ იხილოთ აქ:",
    "customers.label.Our_Services_availability":
      "ჩვენი სერვისები ხელმისაწვდომი არ არის ნიდერლანდების, EEA-ს ან სხვა შერჩეულ ადგილებში ყველგან. ჩვენს საშინაო და როუმინგის სამართლიანი გამოყენების პოლიტიკაში შედის სერვისების მისაღები გამოყენება:",
    "customers.label.Lycamobile_network_speeds":
      "Lycamobile ქსელის მონაცემთა სერვისი და მინიმალური და მაქსიმალური სიჩქარე დამოკიდებულია თქვენს ადგილმდებარეობაზე, გამოყენებულ მოწყობილობაზე და შეძენილ გეგმაზე (2G, Edge, 3G, 4G, 5G).",
    "customers.label.Mobile_data_speed_variation":
      "თქვენი მობილური ინტერნეტის სიჩქარე შეიძლება განსხვავდებოდეს და დამოკიდებულია თქვენს ადგილმდებარეობაზე, გარემოზე (ამინდი, ხეები, შენობის მასალები და ქსელის მომხმარებელთა რაოდენობა) და მოწყობილობაზე.",
    "customers.label.Price": "ფასი",
    "customers.label.ContractReview": "კონტრაქტის გადახედვა",
    "customers.label.Terms&Conditions": "წესები და პირობები",
    "customers.label.ReviewThisContract": "ამ კონტრაქტის გადახედვა",
    "customers.label.We_have_sent_these_to": "ჩვენ ეს გავგზავნეთ",
    "customers.label.DownloadContractInformation":
      "კონტრაქტის ინფორმაციის გადმოწერა",
    "customers.label.DownloadContractSummary": "კონტრაქტის შეჯამების გადმოწერა",
    "customers.label.ContractInformation": "კონტრაქტის ინფორმაცია",
    "customers.label.ContactDetails": "საკონტაქტო დეტალები",
    "customers.label.Description_of_Services": "სერვისების აღწერა",
    "customers.label.This_contract_summary_and_our_Abonnement_offer_of":
      "ამ კონტრაქტის შეჯამება და ჩვენი გამოწერის შეთავაზება",
    "customers.label.an_airtime_service_for": "საჰაერო დროის სერვისი",
    "customers.label.comes_with:": "მოყვება:",
    "customers.label.Any_Out_of_bundle_charges_can_be_found_at:":
      "გარეშე გადასახადები შეგიძლიათ იხილოთ აქ:",
    "customers.label.service_description":
      "რომელიც საშუალებას გაძლევთ განახორციელოთ და მიიღოთ ხმოვანი ზარები, გაგზავნოთ და მიიღოთ SMS, გამოიყენოთ მონაცემები და მიიღოთ წვდომა ინტერნეტზე, ეს ყველაფერი ქსელის მეშვეობით, ასევე ნებისმიერი დამატებითი სერვისი, რომელზეც ჩვენ ვთანხმდებით და რომელიც თქვენ ირჩევთ.",
    "customers.label.YouHaveChosenNoCap":
      "თქვენ აირჩიეთ შეუზღუდავი ლიმიტი. ეს ნიშნავს, რომ შეგიძლიათ გამოიყენოთ თქვენი ტელეფონი ზარებისთვის, ტექსტებისთვის, საერთაშორისო წუთებისთვის, როუმინგისთვის და პაკეტის გარეთ მონაცემებისთვის. თქვენ დაგერიცხებათ მაქსიმუმ 60 € ამისთვის.",
    "customers.label.SelectDate":
      "აირჩიეთ თარიღი [ყოველთვიური გადახდა ჩამოიჭრება თქვენი ანგარიშიდან 14 დღის შემდეგ თქვენი შერჩეული ბილინგის თარიღის მიხედვით] *",
    "customers.label.billing_cycle": "ბილინგის ციკლი",
    "customers.label.SelectBilling": "აირჩიეთ ბილინგი",
    "customers.label.I_Agree_To": "ვეთანხმები",
    "customers.label.TermsAndConditions": "წესები და პირობები",
    "customers.label.ThisNumberIsReservedFor": "ეს ნომერი დაცულია",
    "customers.label.TotalPrice": "სრული ფასი:",
    "customers.label.CustomerInfo": "ಗ್ರಾಹಕರ ಮಾಹಿತಿ",
    "customers.label.title": "ಶೀರ್ಷಿಕೆ",
    "customers.label.SelectTitle": "ಶೀರ್ಷಿಕೆ ಆಯ್ಕೆಮಾಡಿ",
    "customers.label.initials": "ಆರಂಭಾತಕ್ಷರಗಳು",
    "customers.label.Basket": "ಟೋಕರಿ",
    "customers.label.first_name": "ಮೊದಲ ಹೆಸರು",
    "customers.label.last_name": "ಕೊನೆಯ ಹೆಸರು",
    "customers.label.email_address": "ಇಮೇಲ್ ವಿಳಾಸ",
    "customers.label.contact_number": "ಸಂಪರ್ಕ ಸಂಖ್ಯೆ",
    "customers.label.date_of_birth": "ಹುಟ್ಟಿದ ದಿನಾಂಕ",
    "customers.label.select_language": "ಭಾಷೆಯನ್ನು ಆಯ್ಕೆಮಾಡಿ",
    "customers.label.how_did_you_hear": "ನಮ್ಮ ಬಗ್ಗೆ ಹೇಗೆ ಕೇಳಿದ್ದೀರಿ?",
    "customers.label.postal_code": "ಅಂಚೆ ಕೋಡ್",
    "customers.label.country": "ದೇಶ",
    "customers.label.Enter_address_manually": "ವಿಳಾಸವನ್ನು ಕೈಯಾರೆ ನಮೂದಿಸಿ",
    "customers.label.Find_address": "ವಿಳಾಸವನ್ನು ಹುಡುಕಿ",
    "customers.label.Select_Address": "ವಿಳಾಸ ಆಯ್ಕೆಮಾಡಿ",
    "customers.label.Select_an_address": "ಒಂದು ವಿಳಾಸ ಆಯ್ಕೆಮಾಡಿ",
    "customers.label.Enter_address_dynamically": "ಡೈನಾಮಿಕ್ ವಿಳಾಸ ನಮೂದಿಸಿ",
    "customers.label.address_number": "ವಿಳಾಸ ಸಂಖ್ಯೆ",
    "customers.label.street": "ರಸ್ತೆ",
    "customers.label.state": "ರಾಜ್ಯ",
    "customers.label.city": "ನಗರ",
    "customers.label.resident_period": "ನಿವಾಸ ಅವಧಿ",
    "customers.label.Spend_Cap_Amount": "ಖರ್ಚು ಮಿತಿಯ ಮೊತ್ತ",
    "customers.label.I_don’t_want_a_Spend_Cap":
      "ನಾನು ಖರ್ಚು ಮಿತಿಯನ್ನು ಬಯಸುವುದಿಲ್ಲ",
    "customers.label.Monthly_Bill_Generation_Date":
      "ಮಾಸಿಕ ಬಿಲ್ ಉತ್ಪಾದನೆ ದಿನಾಂಕ",
    "customers.label.Select_a_Monthly_Plan": "აირჩიეთ ყოველთვიური გეგმა",
    "customers.label.Search_plans": "გეგმის ძიება...",
    "customers.label.search": "ძებნა",
    "customers.label.Select_a_plan": "აირჩიეთ გეგმა",
    "customers.label.Basket": "კალათა",
    "customers.label.This_number_is_reserved_for": "ეს ნომერი დაცულია",
    "customers.label.ViewT&C": "იხილეთ პირობები",
    "customers.label.TransferringFromPreviousNetwork":
      "წინა ქსელიდან გადატანა (მოიტანეთ ძველი ნომერი)",
    "customers.label.SIM_Information": "SIM ინფორმაცია",
    "customers.label.Prepaid": "წინასწარ გადახდილი",
    "customers.label.Postpaid": "შემდგომი გადახდა",
    "customers.label.Physical_SIM": "ფიზიკური SIM",
    "customers.label.eSIM": "eSIM",
    "customers.label.SelectCustomerType": "აირჩიეთ მომხმარებლის ტიპი",
    "customers.label.New_to_Lyca": "Lyca-ში ახალი",
    "customers.label.Convert_Lyca_Prepaid_to_Postpaid":
      "Lyca წინასწარ გადახდილი -> შემდგომი გადახდის გადაყვანა",
    "customers.label.Existing_customer_is_going_to_be_sent_a_secure_link_to_confirm_that_they_wish_to_move_from_prepaid_to_abonnement.":
      "არსებული მომხმარებელი მიიღებს უსაფრთხო ბმულს, რათა დაადასტუროს, რომ სურს გადაცვლა წინასწარი გადახდიდან აბონემენტზე.",
    "customers.label.Customer_to_receive_an_SMS": "მომხმარებელი მიიღებს SMS-ს",
    "customers.label.Lyca_Mobile_Number": "Lyca მობილურის ნომერი",
    "customers.label.Enter_the_Lyca_Mobile_Number":
      "შეიყვანეთ Lyca მობილურის ნომერი",
    "customers.label.Nationality": "ეროვნება",
    "customers.label.Send_Secure_link": "გაგზავნეთ უსაფრთხო ბმული",
    "customers.label.New_to_Lyca_Mobile": "Lyca Mobile-ში ახალი",
    "customers.label.serial_number": "სერიული ნომერი",
    "customers.label.Serial_Number": "სერიული ნომერი (ბოლო 4 ციფრი)",
    "customers.label.PUK_Code": "PUK კოდი",
    "customers.label.PUK_Code_is_not_matched": "PUK კოდი არ ემთხვევა",
    "customers.label.Switching_to_Lyca_Mobile": "Lyca Mobile-ზე გადართვა",
    "customers.label.Enter_the_PUK_Code": "შეიყვანეთ PUK კოდი",
    "customers.label.Basket": "კალათა",
    "customers.label.Gender": "სქესი",
    "customers.label.business_name": "ბიზნესის სახელი",
    "customers.label.phone_number": "ტელეფონის ნომერი",
    "customers.label.Date_of_Birth": "დაბადების თარიღი",
    "customers.label.VIP": "VIP",
    "customers.label.Disability": "ინვალიდობა",
    "customers.label.District": "რაიონი",
    "customers.label.Is_your_billing_address_same_as_primary_address":
      "არის თქვენი საბუთების მისამართი იგივე, რაც პირველადი მისამართი?",
    "customers.label.Supressbill": "ანგარიშის დამალვა",
    "customers.label.SelectCategory": "აირჩიეთ კატეგორია",
    "customers.label.SelectGender": "აირჩიეთ სქესი",
    "customers.label.SelectPreferences": "აირჩიეთ პრეფერენციები",
    "customers.label.SelectNationality": "აირჩიეთ ეროვნულობა",
    "customers.label.SelectVIP": "აირჩიეთ VIP",
    "customers.label.SelectDisability": "აირჩიეთ ინვალიდობა",
    "customers.label.SelectCity": "აირჩიეთ ქალაქი",
    "customers.label.SelectBillDay": "აირჩიეთ ბილინგის დღე",
    "customers.label.SelectType": "აირჩიეთ ტიპი",
    "customers.label.SelectFiscalYear": "აირჩიეთ ფისკალური წელი",
    "customers.label.SelectFiscalQuarter": "აირჩიეთ ფისკალური კვარტალი",
    "customers.label.SelectBillMode": "აირჩიეთ ბილინგის რეჟიმი",
    "customers.label.SelectInvoiceType": "აირჩიეთ ინვოისის ტიპი",
    "customers.label.IMSI": "IMSI",
    "customers.label.SalesMotion": "გაყიდვების მოძრაობა",
    "customers.label.SpendCap": "ხარჯვის ლიმიტი",
    "customers.label.ActivationDate": "აქტივაციის თარიღი",
    "customers.label.ExpiryDate": "ვადის გასვლის თარიღი",
    "customers.label.NextRenewalDate": "მომდევნო განახლების თარიღი",
    "customers.label.BalanceTransfer": "ბალანსის გადაცემა",
    "customers.label.RecieverClientId": "მიმღების კლიენტის ID",
    "customers.label.Amount": "თანხა",
    "customers.label.EnterTopUpAmount": "შეიყვანეთ შესავსები თანხა",
    "customers.label.ResponseId": "პასუხის ID",
    "customers.label.BalanceName": "ბალანსის სახელი",
    "customers.label.Allowance": "დაშვებული თანხა",
    "customers.label.Consumption": "მოხმარება",
    "customers.label.AvailableBalance": "ხელმისაწვდომი ბალანსი",
    "customers.label.DaysLeft": "დარჩენილი დღეები",
    "customers.label.Discount": "ფასდაკლება",
    "customers.label.postal_code": "საფოსტო კოდი",
    "customers.label.address_number": "მისამართის ნომერი",
    "customers.label.city": "ქალაქი",
    "customers.label.state": "შტატი",
    "customers.label.country": "ქვეყანა",
    "customers.label.resident_period": "საცხოვრებელი პერიოდი",
    "customers.label.postcode": "საფოსტო კოდი",
    "customers.label.comment_date": "კომენტარის თარიღი",
    "customers.label.how_did_you_hear": "როგორ გაიგეთ ჩვენს შესახებ?",
    "customers.label.select_language": "ენის არჩევა",
    "customers.label.email_address": "ელ.ფოსტის მისამართი",
    "customers.label.contact_number": "საკონტაქტო ნომერი",
    "customers.label.initials": "ინიციალები",
    "customers.label.communication_type": "კომუნიკაციის ტიპი",
    "customers.label.BuySIM": "SIM-ის შეძენა",
    "customers.label.origination": "წარმოშობა",
    "customers.label.address": "მისამართი",
    "customers.label.destination_address": "დანიშნულების მისამართი",
    "customers.label.event": "მოვლენა",
    "customers.label.charge_party": "დამუხტული მხარე",
    "customers.label.service_subs_type": "სერვისის გამოწერის ტიპი",
    "customers.label.calling_party": "მომწოდებელი მხარე",
    "customers.label.called_party": "მიმღები მხარე",
    "customers.label.usage": "გამოყენება",
    "customers.label.monetary_charge": "ფასიანი გადასახადი",
    "customers.label.result_code": "შედეგის კოდი",
    "customers.label.generation_time": "გენერაციის დრო",
    "customer.label.generationdatetime": "გენერაციის თარიღი და დრო",
    "customers.label.transaction_id": "ტრანზაქციის ID",
    "customers.label.application_transaction_id": "აპლიკაციის ტრანზაქციის ID",
    "customers.label.application_name": "აპლიკაციის სახელი",
    "customers.label.recharge_value": "შევსების მნიშვნელობა",
    "customers.label.interface": "ინტერფეისი",
    "customers.label.result": "შედეგი",
    "customers.label.comment": "კომენტარი",
    "customers.label.recharge": "შევსება",
    "customers.label.cdr": "CDR",
    "customers.label.notifications": "შეტყობინებები",
    "customers.label.mobile_no": "Enter Mobile No",
    "customers.label.email_id": "Enter Email Id",
    "customers.label.serial_number": "Serial No",
    "customers.label.digital_content": "ციფრული კონტენტი",
    "customers.label.buySim": "SIM-ის ყიდვა",
    "customers.label.outstanding_due": "გადასახდელი თანხა",
    "customers.label.due_date": "გადახდის თარიღი",
    "customers.label.unbilled_amount": "აუდარეგისტრირებული თანხა",
    "customers.label.next_bill_day": "შემდეგი გადასახდელი დღე",
    "customers.label.view_allowances": "ხარჯების ნახვა",
    "customers.label.view_service_details": "სერვისის დეტალების ნახვა",
    "customers.label.spend_limit": "დახარჯვის ლიმიტი",
    "customers.label.topup_balance": "ბალანსის შევსება",
    "customers.label.next_renewal_date": "შემდეგი განახლების თარიღი",
    "customers.label.allowance": "დანამატი",
    "customers.label.ViewDocumentUpload": "დოკუმენტის ატვირთვის ნახვა",
    "customers.label.total_net_amount": "სრული სუფთა თანხა",
    "customers.label.cancelRemark": "გააუქმეთ შენიშვნა",
    "customers.label.cancelPayment": "გადახდის გაუქმება",
    "customers.label.all": "ყველა",
    "customers.label.billProfile": "ಬಿಲ್ ಪ್ರೊಫೈಲ್",
    "customers.label.charges": "ಶುಲ್ಕ",
    "customers.label.book_order": "წიგნის შეკვეთა",
    "customers.label.customers": "აბონენტები",
    "customers.label.search_for_clients": "აბონენტების ძებნა",
    "customers.label.advance_search": "გაფერხებული ძებნა",
    "customers.label.create_customer": "აბონენტის შექმნა",
    "customers.label.account_no": "ანგარიშის ნომერი",
    "customers.label.customer_name": "აბონენტის სახელი",
    "customers.label.business_entity": "ბიზნეს ენთიტეტი",
    "customers.label.balance": "ბალანსი",
    "customers.label.created_by": "შექმნილია მიერ",
    "customers.label.created_on": "შექმნილია",
    "customers.label.credit_limit": "კრედიტის ლიმიტი",
    "customers.label.transaction_history": "ტრანზაქციის ისტორია",
    "customers.label.external_activity_log": "გარე აქტივობის ლოგი",
    "customers.label.settings": "პარამეტრები",
    "system.label.currency_noncurrency": "ვალუტა არა-ვალუტა",
    "entity.label.configure": "კონფიგურაცია",

    "customers.label.valid_from": "ძალაშია",
    "customers.label.valid_to": "ძალაშია მდე",
    "customers.label.non_currency_details": "არასავალუტო დეტალები",
    "customers.label.view_details": "დეტალების ნახვა",
    "customers.label.status": "სტატუსი",
    "customers.label.first_name": "სახელი",
    "customers.label.price_discount": "ფასი და ფასდაკლება",
    "customers.label.collection_status": "შეგროვების სტატუსი",
    "customers.label.last_name": "გვარი",
    "customers.label.city_area": "ქალაქი/უბანი",
    "customers.label.email": "ელ. ფოსტა",
    "customers.label.phone": "ტელეფონი",
    "customers.label.cafid": "CAF Id",
    "customers.label.enter_business_entity": "შეიყვანეთ ბიზნეს სუბიექტი",
    "customers.label.select": "არჩიეთ",
    "customers.label.refund": "დაბრუნება",
    "customers.label.refund_id": "დაბრუნების ID",
    "customers.label.refund_amount": "დაბრუნების ოდენობა",
    "customers.label.select_category_type": "აირჩიეთ კატეგორიის ტიპი",
    "customers.label.clear": "გასუფთავება",
    "customers.label.search": "ძებნა",
    "customers.label.customer_activation": "აბონენტის გააქტიურება",
    "customers.label.customer_details": "აბონენტის დეტალები",
    "customers.label.loc": "LOC",
    "customers.label.customer_category": "აბონენტის კატეგორია",
    "customers.label.service_details": "მომსახურების დეტალები",
    "customers.label.name": "სახელი",
    "customers.label.add_service": "მომსახურების დამატება",
    "customers.label.network_node": "ქსელის ნოუდი",
    "customers.label.device_details": "მოწყობილობის დეტალები",
    "customers.label.item": "ნივთი",
    "customers.label.discount_code": "ფასდაკლების კოდი",
    "customers.label.total_price": "საერთო ფასი",
    // "customers.label.device_details": "მოწყობილობის დეტალები",
    "customers.label.plan_details": "გეგმის დეტალები",
    "customers.label.payment_details": "Გადახდის დეტალები",
    "customers.label.plan_list": "გეგმის სია",
    "customers.label.plan": "გეგმა",
    "customers.label.contract_period": "ხელშეკრულების პერიოდი",
    "customers.label.charge_cycle": "გადასახადის ციკლი",
    "customers.label.cancel": "გაუქმება",
    "customers.label.next": "შემდეგი",
    "customers.label.done": "შესრულებულია",
    "customers.label.reopen": "ხელახლა გახსნა",
    "customers.label.submit": "წარმოადგენს",
    "customers.label.view_customer": "დახურვა კლიენტი",
    "customers.label.account_number": "ანგარიშის ნომერი",
    "customers.label.serial_no": "სერიული ნომერი",
    "customers.label.office_hierarchy": "ოფისის იერარქია",
    "customers.label.account_type": "ანგარიშის ტიპი",
    // "customers.label.balance": "ბალანსი",
    "customers.label.stb_serial_no": "STB სერიული ნომერი",
    "customers.label.non_currency_balance": "არ ვალუტური ბალანსი",
    "customers.label.service_orders": "მომსახურების ბრძანებები",
    "customers.label.more_info": "მეტი ინფორმაცია",
    "customers.label.notes": "შენიშვნები",
    "customers.label.device": "მოწყობილობა",
    "customers.label.tickets": "ბილეთები",
    "customers.label.on_demand": "მოთხოვნაზე",
    "customers.label.on_demand_billing": "ბილინგი მოთხოვნით",
    "customers.label.payments": "გადახდები",
    "customers.label.invoice": "ინვოისი",
    "customers.label.contact_information": "კონტაქტური ინფორმაცია",
    "customers.label.address_information": "მისამართის ინფორმაცია",
    "customers.label.billing_information": "გადახდის ინფორმაცია",
    "customers.label.balance_information": "ბალანსის ინფორმაცია",
    // "customers.label.customer_name": "კლიენტის სახელი",
    "customers.label.parent_child": "მშობელი/შვილი",
    "customers.label.created_date": "შექმნის თარიღი",
    "customers.label.district": "რაიონი",
    "customers.label.pincode": "საფოსტო ინდექსი",
    "customers.label.last_bill_amount": "ბოლო გადასახდელი თანხა",
    "customers.label.last_bill_date": "ბოლო გადასახდელი თარიღი",
    "customers.label.last_bill_paid": "ბოლო გადასახდელი გადახდილია",
    "customers.label.last_paid_amount": "ბოლო გადახდილი თანხა",
    "customers.label.last_payment_date": "ბოლო გადახდის თარიღი",
    "customers.label.next_bill_date": "შემდეგი გადასახდელი თარიღი",
    "customers.label.service_overview": "სერვისის მიმოხილვა",
    "customers.label.service_without_device": "სერვისი მაკუთვნებელი გარეშე",
    "customers.label.create_ticket": "ბილეთის შექმნა",
    "customers.label.service_activation": "სერვისის აქტივაცია",
    "customers.label.order_charging": "შეკვეთის ჩარიცხვა",
    "customers.label.top_up": "შევსება",
    "customers.label.redeem": "ანგარიში",
    "customers.label.collection_name": "კოლექციის სახელი",
    "customers.label.redeem_voucher": "გამოისყიდეთ ვაუჩერი",
    "customers.label.service_id": "მომსახურების ID",
    "customers.label.service_code": "მომსახურების კოდი",
    "customers.label.start_date": "დაწყების თარიღი",
    "customers.label.modified_date": "შეცვლის თარიღი",
    // "customers.label.status": "სტატუსი",
    "customers.label.info": "ინფო",
    "customers.label.action": "ქმედება",
    "customers.label.add_device": "მოწესრიგე მაგიდა",
    "customers.label.add_plans": "გეგმიური გეგმები",
    "customers.label.suspend": "შეჩერება",
    "customers.label.reactivate": "რეაქტივაცია",
    "customers.label.terminate": "გათიშვა",
    "customers.label.command_center": "ბრძანებების ცენტრი",
    "customers.label.retrack": "ხელახლა მიმდინარეობა",
    "customers.label.cancel_plans": "გეგმების გაუქმება",
    "customers.label.device_overview": "მოწესრიგების მიმოხილვა",
    "customers.label.item_code": "ნივთის კოდი",
    "customers.label.orders_overview": "შეკვეთების მიმოხილვა",
    // "customers.label.plan": "გეგმა",
    "customers.label.end_date": "დასრულების თარიღი",
    "customers.label.price": "ფასი",
    "customers.label.short_description": "მოკლე აღწერა",
    "customers.label.description": "აღწერა",
    "customers.label.add_note": "შენიშვნის დამატება",
    "customers.label.note": "შენიშვნა",
    "customers.label.sale_type": "გაყიდვის ტიპი",
    "customers.label.bill_item_details": "ანგარიშის საქონლის დეტალები",
    "customers.label.charge_id": "დაკისრების ID",
    "customers.label.order_id": "შეკვეთის ID",
    "customers.label.item_tax_details": "საქონლის გადასახადის დეტალები",
    "customers.label.discount_details": "ფასდაკლების დეტალები",
    "customers.label.sale_date": "გაყიდვის თარიღი",
    "customers.label.charge_code": "გადახდის კოდი",
    "customers.label.quantity": "რაოდენობა",
    // "customers.label.total_price": "ჯამური ფასი",
    "customers.label.warranty_date": "გარანტიის თარიღი",
    "customers.label.allocate": "გაყიდვის გაკეთება",
    "customers.label.contact_info": "კონტაქტის ინფო",
    "customers.label.edit_customer": "კლიენტის რედაქტირება",
    "customers.label.lco": "LCO",
    "customers.label.title": "სათაური",
    // "customers.label.customer_category": "კლიენტის კატეგორია",
    "customers.label.middle_name": "შუა სახელი",
    "customers.label.caf_id": "CAF იდენტიფიკატორი",
    "customers.label.landline_number": "სტაციონარული ნომერი",
    "customers.label.user_name": "მომხმარებელის სახელი",
    "customers.label.customer_photo": "კლიენტის ფოტო",
    "customers.label.id_proof": "იდენტიფიკაციის პრუვა",
    "customers.label.id_proof_value": "იდენტიფიკაციის პრუვის მნიშვნელობა",
    "customers.label.save": "შენახვა",
    "customers.label.close_customer": "კლიენტის დახურვა",
    "customers.label.closure_date": "დახურვის თარიღი",
    "customers.label.closure_reason": "დახურვის მიზეზი",
    "customers.label.close": "დახურვა",
    "customers.label.address_info": "მისამართის ინფო",
    "customers.label.edit_address": "მისამართის რედაქტირება",
    "customers.label.address_no": "მისამართის ნომერი",
    "customers.label.street": "ქუჩა",
    "customers.label.building": "შენობა",
    "customers.label.zipcode": "საფოსტო კოდი",
    "customers.label.billing": "ბილინგი",
    "customers.label.same_as_primary": "იგივე როგორც პირველი",
    "customers.label.building_code": "შენობის კოდი",
    "customers.label.add_address": "მისამართის დამატება",
    "customers.label.address_type": "მისამართის ტიპი",
    "customers.label.billing_info": "გადახდის ინფო",
    "customers.label.created_adjustment": "შექმნილი შესასწორებელი",
    "customers.label.create_order": "შეუკითხავა",
    "customers.label.sale_catalog": "გაყიდვების კატალოგი",
    "customers.label.renew_plan": "განაახლეთ გეგმა",
    "customers.label.auto_renew": "ავტო გადახდებით განახლება",
    // "customers.label.search": "ძებნა",
    "customers.label.entity_name": "ენთიტეტის სახელი",
    "customers.label.discount": "ფასდაკლება",
    "customers.label.provisioning_commands": "პროვიზიონირების ბრძანებები",
    "customers.label.command": "ბრძანება",
    "customers.label.plans": "გეგმები",
    "customers.label.client_service_detail": "კლიენტის სერვისის დეტალები",
    "customers.label.id": "იდენტიფიკაცია",
    "customers.label.parameter_name": "პარამეტრის სახელი",
    "customers.label.parameter_value": "პარამეტრის მნიშვნელობა",
    "customers.label.request_type": "მოთხოვნის ტიპი",
    "customers.label.client_info": "კლიენტის ინფორმაცია",
    "customers.label.service_info": "სერვისის ინფორმაცია",
    "customers.label.new_device_info": "ახალი მოწყობილობის ინფორმაცია",
    "customers.label.task_list": "დავალებების სია",
    "customers.label.provisioning_detail": "პროვიზიონირების დეტალები",
    "customers.label.provisioning_id": "პროვიზიონირების ID",
    "customers.label.task_id": "დავალების ID",
    "customers.label.sent_message": "გაგზავნილი შეტყობინება",
    "customers.label.available_plans": "ხელმისაწვდო გეგმები",
    "customers.label.disconnect_order": "გამორიცხვის ბრძანება",
    "customers.label.reason": "მიზეზი",
    "customers.label.porting_out": "პორტირება გარეთ",
    "customers.label.prepaid_to_postpaid": "წინასწარი გადახდის შემდგომი",
    "customers.label.postpaid_to_prepaid": "პოსტგადახდილი წინასწარ გადახდის",
    "customers.label.addons": "დამატებები",
    "customers.label.change_plan": "გეგმის შეცვლა",
    "customers.label.swap_sim": "სიმ ბარათის შეცვლა",
    "customers.label.select_date": "თარიღის არჩევა",
    "customers.label.order_date": "შეკვეთის თარიღი",
    "customers.label.priority": "პრიორიტეტი",
    "customers.label.ticket_date": "ბილეთის თარიღი",
    "customers.label.category": "კატეგორია",
    "customers.label.sub_category": "ქვე-კატეგორია",
    "customers.label.team": "გუნდი",
    "customers.label.team_user": "გუნდის მომხმარებელი",
    "customers.label.source": "წყარო",
    "customers.label.due_time": "შესრულების დრო",
    "customers.label.device_swap": "მოწყობილობის შეცვლა",
    // "customers.label.terminate": "გაწყვეტა",
    "customers.label.confirm": "დადასტურება",
    "customers.label.continue": "განაგრძე",
    "customers.label.process_date": "პროცესის თარიღი",
    "customers.label.pin_number": "PIN ნომერი",
    "customers.label.renewal": "განახლება",
    // "customers.label.create_customer": "დაამატეთ კლიენტი",
    "customers.label.individual": "ინდივიდუალური",
    "customers.label.corporate": "კორპორაცია",
    "customers.label.corporate_details": "კორპორატიული დეტალები",
    "customers.label.contact_person": "კონტაქტის პიროვნება",
    "customers.label.entity": "ენტიტეტი",
    "customers.label.client_category": "კლიენტის კატეგორია",
    "customers.label.preferences": "პრეფერენციები",
    "customers.label.parent_id": "მშობელი ID",
    "customers.label.child": "შვიდი",
    "customers.label.villege_street": "სოფელი/ქუჩა",
    "customers.label.billing_address": "ბილინგის მისამართი",
    "customers.label.bill_information": "განახლების ინფორმაცია",
    "customers.label.bill_day_of_month": "თვეში დღე ანაბინი",
    "customers.label.fiscal_year": "ფინანსური წელი",
    "customers.label.fiscal_quater": "ფინანსური კვარტალი",
    "customers.label.bill_mode": "განახლების რეჟიმი",
    "customers.label.invoice_type": "ინვოისის ტიპი",
    "customers.label.payment_information": "გადახდის ინფორმაცია",
    "customers.label.funder_name": "ფონდის სახელი",
    "customers.label.funder_id": "ფონდის ID",
    "customers.label.po_number": "PO ნომერი",
    "customers.label.payment_term": "გადახდის პირობა",
    "customers.label.customer_created_successfully": "კლიენტი წარმოებულია",
    "customers.label.go_to_customer": "გადადით კლიენტზე",
    "customers.label.view_order": "შეუთავაზეთ შეკვეთა",
    "customers.label.disconnect": "გამუქცევა",
    "customers.label.apply_promo": "პრომო გამოყენება",
    // "customers.label.order_id": "შეკვეთის ID",
    "customers.label.order_type": "შეკვეთის ტიპი",
    "customers.label.billing_cycle": "ბილინგის ციკლი",
    "customers.label.plan_name": "გეგმის სახელი",
    "customers.label.user_action": "მომხმარებელის მოქმედება",
    "customers.label.invoice_till_date": "ინვოისი დღემდე",
    "customers.label.order_services": "შეკვეთის მომსახურება",
    "customers.label.service_type": "სერვისის ტიპი",
    "customers.label.service_description": "სერვისის აღწერა",
    "customers.label.bill_start_date": "ბილინგის დაწყების თარიღი",
    "customers.label.bill_end_date": "ბილინგის დასრულების თარიღი",
    // "customers.label.invoice_till_date": "ინვოისი დღემდე",
    "customers.label.charge_type": "გადასახადის ტიპი",
    "customers.label.rate_uom": "კურსი/UOM",
    "customers.label.discount_description": "ფასდაკლების აღწერა",
    "customers.label.discount_type": "ფასდაკლების ტიპი",
    "customers.label.discount_start_date": "ფასდაკლების დაწყების თარიღი",
    "customers.label.discount_end_date": "ფასდაკლების დასრულების თარიღი",
    "customers.label.discount_amount": "ფასდაკლების თანხა",
    "customers.label.order_transaction": "შეკვეთის ტრანზაქცია",
    "customers.label.user": "მომხმარებელი",
    "customers.label.transaction_date": "ტრანზაქციის თარიღი",
    "customers.label.transaction_type": "ტრანზაქციის ტიპი",
    "customers.label.actual_date": "რეალური თარიღი",
    "customers.label.promo": "პრომო",
    "customers.label.promotion": "პრომოცია",
    "customers.label.disconnection_date": "დისკონექტირების თარიღი",
    "customers.label.disconnection_reason": "დისკონექტირების მიზეზი",
    "customers.label.problem_code": "პრობლემის კოდი",
    "customers.label.assign_to": "Assign To",
    "customers.label.last_comment": "ბოლო კომენტარი",
    "customers.label.file_name": "ფაილის სახელი",
    "customers.label.edit_ticket": "ბილეთის რედაქტირება",
    "customers.label.close_ticket": "ბილეთის დახურვა",
    "customers.label.resolution_description": "გამოხმაურების აღწერა",
    "customers.label.ticket_history": "ბილეთის ისტორია",
    // "customers.label.last_comment": "ბოლო კომენტარი",
    "customers.label.problem_description": "პრობლემის აღწერა",
    "customers.label.generate": "გენერაცია",
    "customers.label.bill_date": "ინვოისის თარიღი",
    "customers.label.amount": "თანხა",
    "customers.label.statement": "განცხადება",
    // "customers.label.due_date": "საბოლოო თარიღი",
    "customers.label.promotional_message": "სავაჭრო შეტყობინება",
    "customers.label.download": "ჩამოტვირთვა",
    "customers.label.due_amount": "სავაჭრო თანხა",
    "customers.label.transactions": "ტრანზაქციები",
    "customers.label.file": "ფაილი",
    "customers.label.reset": "განულება",
    "customers.label.order_details": "შეკვეთის დეტალები",
    "customers.label.make_payment": "გადახდა",
    "customers.label.credit_amount": "კრედიტის ოდენობა",
    "customers.label.debit_amount": "დებიტის ოდენობა",
    "customers.label.cancel_remark": "გაუქმების შენიშვნა",
    "customers.label.pay_invoice": "ინვოისის გადახდა",
    "customers.label.account": "ანგარიში",
    "customers.label.deposit": "გადახდა",
    "customers.label.payment_date": "გადახდის თარიღი",
    "customers.label.receipt_no": "მიღების ნომერი",
    "customers.label.cheque_no": "ჩეკის ნომერი",
    "customers.label.bank_name": "ბანკის სახელი",
    "customers.label.branch_name": "ფილიალის სახელი",
    "customers.label.cheque_date": "ჩეკის თარიღი",
    "customers.label.invoice_id": "ინვოისის ID",
    "customers.label.invoice_date": "ინვოისის თარიღი",
    "customers.label.invoice_amount": "ინვოისის ოდენობა",
    // "customers.label.due_amount": "შენატანის ოდენობა",
    "customers.label.payment_reversal": "გადახდის უკუგავიანესი",
    "customers.label.date_filter": "თარიღის ფილტრი",
    "customers.label.add_event_order": "მოვახერხეთ ღონისძიების შეკვეთა",
    "customers.label.event_order": "ივენტის შეკვეთა",
    "customers.label.eventdate": "ივენტის თარიღი",
    "customers.label.serviceAddress": "მომსახურების მისამართი",
    "customers.label.event_name": "ღონისძიების სახელი",
    "customers.label.booked_date": "დაჯავშნილი თარიღი",
    "customers.label.event_price": "ღონისძიების ფასი",
    "customers.label.events": "ღონისძიებები",
    "customers.label.format_type": "ფორმატის ტიპი",
    "customers.label.opt_type": "OPT ტიპი",
    "customers.label.client_bill_profile": "კლიენტის განაცხადის პროფილი",
    "customers.label.edit": "რედაქტირება",
    "customers.label.type": "ტიპი",
    "customers.label.client_id": "კლიენტის ID",
    "customers.label.bill_frequency": "გადასახადის პერიოდი",
    "customers.label.bill_segment": "გადასახადის სეგმენტი",
    // "customers.label.next_bill_day": "შემდეგი გადახდის დღე",
    "customers.label.last_bill_day": "ბოლო გადახდის დღე",
    "customers.label.last_bill_no": "ბოლო გადახდის ნომერი",
    "customers.label.payment_type": "გადახდის ტიპი",
    "customers.label.bill_suppression_flag": "გადასახადის შეზღუდვის დრო",
    "customers.label.bill_suppression_id": "გადასახადის შეზღუდვის ID",
    "customers.label.first_bill": "პირველი გადახდა",
    "customers.label.hot_bill": "თბილი გადახდა",
    "customers.label.edit_bill_profile": "ბილის პროფილის რედაქტირება",
    "customers.label.bill_currency": "ბილის ვალუტა",
    "customers.label.bill_suppression": "ბილის დაწევა",
    // "customers.label.more_info": "მეტი ინფო",
    "customers.label.identities": "იდენტიფიკაციები",
    "customers.label.add_client_identities":
      "კლიენტის იდენტიფიკაციების დამატება",
    "customers.label.unique_identification": "უნიკალური იდენტიფიკაცია",
    "customers.label.identity_documents": "იდენტიფიკაციის დოკუმენტები",
    "customers.label.additional_info": "დამატებითი ინფორმაცია",
    "customers.label.nationality": "ეროვნული სტატუსი",
    "customers.label.date_of_birth": "დაბადების თარიღი",
    "customers.label.preferred_language": "სასურველი ენა",
    "customers.label.finance_id": "ფინანსთა იდენტიფიკაცია",
    "customers.label.remarks": "შენიშვნები",
    "customers.label.preferred_communication": "სასურველი კომუნიკაცია",
    "customers.label.add_client_identifier":
      "კლიენტის იდენტიფიკატორის დამატება",
    "customers.label.document_type": "დოკუმენტის ტიპი",
    "customers.label.document_uploads": "დოკუმენტის ატვირთვა",
    "customers.label.select_file": "ფაილის არჩევა",
    "customers.label.credit_card_details": "საკრედიტო ბარათის დეტალები",
    "customers.label.card_number": "ბარათის ნომერი",
    "customers.label.cvv": "CVV",
    "customers.label.card_type": "ბარათის ტიპი",
    "customers.label.expiry_date": "ვადის დასაწყისი",
    "customers.label.ach_card": "ACH ბარათი",
    "customers.label.ach_card_routing_number":
      "ACH ბარათის მიმართულების ნომერი",
    "customers.label.bank_account_number": "ბანკის ანგარიშის ნომერი",
    "customers.label.childs": "შვილები",
    "customers.label.cell_phone": "მობილური ტელეფონი",
    "customers.label.create_client_additional_info":
      "დაამატეთ კლიენტის დამატებითი ინფორმაცია",
    "customers.label.gender": "სქესი",
    "customers.label.id_type": "ID ტიპი",
    // "customers.label.nationality": "ეროვნული სტატუსი",
    "customers.label.id_number": "ID ნომერი",
    "customers.label.job_title": "სამუშაო დასახელება",
    "customers.label.age_group": "ასაკის ჯგუფი",
    "customers.label.uts_customer_id": "UTS კლიენტის ID",
    "customers.label.ach_card_name": "ACH ბარათის სახელი",
    "customers.label.adjustment": "შესასწორებელი",
    // "customers.label.created_adjustment": "შექმნილი შესასწორებელი",
    "customers.label.adjustment_date": "შესწორების თარიღი",
    "customers.label.adjustment_code": "შესასწორებლის კოდი",
    "customers.label.adjustment_amount": "შესასწორებლის ოდნავა",
    "customers.label.adjustment_type": "შესასწორებლის ტიპი",
    "customers.label.activity_log": "აქტივობის ჟურნალი",
    "customers.label.office_id": "ოფისის ID",
    "customers.label.history": "ისტორია",
    "customers.label.filter_by_date": "თარიღის ფილტრვით",
    "customers.label.view_usage_details": "გამოყენების დეტალების ნახვა",
    "customers.label.units": "ერთეულები",
    "customers.label.tax": "საგადასახადო",
    "customers.label.total_amount": "ჯამური ოდნავა",
    "customers.label.account_transaction": "ანგარიშის გარიგება",
    "customers.label.csv_pdf": "CSV/PDF",
    "customers.label.charge_description": "ხარჯის აღწერა",
    "customers.label.journals": "ჟურნალები",
    "customers.label.download_financial_summary_data":
      "ფინანსური რეზიუმე მონაცემთა ჩამოტვირთვა",
    "customers.label.select_from_date": "თარიღიდან არჩევა",
    "customers.label.select_to_date": "თარიღამდე არჩევა",
    "customers.label.village_street": "სოფელი/ქუჩა",
    "customers.label.previous": "წინა",
    "customers.label.Disconnect": "გათიშვა",
    "customers.label.ApplyPromo": "წინადადების გამოყენება",
    "customers.label.Service": "სერვისი",
    "customers.label.Product": "პროდუქტი",
    "customers.label.CreditCard": "საკრედიტო ბარათი",
    "customers.label.Paypal": "Paypal",
    "customers.label.BusinessEntity": "ბიზნეს ერთეული",
    "customers.label.Plan": "გეგმა",
    "customers.label.Phone": "ტელეფონი",
    "customers.label.TaxExemption": "გადასახადისგან გათავისუფლება",
    "customers.label.YES": "დიახ",
    "customers.label.NO": "არა",
    "customers.label.Resolution": "გადაწყვეტილება",
    "customers.label.AccountNo": "ანგარიშის ნომერი",
    "customers.label.ChipId": "ჩიპის იდენტიფიკატორი",
    "customers.label.MobileNo": "მობილურის ნომერი",
    "customers.label.EmailId": "ელ. ფოსტის იდენტიფიკატორი",
    "customers.label.SerialNo": "სერიული ნომერი",
    "customers.label.LegacyNo": "მემკვიდრეობის ნომერი",
    "customers.label.searchclient": "მომხმარებლის ძიება",
    "customers.label.PrimaryAddress": "მთავარი მისამართი",
    "customers.label.BillingAddress": "ბილინგის მისამართი",
    // "customers.label.lco": "lco",
    "customers.label.EventDate": "მოვლენის თარიღი",
    "customers.label.CreateAdjustment": "შექმენით შესწორება",
    "customers.label.full_name": "სრული სახელი",
    "customers.label.bill_collection_action": "გადასახადის შეგროვების ქმედება",
    "customers.label.collection_actions": "შეგროვების ქმედებები",
    "customers.label.action_name": "ქმედების სახელი",
    "customers.label.action_date": "ქმედების თარიღი",
    "customers.label.balance_due": "დარჩენილი თანხა",
    "customers.label.bill_id": "ინვოისის ID",
    "customers.label.payinfo": "გადახდის ინფორმაცია",
    "customers.label.cardtoken": "ბარათის ტოკენი",
    "customers.label.autopay": "ავტომატური გადახდა",
    "customers.label.paynow": "გადაიხადე ახლავე",
    "customers.label.featureList": "მახასიათებლების სია",
    "customers.label.consumed": "გამოყენებული",
    "customers.label.updateCreditLimt": "განაახლეთ კრედიტის ლიმიტი",
    "customers.label.PendingForApproval": "მიმდინარე დამტკიცებისთვის",

    "customers.label.SpendCapHistory": "ხარჯვის ზღვარის ისტორია",
    "customers.label.DateTime": "თარიღი და დრო",
    "customers.label.SpendCapEventName": "ღონისძიების სახელი",
    "customers.label.SpendingLimit": "ხარჯვის ზღვარი",
    "customers.label.ConsumedLimit": "დახარჯული ლიმიტი",
    "customers.label.EventId": "ღონისძიების ID",
    "customers.label.collectionStatus": "შეგროვების სტატუსი",
  },
  lo: {
    "customers.label.temporaryBlock": "ບລັອກຊົ່ວຄາວ",
    "customers.label.unBlock": "ປົດບັກ",
    "customers.label.feedback": "ຄວາມຄິດເຫັນ",
    "customers.label.event_id": "ID ຂອງເຫດການ",
    "customers.label.slc_state_history": "ປະຫວັດສະຖານະ SLC",
    "customers.label.slc": "SLC",
    "customers.label.state_Change_Time": "ເວລາປ່ຽນສະຖານະ",
    "customers.label.event": "ເຫດການ",
    "customers.label.previous_state": "ສະຖານະກ່ອນໜ້າ",
    "customers.label.resolution_date": "ວັນທີ່ແກ້ໄຂ",
    "customers.label.current_state": "ສະຖານະປັດຈຸບັນ",
    "customers.label.created_time": "ເວລາສ້າງ",
    "customers.label.creation_time": "ເວລາສ້າງ",
    "customers.label.Promotion": "ສົ່ງເສີມການຂາຍ",
    "customers.label.slc_status": "ສະຖານະ SLC",
    "customers.label.update_slc_status": "ອັບເດດສະຖານະ SLC",
    "customers.label.temporary_block": "ການບລັອກຊົ່ວຄາວ",
    "customers.label.workflow_id": "ID ຂອງຂະບວນການເຮັດວຽກ",
    "customers.label.externalPromoId": "ID ສົ່ງເສີມການຂາຍພາຍນອກ",
    "customers.label.externalPromoName": "ຊື່ສົ່ງເສີມການຂາຍພາຍນອກ",
    "customers.label.promoCode": "ລະຫັດສົ່ງເສີມການຂາຍ",
    "customers.label.promoDescription": "ລາຍລະອຽດສົ່ງເສີມການຂາຍ",
    "customers.label.ScheduleOrder": "ກຳນົດການສັ່ງຊື້",
    "customers.label.ScheduledDate": "ວັນທີທີ່ກຳນົດໄວ້",
    "customers.label.ViewRateLimit": "ເບິ່ງຂອບເຂດອັດຕາ",
    "customers.label.SelectType": "ເລືອກປະເພດ",
    "customers.label.search": "ຄົ້ນຫາ",
    "customers.label.SelectTaxExemption": "ເລືອກການຍົກເວັ້ນພາສີ",
    "customers.label.ViewTickets": "ເບິ່ງປັນຫາ",
    "customers.label.TicketHistory": "ປະຫວັດການແຈ້ງປັນຫາ",
    "customers.label.ReopenTicket": "ເປີດປັນຫາອີກຄັ້ງ",
    "customers.label.SelectInvoiceType": "ເລືອກປະເພດໃບແຈ້ງໜີ້",
    "customers.label.SelectCategory": "ເລືອກປະເພດ",
    "customers.label.SelectSubCategory": "ເລືອກປະເພດຍ່ອຍ",
    "customers.label.SelectSource": "ເລືອກແຫຼ່ງຂໍ້ມູນ",
    "customers.label.TicketHistory": "ປະຫວັດບັດທີ່",
    "customers.label.ViewSpendCap": "ເບິ່ງຂີດຈໍາກັດຄ່າໃຊ້ຈ່າຍ",
    "customers.label.ResponseMessage": "ຂໍ້ຄວາມຕອບກັບ",
    "customers.label.AddPlan": "ເພີ່ມແຜນ",
    "customers.label.Basket": "ກະຕ່າ",
    "customers.label.TotalPrice": "ລາຄາລວມ",
    "customers.label.Send_Link_to_Customer_to_Complete_Payment":
      "ສົ່ງລິ້ງໃຫ້ລູກຄ້າເພື່ອສຳເລັດການຈ່າຍເງິນ",
    "customers.label.CheckPaymentStatus": "ກວດສະຖານະການຈ່າຍເງິນ",
    "customers.label.Are_you_sure_you_want_to_terminate?":
      "ທ່ານແນ່ໃຈບໍທີ່ຈະຢຸດ?",
    "customers.label.Unlimited": "ບໍ່ຈໍາກັດ",
    "customers.label.days_left": "ວັນທີເຫຼືອ",
    "customers.label.search": "ຄົ້ນຫາ",
    "customers.label.JobTitle": "ຕຳແໜ່ງວຽກ",
    "customers.label.SelectDocumentType": "ເລືອກປະເພດເອກະສານ",
    "customers.label.SelectEvents": "ເລືອກເຫດການ",
    "customers.label.SelectFormatType": "ເລືອກປະເພດຮູບແບບ",
    "customers.label.SelectAdjustmentType": "ເລືອກປະເພດປັບປຸງ",
    "customers.label.card_number": "ເລກບັດ",
    "customers.label.Select_OPT_Type": "ເລືອກປະເພດ OTP",
    "customers.label.StartDate": "ວັນເລີ່ມ",
    "customers.label.EndDate": "ວັນສິ້ນສຸດ",
    "customers.label.Cancel": "ຍົກເລີກ",
    "customers.label.Set": "ຕັ້ງຄ່າ",
    "customers.label.PaymentDetails": "ລາຍລະອຽດການຈ່າຍ",
    "customers.label.PaymentReceipt": "ໃບຮັບເງິນ",
    "customers.label.Status": "ສະຖານະ",
    "customers.label.PaymentAmount": "ຈຳນວນເງິນທີ່ຈ່າຍ",
    "customers.label.Transaction": "ທຸລະກຳ",
    "customers.label.PaymentPage": "ຫນ້າການຈ່າຍເງິນ",
    "customers.label.ItemCode": "ລະຫັດລາຍການ",
    "customers.label.StartDate": "ວັນທີເລີ່ມ",
    "customers.label.English": "ພາສາອັງກິດ",
    "customers.label.SelectIdProof": "ເລືອກໃບສະແດງຕົວ",
    "customers.label.SelectAdjustementCode": "ເລືອກລະຫັດປັບປ່ຽນ",
    "customers.label.SelectAdjustmentType": "ເລືອກປະເພດປັບປ່ຽນ",
    "customers.label.SelectFormat": "ເລືອກຮູບແບບ",
    "customers.label.AreYouSure?": "ເຈົ້າແນ່ໃຈບໍ່?",
    "customers.label.ChargeId": "ໄອດີຄ່າໃຊ້ຈ່າຍ",
    "customers.label.ChargeDescription": "ຄຳອະທິບາຍຄ່າໃຊ້ຈ່າຍ",
    "customers.label.SelectDate": "ເລືອກວັນທີ",
    "customers.label.SelectPriority": "ເລືອກລຳດັບຄວາມສຳຄັນ",
    "customers.label.SelectCategory": "ເລືອກປະເພດ",
    "customers.label.SelectSubCategory": "ເລືອກປະເພດຍ່ອຍ",
    "customers.label.SelectSource": "ເລືອກແຫຼ່ງຂໍ້ມູນ",
    "customers.label.ViewSpendCap": "ເບິ່ງຂອບຂອງການໃຊ້ຈ່າຍ",
    "customers.label.Amount": "ຈຳນວນ",
    "customers.label.PlanCode": "ລະຫັດແຜນ",
    "customers.label.Price": "ລາຄາ",
    "customers.label.Status": "ສະຖານະ",
    "customers.label.EndDate": "ວັນທີສິ້ນສຸດ",
    "customers.label.ContractPeriod": "ໄລຍະສັນຍາ",
    "customers.label.AutoRenew": "ຕໍ່ອາຍຸອັດຕະໂນມັດ",
    "customers.label.Description": "ລາຍລະອຽດ",
    "customers.label.ThankYou": "ຂອບໃຈ!",
    "customers.label.ConnectionActivated":
      "ການເຊື່ອມຕໍ່ໄດ້ຖືກເປີດໃຊ້ສຳເລັດແລ້ວດ້ວຍເລກບັນຊີ",
    "customers.label.GoToCustomerDetail": "ໄປຫາລາຍລະອຽດຂອງລູກຄ້າ",
    "customers.label.Payment": "ການຈ່າຍເງິນ",
    "customers.label.CustomerToPay": "ລູກຄ້າທີ່ຈະຈ່າຍ:",
    "customers.label.MonthlyPayment": "ການຈ່າຍເງິນລາຍເດືອນ",
    "customers.label.SetupWithDirectDebitOrCreditCard":
      "ຕັ້ງຄ່າກັບບັດເຄຣດິດ ຫລື ການຫັກເງິນຕົວອັດ",
    "customers.label.SendLinkToCustomerToCompletePayment":
      "ສົ່ງລິ້ງໃຫ້ລູກຄ້າເພື່ອສຳເລັດການຈ່າຍເງິນ",
    "customers.label.CheckPaymentStatus": "ກວດເບິ່ງສະຖານະການຈ່າຍເງິນ",
    "customers.label.ThisNumberIsReservedFor": "ເບີນີ້ຖືກຈອງໃຫ້",
    "customers.label.YouSelected": "ເຈົ້າເລືອກ",
    "customers.label.SerialNo": "ເລກລຳດັບ",
    "customers.label.PhoneNo": "ເບີໂທ",
    "customers.label.ActivatingCustomer": "ກຳລັງເປີດໃຊ້ລູກຄ້າ...",
    "customers.label.LoadingOrderStatus": "ກຳລັງໂຫຼດສະຖານະການສັ່ງຊື້...",
    "customers.label.OrderStatus": "ສະຖານະການສັ່ງຊື້:",
    "customers.label.Failed": "ລົ້ມເຫລວ",
    "customers.label.RoamingOutsideEEA": "ໂຣມມິງມີນອກ EEA",
    "customers.label.TariffTermsDetails":
      "ກະລຸນາເບິ່ງເງື່ອນໄຂຄ່າທາລິຟ ແລະເວັບໄຊທ໌ຂອງເຮົາ ສໍາລັບລາຍລະອຽດກ່ຽວກັບຄ່າທາລິຟສະເພາະ ແລະຄ່າໃຊ້ຈ່າຍນອກແພັກເກດຂອງທ່ານ.",
    "customers.label.PaymentTerms":
      "ເຮົາຈະຫັກເງິນທີ່ທ່ານຕ້ອງຈ່າຍໃຫ້ເຮົາ ຈາກບັນຊີຂອງທ່ານໂດຍ SEPA direct debit. ບິນຈະແຈ້ງວັນທີທີ່ຈະຫັກເງິນ. ບາງກໍລະນີ, ອາດມີຄ່າໃຊ້ຈ່າຍເພີ່ມເຕີມຖ້າທ່ານໃຊ້ບໍລິການເກີນໄປ. ຖ້າທ່ານຈ່າຍໂດຍບັດເຄຣດິດ ຫລື ບັດເດບິດ, ທ່ານອະນຸຍາດໃຫ້ບໍລິສັດບັດໃຫ້ຂໍ້ມູນກັບເຮົາ ແລະຜູ້ຮັບເຫດເພື່ອໃຫ້ການໃຫ້ບໍລິການດຳເນີນໄປໄດ້.",
    "customers.label.ServiceAgreementTerms":
      "ໄລຍະເວລາ, ການຕໍ່ໃຫ້ແລະການຢຸດສັນຍາ",
    "customers.label.Duration": "ໄລຍະເວລາ",
    "customers.label.Renewal": "ການຕໍ່ໃຫ້",
    "customers.label.ContractTermsAndConditions": "ເງື່ອນໄຂແລະຂໍ້ກຳນົດຂອງສັນຍາ",
    "customers.label.TermsAndConditions": "ເງື່ອນໄຂ ແລະ ຂໍ້ກຳນົດ",
    "customers.label.CustomerExplanation": "ຂ້ອຍໄດ້ອະທິບາຍລາຍລະອຽດໃຫ້ລູກຄ້າ",
    "customers.label.CustomerAgreement":
      "ແລະເຂົາໄດ້ຕົກລົງທີ່ຈະດຳເນີນການສັ່ງຊື້",
    "customers.label.NumberReservedFor": "ເລກນີ້ຖືກສະຫງວນໄວ້ໃຫ້",
    "customers.label.YouSelected": "ເຈົ້າໄດ້ເລືອກ",
    "customers.label.SerialNo": "ເລກລຳດັບ",
    "customers.label.PhoneNo": "ເບີໂທ",
    "customers.label.TotalPrice": "ລາຄາລວມ",
    "customers.label.FeaturesForEndUsersWithDisabilities":
      "ຄຸນລັກສະນະສໍາລັບຜູ້ໃຊ້ທີ່ມີຄວາມບົ່ງໃບ້",
    "customers.label.InformationSupportServices":
      "ຂໍ້ມູນສະຫນັບສະຫນູນບໍລິການຂອງພວກເຮົາມີຢູ່ໃນຮູບແບບທີ່ແຕກຕ່າງກັນ. ຖ້າທ່ານຕ້ອງການເຂົ້າເຖິງຂໍ້ມູນໃນຮູບແບບທີ່ແຕກຕ່າງ, ກະລຸນາໂທຫາພວກເຮົາຜ່ານ SIM Lycamobile ຂອງທ່ານໃນເບີ 1200 ຫລືເຂົ້າໄປທີ່",
    "customers.label.HowWeUseYourInformation":
      "ວິທີທີ່ພວກເຮົານຳໃຊ້ຂໍ້ມູນຂອງທ່ານ",
    "customers.label.InformationUsageDetails":
      "ພວກເຮົາຈະເກັບຂໍ້ມູນກ່ຽວກັບວິທີທີ່ທ່ານນຳໃຊ້ບໍລິການຂອງພວກເຮົາ ແລະ ບໍລິການຂອງບຸກຄົນທີ່ສາມທີ່ໃຊ້ຄວາມຮ່ວມມືກັບບໍລິການຂອງພວກເຮົາ, ລວມທັງສະຖານທີ່ ແລະ ການໃຊ້ບັນຊີຂອງທ່ານ, ເພື່ອປັບປຸງປະສົບການໂດຍລວມຂອງທ່ານກັບພວກເຮົາ.",
    "customers.label.CustomerComplaints":
      "ຖ້າຫາກທ່ານບໍ່ພໍໃຈກັບຄວາມໄວ, ຄຸນນະພາບ ຫລື ອື່ນໆຂອງບໍລິການ, ແລະ ຕ້ອງການຮ້ອງທຸກ, ກະລຸນາຕິດຕໍ່ບໍລິການລູກຄ້າ.",
    "customers.label.DisputeResolution":
      "ຖ້າຫາກພວກເຮົາບໍ່ສາມາດແກ້ໄຂການຮ້ອງທຸກຂອງທ່ານ, ທ່ານສາມາດສົ່ງຄຳຮ້ອງທຸກພາຍໃນ 12 ເດືອນຫາຄະນະກຳມະການແກ້ໄຂຄວາມຂັດແຍ້ງຂອງບໍລິການດ້ານໂທຄະນິກ.",
    "customers.label.costsEuro": "ຄ່າໃຊ້ຈ່າຍ €",
    "customers.label.thereafterEuro": "ຕໍ່ໄປ €",
    "customers.label.forTheFirst": "ສໍາລັບຄັ້ງທໍາອິດ",
    "customers.label.perMonthInclusiveVAT":
      "ຕໍ່ເດືອນ, ລວມທັງ VAT (ເປັນປະຈໍາປີເພີ່ມ CPI+3.9%)",
    "customers.label.paymentTerms":
      "ທ່ານຈະຕ້ອງຈ່າຍຄ່າໃຊ້ຈ່າຍຂອງທ່ານທຸກເດືອນໃຫ້ທັນເວລາ",
    "customers.label.minimumPeriod": "ມີໄລຍະເວລາຂັ້ນຕ່ຳ 1 ເດືອນ",
    "customers.label.earlyTerminationCharge":
      "ຖ້າທ່ານຢຸດບໍລິການທັງທີ, ທ່ານຈະຕ້ອງຈ່າຍຄ່າປັບ",
    "customers.label.ContractSummarys":
      "ສະຫຼຸບສັນຍານີ້ ແລະການສະເໜີຂອງພວກເຮົາ ສໍາລັບບໍລິການສາກົນຂະໜາດໃຫຍ່ 1 ເດືອນ, ທີ່ໃຫ້ທ່ານສາມາດໂທແລະຮັບສາຍໂທ, ສົ່ງແລະຮັບ SMS, ນຳໃຊ້ອິນເຕີເນັດ, ຜ່ານເຄືອຂ່າຍ, ພ້ອມດ້ວຍບໍລິການເສີມທີ່ທ່ານໄດ້ເລືອກ.",
    "customers.label.The": "ອັນນີ້",
    "customers.label.ComesWith": "ມີ:",
    "customers.label.MobileDataSpeeds": "ຄວາມໄວຂອງບໍລິການຂໍ້ມູນໂທລະສັບ",
    "customers.label.DataServiceDescription":
      "ບໍລິການຂໍ້ມູນແລະຄວາມໄວຕ່ຳສຸດ ແລະສູງສຸດທີ່ເຂົ້າເຖິງໄດ້ຜ່ານເຄືອຂ່າຍ Lycamobile ນັ້ນຂຶ້ນຢູ່ກັບຕໍາແໜ່ງ, ອຸປະກອນ ແລະແຜນທີ່ໄດ້ຊື້ (2G, Edge, 3G, 4G, 5G).",
    "customers.label.SpeedVariation":
      "ຄວາມໄວຂອງບໍລິການຂໍ້ມູນອາດປ່ຽນແປງໄດ້ ແລະຂື້ນກັບສະຖານທີ່, ສະພາບແວດລ້ອມ (ອາກາດ, ຕົ້ນໄມ້, ວັດຖຸກອ້ອມຂ້າງ) ແລະອຸປະກອນທີ່ໃຊ້ເຊື່ອມຕໍ່.",
    "customers.label.LycamobileBV": "Lycamobile B.V.",
    "customers.label.Robijnlaan17": "Robijnlaan 17,",
    "customers.label.2132WXHoofddorp": "2132WX Hoofddorp,",
    "customers.label.TheNetherlands": "ປະເທດເນເທີແລນ",
    "customers.label.ContractSummary": "ສະຫຼຸບສັນຍາ",
    "customers.label.ContractSummaryDescription1":
      "ສະຫຼຸບສັນຍານີ້ລວມເອົາຂໍ້ມູນສໍາຄັນຂອງການບໍລິການຕາມທີ່ກົດໝາຍກໍານົດ.",
    "customers.label.ContractSummaryDescription2":
      "ຊ່ວຍໃຫ້ທ່ານສາມາດປຽບທຽບຄວາມແຕກຕ່າງຂອງການບໍລິການ.",
    "customers.label.ContractSummaryDescription3":
      "ຂໍ້ມູນທັງໝົດກ່ຽວກັບການບໍລິການສາມາດເບິ່ງໄດ້ໃນເອກະສານອື່ນໆ.",
    "customers.label.ContractSummaryValidity":
      "ສະຫຼຸບສັນຍານີ້ໃຊ້ໄດ້ຈົນກວ່າຈະໝົດອາຍຸໃນໜ້າຊໍາລະເງິນ",
    "customers.label.AcceptOffer":
      "ຖ້າຄວາມສະຫນອງນີ້ເໝາະສົມ, ທ່ານສາມາດຍອມຮັບມັນໄດ້ຜ່ານໜ້າຊໍາລະເງິນ. ກະລຸນາເກັບເອກະສານນີ້ໄວ້ເພື່ອເປັນຫຼັກຖານ.",
    "customers.label.Services": "ບໍລິການ",
    "customers.label.TermsConditions":
      "ພາຍໃຕ້ເງື່ອນໄຂຂອງສັນຍາບໍລິການ, ຖ້າພວກເຮົາຜິດສັນຍາທີ່ມີຜົນສຳຄັນ ແລະບໍ່ສາມາດໃຫ້ຂໍ້ມູນໃຫ້ທ່ານໄດ້, ທ່ານສາມາດຍົກເລີກສັນຍາໄດ້.",
    "customers.label.EmergencyOrganisations":
      "ອົງການເຫດສຸກເສີນ ແລະຂໍ້ມູນທີ່ຕັ້ງຜູ້ໂທ",
    "customers.label.EmergencyCallInstructions":
      "ຖ້າຈຳເປັນຕ້ອງໂທເຫດສຸກເສີນ 112/999, ອຸປະກອນຄວນສາມາດເຂົ້າເຖິງເຄືອຂ່າຍ 2G, 3G, 4G, 5G.",
    "customers.label.EmergencyCallAvailability":
      "ໂທເຫດສຸກເສີນໄດ້ເມື່ອມີເຄືອຂ່າຍ.",
    "customers.label.PlanName": "ຊື່ແຜນ",
    "customers.label.EuropeanOnlineDisputeResolution":
      "ເວັບໄຊຕ໌ຂອງອີຢູສໍາລັບການແກ້ໄຂຂໍ້ຂັດແຍ້ອອນໄລນ໌",
    "customers.label.ECWebsite": "ec.europa.eu/consumers/odr",
    "customers.label.DisputeResolutionDetails":
      "ໃຫ້ຜູ້ບໍລິໂພກສາມາດສົ່ງຂໍ້ຂັດແຍ້ທີ່ກ່ຽວກັບການຊື້ສິນຄ້າອອນໄລນ໌ກັບພວກເຮົາ. ທ່ານສາມາດເຂົ້າໄປເບິ່ງເວັບໄຊຕ໌ຂອງພວກເຮົາເພື່ອເບິ່ງສໍາເນົາຂອງຂໍ້ຕົກລົງໃນການຮັບຄໍາຮ້ອງທຸກໃຈ ແລະ ຂໍ້ມູນໃຫມ່ໆເກົ່າກັບການແກ້ໄຂຂໍ້ຂັດແຍ້ແບບທາງເລືອກ.",
    "customers.label.NetherlandsLawCompliance":
      "ໃນກໍລະນີທີ່ຄວາມໄວຂອງບໍລິການອິນເຕີເນັດມີຄວາມຜິດປົກກະຕິຢ່າງຕໍ່ເນື່ອງ ຫຼືບໍ່ຄືກັບທີ່ສັນຍາ, Lycamobile ຈະໃຫ້ບໍລິການໃໝ່ໃນໄລຍະເວລາທີ່ເໝາະສົມ. ຖ້າບໍ່ສາມາດໃຫ້ບໍລິການໃໝ່ໄດ້, Lycamobile ຈະຫຼຸດຄ່າບໍລິການໃຫ້ຜູ້ໃຊ້ເພື່ອຄວາມຍຸດຕິທຳ.",
    "customers.label.DirectoryServiceInfo":
      "ທ່ານສາມາດຂໍໃຫ້ພວກເຮົາໃສ່ເບີໂທລະສັບມືຖືຂອງທ່ານໃນສະມຸດໂທລະສັບ ແລະ/ຫລື ບໍລິການຊອກຫາໃນສະມຸດໂທລະສັບ. ແຕ່ທ່ານຄວນຮູ້ວ່າ ຖ້າທ່ານຂໍໃຫ້ມີບໍລິການນີ້, ເບີຂອງທ່ານຈະຖືກເຫັນໂດຍບໍລິສັດທີ່ເກັບຂໍ້ມູນສຳລັບຈຸດປະສົງການຕະຫຼາດ. ຖ້າທ່ານກັງວົນກ່ຽວກັບສິ່ງນີ້, ທ່ານສາມາດຍຸດຄວາມເປັນໄປໄດ້ໂດຍເລືອກອອກ ຫລື ໃຊ້ສິດຂອງທ່ານໃນການຄັດຄ້ານ.",
    "customers.label.RemediesComplaints":
      "ການແກ້ໄຂ, ການຈັດການຂໍ້ຮ້ອງທຸກ ແລະ ການແກ້ໄຂຂໍ້ຂັດແຍ້ງ",
    "customers.label.ContactCustomerService":
      "ຖ້າທ່ານຈຳເປັນຕ້ອງຕິດຕໍ່ບໍລິການລູກຄ້າ, ກະລຸນາໄປທີ່ເວັບໄຊທ໌ ແລະ ຄລິກ 'ຕິດຕໍ່ພວກເຮົາ'. ຖ້າທ່ານຕ້ອງການຮ້ອງທຸກກ່ຽວກັບບໍລິການຂອງພວກເຮົາ, ກະລຸນາຕິດຕໍ່ບໍລິການລູກຄ້າ. ຖ້າທ່ານຍັງຄົງບໍ່ພໍໃຈ, ທ່ານສາມາດຂຽນໃຫ້ມີການກວດຄືນໂດຍບໍ່ລຳເອົາຜົນປະໂຫຍດ.",
    "customers.label.IncludeMobileNumber":
      "ກະລຸນາໃສ່ເບີໂທມືຖືຂອງທ່ານຖ້າທ່ານຂຽນຈົ່ງພວກເຮົາ. ຖ້າພວກເຮົາບໍ່ສາມາດແກ້ໄຂຂໍ້ຮ້ອງທຸກຂອງທ່ານໄດ້, ທ່ານສາມາດສົ່ງຄວາມຮ້ອ",
    "customers.label.Termination": "ຍົກເລີກ",
    "customers.label.TerminationNotice":
      "ຫຼັງຈາກລະຍະເວລາຂັ້ນຕ່ຳ, ທ່ານສາມາດຍົກເລີກຂໍ້ຕົກລົງໂດຍໃຫ້ຄຳແຈ້ງເຕືອນ (ເຊິ່ງບໍ່ມີຜົນຕໍ່ກົດໝາຍອື່ນໆ) ແລະທ່ານຈະຕ້ອງຈ່າຍຄ່າໃຊ້ຈ່າຍໃນໄລຍະເວລາແຈ້ງເຕືອນນີ້.",
    "customers.label.EarlyTerminationCharge":
      "ຫາກທ່ານປະສົບກັບການຍົກເລີກກ່ອນກຳນົດ, ທ່ານຈະຕ້ອງຈ່າຍຄ່າໃຊ້ຈ່າຍທີ່ບໍ່ເກີນຄ່າສະຫມັກລາຍເດືອນຂອງທ່ານຄູນດ້ວຍຈຳນວນເດືອນທີ່ເຫຼືອ.",
    "customers.label.OptionalAddOnTermination":
      "ບໍ່ມີຜົນຕໍ່ແຜນບໍລິການລາຍເດືອນ.",
    "customers.label.CancellationInfo":
      "ທ່ານສາມາດຍົກເລີກໄດ້ໃນ 14 ມື້ຫຼັງຈາກການສັ່ງຊື້.",
    "customers.label.Security": "ຄວາມປອດໄພ",
    "customers.label.DataProtection": "ການປົກປ້ອງຂໍ້ມູນ",
    "customers.label.TariffTerms":
      "ກະລຸນາເບິ່ງເງື່ອນໄຂອັດຕາແລະເວັບໄຊຂອງພວກເຮົາ ສຳລັບລາຍລະອຽດກ່ຽວກັບອັດຕາເຉຉະຈົດ ແລະຄ່າໃຊ້ຈ່າຍນອກເຄື່ອງໃຊ້ຂອງທ່ານ.",
    "customers.label.DeliveryOfService": "ການຈັດສົ່ງບໍລິການ",
    "customers.label.PaymentTerms":
      "ພວກເຮົາຈະດຶງເງິນທີ່ທ່ານຈຳເປັນຕ້ອງຈ່າຍຈາກບັນຊີຂອງທ່ານໂດຍການໂອນເງິນ SEPA, ຍົກເວັ້ນວ່າເຮົາໄດ້ຕົກລົງກັບທ່ານແບບອື່ນ...",
    "customers.label.ServiceStartDate":
      "ວັນທີ່ Lycamobile ຈະໃຫ້ບໍລິການແມ່ນວັນທີ່ທ່ານລົງທະບຽນກັບ Lycamobile.",
    "customers.label.ContractDuration":
      "ໄລຍະເວລາ, ການຕໍ່ໄປ ແລະການຍົກເລີກຂອງສັນຍາບໍລິການ",
    "customers.label.MinimumPeriod":
      "ຂໍ້ສັນຍາຂອງທ່ານມີໄລຍະເວລາຕ່ຳສຸດທີ່ເອີ້ນວ່າ ໄລຍະເວລາຂັ້ນຕ່ຳ, ອາດຈະເປັນເພີງ 1 ເດືອນສຳລັບແຜນລາຍເດືອນ ຫຼື 24 ເດືອນສຳລັບຂໍ້ສັນຍາໄລຍະຍາວ.",
    "customers.label.ContractRenewal":
      "ໃນການຕໍ່ສັນຍາ, ທ່ານຕ້ອງແຈ້ງ Lycamobile ໃນຂະນະທີ່ສັນຍາເກົ່າຂອງທ່ານຍັງມີຜົນບັງຄັບ, ໂດຍໄດ້ສະເໜີຄວາມຍິນຍອມໃນການຕໍ່ສັນຍາ.",
    "customers.label.DataCostDetails":
      "ຂໍ້ມູນ {40 GB} ມີຄ່າ {18.90} ຢູໂຣ ສໍາລັບ {3 ເດືອນ} ແລະຕໍ່ຈາກນັ້ນ {27.00} ຢູໂຣ/ເດືອນ, ລວມທັງ VAT (ອາດຈະມີການເພີ່ມຂື້ນປະຈໍາປີ CPI + 3.9%). ສອບຖາມເພີ່ມເຕີມໄດ້ທີ່ເວັບໄຊຂອງພວກເຮົາ.",
    "customers.label.AdditionalAddons":
      "ມີ Add-ons ເພີ່ມເຕີມທີ່ສາມາດເພີ່ມເຂົ້າໄປໃນແຜນຂອງທ່ານໄດ້ ແລະຈະຖືກຄິດເງິນແບບແຍກ.",
    "customers.label.SpendingLimits": "ຂີດຈໍາການຄ່າໃຊ້ຈ່າຍ",
    "customers.label.SpendingLimitDetails":
      "Lycamobile ຈະກຳນົດຂີດຈໍາການຄ່າໃຊ້ຈ່າຍຂອງບັນຊີທ່ານຕາມຄວາມຕ້ອງການ ສູງສຸດບໍ່ເກີນ 250 ຢູໂຣ.",
    "customers.label.PremiumCharges":
      "ການໂທ ຫຼື SMS ທີ່ມີເລກສັ້ນ ແລະ ການໂທລະຫວ່າງປະເທດບໍ່ລວມຢູ່ໃນໂຄງການນີ້ ແລະຈະຖືກຄິດເງິນຕາມຄ່າບໍລິການ.",
    "customers.label.InternationalRates":
      "ຄ່າໂທ ຈາກ ປະເທດຮອງ ທຸກສູ່ ປະເທດອື່ນຈະຖືກຄິດເງິນຕາມອັດຕາຂອງພວກເຮົາ.",
    "customers.label.RoamingInEEA": "ການໂທໃນ EEA",
    "customers.label.RoamingOutsideEEA": "ການໂທນອກ EEA",
    "customers.label.RoamingCharges":
      "ການໃຊ້ໂທລະສັບ (ໂທ, ຂໍ້ຄວາມ, ແລະອິນເຕີເນັດ) ຂອງທ່ານຂະນະທີ່ທ່ານຢູ່ນອກ ປະເທດຮອງ ຫຼື EEA ແລະສະຖານທີ່ທີ່ກຳນົດ ຈະຖືກຄິດເງິນຕາມຄ່າບໍລິການຂອງພວກເຮົາ.",
    "customers.label.Any_Out_of_bundle_charges_can_be_found_at":
      "ຄ່າໃຊ້ຈ່າຍນອກແຜນສາມາດພົບໄດ້ທີ່:",
    "customers.label.Exclusions_for_voice_international_voice_SMS_Data_Roaming_can_be_found_at":
      "ຂໍ້ຍົກເວັ້ນສຳລັບສຽງ, ສຽງສາກົນ, SMS, ການໂຮມມິ່ງຂໍ້ມູນສາມາດພົບໄດ້ທີ່:",
    "customers.label.Our_Services_availability":
      "ບໍລິການຂອງພວກເຮົາບໍ່ໄດ້ມີໃຫ້ບໍລິການທຸກໆບ່ອນໃນເນເທີແລນ, EEA ຫຼືສະຖານທີ່ອື່ນໆທີ່ໄດ້ຄັດເລືອກ. ຂໍ້ກຳນົດການໃຊ້ຢ່າງຍຸດທະສາດຂອງພວກເຮົາຖືກລວມໃສ່ໃນນະໂຍບາຍ Fair Use:",
    "customers.label.Lycamobile_network_speeds":
      "ບໍລິການຂໍ້ມູນແລະຄວາມໄວທີ່ພ້ອມໃຫ້ໃນເຄືອຂ່າຍ Lycamobile ຂຶ້ນຢູ່ກັບເຕັກໂນໂລຊີທີ່ທ່ານມີອັດທະພາບ (2G, 3G, 4G, 5G).",
    "customers.label.Mobile_data_speed_variation":
      "ຄວາມໄວຂອງບໍລິການຂໍ້ມູນຂອງທ່ານອາດຈະແຕກຕ່າງກັນໂດຍຂຶ້ນຢູ່ກັບສະຖານທີ່ ແລະປັດໃຈພາຍນອກ.",
    "customers.label.Price": "ລາຄາ",
    "customers.label.ContractReview": "ການກວດສອບສັນຍາ",
    "customers.label.Terms&Conditions": "ເງື່ອນໄຂ ແລະ ຂໍ້ກຳນົດ",
    "customers.label.ReviewThisContract": "ກວດສອບສັນຍານີ້",
    "customers.label.We_have_sent_these_to": "ພວກເຮົາໄດ້ສົ່ງໃຫ້",
    "customers.label.DownloadContractInformation": "ດາວໂຫລດຂໍ້ມູນສັນຍາ",
    "customers.label.DownloadContractSummary": "ດາວໂຫລດສັນຍາສະຫຼຸບ",
    "customers.label.ContractInformation": "ຂໍ້ມູນສັນຍາ",
    "customers.label.ContactDetails": "ລາຍລະອຽດຕິດຕໍ່",
    "customers.label.Description_of_Services": "ລາຍລະອຽດບໍລິການ",
    "customers.label.This_contract_summary_and_our_Abonnement_offer_of":
      "ສັນຍານີ້ ແລະ ຂໍ້ສະເໜີສະມາຊິກ",
    "customers.label.an_airtime_service_for": "ບໍລິການເວລາສາຍ",
    "customers.label.comes_with:": "ມີ:",
    "customers.label.Any_Out_of_bundle_charges_can_be_found_at:":
      "ຄ່າໃຊ້ຈ່າຍເສີມສາມາດເບິ່ງໄດ້ທີ່:",
    "customers.label.service_description":
      "ຊຶ່ງໃຫ້ທ່ານສາມາດໂທ ແລະ ຮັບສາຍ, ສົ່ງ ແລະ ຮັບ SMS, ໃຊ້ຂໍ້ມູນ, ແລະ ເຂົ້າເຖິງອິນເຕີເນັດ.",
    "customers.label.YouHaveChosenNoCap":
      "ທ່ານໄດ້ເລືອກບໍ່ຈຳກັດ. ນີ້ໝາຍເຖິງວ່າທ່ານສາມາດໃຊ້ໂທລະສັບຂອງທ່ານໄດ້ສຳລັບໂທ, ຂໍ້ຄວາມ, ນາທີລະຫວ່າງປະເທດ, ໂຣມິງ ແລະຂໍ້ມູນຢູ່ນອກແຜນລາຍເດືອນຂອງທ່ານ. ທ່ານຈະໄດ້ຖືກເກັບເງິນສູງສຸດເຖິງ 60 €.",
    "customers.label.SelectDate":
      "ເລືອກວັນທີ [ການຈ່າຍເງິນລາຍເດືອນຈະຖືກຫັກຈາກບັນຊີຂອງທ່ານ 14 ວັນຫຼັງຈາກວັນທີສ້າງໃບບິນທີ່ທ່ານເລືອກ] *",
    "customers.label.BillingCycle": "ລະບົບການຄິດໄລ່",
    "customers.label.SelectBilling": "ເລືອກການຄິດໄລ່",
    "customers.label.I_Agree_To": "ຂ້ອຍຕົກລົງ",
    "customers.label.TermsAndConditions": "ເງື່ອນໄຂແລະຂໍ້ກຳນົດ",
    "customers.label.ThisNumberIsReservedFor": "ເບີນີ້ຖືກສະຫງວນໄວ້ໃຫ້",
    "customers.label.TotalPrice": "ລາຄາທັງໝົດ:",
    "customers.label.CustomerInfo": "ຂໍ້ມູນລູກຄ້າ",
    "customers.label.title": "ຫົວຂໍ້",
    "customers.label.SelectTitle": "ເລືອກຫົວຂໍ້",
    "customers.label.initials": "ຕົວອັກສອນແທນ",
    "customers.label.Basket": "ກະຕ່າ",
    "customers.label.first_name": "ຊື່",
    "customers.label.last_name": "ນາມສະກຸນ",
    "customers.label.email_address": "ທີ່ຢູ່ອີເມວ",
    "customers.label.contact_number": "ເບີໂທຕິດຕໍ່",
    "customers.label.date_of_birth": "ວັນເກີດ",
    "customers.label.select_language": "ເລືອກພາສາ",
    "customers.label.how_did_you_hear": "ເຈົ້າໄດ້ຍິນກ່ຽວກັບພວກເຮົາຢ່າງໃດ?",
    "customers.label.postal_code": "ລະຫັດໄປສະນີ",
    "customers.label.country": "ປະເທດ",
    "customers.label.Enter_address_manually": "ໃສ່ທີ່ຢູ່ດ້ວຍຕົວເອງ",
    "customers.label.Find_address": "ຊອກຫາທີ່ຢູ່",
    "customers.label.Select_Address": "ເລືອກທີ່ຢູ່",
    "customers.label.Select_an_address": "ເລືອກທີ່ຢູ່ຫນຶ່ງ",
    "customers.label.Enter_address_dynamically": "ໃສ່ທີ່ຢູ່ແບບດິນາມິກ",
    "customers.label.address_number": "ເລກທີ່ຢູ່",
    "customers.label.street": "ຖະໜົນ",
    "customers.label.state": "ລັດ",
    "customers.label.city": "ເມືອງ",
    "customers.label.resident_period": "ໄລຍະທີ່ຢູ່",
    "customers.label.Spend_Cap_Amount": "ຈຳນວນເງິນຈຳກັດ",
    "customers.label.I_don’t_want_a_Spend_Cap": "ຂ້ອຍບໍ່ຕ້ອງການຈຳກັດຄ່າໃຊ້ຈ່າຍ",
    "customers.label.Monthly_Bill_Generation_Date": "ວັນທີ່ສ້າງໃບບິນລາຍເດືອນ",
    "customers.label.Select_a_Monthly_Plan": "ເລືອກແຜນລາຍເດືອນ",
    "customers.label.Search_plans": "ຄົ້ນຫາແຜນ...",
    "customers.label.search": "ຄົ້ນຫາ",
    "customers.label.Select_a_plan": "ເລືອກແຜນ",
    "customers.label.Basket": "ກະຕ່າ",
    "customers.label.This_number_is_reserved_for": "ໝາຍເລກນີ້ສຳລັບ",
    "customers.label.ViewT&C": "ເບິ່ງເງື່ອນໄຂ",
    "customers.label.TransferringFromPreviousNetwork":
      "ການຍ້າຍຈາກເຄືອຂ່າຍເກົ່າ (ນຳເບີເກົ່າຂອງທ່ານມາ)",
    "customers.label.SIM_Information": "ຂໍ້ມູນ SIM",
    "customers.label.Prepaid": "ພຣີເພດ",
    "customers.label.Postpaid": "ໂພສເພດ",
    "customers.label.Physical_SIM": "SIM ທີ່ເປັນວັດຖຸ",
    "customers.label.eSIM": "eSIM",
    "customers.label.SelectCustomerType": "ເລືອກປະເພດລູກຄ້າ",
    "customers.label.New_to_Lyca": "ໃໝ່ໃນ Lyca",
    "customers.label.Convert_Lyca_Prepaid_to_Postpaid":
      "ປ່ຽນຈາກ Lyca Prepaid ເປັນ Postpaid",
    "customers.label.Existing_customer_is_going_to_be_sent_a_secure_link_to_confirm_that_they_wish_to_move_from_prepaid_to_abonnement.":
      "ລູກຄ້າທີ່ມີຢູ່ຈະໄດ້ຮັບລິ້ງທີ່ປອດໄພເພື່ອຢືນຢັນວ່າພວກເຂົາຕ້ອງການປ່ຽນໄປເປັນການສະໝັກໃໝ່.",
    "customers.label.Customer_to_receive_an_SMS": "ລູກຄ້າຈະໄດ້ຮັບ SMS",
    "customers.label.Lyca_Mobile_Number": "ເບີ Lyca Mobile",
    "customers.label.Enter_the_Lyca_Mobile_Number": "ໃສ່ເບີ Lyca Mobile",
    "customers.label.Nationality": "ສັນຊາດ",
    "customers.label.Send_Secure_link": "ສົ່ງລິ້ງທີ່ປອດໄພ",
    "customers.label.New_to_Lyca_Mobile": "ໃໝ່ໃນ Lyca Mobile",
    "customers.label.serial_number": "ເລກລຳດັບ",
    "customers.label.Serial_Number": "ເລກລຳດັບ (4 ຕົວສຸດທ້າຍ)",
    "customers.label.PUK_Code": "ລະຫັດ PUK",
    "customers.label.PUK_Code_is_not_matched": "ລະຫັດ PUK ບໍ່ຄືກັນ",
    "customers.label.Switching_to_Lyca_Mobile": "ປ່ຽນໄປ Lyca Mobile",
    "customers.label.Enter_the_PUK_Code": "ໃສ່ລະຫັດ PUK",
    "customers.label.Basket": "ກະຕ່າ",
    "customers.label.Gender": "ເພດ",
    "customers.label.business_name": "ຊື່ທຸລະກິດ",
    "customers.label.phone_number": "ເບີໂທ",
    "customers.label.Date_of_Birth": "ວັນເກີດ",
    "customers.label.VIP": "ວີໄອພີ",
    "customers.label.Disability": "ຄວາມພິການ",
    "customers.label.District": "ເຂດ",
    "customers.label.Is_your_billing_address_same_as_primary_address":
      "ທີ່ຢູ່ສຳລັບການຈ່າຍເງິນຄືກັບທີ່ຢູ່ຫຼັກຂອງເຈົ້າບໍ?",
    "customers.label.Supressbill": "ປິດບິນ",
    "customers.label.SelectCategory": "ເລືອກປະເພດ",
    "customers.label.SelectGender": "ເລືອກເພດ",
    "customers.label.SelectPreferences": "ເລືອກຄວາມມັກ",
    "customers.label.SelectNationality": "ເລືອກສັນຊາດ",
    "customers.label.SelectVIP": "ເລືອກ VIP",
    "customers.label.SelectDisability": "ເລືອກຄວາມພິການ",
    "customers.label.SelectCity": "ເລືອກເມືອງ",
    "customers.label.SelectBillDay": "ເລືອກວັນບິນ",
    "customers.label.SelectType": "ເລືອກປະເພດ",
    "customers.label.SelectFiscalYear": "ເລືອກປີການເງິນ",
    "customers.label.SelectFiscalQuarter": "ເລືອກຂອບເຂດການເງິນ",
    "customers.label.SelectBillMode": "ເລືອກຮູບແບບບິນ",
    "customers.label.SelectInvoiceType": "ເລືອກປະເພດໃບບິນ",
    "customers.label.IMSI": "IMSI",
    "customers.label.SalesMotion": "ການຂາຍເຄື່ອນໄຫວ",
    "customers.label.SpendCap": "ຂີດຈຳກັດຄ່າໃຊ້ຈ່າຍ",
    "customers.label.ActivationDate": "ວັນທີເປີດໃຊ້ງານ",
    "customers.label.ExpiryDate": "ວັນທີໝົດອາຍຸ",
    "customers.label.NextRenewalDate": "ວັນທີຕໍ່ໃຫມ່ຕໍ່ໄປ",
    "customers.label.BalanceTransfer": "ໂອນຍອດເງິນ",
    "customers.label.RecieverClientId": "ID ຂອງລູກຄ້າຜູ້ຮັບ",
    "customers.label.Amount": "ຈຳນວນເງິນ",
    "customers.label.EnterTopUpAmount": "ໃສ່ຈຳນວນເງິນເຕີມ",
    "customers.label.ResponseId": "ID ຕອບກັບ",
    "customers.label.BalanceName": "ຊື່ຍອດເງິນ",
    "customers.label.Allowance": "ສິດທິໄດ້ຮັບ",
    "customers.label.Consumption": "ການໃຊ້ຈ່າຍ",
    "customers.label.AvailableBalance": "ຍອດເງິນທີ່ມີໃຫ້ໃຊ້",
    "customers.label.DaysLeft": "ມື້ທີ່ເຫຼືອ",
    "customers.label.Discount": "ສ່ວນຫຼຸດ",
    "customers.label.postal_code": "ລະຫັດໄປສະນີ",
    "customers.label.address_number": "ເລກທີ່ຢູ່",
    "customers.label.city": "ເມືອງ",
    "customers.label.state": "ລັດ",
    "customers.label.country": "ປະເທດ",
    "customers.label.comment_date": "ວັນທີຄວາມຄິດເຫັນ",
    "customers.label.resident_period": "ຊ່ວງເວລາຢູ່",
    "customers.label.postcode": "ລະຫັດໄປສະນີ",
    "customers.label.how_did_you_hear": "ເຈົ້າຮູ້ກ່ຽວກັບພວກເຮົາໄດ້ແນວໃດ?",
    "customers.label.select_language": "ເລືອກພາສາ",
    "customers.label.email_address": "ທີ່ຢູ່ອີເມວ",
    "customers.label.contact_number": "ເບີໂທຕິດຕໍ່",
    "customers.label.initials": "ຕົວອັກສອນຍໍ້",
    "customers.label.communication_type": "ປະເພດການສື່ສານ",
    "customers.label.BuySIM": "ຊື້ SIM",
    "customers.label.origination": "ຕົ້ນກຳເນີດ",
    "customers.label.address": "ທີ່ຢູ່",
    "customers.label.destination_address": "ທີ່ຢູ່ປາຍທາງ",
    "customers.label.event": "ເຫດການ",
    "customers.label.charge_party": "ຝ່າຍເກັບເງິນ",
    "customers.label.service_subs_type": "ປະເພດການສະໝັກບໍລິການ",
    "customers.label.calling_party": "ຝ່າຍໂທ",
    "customers.label.called_party": "ຝ່າຍຮັບ",
    "customers.label.usage": "ການໃຊ້ງານ",
    "customers.label.monetary_charge": "ຄ່າໃຊ້ຈ່າຍ",
    "customers.label.result_code": "ລະຫັດຜົນໄດ້ຮັບ",
    "customers.label.generation_time": "ເວລາສ້າງ",
    "customer.label.generationdatetime": "ວັນທີ ແລະເວລາຜະລິດ",
    "customers.label.application_transaction_id": "ID ທຸລະກໍາຂອງແອັບ",
    "customers.label.application_name": "ຊື່ແອັບ",
    "customers.label.recharge_value": "ມູນຄ່າການເຕີມເງິນ",
    "customers.label.interface": "ອິນເທີເຟດ",
    "customers.label.result": "ຜົນໄດ້ຮັບ",
    "customers.label.comment": "ຄວາມຄິດເຫັນ",
    "customers.label.recharge": "ເຕີມເງິນ",
    "customers.label.cdr": "CDR",
    "customers.label.notifications": "ແຈ້ງການ",
    "customers.label.mobile_no": "Enter Mobile No",
    "customers.label.email_id": "Enter Email Id",
    "customers.label.serial_number": "Serial No",
    "customers.label.digital_content": "ການຂໍ້ມູນດິນ",
    "customers.label.buySim": "ຊື້ SIM",
    "customers.label.outstanding_due": "ຈໍານວນໜີ້",
    "customers.label.due_date": "ວັນທີຄົບກໍານົດ",
    "customers.label.unbilled_amount": "ຈໍານວນທີ່ຍັງບໍ່ໄດ້ອອກບິນ",
    "customers.label.next_bill_day": "ວັນຄິດໄລ່ບິນຕໍ່ໄປ",
    "customers.label.view_allowances": "ເບິ່ງຄ່າທົດແທນ",
    "customers.label.view_service_details": "ເບິ່ງລາຍລະອຽດການບໍລິການ",
    "customers.label.spend_limit": "ຂີດຈໍາກັດໃນການໃຊ້ຈ່າຍ",
    "customers.label.topup_balance": "ເພີ່ມເງິນໃສ່",
    "customers.label.next_renewal_date": "ວັນຕໍ່ສັນຍາຄັ້ງຕໍ່ໄປ",
    "customers.label.allowance": "ຄ່າທົດແທນ",
    "customers.label.ViewDocumentUpload": "ເບິ່ງການອັບໂຫລດເອກະສານ",
    "customers.label.total_net_amount": "ຈໍານວນເງິນລວມທັງໝົດ",
    "customers.label.cancelRemark": "ຍົກເລີກຂໍ້ສັງເກດ",
    "customers.label.cancelPayment": "ຍົກເລີກການຈ່າຍເງິນ",
    "customers.label.all": "ທັງໝົດ",
    "customers.label.billProfile": "ໂປຣໄຟລ໌ບິນ",
    "customers.label.charges": "ຄ່າທໍານຽມ",
    "customers.label.book_order": "ການສັ່ງຊື່ປຶ້ມ",
    "customers.label.customers": "ລູກຄ້າ",
    "customers.label.search_for_clients": "ຄົ້ນຫາລູກຄ້າ",
    "customers.label.advance_search": "ການຄົ້ນຫາຂັ້ນສູງ",
    "customers.label.created_by": "ສ້າງໂດຍ",
    "customers.label.created_on": "ສ້າງວັນທີ",
    "customers.label.credit_limit": "ຂີດຕິດຄິດສິດ",
    "customers.label.transaction_history": "ປະຫວັດການທຳລາຍ",
    "customers.label.external_activity_log": "ການກວດສອບກິດຈະກຳພາຍນອກ",
    "customers.label.settings": "ການຕັ້ງຄ່າ",
    "system.label.currency_noncurrency": "ເງິນ ເຫົາເງິນ",
    "entity.label.configure": "ກຳນົດ",

    "customers.label.create_customer": "ສ້າງລູກຄ້າ",
    "customers.label.account_no": "ເລກບັນຊີ",
    "customers.label.customer_name": "ຊື່ລູກຄ້າ",
    "customers.label.business_entity": "ສິດທິງີຊື່",
    "customers.label.balance": "ຍອດເງິນ",
    "customers.label.valid_from": "ມີຜົນຕັ້ງແຕ່",
    "customers.label.valid_to": "ມີຜົນຫາວັນ",
    "customers.label.non_currency_details": "ລາຍລະອຽດທີ່ບໍ່ແມ່ນເງິນຕາ",
    "customers.label.view_details": "ເບິ່ງລາຍລະອຽດ",
    "customers.label.status": "ສະຖານະ",
    "customers.label.first_name": "ຊື່",
    "customers.label.price_discount": "ລາຄາ ແລະ ສ່ວນຫຼຸດ",
    "customers.label.collection_status": "ສະຖານະການເກັບກຳ",
    "customers.label.last_name": "ນາມສະກຸນ",
    "customers.label.city_area": "ເມືອງ/ເຂດ",
    "customers.label.email": "ອີເມວ",
    "customers.label.phone": "ເບີໂທ",
    "customers.label.cafid": "CAF Id",
    "customers.label.enter_business_entity": "ໃສ່ຫົວໜ່ວຍທຸລະກິດ",
    "customers.label.select": "ເລືອກ",
    "customers.label.refund": "ການຄືນເງິນ",
    "customers.label.refund_id": "ເລກບັດຄືນ",
    "customers.label.refund_amount": "ຈຳນວນເງິນຄືນ",
    "customers.label.select_category_type": "ເລືອກປະເພດຈຸດ",
    "customers.label.clear": "ລ້າງອອກ",
    "customers.label.search": "ຄົ້ນຫາ",
    "customers.label.customer_activation": "ການເປີດງານລູກຄ້າ",
    "customers.label.customer_details": "ລາຍລະອຽດລູກຄ້າ",
    "customers.label.loc": "LOC",
    "customers.label.customer_category": "ປະເພດລູກຄ້າ",
    "customers.label.service_details": "ລາຍລະອຽດການບໍລິການ",
    "customers.label.name": "ຊື່",
    "customers.label.add_service": "ເພີ່ມບໍລິການ",
    "customers.label.network_node": "ໂດຍການຊັດທະບຽນ",
    "customers.label.device_details": "ລາຍລະອຽດອຸປະກອນ",
    "customers.label.item": "ລາຍການ",
    "customers.label.discount_code": "ລະຫັດສ່ວນຫຼຸດ",
    "customers.label.total_price": "ລາຄາລວມ",
    // "customers.label.device_details": "ລາຍລະອຽດຂອງອຸປະກອນ",
    "customers.label.plan_details": "ລາຍລະອຽດຂອງໂປຣໂມຊັ່ນ",
    "customers.label.payment_details": "ລາຍ​ລະ​ອຽດ​ການ​ຊໍາ​ລະ​ເງິນ",
    "customers.label.plan_list": "ລາຍຊື່ຂອງໂປຣໂມຊັ່ນ",
    "customers.label.plan": "ໂປຣໂມຊັ່ນ",
    "customers.label.contract_period": "ການຈໍາກັດຄືນ",
    "customers.label.charge_cycle": "ຊະນິດລາຍໄອຄອນ",
    "customers.label.cancel": "ຍົກເລີກ",
    "customers.label.next": "ຕໍ່ໄປ",
    "customers.label.done": "ສຳ ເລັດ",
    "customers.label.reopen": "ເປີດຄືນໃໝ່",
    "customers.label.submit": "ສົ່ງ",
    "customers.label.view_customer": "ເບິ່ງລູກຄ້າ",
    "customers.label.account_number": "ເລກບັດປະຈຳຕົວ",
    "customers.label.serial_no": "ເລກຫມາຍ",
    "customers.label.office_hierarchy": "ຄະນິດຂອງຫ້ອງການ",
    "customers.label.account_type": "ປະເພດບັດປະຈຳຕົວ",
    // "customers.label.balance": "ຍອດຍົກຍ້າຍ",
    "customers.label.stb_serial_no": "ເລກຫມາຍ STB",
    "customers.label.non_currency_balance": "ຍອດຍ້າຍບໍ່ເງິນ",
    "customers.label.service_orders": "ການສະເໜີລາຍຊື່ບໍລິການ",
    "customers.label.more_info": "ຂໍ້ມູນເພີ່ມຕື່ມ",
    "customers.label.notes": "ບັນທຶກ",
    "customers.label.device": "ອຸປະກອນ",
    "customers.label.tickets": "ປະຕິບັດ",
    "customers.label.on_demand": "ໃຫ້ມາ",
    "customers.label.on_demand_billing": "ການເອີ້ນເກັບເງິນຕາມຄວາມຕ້ອງການ",
    "customers.label.payments": "ການຈ່າຍເງິນ",
    "customers.label.invoice": "ໃບຮຽກ",
    "customers.label.contact_information": "ຂໍ້ມູນຕິດຕໍ່",
    "customers.label.address_information": "ຂໍ້ມູນທີ່ຢູ່",
    "customers.label.billing_information": "ຂໍ້ມູນບິນ",
    "customers.label.balance_information": "ຂໍ້ມູນຍອດເງິນ",
    // "customers.label.customer_name": "ຊື່ລູກຄ້າ",
    "customers.label.parent_child": "ຜູ້ອາໄສ/ລາຍການ",
    "customers.label.created_date": "ວັນທີ່ສ້າງ",
    "customers.label.district": "ເມືອງ",
    "customers.label.pincode": "ລະຫັດ PIN",
    "customers.label.last_bill_amount": "ຈຳນວນໃບເລກທີ່ຈຳນວນຫຼັງຈາກ",
    "customers.label.last_bill_date": "ວັນທີ່ໃບບິນຫຼັງຈາກ",
    "customers.label.last_bill_paid": "ຈຳນວນໃບບິນທີ່ຈ່າຍກ່ອນຫຼັງຈາກ",
    "customers.label.last_paid_amount": "ຈຳນວນຄ່າທຳອິດຫຼັງຈາກ",
    "customers.label.last_payment_date": "ວັນທີ່ຈ່າຍຄ່າຫຼັງຈາກ",
    "customers.label.next_bill_date": "ວັນທີ່ໃບເລກຖ້າຜ່ານ",
    "customers.label.service_overview": "ພາບລວມການບໍລິການ",
    "customers.label.service_without_device": "ບໍລິການທາງວຽກຄຸນຄ່າ",
    "customers.label.create_ticket": "ສ້າງໂຄງການ",
    "customers.label.service_activation": "ການເປີດການບໍລິການ",
    "customers.label.order_charging": "ຈຳນວນໃບເລີກ",
    "customers.label.top_up": "ເຕີມເງິນ",
    "customers.label.redeem": "ຊື້ໃຫ້ໜ້າ",
    "customers.label.collection_name": "ຊື່ຄວາມຮວມ",
    "customers.label.redeem_voucher": "ແລກເອົາ Voucher",
    "customers.label.service_id": "ລະຫັດບໍລິການ",
    "customers.label.service_code": "ລະຫັດບໍລິການ",
    "customers.label.service_description": "ລາຍລະອຽດບໍລິການ",
    "customers.label.start_date": "ວັນເລີ່ມ",
    "customers.label.modified_date": "ວັນປັບປຸງ",
    // "customers.label.status": "ສະຖານະ",
    "customers.label.info": "ຂໍ້ມູນ",
    "customers.label.action": "ການປັບປຸງ",
    "customers.label.add_device": "ເພີ່ມອຸປະກອນ",
    "customers.label.add_plans": "ເພີ່ມແຜນການ",
    "customers.label.suspend": "ປັດຈຸບັນ",
    "customers.label.reactivate": "ສົ່ງໃໝ່",
    "customers.label.terminate": "ປະຕິບັດ",
    "customers.label.command_center": "ສ່ວນປະຊຸມການ",
    "customers.label.retrack": "ຄວາມປະຕິເສີນຫຼັງຈາກ",
    "customers.label.cancel_plans": "ຍົກເລີກແຜນການ",
    "customers.label.device_overview": "ພາບລວມອຸປະກອນ",
    "customers.label.item_code": "ລະຫັດສິນຄ້າ",
    "customers.label.orders_overview": "ພາບບົດສະແດງການສັ່ງຊື້",
    // "customers.label.plan": "ໂປຣແກມ",
    "customers.label.end_date": "ວັນສິ້ນສຸດ",
    "customers.label.price": "ລາຄາ",
    "customers.label.short_description": "ລາຍລະອຽດສັ້ນ",
    "customers.label.description": "ລາຍລະອຽດ",
    "customers.label.add_note": "ເພີ່ມໝາຍເຫດ",
    "customers.label.note": "ໝາຍເຫດ",
    "customers.label.sale_type": "ປະເພດການຂາຍ",
    "customers.label.bill_item_details": "ລາຍການລາຍການໃບບິນ",
    "customers.label.charge_id": "ໄອດີຄ່າທຽມ",
    "customers.label.order_id": "ໄອດີສັ່ງຊື້",
    "customers.label.item_tax_details": "ລາຍລະອຽດພາສີລາຍການ",
    "customers.label.discount_details": "ລາຍລະອຽດສ່ວນຫຼຸດ",
    "customers.label.sale_date": "ວັນທີ່ຂາຍ",
    "customers.label.charge_code": "ລະຫັດການຈຳກັດ",
    "customers.label.quantity": "ຈຳນວນ",
    // "customers.label.total_price": "ລວມລາຄາ",
    "customers.label.warranty_date": "ວັນທີ່ມີຄວາມປົກກະຕິ",
    "customers.label.allocate": "ຈຳກັດ",
    "customers.label.contact_info": "ຂໍ້ມູນຕິດຕໍ່",
    "customers.label.edit_customer": "ແກ້ໄຂລູກຄ້າ",
    "customers.label.lco": "LCO",
    "customers.label.title": "ຫົວຂໍ້",
    // "customers.label.customer_category": "ຫມວດຫມູ່ລູກຄ້າ",
    "customers.label.middle_name": "ຊື່ກຳລັງ",
    "customers.label.caf_id": "CAF Id",
    "customers.label.landline_number": "ໝາຍເລກຕັ້ງໂຕະ",
    "customers.label.user_name": "ຊື່ຜູ້ໃຊ້",
    "customers.label.customer_photo": "ຮູບລູກຄ້າ",
    "customers.label.id_proof": "ການຢືນຢັນການປະກາດ",
    "customers.label.id_proof_value": "ຄ່າການຢືນຢັນການປະກາດ",
    "customers.label.save": "ບັນທຶກ",
    "customers.label.close_customer": "ປິດລູກຄ້າ",
    "customers.label.closure_date": "ວັນປິດ",
    "customers.label.closure_reason": "ເຫດຜົນການປິດ",
    "customers.label.close": "ປິດ",
    "customers.label.address_info": "ຂໍ້ມູນທີ່ຢູ່",
    "customers.label.edit_address": "ແກ້ໄຂທີ່ຢູ່",
    "customers.label.address_no": "ເລກທີ່ຢູ່",
    "customers.label.street": "ຖະຫນົນ",
    "customers.label.building": "ອົງການ",
    "customers.label.zipcode": "ໂດຍຮ່າງສີແດງ",
    "customers.label.billing": "ໃບເງິນບິນ",
    "customers.label.same_as_primary": "ໃຫ້ແລະໂທລະສັບ",
    "customers.label.building_code": "ລະຫັດອົງການ",
    "customers.label.add_address": "ເພີ່ມທີ່ຢູ່",
    "customers.label.address_type": "ປະເພດທີ່ຢູ່",
    "customers.label.billing_info": "ຂໍ້ມູນໃບຮັບເງິນ",
    "customers.label.created_adjustment": "ປັບປຸງການປັບປ່ຽນ",
    "customers.label.create_order": "ສ້າງລາຍການ",
    "customers.label.sale_catalog": "ລາຍຊື່ການຂາຍ",
    "customers.label.renew_plan": "ແຜນການຕໍ່ອາຍຸ",
    "customers.label.auto_renew": "ປັບປຸງສະຖານະລົດຕາມເລກບິນ",
    // "customers.label.search": "ຄົ້ນຫາ",
    "customers.label.entity_name": "ຊື່ແອັດດັບ",
    "customers.label.discount": "ສ່ວນລຸດ",
    "customers.label.provisioning_commands": "ຄຳສັ່ງ Provisioning",
    "customers.label.command": "ຄຳສັ່ງ",
    "customers.label.plans": "ການຈັດການ",
    "customers.label.client_service_detail": "ລາຍລະອຽດບໍລິການລູກຄ້າ",
    "customers.label.id": "ລະຫັດ",
    "customers.label.parameter_name": "ຊື່ພາຣິດ",
    "customers.label.parameter_value": "ຄ່າພາຣິດ",
    "customers.label.request_type": "ປະເມີນຜົນຂອງຂໍ້ມູນ",
    "customers.label.client_info": "ຂໍ້ມູນລູກຄ້າ",
    "customers.label.service_info": "ຂໍ້ມູນບໍລິການ",
    "customers.label.new_device_info": "ຂໍ້ມູນອົງການພາຍໃນເຄື່ອງມືໃຫມ່",
    "customers.label.task_list": "ລາຍຊື່ວຽກວິທີການ",
    "customers.label.provisioning_detail": "ລາຍລະອຽດການສະແດງສິ່ງທີ່ພິມ",
    "customers.label.provisioning_id": "ລະຫັດການສະແດງສິ່ງທີ່ພິມ",
    "customers.label.task_id": "ລະຫັດວຽກວິທີການ",
    "customers.label.sent_message": "ຂໍ້ຄວາມທີ່ສົ່ງແລ້ວ",
    "customers.label.available_plans": "ການຈໍາເປັນສັງຄົມການຊ່ວຍເຫຼືອ",
    "customers.label.disconnect_order": "ສົ່ງອອກສິດອົງ",
    "customers.label.reason": "ເຫດຜົນ",
    "customers.label.porting_out": "ກຳລັງອອກ",
    "customers.label.prepaid_to_postpaid": "ຈ່າຍລ່ວງໜ້າເພື່ອຈ່າຍເງິນຫຼັງ",
    "customers.label.postpaid_to_prepaid": "ຈ່າຍລ່ວງໜ້າເພື່ອຈ່າຍລ່ວງໜ້າ",
    "customers.label.addons": "Addons",
    "customers.label.change_plan": "ປ່ຽນແຜນ",
    "customers.label.swap_sim": "ປ່ຽນຊິບ",
    "customers.label.select_date": "ເລືອກວັນທີ່",
    "customers.label.order_date": "ວັນທີ່ສັ່ງຊື້",
    "customers.label.priority": "ລະດັບສະໜັບສະໜູນ",
    "customers.label.ticket_date": "ວັນທີ່ການປັບໄຟລ໌",
    "customers.label.category": "ຫມວດ",
    "customers.label.sub_category": "ໝວດຫມວດ",
    "customers.label.team": "ຄືນ",
    "customers.label.team_user": "ຜູ້ໃຊ້ຂອງຄືນ",
    "customers.label.source": "ຕົວຢ່າງ",
    "customers.label.due_time": "ເວລາທີ່ຕ້ອງການ",
    "customers.label.device_swap": "ຈັດສົ່ງການຈັດສົ່ງອາຍຸ",
    // "customers.label.terminate": "ສົດ",
    "customers.label.confirm": "ຢືນຢັນ",
    "customers.label.continue": "ສືບຕໍ່",
    "customers.label.process_date": "ວັນທີ່ການປະກາດ",
    "customers.label.pin_number": "ເລກທະບຽນ PIN",
    "customers.label.renewal": "ການປັບປຸງ",
    // "customers.label.create_customer": "ສ້າງລູກຄ້າ",
    "customers.label.individual": "ຄົນຊ່າຍ",
    "customers.label.corporate": "ບໍລິສັດ",
    "customers.label.corporate_details": "ລາຍລະອຽດບໍລິສັດ",
    "customers.label.contact_person": "ຜູ້ຕິດຕໍ່",
    "customers.label.entity": "ຕົວແທນ",
    "customers.label.client_category": "ປະເພດລູກຄ້າ",
    "customers.label.preferences": "ຕ້ອງການຖືກເລືອກໃນການບໍລິການ",
    "customers.label.parent_id": "ລັດຖະບານຊ່ວຍເຫຼືອ",
    "customers.label.child": "ເດັກນ້ອຍ",
    "customers.label.villege_street": "ບ້ານ/ຜະລິດ",
    "customers.label.billing_address": "ທີ່ຢູ່ຊຳລະຊ່າງ",
    "customers.label.bill_information": "ຂໍ້ມູນບິນ",
    "customers.label.bill_day_of_month": "ວັນຮັບເງິນເດືອນ",
    "customers.label.fiscal_year": "ປີເລືອກ",
    "customers.label.fiscal_quater": "ຄະນິດບັນດາທີ່",
    "customers.label.bill_mode": "ຮູບແບບບິນ",
    "customers.label.invoice_type": "ປະເພດບິນ",
    "customers.label.payment_information": "ຂໍ້ມູນການຈ່າຍ",
    "customers.label.funder_name": "ຊື່ຜູ້ຊ່ວຍສະເໜີ",
    "customers.label.funder_id": "ID ຜູ້ຊ່ວຍສະເໜີ",
    "customers.label.po_number": "ເລກລົດລາຍ",
    "customers.label.payment_term": "ເງິນກຳນົດ",
    "customers.label.customer_created_successfully": "ຜູ້ຊື້ສ້າງເປັນສຳເລັດ",
    "customers.label.go_to_customer": "ໄປຫາຜູ້ຊື້ສ້າງ",
    "customers.label.view_order": "ເບິ່ງການສັ່ງຊື້",
    "customers.label.disconnect": "ປິດການເຊື່ອມຕໍ່",
    "customers.label.apply_promo": "ໃຫ້ສ່ວນອາຫານ",
    // "customers.label.order_id": "ລະຫັດການສັ່ງຊື້",
    "customers.label.order_type": "ປະເພດການສັ່ງຊື້",
    "customers.label.billing_cycle": "ສະຫຼຸບການບິນ",
    "customers.label.plan_name": "ຊື່ໂປຣໄຟລ",
    "customers.label.user_action": "ການປະຕິບັດຂອງຜູ້ໃຊ້",
    "customers.label.invoice_till_date": "ໃບເວລາມາເຖິງວັນທີ່ມາທີ່ນີ້",
    "customers.label.order_services": "ການສັ່ງຊື້ບັນຊີ",
    "customers.label.service_type": "ປະເພດການບໍລິການ",
    "customers.label.bill_start_date": "ວັນເລີ່ມຕົ້ນບິນ",
    "customers.label.bill_end_date": "ວັນສິ້ນສຸດບິນ",
    // "customers.label.invoice_till_date": "ໃບເວລາມາເຖິງວັນທີ່ມາທີ່ນີ້",
    "customers.label.charge_type": "ປະເພດຄ່າເຊັ່ນ",
    "customers.label.rate_uom": "ອັດຕາ/UOM",
    "customers.label.discount_description": "ລາຍລະອຽດການຫຼຸດ",
    "customers.label.discount_type": "ປະເພດການຫຼຸດ",
    "customers.label.discount_start_date": "ວັນເລີ່ມຕົ້ນຂອງການຫຼຸດ",
    "customers.label.discount_end_date": "ວັນສິ້ນສຸດຂອງການຫຼຸດ",
    "customers.label.discount_amount": "ຈຳນວນການຫຼຸດ",
    "customers.label.order_transaction": "ການເຮັດການສັ່ງຊື້",
    "customers.label.user": "ຜູ້ໃຊ້",
    "customers.label.transaction_date": "ວັນທີ່ເຮັດການສັ່ງຊື້",
    "customers.label.transaction_type": "ປະເພດການເຮັດການ",
    "customers.label.actual_date": "ວັນທີ່ສົ່ງ",
    "customers.label.promo": "ໂປຣໂມເຊີ",
    "customers.label.promotion": "ໂປຣໂມເຊີ",
    "customers.label.disconnection_date": "ວັນທີ່ປິດການເຊື່ອມຕໍ່",
    "customers.label.disconnection_reason": "ເຫດຜົນການປິດການເຊື່ອມຕໍ່",
    "customers.label.problem_code": "ລະຫັດບັນຫາ",
    "customers.label.assign_to": "ມອບແຈ້ງກັບ",
    "customers.label.last_comment": "ຄວາມຄິດເຫັນຫຼ້າສຸດ",
    "customers.label.file_name": "ຊື່ໄຟລ໌",
    "customers.label.edit_ticket": "ແກ້ໄຂບັນຫາ",
    "customers.label.close_ticket": "ປິດບັນຫາ",
    "customers.label.resolution_description": "ລາຍລະອຽດການຮັບປະກັນ",
    "customers.label.ticket_history": "ປະຫວັດການບັນຫາ",
    // "customers.label.last_comment": "ຄວາມຄິດເຫັນຫຼ້າສຸດ",
    "customers.label.problem_description": "ລາຍລະອຽດບັນຫາ",
    "customers.label.generate": "ສ້າງ",
    "customers.label.bill_date": "ວັນລົງບັນຊີ",
    "customers.label.amount": "ຈຳນວນ",
    "customers.label.statement": "ຄຳອະທິບາຍ",
    // "customers.label.due_date": "ວັນຄິດເລື່ອນ",
    "customers.label.promotional_message": "ຂໍ້ຄວາມການແຈ້ງກຳ",
    "customers.label.download": "ດາວໂຫຼດ",
    "customers.label.due_amount": "ຈຳນວນເງິນທີ່ຄິດເລື່ອນ",
    "customers.label.transactions": "ການເຮັດລາຍະການ",
    "customers.label.file": "ເອກະສານ",
    "customers.label.reset": "ປ່ຽນການຕັ້ງຄ່າການລົງທະບຽນ",
    "customers.label.order_details": "ລາຍລະອຽດການສັ່ງຊື້",
    "customers.label.make_payment": "ຈ່າຍເງິນ",
    "customers.label.transaction_id": "ລະຫັດການເຮັດລາຍະການ",
    "customers.label.credit_amount": "ຈຳນວນດຳເນີນການ",
    "customers.label.debit_amount": "ຈຳນວນເງິນເຂົ້າການ",
    "customers.label.cancel_remark": "ໝາຍເຫດການຍົກເລີກ",
    "customers.label.pay_invoice": "ຈ່າຍບິນໃບເກັບ",
    "customers.label.account": "ບັນຊີ",
    "customers.label.deposit": "ມີຄົ້ນ",
    "customers.label.payment_date": "ວັນທີ່ຈ່າຍ",
    "customers.label.payment_type": "ປະເພດການຈ່າຍ",
    "customers.label.receipt_no": "ເລກທີ່ຮັບ",
    "customers.label.cheque_no": "ເລກເຄື່ອງ",
    "customers.label.bank_name": "ຊື່ທະນາຄານ",
    "customers.label.branch_name": "ຊື່ພາກເກົ່າ",
    "customers.label.cheque_date": "ວັນທີ່ເຄື່ອງ",
    "customers.label.invoice_id": "ເລກບິນ",
    "customers.label.invoice_date": "ວັນທີ່ໃບເກັບບິນ",
    "customers.label.invoice_amount": "ຈຳນວນໃບເກັບບິນ",
    // "customers.label.due_amount": "ຈຳນວນທີ່ຕ້ອງການ",
    "customers.label.payment_reversal": "ການຍ້າຍເງິນການຈ່າຍ",
    "customers.label.date_filter": "ການກັບຄືນວັນ",
    "customers.label.add_event_order": "ເພີ່ມການສັ່ງຊື້ກິດຈະກຳ",
    "customers.label.event_order": "ການສັ່ງຊື່ກິດຈະກໍາ",
    "customers.label.eventdate": "ວັນທີຂອງກິດຈະກໍາ",
    "customers.label.serviceAddress": "ທີ່ຢູ່ບໍລິການ",
    "customers.label.event_name": "ຊື່ກິດຈະກຳ",
    "customers.label.booked_date": "ວັນທີ່ຈອງໄດ້",
    "customers.label.event_price": "ລາຄາກິດຈະກຳ",
    "customers.label.events": "ກິດຈະກຳ",
    "customers.label.format_type": "ຮູບແບບຮູບ",
    "customers.label.opt_type": "ປະເພດ OPT",
    "customers.label.client_bill_profile": "ໂປຣໄຟລບັນຊີບັນຊີຂອງລູກຄ້າ",
    "customers.label.edit": "ແກ້ໄຂ",
    "customers.label.type": "ປະເພດ",
    "customers.label.client_id": "ລູກຄ້າ ID",
    "customers.label.bill_currency": "ເງິນເລກບິນ",
    "customers.label.bill_frequency": "ສະຫຼຸບຂອງບິນ",
    "customers.label.bill_segment": "ຈຳນວນບິນ",
    // "customers.label.next_bill_day": "ມື້ບິນດ້ວຍພື້ນຖານ",
    "customers.label.last_bill_day": "ມື້ບິນຫຼ້າສຸດ",
    "customers.label.last_bill_no": "ເລກບິນຫຼ້າສຸດ",
    "customers.label.bill_suppression_flag": "ປ້າຍການປິດບິນ",
    "customers.label.bill_suppression_id": "ID ການປິດບິນ",
    "customers.label.first_bill": "ໃບຮັບບິນທຳລາຍ",
    "customers.label.hot_bill": "ບິນສົ່ງເມືອງ",
    "customers.label.edit_bill_profile": "ແກ້ໄຂໂປຣໂມເຊີນ",
    // "customers.label.bill_currency": "ເງິນໂປຣໂມເຊີນ",
    "customers.label.bill_suppression": "ການປິດໂປຣໂມເຊີນ",
    // "customers.label.more_info": "ຂໍ້ມູນເພີ່ມເຕີມ",
    "customers.label.identities": "ຄວາມຖືກຕ້ອງ",
    "customers.label.add_client_identities": "ເພີ່ມຄວາມຖືກຕ້ອງຂອງລູກຄ້າ",
    "customers.label.unique_identification": "ການປະກາດຂໍ້ມູນທີ່ປະລິມ",
    "customers.label.identity_documents": "ເອກະສານການປະກາດຂໍ້ມູນ",
    "customers.label.additional_info": "ຂໍ້ມູນເພີ່ມເຕີມ",
    "customers.label.nationality": "ສັນຊາດ",
    "customers.label.date_of_birth": "ວັນເດືອນປີເກີດ",
    "customers.label.preferred_language": "ພາສາທີ່ມັກຕາມ",
    "customers.label.finance_id": "ID ການແຈ້ງເຕືອນ",
    "customers.label.remarks": "ຄຳເຫັນ",
    "customers.label.preferred_communication": "ການຕອບຮັບທາງເຄື່ອງມືຖືກຕ້ອງ",
    "customers.label.add_client_identifier": "ເພີ່ມການປະກາດຜູ້ໃຊ້ລູກຄ້າ",
    "customers.label.document_type": "ປະເພດເອກະສານ",
    "customers.label.document_uploads": "ອັບໂຫຼດເອກະສານ",
    "customers.label.select_file": "ເລືອກໄຟລ",
    "customers.label.credit_card_details": "ລາຍລະອຽດການຄຳນຳທີ່ຜ່ານການຈ່າຍ",
    "customers.label.card_number": "ເລກບັດ",
    "customers.label.cvv": "CVV",
    "customers.label.card_type": "ປະເພດບັດ",
    "customers.label.expiry_date": "ວັນໝົດອາຍຸ",
    "customers.label.ach_card": "ບັດ ACH",
    "customers.label.ach_card_routing_number": "ເລກທີ່ເລືອກບັດ ACH",
    "customers.label.bank_account_number": "ເລກບັດຊື້ບັດ",
    "customers.label.childs": "ເດັກນ້ອຍ",
    "customers.label.cell_phone": "ໂທລະສັບມືຖື",
    "customers.label.create_client_additional_info":
      "ສ້າງຂໍ້ມູນເພດພໍ່ໄປຂອງລູກຄ້າເພີ່ມເຕີມ",
    "customers.label.gender": "ເພດ",
    "customers.label.id_type": "ປະເພດ ID",
    // "customers.label.nationality": "ສັນຊາດ",
    "customers.label.id_number": "ເລກບັດ ID",
    "customers.label.job_title": "ຊື່ວຽກມັນ",
    "customers.label.age_group": "ຊຸດລຽງຂອງອາຍຸ",
    "customers.label.uts_customer_id": "ID ລູກຄ້າ UTS",
    "customers.label.ach_card_name": "ຊື່ບັດ ACH",
    "customers.label.adjustment": "ການປັບປຸງ",
    // "customers.label.created_adjustment": "ການປັບປຸງທີ່ສ້າງແລ້ວ",
    "customers.label.adjustment_date": "ວັນທີ່ປັບປຸງ",
    "customers.label.adjustment_code": "ລະຫັດການປັບປຸງ",
    "customers.label.adjustment_amount": "ຈຳນວນການປັບປຸງ",
    "customers.label.adjustment_type": "ປະເພດການປັບປຸງ",
    "customers.label.activity_log": "ບັນທຶກກິດຈະກຳ",
    "customers.label.office_id": "ເລກຂອງສະຖານະ",
    "customers.label.history": "ປະຫວັດ",
    "customers.label.filter_by_date": "ການກັ້ນຕອນທີ່ດຶງຂັ້ນທີ່ວັນ",
    "customers.label.view_usage_details": "ເບິ່ງລາຍລະອຽດການໃຊ້ບໍລິການ",
    "customers.label.units": "ຫົວໜ່ວຍ",
    "customers.label.tax": "ພາສີ",
    "customers.label.total_amount": "ຈຳນວນລວມ",
    "customers.label.account_transaction": "ການເຮັດລາຍງານບັນຊີ",
    "customers.label.csv_pdf": "CSV/PDF",
    "customers.label.charge_description": "ລາຍລະອຽດຄາຕ່ຳ",
    "customers.label.journals": "ປື້ມ",
    "customers.label.download_financial_summary_data":
      "ດາວໂຫຼດຂໍ້ມູນສົງຄ່າການເບິ່ງຕົ້ນສະບັບ",
    "customers.label.select_from_date": "ເລືອກຈາກວັນທີ",
    "customers.label.select_to_date": "ເລືອກຈາກວັນທີ",
    "customers.label.village_street": "ບ້ານ/ຖະຫນົນ",
    "customers.label.previous": "ກ່ອນໜ້າ",
    "customers.label.Disconnect": "ຕັດຂາດ",
    "customers.label.ApplyPromo": "ນຳໃຊ້ໂປໂມຊັນ",
    "customers.label.Service": "ບໍລິການ",
    "customers.label.Product": "ຜະລິດຕະພັນ",
    "customers.label.CreditCard": "ບັດເຄຣດິດ",
    "customers.label.Paypal": "Paypal",
    "customers.label.BusinessEntity": "ອົງການທຸລະກິດ",
    "customers.label.Plan": "ແຜນ",
    "customers.label.Phone": "ໂທລະສັບ",
    "customers.label.TaxExemption": "ການຍົກເວັ້ນພາສີ",
    "customers.label.YES": "ແມ່ນ",
    "customers.label.NO": "ບໍ່",
    "customers.label.Resolution": "ຄວາມລະອຽດ",
    "customers.label.AccountNo": "ໝາຍເລກບັນຊີ",
    "customers.label.ChipId": "ເລກບັດຊິບ",
    "customers.label.MobileNo": "ເລກມືຖື",
    "customers.label.EmailId": "ອີເມວໄອດີ",
    "customers.label.SerialNo": "ເລກລຳດັບ",
    "customers.label.LegacyNo": "ເລກມໍຣະດົກ",
    "customers.label.searchclient": "ຊອກຫາລູກຄ້າ",
    "customers.label.PrimaryAddress": "ທີ່ຢູ່ຫຼັກ",
    "customers.label.BillingAddress": "ທີ່ຢູ່ສົ່ງບິນ",
    // "customers.label.lco": "lco",
    "customers.label.EventDate": "ວັນທີເຫດການ",
    "customers.label.CreateAdjustment": "ສ້າງການປັບແປງ",
    "customers.label.full_name": "ຊື່ເຕັມ",
    "customers.label.bill_collection_action": "ການເກັບບິນ",
    "customers.label.collection_actions": "ການເກັບກໍາລັງ",
    "customers.label.action_name": "ຊື່ການກະທໍາ",
    "customers.label.action_date": "ວັນທີຂອງການກະທໍາ",
    "customers.label.balance_due": "ຍອດໜີ້",
    "customers.label.bill_id": "ບິນ Id",
    "customers.label.payinfo": "ຂໍ້ມູນການຈ່າຍເງິນ",
    "customers.label.cardtoken": "ໂທເຄັນບັດ",
    "customers.label.autopay": "ການຈ່າຍອັດຕະ",
    "customers.label.paynow": "ຈ່າຍເງິນດຽວນີ້",
    "customers.label.featureList": "ບັນດາລາຍການ",
    "customers.label.consumed": "ບັນດາລາຍການ",
    "customers.label.updateCreditLimt": "ອັບເດດຂະບວນການເປັນເລກ",
    "customers.label.PendingForApproval": "ລໍຖ້າການອະນຸມັດ",

    "customers.label.SpendCapHistory": "ປະຫວັດຂອງຂີດຈຳກັດຄ່າໃຊ້ຈ່າຍ",
    "customers.label.DateTime": "ວັນທີ ແລະ ເວລາ",
    "customers.label.SpendCapEventName": "ຊື່ເຫດການຂອງຂີດຈໍາກັດ",
    "customers.label.SpendingLimit": "ຂີດຈຳກັດຄ່າໃຊ້ຈ່າຍ",
    "customers.label.ConsumedLimit": "ຂີດຈໍາກັດທີ່ໃຊ້ໄປແລ້ວ",
    "customers.label.EventId": "ເລກລະຫັດເຫດການ",
    "customers.label.collectionStatus": "ສະຖານະການເກັບ",
  },
  vi: {
    "customers.label.temporaryBlock": "Chặn tạm thời",
    "customers.label.unBlock": "Bỏ chặn",
    "customers.label.feedback": "Phản hồi",
    "customers.label.event_id": "ID sự kiện",
    "customers.label.slc_state_history": "Lịch sử trạng thái SLC",
    "customers.label.slc": "SLC",
    "customers.label.state_Change_Time": "Thời gian thay đổi trạng thái",
    "customers.label.event": "Sự kiện",
    "customers.label.previous_state": "Trạng thái trước",
    "customers.label.resolution_date": "Ngày giải quyết",
    "customers.label.current_state": "Trạng thái hiện tại",
    "customers.label.created_time": "Thời gian tạo",
    "customers.label.creation_time": "Thời gian khởi tạo",
    "customers.label.Promotion": "Khuyến mãi",
    "customers.label.slc_status": "Trạng thái SLC",
    "customers.label.update_slc_status": "Cập nhật trạng thái SLC",
    "customers.label.temporary_block": "Chặn tạm thời",
    "customers.label.workflow_id": "ID quy trình làm việc",
    "customers.label.externalPromoId": "ID Khuyến mãi Bên ngoài",
    "customers.label.externalPromoName": "Tên Khuyến mãi Bên ngoài",
    "customers.label.promoCode": "Mã Khuyến mãi",
    "customers.label.promoDescription": "Mô tả Khuyến mãi",
    "customers.label.ScheduleOrder": "Lên lịch đơn hàng",
    "customers.label.ScheduledDate": "Ngày đã lên lịch",
    "customers.label.ViewRateLimit": "Xem giới hạn tốc độ",
    "customers.label.SelectType": "Chọn loại",
    "customers.label.search": "Tìm kiếm",
    "customers.label.SelectTaxExemption": "Chọn miễn thuế",
    "customers.label.ViewTickets": "Xem vé",
    "customers.label.TicketHistory": "Lịch sử vé",
    "customers.label.ReopenTicket": "Mở lại vé",
    "customers.label.SelectInvoiceType": "ငွေပေးချေမှုအမျိုးအစားကို ရွေးပါ",
    "customers.label.SelectCategory": "အမျိုးအစား ရွေးပါ",
    "customers.label.SelectSubCategory": "ခွဲအမျိုးအစား ရွေးပါ",
    "customers.label.SelectSource": "အရင်းအမြစ် ရွေးပါ",
    "customers.label.TicketHistory": "စာရင်းသွင်းမှတ်တမ်း",
    "customers.label.ViewSpendCap": "Xem giới hạn chi tiêu",
    "customers.label.ResponseMessage": "Thông điệp phản hồi",
    "customers.label.AddPlan": "Thêm gói",
    "customers.label.Basket": "Giỏ hàng",
    "customers.label.TotalPrice": "Tổng giá",
    "customers.label.Send_Link_to_Customer_to_Complete_Payment":
      "Gửi liên kết cho khách hàng để hoàn tất thanh toán",
    "customers.label.CheckPaymentStatus": "Kiểm tra trạng thái thanh toán",
    "customers.label.Are_you_sure_you_want_to_terminate?":
      "Bạn có chắc chắn muốn chấm dứt không?",
    "customers.label.Unlimited": "Không giới hạn",
    "customers.label.days_left": "ngày còn lại",
    "customers.label.search": "Tìm kiếm",
    "customers.label.JobTitle": "Chức danh công việc",
    "customers.label.SelectDocumentType": "Chọn loại tài liệu",
    "customers.label.SelectEvents": "Chọn sự kiện",
    "customers.label.SelectFormatType": "Chọn loại định dạng",
    "customers.label.SelectAdjustmentType": "Chọn loại điều chỉnh",
    "customers.label.card_number": "Số thẻ",
    "customers.label.Select_OPT_Type": "Chọn loại OTP",
    "customers.label.StartDate": "Ngày bắt đầu",
    "customers.label.EndDate": "Ngày kết thúc",
    "customers.label.Cancel": "Hủy bỏ",
    "customers.label.Set": "Đặt",
    "customers.label.PaymentDetails": "Chi tiết thanh toán",
    "customers.label.PaymentReceipt": "Biên lai thanh toán",
    "customers.label.Status": "Trạng thái",
    "customers.label.PaymentAmount": "Số tiền thanh toán",
    "customers.label.Transaction": "Giao dịch",
    "customers.label.PaymentPage": "Trang thanh toán",
    "customers.label.ItemCode": "Mã sản phẩm",
    "customers.label.StartDate": "Ngày bắt đầu",
    "customers.label.English": "Tiếng Anh",
    "customers.label.SelectIdProof": "Chọn giấy tờ tùy thân",
    "customers.label.SelectAdjustementCode": "Chọn mã điều chỉnh",
    "customers.label.SelectAdjustmentType": "Chọn loại điều chỉnh",
    "customers.label.SelectFormat": "Chọn định dạng",
    "customers.label.AreYouSure?": "Bạn có chắc không?",
    "customers.label.ChargeId": "Mã phí",
    "customers.label.ChargeDescription": "Mô tả phí",
    "customers.label.DiscountAmount": "Số tiền giảm giá",
    "customers.label.NetChargeAmount": "Số tiền phí thực tế",
    "customers.label.TaxDescription": "Mô tả thuế",
    "customers.label.TaxAmount": "Số tiền thuế",
    "customers.label.SelectDate": "Chọn ngày",
    "customers.label.SelectPriority": "Chọn mức ưu tiên",
    "customers.label.SelectCategory": "Chọn danh mục",
    "customers.label.SelectSubCategory": "Chọn danh mục con",
    "customers.label.SelectSource": "Chọn nguồn",
    "customers.label.ViewSpendCap": "Xem giới hạn chi tiêu",
    "customers.label.Amount": "Số tiền",
    "customers.label.PlanCode": "Mã gói",
    "customers.label.Price": "Giá",
    "customers.label.Status": "Trạng thái",
    "customers.label.EndDate": "Ngày kết thúc",
    "customers.label.ContractPeriod": "Thời gian hợp đồng",
    "customers.label.AutoRenew": "Tự động gia hạn",
    "customers.label.Description": "Mô tả",
    "customers.label.ThankYou": "Cảm ơn bạn!",
    "customers.label.ConnectionActivated":
      "Kết nối đã được kích hoạt thành công với Số tài khoản",
    "customers.label.GoToCustomerDetail": "Đi đến chi tiết khách hàng",
    "customers.label.Payment": "Thanh toán",
    "customers.label.CustomerToPay": "Khách hàng phải trả:",
    "customers.label.MonthlyPayment": "Thanh toán hàng tháng",
    "customers.label.SetupWithDirectDebitOrCreditCard":
      "Thiết lập với ghi nợ trực tiếp hoặc thẻ tín dụng",
    "customers.label.SendLinkToCustomerToCompletePayment":
      "Gửi liên kết cho khách hàng để hoàn tất thanh toán",
    "customers.label.CheckPaymentStatus": "Kiểm tra trạng thái thanh toán",
    "customers.label.ThisNumberIsReservedFor": "Số này được dành riêng cho",
    "customers.label.YouSelected": "Bạn đã chọn",
    "customers.label.SerialNo": "Số sê-ri",
    "customers.label.PhoneNo": "Số điện thoại",
    "customers.label.ActivatingCustomer": "Đang kích hoạt khách hàng...",
    "customers.label.LoadingOrderStatus": "Đang tải trạng thái đơn hàng...",
    "customers.label.OrderStatus": "Trạng thái đơn hàng:",
    "customers.label.Failed": "Thất bại",
    "customers.label.RoamingOutsideEEA": "Chuyển vùng ngoài EEA",
    "customers.label.TariffTermsDetails":
      "Vui lòng xem Điều khoản Giá cước và Trang web của chúng tôi để biết thêm chi tiết về các giá cước và phí ngoài gói cước của bạn.",
    "customers.label.PaymentTerms":
      "Chúng tôi sẽ trừ số tiền bạn cần thanh toán từ tài khoản của bạn bằng ghi nợ trực tiếp SEPA, trừ khi có thỏa thuận khác. Hóa đơn sẽ hiển thị ngày chúng tôi sẽ trừ số tiền thanh toán. Chúng tôi có thể yêu cầu bạn thanh toán trước phí một lần và phí đăng ký. Trong một số trường hợp đặc biệt, chúng tôi có thể tính phí tạm thời, ví dụ: nếu trong một khoảng thời gian ngắn, bạn đã sử dụng một dịch vụ nào đó vượt mức trung bình. Nếu bạn thanh toán bằng thẻ tín dụng hoặc thẻ ghi nợ, bạn cho phép công ty thẻ thanh toán cung cấp cho chúng tôi và, một cách bảo mật, cho các nhà thầu phụ và/hoặc đại lý của chúng tôi thông tin về tài khoản thẻ thanh toán của bạn nếu cần thiết liên quan đến Thỏa thuận. Bạn cũng cho phép họ thông báo cho chúng tôi nếu tài khoản thanh toán của bạn bị chấm dứt hoặc tạm ngừng bất cứ lúc nào.",
    "customers.label.ServiceAgreementTerms":
      "Thời hạn, gia hạn và chấm dứt Thỏa thuận Dịch vụ",
    "customers.label.Duration": "Thời hạn",
    "customers.label.Renewal": "Gia hạn",
    "customers.label.ContractTermsAndConditions":
      "Điều khoản và điều kiện hợp đồng",
    "customers.label.TermsAndConditions": "Điều khoản & Điều kiện",
    "customers.label.CustomerExplanation":
      "Tôi đã cung cấp cho khách hàng một giải thích chi tiết về",
    "customers.label.CustomerAgreement": "và họ đã đồng ý tiếp tục đơn hàng.",
    "customers.label.NumberReservedFor": "Số này được dành cho",
    "customers.label.YouSelected": "Bạn đã chọn",
    "customers.label.SerialNo": "Số sê-ri",
    "customers.label.PhoneNo": "Số điện thoại",
    "customers.label.TotalPrice": "Tổng giá",
    "customers.label.FeaturesForEndUsersWithDisabilities":
      "Tính năng dành cho người dùng khuyết tật",
    "customers.label.InformationSupportServices":
      "Thông tin hỗ trợ dịch vụ của chúng tôi có sẵn ở các định dạng thay thế. Nếu bạn muốn truy cập thông tin dưới định dạng khác, vui lòng gọi số 1200 qua SIM Lycamobile hoặc truy cập",
    "customers.label.HowWeUseYourInformation":
      "Cách chúng tôi sử dụng thông tin của bạn",
    "customers.label.InformationUsageDetails":
      "Chúng tôi sẽ thu thập thông tin về cách bạn sử dụng Dịch vụ của chúng tôi cũng như các dịch vụ của bên thứ ba liên quan, bao gồm vị trí và hoạt động tài khoản của bạn, để nâng cao trải nghiệm tổng thể của bạn.",
    "customers.label.CustomerComplaints":
      "Nếu bạn không hài lòng với tốc độ, chất lượng hoặc các yếu tố khác của dịch vụ và muốn khiếu nại, vui lòng liên hệ với Dịch vụ Khách hàng.",
    "customers.label.DisputeResolution":
      "Nếu chúng tôi không thể giải quyết khiếu nại của bạn, bạn có thể nộp khiếu nại trong vòng 12 tháng tới Ủy ban Giải quyết Tranh chấp Dịch vụ Viễn thông.",
    "customers.label.costsEuro": "chi phí €",
    "customers.label.thereafterEuro": "sau đó €",
    "customers.label.forTheFirst": "cho lần đầu tiên",
    "customers.label.perMonthInclusiveVAT":
      "mỗi tháng, bao gồm VAT (có thể tăng hàng năm theo CPI+3,9%). Xem trang web để biết thêm chi tiết.",
    "customers.label.additionalAddOns":
      "Các tiện ích bổ sung có thể có sẵn cho gói cước của bạn và sẽ được tính phí riêng trên hóa đơn của bạn.",
    "customers.label.paymentTerms":
      "Bạn phải thanh toán phí dịch vụ mà bạn đăng ký và/hoặc sử dụng hàng tháng trước ngày đến hạn trên hóa đơn. Chúng tôi có thể tính phí nếu bạn thanh toán chậm. Chúng tôi có thể yêu cầu đặt cọc trước khi cho phép bạn sử dụng dịch vụ. Vui lòng xem Điều khoản giá cước và trang web của chúng tôi để biết thêm chi tiết về các mức giá cụ thể và các khoản phí ngoài gói.",
    "customers.label.durationRenewalTermination":
      "Thời hạn, gia hạn và chấm dứt",
    "customers.label.minimumPeriod":
      "Có thời hạn tối thiểu là 1 tháng và sẽ tiếp tục hàng tháng sau đó cho đến khi bạn chấm dứt bằng thông báo trước 30 ngày (trừ khi có quy định pháp luật hoặc quy tắc khác) và bạn sẽ phải thanh toán các khoản phí phát sinh trong thời gian thông báo này.",
    "customers.label.cancellationCoolingOff":
      "Nếu bạn thay đổi quyết định về dịch vụ đã mua trực tiếp từ chúng tôi, bạn có thể có quyền hủy Hợp đồng Dịch vụ trong vòng 14 ngày làm mát.",
    "customers.label.earlyTerminationCharge":
      "Bạn đồng ý rằng dịch vụ sẽ bắt đầu ngay lập tức nếu bạn đã có thẻ SIM hoặc khi bạn nhận được thẻ SIM. Nếu bạn muốn chấm dứt Hợp đồng Dịch vụ trong thời gian tối thiểu hoặc chúng tôi chấm dứt Hợp đồng Dịch vụ do bạn vi phạm nghiêm trọng, bạn sẽ phải trả Phí Chấm Dứt Sớm không vượt quá phí đăng ký hàng tháng nhân với số tháng còn lại trong thời gian tối thiểu của bạn, bao gồm VAT (tính theo tỷ lệ hiện hành), trừ một tỷ lệ phần trăm cho một khoản thanh toán cuối cùng duy nhất. Bạn cũng sẽ phải thanh toán cho bất kỳ cuộc gọi, tin nhắn, dữ liệu và các khoản phí khác đã phát sinh, bao gồm cả trong giai đoạn làm mát.",
    "customers.label.ContractSummarys":
      "Tóm tắt hợp đồng này và dịch vụ quốc tế Lớn trong 1 tháng của chúng tôi cho phép bạn thực hiện và nhận cuộc gọi thoại, gửi và nhận tin nhắn SMS, sử dụng dữ liệu và truy cập Internet, thông qua mạng, cùng với bất kỳ dịch vụ bổ sung nào mà chúng tôi đồng ý cung cấp và bạn chọn nhận.",
    "customers.label.The": "Cái này",
    "customers.label.ComesWith": "Đi kèm với:",
    "customers.label.MobileDataSpeeds": "Tốc độ dịch vụ dữ liệu di động",
    "customers.label.DataServiceDescription":
      "Dịch vụ dữ liệu và tốc độ tối thiểu và tối đa có sẵn qua mạng Lycamobile dựa trên công nghệ truy cập (2G, Edge, 3G, 4G, 5G), vị trí của bạn, thiết bị sử dụng và gói cước đã mua.",
    "customers.label.SpeedVariation":
      "Tốc độ dữ liệu di động của bạn có thể thay đổi và phụ thuộc vào vị trí của bạn, môi trường xung quanh (thời tiết, cây cối, vật liệu xây dựng) và số người sử dụng mạng.",
    "customers.label.LycamobileBV": "Lycamobile B.V.",
    "customers.label.Robijnlaan17": "Robijnlaan 17,",
    "customers.label.2132WXHoofddorp": "2132WX Hoofddorp,",
    "customers.label.TheNetherlands": "Hà Lan",
    "customers.label.ContractSummary": "Tóm tắt hợp đồng",
    "customers.label.ContractSummaryDescription1":
      "Bản tóm tắt hợp đồng này cung cấp các yếu tố chính của dịch vụ được đề xuất theo yêu cầu của pháp luật.",
    "customers.label.ContractSummaryDescription2":
      "Nó giúp so sánh các dịch vụ khác nhau.",
    "customers.label.ContractSummaryDescription3":
      "Thông tin đầy đủ về dịch vụ có trong các tài liệu khác.",
    "customers.label.ContractSummaryValidity":
      "Bản tóm tắt hợp đồng này có hiệu lực đến khi thanh toán hết hạn vào",
    "customers.label.AcceptOffer":
      "Nếu ưu đãi này phù hợp, bạn có thể chấp nhận nó qua trang thanh toán. Vui lòng lưu một bản sao của tài liệu này để tham khảo.",
    "customers.label.Services": "Dịch vụ",
    "customers.label.TermsConditions":
      "Theo Điều khoản và Điều kiện của Thỏa thuận Dịch vụ, nếu chúng tôi vi phạm một điều khoản quan trọng của Thỏa thuận khiến chúng tôi không thể cung cấp dữ liệu cho bạn và không khắc phục trong vòng 7 ngày sau khi nhận được khiếu nại từ Dịch vụ Khách hàng Lycamobile, bạn có thể chấm dứt thỏa thuận.",
    "customers.label.EmergencyOrganisations":
      "Tổ chức khẩn cấp và thông tin vị trí người gọi",
    "customers.label.EmergencyCallNetworkDown":
      "Nếu bạn cần thực hiện cuộc gọi khẩn cấp/112/999 khi mạng Lycamobile không hoạt động hoặc không khả dụng, thiết bị của bạn phải có khả năng kết nối với mạng 2G, 3G, 4G hoặc 5G và có thể chọn mạng đối thủ có vùng phủ sóng để truy cập cuộc gọi khẩn cấp.",
    "customers.label.EmergencyCallAvailability":
      "Chỉ có thể thực hiện cuộc gọi khẩn cấp khi có mạng radio khả dụng.",
    "customers.label.PlanName": "Tên gói cước",
    "customers.label.EuropeanOnlineDisputeResolution":
      "Trang giải quyết tranh chấp trực tuyến của Châu Âu",
    "customers.label.ECWebsite": "ec.europa.eu/consumers/odr",
    "customers.label.DisputeResolutionDetails":
      "cho phép người tiêu dùng gửi tranh chấp liên quan đến mua hàng trực tuyến với chúng tôi. Bạn có thể kiểm tra trang web của chúng tôi để xem bản sao của Quy tắc thực hành về khiếu nại và thông tin mới nhất của chúng tôi về các giải pháp thay thế để giải quyết tranh chấp. Chúng tôi ở đây để giúp đỡ. Nếu có vấn đề gì xảy ra, chúng tôi muốn khắc phục. Bạn có thể tìm hiểu thêm về quy trình khiếu nại của chúng tôi trong Quy tắc thực hành khiếu nại khách hàng của chúng tôi.",
    "customers.label.NetherlandsLawCompliance":
      "Trong trường hợp có sự khác biệt liên tục và/hoặc thường xuyên giữa hiệu suất thực tế của dịch vụ truy cập Internet về tốc độ, theo luật của Hà Lan, Lycamobile sẽ cung cấp dịch vụ lại trong thời gian hợp lý. Nếu không thể cung cấp lại dịch vụ, Lycamobile sẽ giảm giá hợp lý cho khách hàng. Nếu khách hàng đã thanh toán, Lycamobile sẽ hoàn tiền phần giá trị vượt quá.",
    "customers.label.DirectoryServiceInfo":
      "Bạn có thể yêu cầu chúng tôi đưa số điện thoại di động của bạn vào danh bạ điện thoại và/hoặc dịch vụ tra cứu danh bạ.",
    "customers.label.RemediesComplaints":
      "Biện pháp khắc phục, xử lý khiếu nại và giải quyết tranh chấp",
    "customers.label.ContactCustomerService":
      "Nếu bạn cần liên hệ với dịch vụ khách hàng, vui lòng truy cập trang web và nhấp vào 'Liên hệ với chúng tôi'.",
    "customers.label.IncludeMobileNumber":
      "Vui lòng bao gồm số điện thoại di động của bạn nếu bạn viết thư cho chúng tôi.",
    "customers.label.Termination": "Chấm dứt",
    "customers.label.TerminationNotice":
      "Sau thời gian tối thiểu, bạn có thể chấm dứt Thỏa thuận bằng cách thông báo cho chúng tôi và bạn sẽ phải thanh toán các khoản phí phát sinh trong thời gian thông báo này.",
    "customers.label.EarlyTerminationCharge":
      "Trừ khi có quy định khác (ví dụ: trong Điều khoản Gói cước của bạn), nếu bạn muốn chấm dứt Hợp đồng Dịch vụ trong thời gian tối thiểu hoặc chúng tôi chấm dứt hợp đồng do bạn vi phạm nghiêm trọng, bạn sẽ phải trả Phí Chấm dứt Sớm bằng với Phí thuê bao hàng tháng nhân với số tháng còn lại trong Thời gian Tối thiểu.",
    "customers.label.OptionalAddOnTermination":
      "Bất kỳ Dịch vụ Tùy chọn nào cũng sẽ bị chấm dứt độc lập với bất kỳ Gói hàng tháng nào.",
    "customers.label.CancellationInfo":
      "Bạn có quyền hủy đơn đặt hàng trong vòng 14 ngày sau khi đặt hàng dịch vụ.",
    "customers.label.Security": "Bảo mật",
    "customers.label.DataProtection":
      "Thông tin cá nhân của bạn sẽ được bảo vệ theo Chính sách Quyền riêng tư của chúng tôi.",
    "customers.label.TariffTerms":
      "Vui lòng xem Điều khoản Giá cước và trang web của chúng tôi để biết thêm chi tiết về giá cước cụ thể và các khoản phí ngoài gói.",
    "customers.label.DeliveryOfService": "Cung cấp dịch vụ",
    "customers.label.PaymentTerms":
      "Chúng tôi sẽ ghi nợ số tiền bạn cần trả từ tài khoản của bạn bằng ghi nợ trực tiếp SEPA. Trừ khi có thỏa thuận khác...",
    "customers.label.ServiceStartDate":
      "Ngày Lycamobile cung cấp dịch vụ là ngày bạn đăng ký với Lycamobile.",
    "customers.label.ContractDuration":
      "Thời hạn, gia hạn và chấm dứt Thỏa thuận Dịch vụ",
    "customers.label.MinimumPeriod":
      "Gói đăng ký của bạn có thời hạn tối thiểu gọi là Thời hạn tối thiểu, có thể là 1 tháng cho Gói hàng tháng và 24 tháng cho Hợp đồng có thời hạn.",
    "customers.label.ContractRenewal":
      "Để gia hạn hợp đồng, bạn phải thông báo cho Lycamobile trong thời gian hợp đồng trước của bạn, đồng ý gia hạn hợp đồng.",
    "customers.label.DataCostDetails":
      "Gói dữ liệu {40GB} có giá {18.90 €} trong {3 tháng} đầu tiên, sau đó là {27.00 €} mỗi tháng, bao gồm VAT (có thể tăng hàng năm theo CPI + 3.9%). Xem thêm chi tiết trên trang web của chúng tôi.",
    "customers.label.AdditionalAddons":
      "Các Add-ons bổ sung có thể có sẵn cho gói của bạn và sẽ được tính phí riêng.",
    "customers.label.SpendingLimits": "Giới hạn chi tiêu",
    "customers.label.SpendingLimitDetails":
      "Lycamobile sẽ đặt giới hạn chi tiêu tối đa €250 theo sở thích của bạn.",
    "customers.label.PremiumCharges":
      "Các cuộc gọi hoặc tin nhắn đến số ngắn và cuộc gọi quốc tế không bao gồm trong gói và sẽ được tính phí theo biểu giá riêng.",
    "customers.label.InternationalRates":
      "Cuộc gọi và tin nhắn từ Hà Lan đến các quốc gia khác sẽ bị tính theo mức giá quốc tế tiêu chuẩn.",
    "customers.label.RoamingInEEA": "Chuyển vùng trong EEA",
    "customers.label.RoamingOutsideEEA": "Chuyển vùng ngoài EEA",
    "customers.label.RoamingCharges":
      "Sử dụng điện thoại của bạn (gọi, nhắn tin và dữ liệu) khi chuyển vùng ngoài Hà Lan hoặc EEA sẽ bị tính theo mức giá chuyển vùng quốc tế.",
    "customers.label.Any_Out_of_bundle_charges_can_be_found_at":
      "Bất kỳ phí vượt gói nào có thể tìm thấy tại:",
    "customers.label.Exclusions_for_voice_international_voice_SMS_Data_Roaming_can_be_found_at":
      "Các ngoại lệ đối với thoại, thoại quốc tế, SMS, Chuyển vùng dữ liệu có thể tìm thấy tại:",
    "customers.label.Our_Services_availability":
      "Dịch vụ của chúng tôi không có sẵn ở mọi nơi tại Hà Lan, EEA hoặc các điểm đến khác được chọn. Việc sử dụng hợp lý dịch vụ của chúng tôi được bao gồm trong Chính sách Sử dụng Công bằng Nội địa và Chuyển vùng tại:",
    "customers.label.Lycamobile_network_speeds":
      "Dịch vụ dữ liệu và tốc độ tối thiểu và tối đa có sẵn qua mạng Lycamobile phụ thuộc vào công nghệ có sẵn (2G, Edge, 3G, 4G, 5G) tại vị trí của bạn, thiết bị bạn đang sử dụng và loại gói bạn đã mua.",
    "customers.label.Mobile_data_speed_variation":
      "Tốc độ dịch vụ dữ liệu di động của bạn có thể thay đổi và phụ thuộc vào vị trí của bạn, môi trường xung quanh (thời tiết, cây cối, vật liệu xây dựng của các tòa nhà bạn đang ở hoặc gần đó và số lượng người sử dụng mạng) và thiết bị được sử dụng để kết nối với mạng.",
    "customers.label.Price": "Giá",
    "customers.label.ContractReview": "Xem xét hợp đồng",
    "customers.label.Terms&Conditions": "Điều khoản & Điều kiện",
    "customers.label.ReviewThisContract": "Xem lại hợp đồng này",
    "customers.label.We_have_sent_these_to":
      "Chúng tôi đã gửi những điều này đến",
    "customers.label.DownloadContractInformation":
      "Tải xuống thông tin hợp đồng",
    "customers.label.DownloadContractSummary": "Tải xuống bản tóm tắt hợp đồng",
    "customers.label.ContractInformation": "Thông tin hợp đồng",
    "customers.label.ContactDetails": "Chi tiết liên hệ",
    "customers.label.Description_of_Services": "Mô tả dịch vụ",
    "customers.label.This_contract_summary_and_our_Abonnement_offer_of":
      "Bản tóm tắt hợp đồng này và ưu đãi dịch vụ của chúng tôi",
    "customers.label.an_airtime_service_for": "Dịch vụ thời gian gọi điện cho",
    "customers.label.comes_with:": "Bao gồm:",
    "customers.label.Any_Out_of_bundle_charges_can_be_found_at:":
      "Các khoản phí ngoài gói có thể được tìm thấy tại:",
    "customers.label.service_description":
      "Dịch vụ này cho phép bạn thực hiện và nhận cuộc gọi thoại, gửi và nhận tin nhắn SMS, sử dụng dữ liệu và truy cập Internet, cùng với các dịch vụ bổ sung mà bạn chọn đăng ký.",
    "customers.label.YouHaveChosenNoCap":
      "Bạn đã chọn không giới hạn. Điều này có nghĩa là bạn có thể sử dụng điện thoại để gọi điện, nhắn tin, phút quốc tế, chuyển vùng và dữ liệu ngoài gói cước hàng tháng. Bạn sẽ bị tính phí lên đến 60 €.",
    "customers.label.SelectDate":
      "Chọn Ngày [Thanh toán hàng tháng sẽ được ghi nợ từ tài khoản của bạn sau 14 ngày kể từ ngày tạo hóa đơn bạn đã chọn] *",
    "customers.label.BillingCycle": "chu kỳ thanh toán",
    "customers.label.SelectBilling": "Chọn thanh toán",
    "customers.label.I_Agree_To": "Tôi đồng ý với",
    "customers.label.TermsAndConditions": "Điều khoản và Điều kiện",
    "customers.label.ThisNumberIsReservedFor": "Số này được dành riêng cho",
    "customers.label.TotalPrice": "Tổng giá:",
    "customers.label.CustomerInfo": "Thông tin khách hàng",
    "customers.label.title": "Tiêu đề",
    "customers.label.SelectTitle": "Chọn tiêu đề",
    "customers.label.initials": "Chữ viết tắt",
    "customers.label.Basket": "Giỏ hàng",
    "customers.label.first_name": "Tên",
    "customers.label.last_name": "Họ",
    "customers.label.email_address": "Địa chỉ email",
    "customers.label.contact_number": "Số liên hệ",
    "customers.label.date_of_birth": "Ngày sinh",
    "customers.label.select_language": "Chọn ngôn ngữ",
    "customers.label.how_did_you_hear": "Bạn biết đến chúng tôi bằng cách nào?",
    "customers.label.postal_code": "Mã bưu điện",
    "customers.label.country": "Quốc gia",
    "customers.label.Enter_address_manually": "Nhập địa chỉ thủ công",
    "customers.label.Find_address": "Tìm địa chỉ",
    "customers.label.Select_Address": "Chọn địa chỉ",
    "customers.label.Select_an_address": "Chọn một địa chỉ",
    "customers.label.Enter_address_dynamically": "Nhập địa chỉ tự động",
    "customers.label.address_number": "Số nhà",
    "customers.label.street": "Đường",
    "customers.label.state": "Tỉnh/Thành phố",
    "customers.label.city": "Thành phố",
    "customers.label.resident_period": "Thời gian cư trú",
    "customers.label.Spend_Cap_Amount": "Hạn mức chi tiêu",
    "customers.label.I_don’t_want_a_Spend_Cap":
      "Tôi không muốn giới hạn chi tiêu",
    "customers.label.Monthly_Bill_Generation_Date":
      "Ngày tạo hóa đơn hàng tháng",
    "customers.label.Select_a_Monthly_Plan": "Chọn gói hàng tháng",
    "customers.label.Search_plans": "Tìm kiếm gói...",
    "customers.label.search": "Tìm kiếm",
    "customers.label.Select_a_plan": "Chọn gói",
    "customers.label.Basket": "Giỏ hàng",
    "customers.label.This_number_is_reserved_for": "Số này được dành cho",
    "customers.label.ViewT&C": "Xem điều khoản và điều kiện",
    "customers.label.TransferringFromPreviousNetwork":
      "Chuyển từ mạng trước đó (Giữ số cũ của bạn)",
    "customers.label.Gender": "Giới tính",
    "customers.label.business_name": "Tên doanh nghiệp",
    "customers.label.phone_number": "Số điện thoại",
    "customers.label.Date_of_Birth": "Ngày sinh",
    "customers.label.VIP": "VIP",
    "customers.label.Disability": "Khuyết tật",
    "customers.label.District": "Quận/Huyện",
    "customers.label.Is_your_billing_address_same_as_primary_address":
      "Địa chỉ thanh toán của bạn có giống với địa chỉ chính không?",
    "customers.label.Supressbill": "Ẩn hóa đơn",
    "customers.label.SelectCategory": "Chọn danh mục",
    "customers.label.SelectGender": "Chọn giới tính",
    "customers.label.SelectPreferences": "Chọn tùy chọn",
    "customers.label.SelectNationality": "Chọn quốc tịch",
    "customers.label.SelectVIP": "Chọn VIP",
    "customers.label.SelectDisability": "Chọn khuyết tật",
    "customers.label.SelectCity": "Chọn thành phố",
    "customers.label.SelectBillDay": "Chọn ngày lập hóa đơn",
    "customers.label.SelectType": "Chọn loại",
    "customers.label.SelectFiscalYear": "Chọn năm tài chính",
    "customers.label.SelectFiscalQuarter": "Chọn quý tài chính",
    "customers.label.SelectBillMode": "Chọn phương thức thanh toán",
    "customers.label.SelectInvoiceType": "Chọn loại hóa đơn",
    "customers.label.IMSI": "IMSI",
    "customers.label.SalesMotion": "Chuyển động bán hàng",
    "customers.label.SpendCap": "Hạn mức chi tiêu",
    "customers.label.ActivationDate": "Ngày kích hoạt",
    "customers.label.ExpiryDate": "Ngày hết hạn",
    "customers.label.NextRenewalDate": "Ngày gia hạn tiếp theo",
    "customers.label.BalanceTransfer": "Chuyển số dư",
    "customers.label.RecieverClientId": "ID khách hàng nhận",
    "customers.label.Amount": "Số tiền",
    "customers.label.EnterTopUpAmount": "Nhập số tiền nạp",
    "customers.label.ResponseId": "ID phản hồi",
    "customers.label.BalanceName": "Tên số dư",
    "customers.label.Allowance": "Hạn mức",
    "customers.label.Consumption": "Tiêu dùng",
    "customers.label.AvailableBalance": "Số dư khả dụng",
    "customers.label.DaysLeft": "Số ngày còn lại",
    "customers.label.Discount": "Giảm giá",
    "customers.label.postal_code": "Mã bưu chính",
    "customers.label.address_number": "Số địa chỉ",
    "customers.label.city": "Thành phố",
    "customers.label.state": "Tiểu bang",
    "customers.label.country": "Quốc gia",
    "customers.label.comment_date": "Ngày bình luận",
    "customers.label.resident_period": "Thời gian cư trú",
    "customers.label.postcode": "Mã bưu chính",
    "customers.label.how_did_you_hear": "Bạn biết về chúng tôi như thế nào?",
    "customers.label.select_language": "Chọn ngôn ngữ",
    "customers.label.email_address": "Địa chỉ Email",
    "customers.label.contact_number": "Số liên lạc",
    "customers.label.initials": "Chữ cái đầu",
    "customers.label.communication_type": "Loại Truyền Thông",
    "customers.label.BuySIM": "Mua SIM",
    "customers.label.origination": "Nguồn gốc",
    "customers.label.address": "Địa chỉ",
    "customers.label.destination_address": "Địa chỉ đích",
    "customers.label.event": "Sự kiện",
    "customers.label.charge_party": "Bên Tính Phí",
    "customers.label.service_subs_type": "Loại Thuê Bao Dịch Vụ",
    "customers.label.calling_party": "Bên Gọi",
    "customers.label.called_party": "Bên Nhận Gọi",
    "customers.label.usage": "Sử Dụng",
    "customers.label.monetary_charge": "Phí Tiền Tệ",
    "customers.label.result_code": "Mã Kết Quả",
    "customers.label.generation_time": "Thời Gian Tạo",
    "customer.label.generationdatetime": "ထုတ်လုပ်သည့် ရက်စွဲနှင့် အချိန်",
    "customers.label.transaction_id": "ID Giao Dịch",
    "customers.label.application_transaction_id": "ID Giao Dịch Ứng Dụng",
    "customers.label.application_name": "Tên Ứng Dụng",
    "customers.label.recharge_value": "Giá Trị Nạp Tiền",
    "customers.label.interface": "Giao Diện",
    "customers.label.result": "Kết Quả",
    "customers.label.comment": "Bình Luận",
    "customers.label.recharge": "Nạp Tiền",
    "customers.label.cdr": "CDR",
    "customers.label.notifications": "Thông Báo",
    "customers.label.mobile_no": "Enter Mobile No",
    "customers.label.email_id": "Enter Email Id",
    "customers.label.serial_number": "Serial No",
    "customers.label.digital_content": "Nội dung số",
    "customers.label.buySim": "Mua SIM",
    "customers.label.outstanding_due": "Số Dư Đến Hạn",
    "customers.label.due_date": "Ngày Đến Hạn",
    "customers.label.unbilled_amount": "Số Tiền Chưa Xuất Hóa Đơn",
    "customers.label.next_bill_day": "Ngày Hóa Đơn Tiếp Theo",
    "customers.label.view_allowances": "Xem Trợ Cấp",
    "customers.label.view_service_details": "Xem chi tiết dịch vụ",
    "customers.label.spend_limit": "Giới Hạn Chi Tiêu",
    "customers.label.topup_balance": "Nạp Tiền",
    "customers.label.next_renewal_date": "Ngày Gia Hạn Tiếp Theo",
    "customers.label.allowance": "Trợ Cấp",
    "customers.label.ViewDocumentUpload": "Xem tài liệu tải lên",
    "customers.label.total_net_amount": "Tổng Số Tiền Ròng",
    "customers.label.cancelRemark": "Hủy nhận xét",
    "customers.label.cancelPayment": "Hủy thanh toán",
    "customers.label.all": "tất cả",
    "customers.label.billProfile": "Hồ sơ Hóa đơn",
    "customers.label.charges": "Phí",
    "customers.label.book_order": "Đặt Hàng Sách",
    "customers.label.customers": "Khách hàng",
    "customers.label.search_for_clients": "Tìm kiếm Khách hàng",
    "customers.label.advance_search": "Tìm kiếm Nâng cao",
    "customers.label.create_customer": "Tạo Khách hàng",
    "customers.label.account_no": "Số tài khoản",
    "customers.label.customer_name": "Tên Khách hàng",
    "customers.label.business_entity": "Thực thể Kinh doanh",
    "customers.label.balance": "Số dư",
    "customers.label.created_by": "Tạo bởi",
    "customers.label.created_on": "Tạo vào",
    "customers.label.credit_limit": "Hạn mức tín dụng",
    "customers.label.transaction_history": "Lịch sử giao dịch",
    "customers.label.external_activity_log": "Nhật ký hoạt động bên ngoài",
    "customers.label.settings": "Cài đặt",
    "system.label.currency_noncurrency": "Tiền tệ Không phải tiền tệ",
    "entity.label.configure": "Cấu hình",

    "customers.label.valid_from": "Có hiệu lực từ",
    "customers.label.valid_to": "Có hiệu lực đến",
    "customers.label.non_currency_details": "Chi tiết phi tiền tệ",
    "customers.label.view_details": "Xem chi tiết",
    "customers.label.status": "Trạng thái",
    "customers.label.first_name": "Tên",
    "customers.label.price_discount": "Giá & Giảm giá",
    "customers.label.collection_status": "Trạng thái thu thập",
    "customers.label.last_name": "Họ",
    "customers.label.city_area": "Thành phố/Khu vực",
    "customers.label.email": "Email",
    "customers.label.phone": "Điện thoại",
    "customers.label.cafid": "CAF Id",
    "customers.label.enter_business_entity": "Nhập thực thể kinh doanh",
    "customers.label.select": "Chọn",
    "customers.label.refund": "Hoàn tiền",
    "customers.label.refund_id": "Mã hoàn tiền",
    "customers.label.refund_amount": "Số tiền hoàn lại",
    "customers.label.select_category_type": "Chọn loại danh mục",
    "customers.label.clear": "Xóa",
    "customers.label.search": "Tìm kiếm",
    "customers.label.customer_activation": "Kích hoạt Khách hàng",
    "customers.label.customer_details": "Chi tiết Khách hàng",
    "customers.label.loc": "LOC",
    "customers.label.customer_category": "Danh mục Khách hàng",
    "customers.label.service_details": "Chi tiết Dịch vụ",
    "customers.label.name": "Tên",
    "customers.label.add_service": "Thêm Dịch vụ",
    "customers.label.network_node": "Nút Mạng",
    "customers.label.device_details": "Chi tiết Thiết bị",
    "customers.label.serial_no": "Số Serial",
    "customers.label.item": "Mục",
    "customers.label.discount_code": "Mã Giảm giá",
    "customers.label.total_price": "Tổng Giá",
    // "customers.label.device_details": "Chi tiết Thiết bị",
    "customers.label.plan_details": "Chi tiết Kế hoạch",
    "customers.label.payment_details": "Chi tiết thanh toán",
    "customers.label.plan_list": "Danh sách Kế hoạch",
    "customers.label.plan": "Kế hoạch",
    "customers.label.contract_period": "Thời hạn Hợp đồng",
    "customers.label.charge_cycle": "Chu kỳ tính phí",
    "customers.label.cancel": "Hủy",
    "customers.label.next": "Tiếp theo",
    "customers.label.done": "Hoàn tất",
    "customers.label.reopen": "Mở lại",
    "customers.label.submit": "Gửi",
    "customers.label.view_customer": "Xem Khách hàng",
    "customers.label.account_number": "Số tài khoản",
    "customers.label.office_hierarchy": "Cấp bậc văn phòng",
    "customers.label.account_type": "Loại tài khoản",
    // "customers.label.balance": "Số dư",
    "customers.label.stb_serial_no": "Số Serial STB",
    "customers.label.non_currency_balance": "Số dư không tiền tệ",
    "customers.label.service_orders": "Đơn dịch vụ",
    "customers.label.more_info": "Thông tin thêm",
    "customers.label.notes": "Ghi chú",
    "customers.label.device": "Thiết bị",
    "customers.label.tickets": "Vé",
    "customers.label.on_demand": "Theo yêu cầu",
    "customers.label.on_demand_billing": "Thanh toán theo yêu cầu",
    "customers.label.payments": "Thanh toán",
    "customers.label.invoice": "Hóa đơn",
    "customers.label.contact_information": "Thông tin liên hệ",
    "customers.label.address_information": "Thông tin địa chỉ",
    "customers.label.billing_information": "Thông tin thanh toán",
    "customers.label.balance_information": "Thông tin số dư",
    // "customers.label.customer_name": "Tên khách hàng",
    "customers.label.parent_child": "Cha/Mẹ",
    "customers.label.created_date": "Ngày tạo",
    "customers.label.district": "Quận",
    "customers.label.pincode": "Mã bưu chính",
    "customers.label.last_bill_amount": "Số tiền hóa đơn cuối cùng",
    "customers.label.last_bill_date": "Ngày hóa đơn cuối cùng",
    "customers.label.last_bill_paid": "Hóa đơn cuối cùng đã thanh toán",
    "customers.label.last_paid_amount": "Số tiền đã thanh toán lần cuối",
    "customers.label.last_payment_date": "Ngày thanh toán cuối cùng",
    "customers.label.next_bill_date": "Ngày hóa đơn tiếp theo",
    "customers.label.service_overview": "Tổng quan dịch vụ",
    "customers.label.service_without_device": "Dịch vụ không có thiết bị",
    "customers.label.create_ticket": "Tạo ticket",
    "customers.label.service_activation": "Kích hoạt dịch vụ",
    "customers.label.order_charging": "Đơn hàng sạc",
    "customers.label.top_up": "Nạp tiền",
    "customers.label.redeem": "Đổi điểm",
    "customers.label.collection_name": "Tên bộ sưu tập",
    "customers.label.redeem_voucher": "Đổi phiếu thưởng",
    "customers.label.service_id": "ID Dịch vụ",
    "customers.label.service_code": "Mã Dịch vụ",
    "customers.label.service_description": "Mô tả Dịch vụ",
    "customers.label.start_date": "Ngày bắt đầu",
    "customers.label.modified_date": "Ngày sửa đổi",
    // "customers.label.status": "Trạng thái",
    "customers.label.info": "Thông tin",
    "customers.label.action": "Hành động",
    "customers.label.add_device": "Thêm Thiết bị",
    "customers.label.add_plans": "Thêm Kế hoạch",
    "customers.label.suspend": "Đình chỉ",
    "customers.label.reactivate": "Kích hoạt lại",
    "customers.label.terminate": "Chấm dứt",
    "customers.label.command_center": "Trung tâm điều khiển",
    "customers.label.retrack": "Theo dõi lại",
    "customers.label.cancel_plans": "Hủy Kế hoạch",
    "customers.label.device_overview": "Tổng quan Thiết bị",
    "customers.label.item_code": "Mã Sản phẩm",
    "customers.label.orders_overview": "Tổng quan đơn hàng",
    // "customers.label.plan": "Kế hoạch",
    "customers.label.end_date": "Ngày kết thúc",
    "customers.label.price": "Giá",
    "customers.label.short_description": "Mô tả ngắn",
    "customers.label.description": "Mô tả",
    "customers.label.add_note": "Thêm Ghi chú",
    "customers.label.note": "Ghi chú",
    "customers.label.sale_type": "Loại Bán hàng",
    "customers.label.bill_item_details": "Chi tiết mục hóa đơn",
    "customers.label.charge_id": "Mã phí",
    "customers.label.order_id": "Mã đơn hàng",
    "customers.label.item_tax_details": "Chi tiết thuế mặt hàng",
    "customers.label.discount_details": "Chi tiết giảm giá",
    "customers.label.sale_date": "Ngày Bán hàng",
    "customers.label.charge_code": "Mã phí",
    "customers.label.quantity": "Số lượng",
    // "customers.label.total_price": "Tổng giá",
    "customers.label.warranty_date": "Ngày Bảo hành",
    "customers.label.allocate": "Phân bổ",
    "customers.label.contact_info": "Thông tin Liên hệ",
    "customers.label.edit_customer": "Chỉnh sửa Khách hàng",
    "customers.label.lco": "LCO",
    "customers.label.title": "Tiêu đề",
    // "customers.label.customer_category": "Danh mục Khách hàng",
    "customers.label.middle_name": "Tên Đệm",
    "customers.label.caf_id": "CAF Id",
    "customers.label.landline_number": "Số điện thoại cố định",
    "customers.label.user_name": "Tên người dùng",
    "customers.label.customer_photo": "Ảnh Khách hàng",
    "customers.label.id_proof": "Chứng minh nhân dân",
    "customers.label.id_proof_value": "Giá trị chứng minh nhân dân",
    "customers.label.save": "Lưu",
    "customers.label.close_customer": "Đóng Khách hàng",
    "customers.label.closure_date": "Ngày Đóng",
    "customers.label.closure_reason": "Lý Do Đóng",
    "customers.label.close": "Đóng",
    "customers.label.address_info": "Thông Tin Địa chỉ",
    "customers.label.edit_address": "Chỉnh Sửa Địa chỉ",
    "customers.label.address_no": "Số Địa chỉ",
    "customers.label.street": "Đường",
    "customers.label.building": "Tòa nhà",
    "customers.label.zipcode": "Mã bưu chính",
    "customers.label.billing": "Thanh toán",
    "customers.label.same_as_primary": "Giống như Chính",
    "customers.label.building_code": "Mã Tòa nhà",
    "customers.label.add_address": "Thêm Địa chỉ",
    "customers.label.address_type": "Loại Địa chỉ",
    "customers.label.billing_info": "Thông Tin Thanh toán",
    "customers.label.created_adjustment": "Điều chỉnh Đã Tạo",
    "customers.label.create_order": "Tạo Đơn hàng",
    "customers.label.sale_catalog": "Danh mục Bán hàng",
    "customers.label.renew_plan": "Gia hạn gói",
    "customers.label.auto_renew": "Tự động Gia hạn",
    // "customers.label.search": "Tìm kiếm",
    "customers.label.entity_name": "Tên thực thể",
    "customers.label.discount": "Giảm giá",
    "customers.label.provisioning_commands": "Lệnh cung cấp",
    "customers.label.command": "Lệnh",
    "customers.label.plans": "Kế hoạch",
    "customers.label.client_service_detail": "Chi tiết Dịch vụ Khách hàng",
    "customers.label.id": "Id",
    "customers.label.parameter_name": "Tên Tham số",
    "customers.label.parameter_value": "Giá trị Tham số",
    "customers.label.request_type": "Loại Yêu Cầu",
    "customers.label.client_info": "Thông Tin Khách Hàng",
    "customers.label.service_info": "Thông Tin Dịch Vụ",
    "customers.label.new_device_info": "Thông Tin Thiết Bị Mới",
    "customers.label.task_list": "Danh Sách Công Việc",
    "customers.label.provisioning_detail": "Chi Tiết Cấu Hình",
    "customers.label.provisioning_id": "ID Cấu Hình",
    "customers.label.task_id": "ID Công Việc",
    "customers.label.sent_message": "Tin Nhắn Đã Gửi",
    "customers.label.available_plans": "Kế hoạch có sẵn",
    "customers.label.disconnect_order": "Đơn ngắt kết nối",
    "customers.label.reason": "Lý do",
    "customers.label.porting_out": "Đang chuyển ra ngoài",
    "customers.label.prepaid_to_postpaid": "Trả trước sang trả sau",
    "customers.label.postpaid_to_prepaid": "Trả sau thành trả trước",
    "customers.label.addons": "Tiện ích bổ sung",
    "customers.label.change_plan": "Thay đổi kế hoạch",
    "customers.label.swap_sim": "Thay SIM",
    "customers.label.select_date": "Chọn ngày",
    "customers.label.order_date": "Ngày Đặt hàng",
    "customers.label.priority": "Ưu tiên",
    "customers.label.ticket_date": "Ngày Ticket",
    "customers.label.category": "Danh mục",
    "customers.label.sub_category": "Danh mục phụ",
    "customers.label.team": "Nhóm",
    "customers.label.team_user": "Người dùng nhóm",
    "customers.label.source": "Nguồn",
    "customers.label.due_time": "Hạn chót",
    "customers.label.device_swap": "Đổi thiết bị",
    // "customers.label.terminate": "Chấm dứt",
    "customers.label.confirm": "Xác nhận",
    "customers.label.continue": "Tiếp tục",
    "customers.label.process_date": "Ngày Xử lý",
    "customers.label.pin_number": "Số PIN",
    "customers.label.renewal": "Gia hạn",
    // "customers.label.create_customer": "Tạo Khách hàng",
    "customers.label.individual": "Cá nhân",
    "customers.label.corporate": "Doanh nghiệp",
    "customers.label.corporate_details": "Chi tiết Doanh nghiệp",
    "customers.label.contact_person": "Người liên hệ",
    "customers.label.entity": "Thực thể",
    "customers.label.client_category": "Danh mục Khách hàng",
    "customers.label.preferences": "Sở thích",
    "customers.label.parent_id": "ID Cha",
    "customers.label.child": "Con",
    "customers.label.villege_street": "Thôn/Đường",
    "customers.label.billing_address": "Địa chỉ Thanh toán",
    "customers.label.bill_information": "Thông tin hóa đơn",
    "customers.label.bill_day_of_month": "Ngày hóa đơn trong tháng",
    "customers.label.fiscal_year": "Năm tài chính",
    "customers.label.fiscal_quater": "Quý tài chính",
    "customers.label.bill_mode": "Chế độ hóa đơn",
    "customers.label.invoice_type": "Loại hóa đơn",
    "customers.label.payment_information": "Thông tin thanh toán",
    "customers.label.funder_name": "Tên người tài trợ",
    "customers.label.funder_id": "ID người tài trợ",
    "customers.label.po_number": "Số đơn đặt hàng",
    "customers.label.payment_term": "Điều khoản thanh toán",
    "customers.label.customer_created_successfully":
      "Tạo khách hàng thành công",
    "customers.label.go_to_customer": "Đi đến khách hàng",
    "customers.label.view_order": "Xem đơn hàng",
    "customers.label.disconnect": "Ngắt kết nối",
    "customers.label.apply_promo": "Áp dụng khuyến mãi",
    // "customers.label.order_id": "ID Đơn hàng",
    "customers.label.order_type": "Loại đơn hàng",
    "customers.label.billing_cycle": "Chu kỳ thanh toán",
    "customers.label.plan_name": "Tên gói cước",
    "customers.label.user_action": "Hành động của người dùng",
    "customers.label.invoice_till_date": "Hóa đơn cho đến ngày",
    "customers.label.order_services": "Dịch vụ đơn hàng",
    "customers.label.service_type": "Loại dịch vụ",
    "customers.label.bill_start_date": "Ngày bắt đầu hóa đơn",
    "customers.label.bill_end_date": "Ngày kết thúc hóa đơn",
    // "customers.label.invoice_till_date": "Hóa đơn cho đến ngày",
    "customers.label.charge_type": "Loại phí",
    "customers.label.rate_uom": "Tỷ lệ/UOM",
    "customers.label.discount_description": "Mô tả giảm giá",
    "customers.label.discount_type": "Loại giảm giá",
    "customers.label.discount_start_date": "Ngày bắt đầu giảm giá",
    "customers.label.discount_end_date": "Ngày kết thúc giảm giá",
    "customers.label.discount_amount": "Số tiền giảm giá",
    "customers.label.order_transaction": "Giao dịch đơn hàng",
    "customers.label.user": "Người dùng",
    "customers.label.transaction_date": "Ngày giao dịch",
    "customers.label.transaction_type": "Loại giao dịch",
    "customers.label.actual_date": "Ngày thực tế",
    "customers.label.promo": "Khuyến mãi",
    "customers.label.promotion": "Khuyến mãi",
    "customers.label.disconnection_date": "Ngày ngắt kết nối",
    "customers.label.disconnection_reason": "Lý do ngắt kết nối",
    "customers.label.problem_code": "Mã vấn đề",
    "customers.label.assign_to": "Giao cho",
    "customers.label.last_comment": "Bình luận gần đây",
    "customers.label.file_name": "Tên tệp",
    "customers.label.edit_ticket": "Chỉnh sửa yêu cầu",
    "customers.label.close_ticket": "Đóng yêu cầu",
    "customers.label.resolution_description": "Mô tả giải quyết",
    "customers.label.ticket_history": "Lịch sử yêu cầu",
    // "customers.label.last_comment": "Bình luận gần đây",
    "customers.label.problem_description": "Mô tả vấn đề",
    "customers.label.generate": "Tạo",
    "customers.label.bill_date": "Ngày hóa đơn",
    "customers.label.amount": "Số tiền",
    "customers.label.statement": "Báo cáo",
    // "customers.label.due_date": "Ngày đến hạn",
    "customers.label.promotional_message": "Thông điệp khuyến mãi",
    "customers.label.download": "Tải xuống",
    "customers.label.due_amount": "Số tiền đến hạn",
    "customers.label.transactions": "Giao dịch",
    "customers.label.file": "Tệp tin",
    "customers.label.reset": "Đặt lại",
    "customers.label.order_details": "Chi tiết đơn hàng",
    "customers.label.make_payment": "Thanh toán",
    "customers.label.credit_amount": "Số dư tín dụng",
    "customers.label.debit_amount": "Số dư nợ",
    "customers.label.cancel_remark": "Ghi chú hủy",
    "customers.label.pay_invoice": "Thanh toán hóa đơn",
    "customers.label.account": "Tài khoản",
    "customers.label.deposit": "Tiền gửi",
    "customers.label.payment_date": "Ngày thanh toán",
    "customers.label.payment_type": "Loại thanh toán",
    "customers.label.receipt_no": "Số biên nhận",
    "customers.label.cheque_no": "Số séc",
    "customers.label.bank_name": "Tên ngân hàng",
    "customers.label.branch_name": "Tên chi nhánh",
    "customers.label.cheque_date": "Ngày séc",
    "customers.label.invoice_id": "ID Hóa đơn",
    "customers.label.invoice_date": "Ngày Hóa đơn",
    "customers.label.invoice_amount": "Số tiền Hóa đơn",
    // "customers.label.due_amount": "Số tiền đến hạn",
    "customers.label.payment_reversal": "Hoàn đổi thanh toán",
    "customers.label.date_filter": "Bộ lọc ngày",
    "customers.label.add_event_order": "Thêm Đơn Đặt Sự Kiện",
    "customers.label.event_order": "Đặt Hàng Sự Kiện",
    "customers.label.eventdate": "Ngày Sự Kiện",
    "customers.label.serviceAddress": "Địa Chỉ Dịch Vụ",
    "customers.label.event_name": "Tên Sự Kiện",
    "customers.label.booked_date": "Ngày Đặt",
    "customers.label.event_price": "Giá Sự Kiện",
    "customers.label.events": "Sự Kiện",
    "customers.label.format_type": "Loại Định Dạng",
    "customers.label.opt_type": "Loại OPT",
    "customers.label.client_bill_profile": "Hồ sơ hóa đơn khách hàng",
    "customers.label.edit": "Chỉnh sửa",
    "customers.label.type": "Loại",
    "customers.label.client_id": "ID Khách hàng",
    "customers.label.bill_currency": "Tiền tệ hóa đơn",
    "customers.label.bill_frequency": "Tần suất hóa đơn",
    "customers.label.bill_segment": "Đoạn hóa đơn",
    // "customers.label.next_bill_day": "Ngày hóa đơn kế tiếp",
    "customers.label.last_bill_day": "Ngày hóa đơn cuối cùng",
    "customers.label.last_bill_no": "Số hóa đơn cuối cùng",
    "customers.label.bill_suppression_flag": "Cờ đè nén hóa đơn",
    "customers.label.bill_suppression_id": "ID đè nén hóa đơn",
    "customers.label.first_bill": "Hóa đơn đầu tiên",
    "customers.label.hot_bill": "Hóa đơn nóng",
    "customers.label.edit_bill_profile": "Chỉnh sửa hồ sơ hóa đơn",
    "customers.label.bill_suppression": "Kiềm chế hóa đơn",
    // "customers.label.more_info": "Thêm thông tin",
    "customers.label.identities": "Nhận dạng",
    "customers.label.add_client_identities": "Thêm danh tính khách hàng",
    "customers.label.unique_identification": "Nhận dạng duy nhất",
    "customers.label.identity_documents": "Tài liệu nhận dạng",
    "customers.label.additional_info": "Thông tin bổ sung",
    "customers.label.nationality": "Quốc tịch",
    "customers.label.date_of_birth": "Ngày sinh",
    "customers.label.preferred_language": "Ngôn ngữ ưa thích",
    "customers.label.finance_id": "ID Tài chính",
    "customers.label.remarks": "Ghi chú",
    "customers.label.preferred_communication": "Giao tiếp ưa thích",
    "customers.label.add_client_identifier": "Thêm định danh khách hàng",
    "customers.label.document_type": "Loại tài liệu",
    "customers.label.document_uploads": "Tải lên tài liệu",
    "customers.label.select_file": "Chọn tệp",
    "customers.label.credit_card_details": "Chi tiết thẻ tín dụng",
    "customers.label.card_number": "Số thẻ",
    "customers.label.cvv": "CVV",
    "customers.label.card_type": "Loại thẻ",
    "customers.label.expiry_date": "Ngày hết hạn",
    "customers.label.ach_card": "Thẻ ACH",
    "customers.label.ach_card_routing_number": "Số định tuyến thẻ ACH",
    "customers.label.bank_account_number": "Số tài khoản ngân hàng",
    "customers.label.childs": "Con cái",
    "customers.label.cell_phone": "Điện thoại di động",
    "customers.label.create_client_additional_info":
      "Tạo thông tin bổ sung cho khách hàng",
    "customers.label.gender": "Giới tính",
    "customers.label.id_type": "Loại ID",
    // "customers.label.nationality": "Quốc tịch",
    "customers.label.id_number": "Số ID",
    "customers.label.job_title": "Chức danh công việc",
    "customers.label.age_group": "Nhóm tuổi",
    "customers.label.uts_customer_id": "ID khách hàng UTS",
    "customers.label.ach_card_name": "Tên thẻ ACH",
    "customers.label.adjustment": "Điều chỉnh",
    // "customers.label.created_adjustment": "Điều chỉnh đã tạo",
    "customers.label.adjustment_date": "Ngày điều chỉnh",
    "customers.label.adjustment_code": "Mã điều chỉnh",
    "customers.label.adjustment_amount": "Số tiền điều chỉnh",
    "customers.label.adjustment_type": "Loại điều chỉnh",
    "customers.label.activity_log": "Nhật ký hoạt động",
    "customers.label.office_id": "ID văn phòng",
    "customers.label.history": "Lịch sử",
    "customers.label.filter_by_date": "Lọc theo ngày",
    "customers.label.view_usage_details": "Xem chi tiết sử dụng",
    "customers.label.units": "Đơn vị",
    "customers.label.tax": "Thuế",
    "customers.label.total_amount": "Tổng số tiền",
    "customers.label.account_transaction": "Giao dịch tài khoản",
    "customers.label.csv_pdf": "CSV/PDF",
    "customers.label.charge_description": "Mô tả phí",
    "customers.label.journals": "Nhật ký",
    "customers.label.download_financial_summary_data":
      "Tải xuống dữ liệu tóm tắt tài chính",
    "customers.label.select_from_date": "Chọn từ ngày",
    "customers.label.select_to_date": "Chọn đến ngày",
    "customers.label.village_street": "Làng/Đường",
    "customers.label.previous": "Trước",
    "customers.label.Disconnect": "Ngắt Kết Nối",
    "customers.label.ApplyPromo": "Áp Dụng Khuyến Mãi",
    "customers.label.Service": "Dịch Vụ",
    "customers.label.Product": "Sản Phẩm",
    "customers.label.CreditCard": "Thẻ Tín Dụng",
    "customers.label.Paypal": "Paypal",
    "customers.label.BusinessEntity": "Thực Thể Kinh Doanh",
    "customers.label.Plan": "Kế Hoạch",
    "customers.label.Phone": "Điện Thoại",
    "customers.label.TaxExemption": "Miễn Thuế",
    "customers.label.YES": "CÓ",
    "customers.label.NO": "KHÔNG",
    "customers.label.Resolution": "Nghị Quyết",
    "customers.label.AccountNo": "Số Tài Khoản",
    "customers.label.ChipId": "ID Chip",
    "customers.label.MobileNo": "Số Di Động",
    "customers.label.EmailId": "ID Email",
    "customers.label.SerialNo": "Số Seri",
    "customers.label.LegacyNo": "Số Thừa Kế",
    "customers.label.searchclient": "Tìm kiếm khách hàng",
    "customers.label.PrimaryAddress": "Địa Chỉ Chính",
    "customers.label.BillingAddress": "Địa Chỉ Thanh Toán",
    // "customers.label.lco": "lco",
    "customers.label.EventDate": "Ngày Sự Kiện",
    "customers.label.CreateAdjustment": "Tạo Điều Chỉnh",
    "customers.label.full_name": "Họ và tên",
    "customers.label.bill_collection_action": "Hành động Thu thập Hóa đơn",
    "customers.label.collection_actions": "Hành động Thu thập",
    "customers.label.action_name": "Tên Hành động",
    "customers.label.action_date": "Ngày Hành động",
    "customers.label.balance_due": "Số dư Nợ",
    "customers.label.bill_id": "ID Hóa đơn",
    "customers.label.payinfo": "Thông tin thanh toán",
    "customers.label.cardtoken": "Mã thẻ",
    "customers.label.autopay": "Thanh toán tự động",
    "customers.label.paynow": "Thanh toán ngay",
    "customers.label.featureList": "Danh sách tính năng",
    "customers.label.consumed": "Đã tiêu thụ",
    "customers.label.updateCreditLimt": "Cập nhật giới hạn tín dụng",
    "customers.label.PendingForApproval": "Đang chờ phê duyệt",

    "customers.label.SpendCapHistory": "Lịch sử giới hạn chi tiêu",
    "customers.label.DateTime": "Ngày và giờ",
    "customers.label.SpendCapEventName": "Tên sự kiện giới hạn chi tiêu",
    "customers.label.SpendingLimit": "Giới hạn chi tiêu",
    "customers.label.ConsumedLimit": "Giới hạn đã tiêu",
    "customers.label.EventId": "ID sự kiện",
    "customers.label.collectionStatus": "Trạng thái thu thập",
  },
  my_MM: {
    "customers.label.temporaryBlock": "ယာယီတားမြစ်",
    "customers.label.unBlock": "ပိတ်ဆို့မှုဖျက်ရန်",
    "customers.label.feedback": "အကြံပြုချက်",
    "customers.label.event_id": "ဖြစ်စဉ်အိုင်ဒီ",
    "customers.label.slc_state_history": "SLC အခြေအနေမှတ်တမ်း",
    "customers.label.slc": "SLC",
    "customers.label.state_Change_Time": "အခြေနေပြောင်းချိန်",
    "customers.label.event": "ဖြစ်ရပ်",
    "customers.label.previous_state": "ယခင်အခြေအနေ",
    "customers.label.resolution_date": "ဖြေရှင်းသည့်နေ့စွဲ",
    "customers.label.current_state": "လက်ရှိအခြေအနေ",
    "customers.label.created_time": "ဖန်တီးချိန်",
    "customers.label.creation_time": "ဖန်တီးချိန်",
    "customers.label.Promotion": "ပရိုမိုးရှင်း",
    "customers.label.slc_status": "SLC အနေအထား",
    "customers.label.update_slc_status": "SLC အနေအထားကို ပြင်ဆင်ရန်",
    "customers.label.temporary_block": "ယာယီတားမြစ်မှု",
    "customers.label.workflow_id": "အလုပ်လုပ်ငန်းစဉ်အိုင်ဒီ",
    "customers.label.externalPromoId": "ပြင်ပ ပရိုမိုးရှင်း ID",
    "customers.label.externalPromoName": "ပြင်ပ ပရိုမိုးရှင်း အမည်",
    "customers.label.promoCode": "ပရိုမိုးရှင်း ကုဒ်",
    "customers.label.promoDescription": "ပရိုမိုးရှင်း ဖော်ပြချက်",
    "customers.label.ScheduleOrder": "အမှာစာ အချိန်ချိန်းရန်",
    "customers.label.ScheduledDate": "စာရင်းသွင်းထားသည့်ရက်",
    "customers.label.ViewRateLimit": "နှုန်းကန့်သတ်ကိုကြည့်ပါ",
    "customers.label.SelectType": "အမျိုးအစားရွေးပါ",
    "customers.label.search": "ရှာဖွေရန်",
    "customers.label.SelectTaxExemption": "အခွန်ကင်းလွတ်ခွင့် ရွေးပါ",
    "customers.label.ViewTickets": "ဆိုဒ်များကြည့်ရန်",
    "customers.label.TicketHistory": "ဆိုဒ်မှတ်တမ်း",
    "customers.label.ReopenTicket": "ဆိုဒ်ကိုပြန်ဖွင့်ပါ",
    "customers.label.SelectInvoiceType": "ငွေပေးချေမှုအမျိုးအစားကို ရွေးပါ",
    "customers.label.SelectCategory": "အမျိုးအစား ရွေးပါ",
    "customers.label.SelectSubCategory": "ခွဲအမျိုးအစား ရွေးပါ",
    "customers.label.SelectSource": "အရင်းအမြစ် ရွေးပါ",
    "customers.label.TicketHistory": "စာရင်းသွင်းမှတ်တမ်း",
    "customers.label.ViewSpendCap": "အသုံးစရိတ်ကန့်သတ်မှုကြည့်ရန်",
    "customers.label.ResponseMessage": "တုံ့ပြန်မှုမက်ဆေ့ချ်",
    "customers.label.AddPlan": "အစီအစဉ်ထည့်ရန်",
    "customers.label.Basket": "ဈေးခြင်း",
    "customers.label.TotalPrice": "စုစုပေါင်းစျေးနှုန်း",
    "customers.label.Send_Link_to_Customer_to_Complete_Payment":
      "ငွေပေးချေမှုပြီးစီးရန်ဖောက်သည်ထံလင့်ခ်ပေးပို့ပါ",
    "customers.label.CheckPaymentStatus": "ငွေပေးချေမှုအခြေအနေစစ်ဆေးပါ",
    "customers.label.Are_you_sure_you_want_to_terminate?":
      "သင်ရပ်သွားလိုသည်မှာသေချာပါသလား?",
    "customers.label.Unlimited": "အကန့်အသတ်မရှိ",
    "customers.label.days_left": "ကျန်ရှိသောရက်များ",
    "customers.label.search": "ရှာဖွေရန်",
    "customers.label.JobTitle": "အလုပ်ရာထူး",
    "customers.label.SelectDocumentType": "စာရွက်စာတမ်း အမျိုးအစားရွေးချယ်ရန်",
    "customers.label.SelectEvents": "ဖြစ်ရပ်များကို ရွေးချယ်ပါ",
    "customers.label.SelectFormatType": "ပုံစံ အမျိုးအစားရွေးချယ်ရန်",
    "customers.label.SelectAdjustmentType":
      "ညှိနှိုင်းမှု အမျိုးအစားရွေးချယ်ရန်",
    "customers.label.card_number": "ကဒ်နံပါတ်",
    "customers.label.Select_OPT_Type": "OTP အမျိုးအစားရွေးချယ်ပါ",
    "customers.label.StartDate": "စတင်သည့်ရက်စွဲ",
    "customers.label.EndDate": "ပြီးဆုံးသည့်ရက်စွဲ",
    "customers.label.Cancel": "ဖျက်သိမ်းပါ",
    "customers.label.Set": "သတ်မှတ်ပါ",
    "customers.label.PaymentDetails": "ငွေပေးချေမှု အသေးစိတ်",
    "customers.label.PaymentReceipt": "ငွေလက်ခံပြေစာ",
    "customers.label.Status": "အခြေအနေ",
    "customers.label.PaymentAmount": "ငွေပေးချေမှု ပမာဏ",
    "customers.label.Transaction": "ငွေလွှဲမှု",
    "customers.label.PaymentPage": "ငွေပေးချေမှု စာမျက်နှာ",
    "customers.label.ItemCode": "ပစ္စည်းကုဒ်",
    "customers.label.StartDate": "စတင်သည့်ရက်",
    "customers.label.English": "အင်္ဂလိပ်",
    "customers.label.SelectIdProof": "မှတ်ပုံတင်အထောက်အထားရွေးပါ",
    "customers.label.SelectAdjustementCode": "ချိန်ညှိကုဒ်ရွေးပါ",
    "customers.label.SelectAdjustmentType": "ချိန်ညှိမှုအမျိုးအစားရွေးပါ",
    "customers.label.SelectFormat": "ဖော်မက်ရွေးချယ်ပါ",
    "customers.label.AreYouSure?": "သေချာပြီလား?",
    "customers.label.ChargeId": "ကျသင့်ငွေ ID",
    "customers.label.ChargeDescription": "ကျသင့်ငွေရေးရာဖော်ပြချက်",
    "customers.label.DiscountAmount": "လျှော့စျေးပမာဏ",
    "customers.label.NetChargeAmount": "အသင့်ကျသင့်ငွေပမာဏ",
    "customers.label.TaxDescription": "အခွန်ဖော်ပြချက်",
    "customers.label.TaxAmount": "အခွန်ပမာဏ",
    "customers.label.SelectDate": "ရက်စွဲရွေးပါ",
    "customers.label.SelectPriority": "ဦးစားပေးမှုရွေးပါ",
    "customers.label.SelectCategory": "အမျိုးအစားရွေးပါ",
    "customers.label.SelectSubCategory": "ဌာနခွဲအမျိုးအစားရွေးပါ",
    "customers.label.SelectSource": "ရင်းမြစ်ရွေးပါ",
    "customers.label.ViewSpendCap": "အသုံးစရိတ်ကန့်သတ်မှုကြည့်ပါ",
    "customers.label.Amount": "ပမာဏ",
    "customers.label.PlanCode": "အစီအစဉ်ကုဒ်",
    "customers.label.Price": "ဈေးနှုန်း",
    "customers.label.Status": "အခြေအနေ",
    "customers.label.EndDate": "ကုန်ဆုံးမည့်ရက်",
    "customers.label.ContractPeriod": "စာချုပ်ကာလ",
    "customers.label.AutoRenew": "အလိုအလျောက်သက်တမ်းတိုးခြင်း",
    "customers.label.Description": "ဖော်ပြချက်",
    "customers.label.ThankYou": "ကျေးဇူးတင်ပါတယ်!",
    "customers.label.ConnectionActivated":
      "အကောင့်နံပါတ်ဖြင့် ချိတ်ဆက်မှုကို အောင်မြင်စွာဖွင့်လိုက်ပါပြီ",
    "customers.label.GoToCustomerDetail": "ဖောက်သည်အသေးစိတ်သို့သွားပါ",
    "customers.label.Payment": "ငွေပေးချေမှု",
    "customers.label.CustomerToPay": "ဝယ်သူ ပေးချေရမည်:",
    "customers.label.MonthlyPayment": "လစဉ် ပေးချေမှု",
    "customers.label.SetupWithDirectDebitOrCreditCard":
      "ဖြတ်လမ်းငွေထုတ်ကတ် သို့မဟုတ် အကြွေးဝယ်ကတ် ဖြင့် တပ်ဆင်မည်",
    "customers.label.SendLinkToCustomerToCompletePayment":
      "ငွေပေးချေမှုကို ပြီးစီးရန် ဝယ်သူအား လင့်ခ် ပို့ပါ",
    "customers.label.CheckPaymentStatus": "ငွေပေးချေမှု အခြေအနေ စစ်ဆေးပါ",
    "customers.label.ThisNumberIsReservedFor":
      "ဤနံပါတ်ကို သီးသန့်သိမ်းဆည်းထားသည်",
    "customers.label.YouSelected": "သင်ရွေးချယ်ခဲ့သည်",
    "customers.label.SerialNo": "အမှတ်စဉ်",
    "customers.label.PhoneNo": "ဖုန်းနံပါတ်",
    "customers.label.ActivatingCustomer": "ဖောက်သည်ကို ဖွင့်နေသည်...",
    "customers.label.LoadingOrderStatus": "အော်ဒါအခြေအနေ တင်နေသည်...",
    "customers.label.OrderStatus": "အော်ဒါအခြေအနေ:",
    "customers.label.Failed": "မအောင်မြင်ပါ",
    "customers.label.RoamingOutsideEEA": "EEA ပြင်ပတွင် Roaming",
    "customers.label.TariffTermsDetails":
      "သင့်ရဲ့အသုံးပြုခွင့်ထဲမပါဝင်သော စျေးနှုန်းများနှင့် အချိုးအစားများအကြောင်း အသေးစိတ်ကို ကျွန်ုပ်တို့၏ စျေးနှုန်းသတ်မှတ်ချက်များနှင့် ဝက်ဘ်ဆိုဒ်တွင် ကြည့်ရှုပါ။",
    "customers.label.PaymentTerms":
      "ကျွန်ုပ်တို့သည် သင့်ထံမှ SEPA direct debit ဖြင့် ပေးချေမှုကို ချယူမည်ဖြစ်သည်။ ချေးငွေစာချုပ်တွင် ငွေပေးချေမည့် ရက်စွဲကို ပြသမည်။ သတ်မှတ်ချက်များကို ကြိုတင်ပေးချေရန် လိုအပ်နိုင်သည်။ တစ်ချိန်ထဲတွင် သင့်အသုံးပြုမှု အလွန်များသွားပါက အကြားငွေပေးချေမှုများကို ကျွန်ုပ်တို့ တောင်းနိုင်သည်။",
    "customers.label.ServiceAgreementTerms":
      "ဝန်ဆောင်မှုစာချုပ်၏ ကြာမြင့်ချိန်၊ ပြန်လည်သက်တမ်းတိုးခြင်းနှင့် ပယ်ဖျက်မှု",
    "customers.label.Duration": "ကြာမြင့်ချိန်",
    "customers.label.Renewal": "ပြန်လည်သက်တမ်းတိုးခြင်း",
    "customers.label.ContractTermsAndConditions":
      "စာချုပ်သတ်မှတ်ချက်များနှင့်အခြေအနေများ",
    "customers.label.TermsAndConditions": "စည်းကမ်းချက်များနှင့် အခြေအနေများ",
    "customers.label.CustomerExplanation":
      "ငါဖောက်သည်အားအသေးစိတ်ရှင်းလင်းပြပြီ",
    "customers.label.CustomerAgreement":
      "သူတို့ကအမှာစာကိုဆက်လက်လုပ်ဆောင်ရန်သဘောတူသည်။",
    "customers.label.NumberReservedFor": "ဤနံပါတ်သည်ထိန်းသိမ်းထားသည်",
    "customers.label.YouSelected": "သင်ရွေးချယ်ထားသည်",
    "customers.label.SerialNo": "စီရီးနံပါတ်",
    "customers.label.PhoneNo": "ဖုန်းနံပါတ်",
    "customers.label.TotalPrice": "စုစုပေါင်းစျေးနှုန်း",
    "customers.label.FeaturesForEndUsersWithDisabilities":
      "မသန်စွမ်းအသုံးပြုသူများအတွက် လုပ်ဆောင်ချက်များ",
    "customers.label.InformationSupportServices":
      "ကျွန်ုပ်တို့၏ ဝန်ဆောင်မှုများနှင့် ပတ်သက်သော အထောက်အပံ့အချက်အလက်များကို အခြားဖောင်မက်များဖြင့်ရရှိနိုင်ပါသည်။ အခြားဖောင်မက်များဖြင့် အချက်အလက်များကို ရယူလိုပါက သင့်၏ Lycamobile SIM မှ 1200 ကို ခေါ်ဆိုပါ သို့မဟုတ်",
    "customers.label.HowWeUseYourInformation":
      "သင့်၏ အချက်အလက်များကို ကျွန်ုပ်တို့ မည်သို့ အသုံးပြုသည်",
    "customers.label.InformationUsageDetails":
      "သင့်၏ ဝန်ဆောင်မှုများ အသုံးပြုမှုနှင့် ဆက်စပ်သော အချက်အလက်များကို ကျွန်ုပ်တို့ ရယူပါမည်။ ထို့အပြင် သင့်တည်နေရာနှင့် အကောင့်လုပ်ဆောင်မှုများ ပါဝင်ပါသည်။",
    "customers.label.CustomerComplaints":
      "သင့်အနေဖြင့် ဝန်ဆောင်မှု၏ မြန်နှုန်း၊ အရည်အသွေး သို့မဟုတ် အခြားအချက်များနှင့် မကျေနပ်ပါက သုံးစွဲသူဝန်ဆောင်မှုဌာနသို့ ဆက်သွယ်ပါ။",
    "customers.label.DisputeResolution":
      "သင့်တိုင်ကြားချက်ကို 12 လအတွင်း ဆက်သွယ်နိုင်ပါသည်။",
    "customers.label.costsEuro": "ကုန်ကျစရိတ် €",
    "customers.label.thereafterEuro": "ထို့နောက် €",
    "customers.label.forTheFirst": "ပထမအတွက်",
    "customers.label.perMonthInclusiveVAT":
      "လစဉ် (CPI+ 3.9% နှင့်အတူ) VAT အပါအဝင်။ အသေးစိတ်အချက်အလက်များကို ဝက်ဘ်ဆိုက်တွင် ကြည့်ပါ။",
    "customers.label.additionalAddOns":
      "သင့်ရဲ့အစီအစဉ်အတွက် ထပ်ဆောင်း ဝန်ဆောင်မှုများ ရနိုင်ပြီး၊ သင့်ငွေတောင်းခံစာတွင် သီးခြားကျသင့်မည်။",
    "customers.label.paymentTerms":
      "သင်၏ ဝန်ဆောင်မှုများအတွက် လစဉ်ငွေပေးချေ ရမည်ဖြစ်သည်။ ချွင်းချက်မရှိပါက၊ ကျွန်ုပ်တို့သည် နောက်ကျမှုအတွက် အပိုကြေးငွေကောက်ခံနိုင်သည်။",
    "customers.label.durationRenewalTermination":
      "ကာလ၊ အသစ်ပြန်သက်တမ်းတိုးခြင်းနှင့် ဖျက်သိမ်းမှု",
    "customers.label.minimumPeriod":
      "အနည်းဆုံးကာလ 1 လဖြစ်ပြီး၊ ထိုကာလပြီးနောက် 30 ရက်ကြိုတင်အသိပေးခြင်းမရှိဘဲ ဆက်လက်အသုံးပြုနိုင်သည်။",
    "customers.label.cancellationCoolingOff":
      "သင့်မှာ 14 ရက် အတွင်း ဝန်ဆောင်မှုကို ဖျက်သိမ်းခွင့် ရနိုင်သည်။",
    "customers.label.earlyTerminationCharge":
      "သင့်ဝန်ဆောင်မှုစာချုပ်ကို သတ်မှတ်ထားသောကာလအတွင်း ပိတ်လိုက်ပါက သင့်လစဉ်ကြေးငွေနှင့်အညီ အကြေးထပ်ဆောင်းပေးရပါမည်။",
    "customers.label.ContractSummarys":
      "ဤစာချုပ်အကျဉ်းချုပ်နှင့် ၁ လကြာကြာ အပြည်ပြည်ဆိုင်ရာဝန်ဆောင်မှုများကို လက်ခံနိုင်သော ဝန်ဆောင်မှုဖြစ်သည်။ ၎င်းသည် သင့်ကို အသံခေါ်ဆိုမှုများပြုလုပ်ခြင်း၊ SMS များပို့ခြင်းနှင့်လက်ခံခြင်း၊ ဒေတာအသုံးပြုခြင်း၊ အင်တာနက်ကိုအသုံးပြုခြင်းတို့ကို ခွင့်ပြုသည်။",
    "customers.label.The": "ဒီ",
    "customers.label.ComesWith": "ပါဝင်သည်။",
    "customers.label.MobileDataSpeeds":
      "မိုဘိုင်းဒေတာဝန်ဆောင်မှုအမြန်နှုန်းများ",
    "customers.label.DataServiceDescription":
      "Lycamobile ကွန်ရက်မှရရှိနိုင်သော ဒေတာဝန်ဆောင်မှုနှင့် အနည်းဆုံးနှင့်အများဆုံးမြန်နှုန်းများသည် သင့်တည်နေရာ၊ သုံးစွဲသည့်စက်နှင့် ဝယ်ယူထားသည့်အစီအစဉ်ပေါ် မူတည်ပါသည်။ (2G, Edge, 3G, 4G, 5G)",
    "customers.label.SpeedVariation":
      "သင့်မိုဘိုင်းဒေတာဝန်ဆောင်မှု၏မြန်နှုန်းသည် မတည်ငြိမ်နိုင်ပြီး သင့်တည်နေရာ၊ ရာသီဥတု၊ သစ်ပင်များ၊ အဆောက်အဦဆင့်ကဲမှုနှင့် ကွန်ရက်အသုံးပြုသူအရေအတွက်ပေါ်မူတည်ပါသည်။",
    "customers.label.LycamobileBV": "Lycamobile B.V.",
    "customers.label.Robijnlaan17": "Robijnlaan 17,",
    "customers.label.2132WXHoofddorp": "2132WX Hoofddorp,",
    "customers.label.TheNetherlands": "နယ်သာလန်",
    "customers.label.ContractSummary": "စာချုပ်အကျဉ်းချုပ်",
    "customers.label.ContractSummaryDescription1":
      "ဤစာချုပ်အကျဉ်းချုပ်သည် ဥပဒေအရ လိုအပ်သော ဝန်ဆောင်မှုကမ်းလှမ်းမှု၏ အဓိကအချက်များကို ပေးဆောင်ပါသည်။",
    "customers.label.ContractSummaryDescription2":
      "ဝန်ဆောင်မှုကမ်းလှမ်းမှုများကို နှိုင်းယှဉ်ရန် အထောက်အကူပြုသည်။",
    "customers.label.ContractSummaryDescription3":
      "ဝန်ဆောင်မှုနှင့်စပ်လျဉ်းသော ပြည့်စုံသောအချက်အလက်များသည် အခြားစာရွက်စာတမ်းများတွင် ပါရှိသည်။",
    "customers.label.ContractSummaryValidity":
      "ဤစာချုပ်အကျဉ်းချုပ်သည် Checkout သက်တမ်းကုန်ဆုံးသည်အထိ有ထိရောက်မည်။",
    "customers.label.AcceptOffer":
      "ဤကမ်းလှမ်းမှုသည် သင့်တော်မည်ဆိုလျှင် Checkout စာမျက်နှာမှ တဆင့် လက်ခံနိုင်ပါသည်။ သင့်မှတ်တမ်းအတွက် ဤစာရွက်စာတမ်းတစ်စောင်ကို သိမ်းဆည်းထားပါ။",
    "customers.label.Services": "ဝန်ဆောင်မှုများ",
    "customers.label.TermsConditions":
      "ဝန်ဆောင်မှုသဘောတူညီမှု၏ စည်းမျဉ်းများနှင့်သတ်မှတ်ချက်များအောက်တွင်၊ ကျွန်ုပ်တို့က သဘောတူညီမှု၏ အရေးကြီးသောစည်းမျဉ်းတစ်ခုကို ချိုးဖောက်ပြီး၊ သင့်ဝန်ဆောင်မှုတွင် ဒေတာပေးနိုင်မှုကို လုံးဝတားဆီးလျှင်၊ သင့်တိုင်ကြားချက်ကို ၇ ရက်အတွင်း ပြုပြင်မထားလျှင်၊ သဘောတူညီမှုကို ရပ်စဲနိုင်ပါသည်။",
    "customers.label.EmergencyOrganisations":
      "အရေးပေါ်အဖွဲ့အစည်းများနှင့် ခေါ်ဆိုသူတည်နေရာ အချက်အလက်",
    "customers.label.EmergencyCallNetworkDown":
      "Lycamobile ၏ကွန်ရက် အလုပ်မလုပ်သည့်အခါ၊ သင့်ဖုန်းသည် 2G, 3G, 4G သို့မဟုတ် 5G ကွန်ရက်ကို ချိတ်ဆက်နိုင်ရမည်။",
    "customers.label.EmergencyCallAvailability":
      "ကွန်ရက် ရှိနေသမျှသာ အရေးပေါ်ခေါ်ဆိုမှုများ ပြုလုပ်နိုင်ပါသည်။",
    "customers.label.PlanName": "ပလန်အမည်",
    "customers.label.EuropeanOnlineDisputeResolution":
      "ဥရောပအွန်လိုင်း အငြင်းပွားမှုဖြေရှင်းမှုဆိုဒ်",
    "customers.label.ECWebsite": "ec.europa.eu/consumers/odr",
    "customers.label.DisputeResolutionDetails":
      "ဤဆိုဒ်သည် သုံးစွဲသူများအား ကျွန်ုပ်တို့နှင့်အတူ အွန်လိုင်းဝယ်ယူမှုဆိုင်ရာ အငြင်းပွားမှုများကို တင်ပြနိုင်စေရန် ခွင့်ပြုပေးသည်။ သင်သည် ကျွန်ုပ်တို့၏ မတိုင်ခင်အကူအညီပေးခြင်းဆိုင်ရာ စည်းမျဉ်းများနှင့် အခြားလွှဲခြင်းဖြေရှင်းမှုများအကြောင်း အခြားသောသတင်းအချက်အလက်များကို ကျွန်ုပ်တို့၏ ဝက်ဘ်ဆိုဒ်တွင်ကြည့်ရှုနိုင်ပါသည်။",
    "customers.label.NetherlandsLawCompliance":
      "အင်တာနက်ဝန်ဆောင်မှု၏ အမြန်နှုန်းသည့် အချက်အလက်များသည် မမှန်ကန်ခြင်း ရှိပါက၊ ဥပဒေအရ Lycamobile သည် သတ်မှတ်ချိန်အတွင်း ပြန်လည်လုပ်ဆောင်ပေးမည်ဖြစ်သည်။ ပြန်လည်လုပ်ဆောင်မှု မဖြစ်နိုင်ပါက, Lycamobile သည် ဝန်ဆောင်ခ ကို သင့်တင့်သလို လျှော့ချမည်ဖြစ်သည်။",
    "customers.label.DirectoryServiceInfo":
      "သင့်မိုဘိုင်းဖုန်းနံပါတ်ကိုဖုန်းလမ်းညွှန်နှင့်/သို့မဟုတ်ဖုန်းမေးမြန်းမှုဝန်ဆောင်မှုတွင်ထည့်သွင်းပေးရန် ကျွန်ုပ်တို့ကိုတောင်းဆိုနိုင်သည်။ သို့သော် ဤဝန်ဆောင်မှုကိုတောင်းဆိုပါက သင့်နံပါတ်သည် စျေးကွက်ရှာဖွေရေးအတွက် အချက်အလက်စုဆောင်းသောကုမ္ပဏီများထံတွင် မြင်ရနိုင်မည်ဖြစ်သည်။",
    "customers.label.RemediesComplaints":
      "ပြဿနာဖြေရှင်းမှု၊ တိုင်ကြားမှုများနှင့် အငြင်းပွားမှုဖြေရှင်းမှု",
    "customers.label.ContactCustomerService":
      "သင့်အနေဖြင့် ဖုန်းဝန်ဆောင်မှုသို့ ဆက်သွယ်လိုပါက ဝက်ဘ်ဆိုဒ်သို့သွားပြီး 'ဆက်သွယ်ရန်' ကိုနှိပ်ပါ။",
    "customers.label.IncludeMobileNumber":
      "သင်တို့ဖုန်းနံပါတ်ထည့်ပါ။ ကျွန်ုပ်တို့သည်သင့်တိုင်ကြားမှုကိုဖြေရှင်း၍မရပါက၊ သင်သည် ၂၄ လအတွင်း De Geschillencommissie ( Postbus 90600, 2509 LP, Den Haag ) သို့ တင်ပြနိုင်သည်။",
    "customers.label.Termination": "ဖြတ်တောက်ခြင်း",
    "customers.label.TerminationNotice":
      "အနည်းဆုံးကာလပြီးနောက် သင်သည် သတိပေးချက်ပေးပြီး သဘောတူညီမှုကို ပြုလုပ်နိုင်သည်။ သို့မဟုတ် သင်သည် ထိုကာလအတွင်း ရရှိသော ငွေများကို ပေးဆောင်ရမည်။",
    "customers.label.EarlyTerminationCharge":
      "အကယ်၍ သင်သည် သတ်မှတ်ထားသော ကာလအတွင်း သဘောတူညီမှုကို ဖြတ်တောက်လိုပါက သို့မဟုတ် သင်၏ အပြစ်ကြောင့် ကျွန်ုပ်တို့သည် သဘောတူညီမှုကို ဖြတ်တောက်ပါက သင်သည် ရှေးဦးဖြတ်တောက်ခကြေးပေးရမည်။",
    "customers.label.OptionalAddOnTermination":
      "မည်သည့် အပိုဝန်ဆောင်မှုများကိုလည်း သီးခြားဖြတ်တောက်ပါမည်။",
    "customers.label.CancellationInfo":
      "သင်၏ ငွေပေးချေမှုကို 14 ရက်အတွင်း မဖြေရေးမလိုပါက သင်သည် ဖြတ်တောက်ခွင့်ရှိသည်။",
    "customers.label.Security": "လုံခြုံရေး",
    "customers.label.DataProtection":
      "သင်၏ ကိုယ်ရေးကိုယ်တာအချက်အလက်များကို သက်ဆိုင်ရာ လုံခြုံရေးမူဝါဒအတိုင်း ကာကွယ်ပေးပါသည်။",
    "customers.label.TariffTerms":
      "ကျေးဇူးပြု၍ သတ်မှတ်ထားသော တစ်ခုချင်းစီ၏ ဈေးနှုန်းများနှင့် သင့်ရဲ့ အခွန်များအတွက် တိကျသော အသေးစိတ်များကို ကြည့်ရှုပါ။",
    "customers.label.DeliveryOfService": "ဝန်ဆောင်မှု ပေးပို့မှု",
    "customers.label.PaymentTerms":
      "SEPA များမှတဆင့် သင့်လွှဲရမည့်ငွေကို ကျွန်ုပ်တို့ သင့်အကောင့်မှ ချိတ်ဆက်ထုတ်ယူပါမည်။ သို့မဟုတ်...",
    "customers.label.ServiceStartDate":
      "Lycamobile မှ ဝန်ဆောင်မှု ပေးသည့် ရက်စွဲသည် သင့်လုပ်ဆောင်သည့် မှတ်ပုံတင်ခြင်း၏ ရက်စွဲဖြစ်သည်။",
    "customers.label.ContractDuration":
      "ဝန်ဆောင်မှု သဘောတူညီချက်၏ သက်တမ်း, ပြန်လည်သက်တမ်းတိုးခြင်းနှင့် ဖြုတ်ချခြင်း",
    "customers.label.MinimumPeriod":
      "သင့်စာချုပ်တွင် အနည်းဆုံး သက်တမ်းရှိပြီး 1 လ အနည်းဆုံး သက်တမ်းဖြင့် လစဉ် အထူး အစီအစဉ်များနှင့် 24 လ အထိ သတ်မှတ်စာချုပ်များအတွက် သက်တမ်းရှိသည်။",
    "customers.label.ContractRenewal":
      "စာချုပ်ကို ပြန်လည်သက်တမ်းတိုးရန်, သင့်စာချုပ်သက်တမ်း အတွင်း Lycamobile ကို အကြောင်းကြားပေးရမည်။",
    "customers.label.DataCostDetails":
      "{40 GB} ကို {3 လ} အတွက် {18.90 €} ဖြင့် ဝယ်ယူနိုင်ပါသည်။ ထို့နောက် {27.00 €} တစ်လလျှင်ကျသင့်ပါမည်။ VAT ပါဝင်ပြီး CPI + 3.9% နှုန်းဖြင့်နှစ်စဉ်တိုးမြှင့်မည်ဖြစ်သည်။ အသေးစိတ်အချက်အလက်များကို ကျွန်ုပ်တို့၏ဝက်ဘ်ဆိုဒ်တွင်ကြည့်ရှုပါ။",
    "customers.label.AdditionalAddons":
      "သင့်၏အစီအစဉ်အတွက်ထပ်မံသော Add-ons များရရှိနိုင်ပြီး သီးခြားကုန်ကျစရိတ်ဖြင့်ဝယ်ယူရမည်။",
    "customers.label.SpendingLimits": "အသုံးစရိတ်ကန့်သတ်မှုများ",
    "customers.label.SpendingLimitDetails":
      "Lycamobile သည် သင့်၏စရိတ်များကို သင့်ကြိုက်နှုန်းအတိုင်းထိန်းချုပ်မည်ဖြစ်သည်။ အများဆုံး €250 အထိသတ်မှတ်ထားသည်။",
    "customers.label.PremiumCharges":
      "ထူးခြားသောဖုန်းနံပါတ်များ, SMS များနှင့်နိုင်ငံတကာဖုန်းခေါ်ဆိုမှုများသည် အစီအစဉ်တွင်မပါဝင်ပါ။",
    "customers.label.InternationalRates":
      "နယ်စပ်များတွင် အပြည်ပြည်ဆိုင်ရာခေါ်ဆိုမှုနှုန်းထားများအတိုင်းကျသင့်မည်။",
    "customers.label.RoamingInEEA": "EEA အတွင်း Roaming",
    "customers.label.RoamingOutsideEEA": "EEA အပြင် Roaming",
    "customers.label.RoamingCharges":
      "နှစ်ခြိုက်မှုနှင့်သုံးစွဲမှုများ (ဖုန်းခေါ်, စာတို, ဒေတာ) ကို နယ်စပ်ပြင်ပတွင်အသုံးပြုလျှင်, နိုင်ငံတကာ roaming နှုန်းထားများအတိုင်း ကျသင့်မည်။",
    "customers.label.Any_Out_of_bundle_charges_can_be_found_at":
      "ထပ်မံငွေချထားရမည့်အခကြေးငွေများကို ဒီမှာတွေ့နိုင်ပါသည်။",
    "customers.label.Exclusions_for_voice_international_voice_SMS_Data_Roaming_can_be_found_at":
      "အသံ၊ အပြည်ပြည်ဆိုင်ရာအသံ၊ SMS၊ ဒေတာ Roaming အတွက် ချန်ထားသောအချက်များကို ဒီမှာတွေ့နိုင်ပါသည်။",
    "customers.label.Our_Services_availability":
      "ကျွန်ုပ်တို့၏ ဝန်ဆောင်မှုများသည် နယ်သာလန်၊ EEA သို့မဟုတ် အခြားရွေးချယ်ထားသည့်နေရာများတွင် မရှိနိုင်ပါ။",
    "customers.label.Lycamobile_network_speeds":
      "Lycamobile နက်‌ဝပ်ကွန်ရက်မှတစ်ဆင့် သင့်တည်နေရာတွင်ရရှိနိုင်သည့် အနည်းဆုံးနှင့် အများဆုံးအမြန်နှုန်းများသည် သင့်သုံးသည့်အကြိမ်နှုန်းနှင့် ပတ်သက်ပြီးဖြစ်သည်။",
    "customers.label.Mobile_data_speed_variation":
      "သင့်ဒေတာအမြန်နှုန်းသည် သင့်တည်နေရာ၊ မိုးလေဝသ၊ အပင်ဖုံးအုပ်မှု၊ အဆောက်အဦလျှောက်ပတ်မှုနှင့်ပတ်သက်၍ မတူညီနိုင်ပါ။",
    "customers.label.Price": "စျေးနှုန်း",
    "customers.label.ContractReview": "စာချုပ်သုံးသပ်မှု",
    "customers.label.Terms&Conditions": "သတ်မှတ်ချက်များနှင့်စည်းကမ်းများ",
    "customers.label.ReviewThisContract": "ဤစာချုပ်ကို ပြန်လည်သုံးသပ်ပါ",
    "customers.label.We_have_sent_these_to":
      "ကျွန်ုပ်တို့သည် ဤစာများကို ပို့လိုက်ပါပြီ",
    "customers.label.DownloadContractInformation":
      "စာချုပ်အချက်အလက်ကို ဒေါင်းလုပ်ဆွဲပါ",
    "customers.label.DownloadContractSummary":
      "စာချုပ်အကျဉ်းချုပ်ကို ဒေါင်းလုပ်ဆွဲပါ",
    "customers.label.ContractInformation": "စာချုပ်အချက်အလက်",
    "customers.label.ContactDetails": "ဆက်သွယ်ရန်အသေးစိတ်",
    "customers.label.Description_of_Services": "ဝန်ဆောင်မှုဖော်ပြချက်",
    "customers.label.This_contract_summary_and_our_Abonnement_offer_of":
      "ဤစာချုပ်အကျဉ်းချုပ်နှင့် ကျွန်ုပ်တို့၏ ဝန်ဆောင်မှုကမ်းလှမ်းချက်",
    "customers.label.an_airtime_service_for": "အချိန်သုံးဝန်ဆောင်မှု",
    "customers.label.comes_with:": "ပါဝင်သည်:",
    "customers.label.Any_Out_of_bundle_charges_can_be_found_at:":
      "အပိုဝန်ဆောင်မှုကြေးများကို ဤနေရာတွင် ကြည့်နိုင်သည်:",
    "customers.label.service_description":
      "ဤဝန်ဆောင်မှုသည် သင့်အား အသံခေါ်ဆိုမှုများပြုလုပ်ခြင်းနှင့် လက်ခံခြင်း၊ SMS မက်ဆေ့ချ်များပို့ခြင်းနှင့် လက်ခံခြင်း၊ ဒေတာအသုံးပြုခြင်းနှင့် အင်တာနက်သုံးစွဲခြင်း စသည့် ဝန်ဆောင်မှုများကို ပေးနိုင်သည်။",
    "customers.label.YouHaveChosenNoCap":
      "သင့်တော်သော ကန့်သတ်မရှိသော နည်းလမ်းကို ရွေးချယ်ထားသည်။ ဤသည်မှာ သင်၏ဖုန်းကို ခေါ်ဆိုမှုများ၊ မက်ဆေ့ချ်များ၊ အပြည်ပြည်ဆိုင်ရာ မိနစ်များ၊ roaming နှင့် သင်၏လစဉ် အလွှာမှ ပြင်ပဒေတာများအတွက် အသုံးပြုနိုင်သည်။ ဤအတွက် သင့်အား €60 အထိ အခကြေးငွေ ကောက်ခံမည်ဖြစ်သည်။",
    "customers.label.SelectDate":
      "ရက်စွဲရွေးချယ်ပါ [လစဉ်ငွေပေးချေမှုကို သင်ရွေးချယ်ထားသော ငွေတောင်းခံမှု ပြုလုပ်သည့် ရက်စွဲမှ ၁၄ ရက်အတွင်း သင့်အကောင့်မှ ဖြတ်သွားမည်ဖြစ်သည်] *",
    "customers.label.BillingCycle": "ဘေလ်ဖြည့်ချိန်",
    "customers.label.SelectBilling": "ဘေလ်ရွေးချယ်ပါ",
    "customers.label.I_Agree_To": "ငါသဘောတူသည်",
    "customers.label.TermsAndConditions": "စည်းမျဉ်းများနှင့် သတ်မှတ်ချက်များ",
    "customers.label.ThisNumberIsReservedFor": "ဤနံပါတ်ကို မှာယူထားသည်",
    "customers.label.TotalPrice": "စုစုပေါင်းစျေးနှုန်း:",
    "customers.label.CustomerInfo": "ဖောက်သည်အချက်အလက်",
    "customers.label.title": "ခေါင်းစဉ်",
    "customers.label.SelectTitle": "ခေါင်းစဉ်ရွေးပါ",
    "customers.label.initials": "မူလစာလုံးများ",
    "customers.label.Basket": "ခြင်းတောင်း",
    "customers.label.first_name": "နာမည်",
    "customers.label.last_name": "မျိုးနွယ်အမည်",
    "customers.label.email_address": "အီးမေးလ်လိပ်စာ",
    "customers.label.contact_number": "ဆက်သွယ်ရန်နံပါတ်",
    "customers.label.date_of_birth": "မွေးနေ့",
    "customers.label.select_language": "ဘာသာစကားရွေးပါ",
    "customers.label.how_did_you_hear": "သင့်အနေနဲ့ ဘယ်လိုကြားရသလဲ?",
    "customers.label.postal_code": "စာတိုက်ကုဒ်",
    "customers.label.country": "နိုင်ငံ",
    "customers.label.Enter_address_manually": "လိပ်စာကိုကိုယ်တိုင်ရိုက်ထည့်ပါ",
    "customers.label.Find_address": "လိပ်စာရှာဖွေပါ",
    "customers.label.Select_Address": "လိပ်စာရွေးချယ်ပါ",
    "customers.label.Select_an_address": "တစ်ခုရွေးချယ်ပါ",
    "customers.label.Monthly_Bill_Generation_Date": "လစဉ်ငွေတောင်းခံမှုနေ့စွဲ",
    "customers.label.Select_a_Monthly_Plan": "လစဉ် အစီအစဉ်ရွေးပါ",
    "customers.label.Search_plans": "အစီအစဉ်များရှာဖွေပါ...",
    "customers.label.search": "ရှာဖွေပါ",
    "customers.label.Select_a_plan": "အစီအစဉ်ရွေးချယ်ပါ",
    "customers.label.Basket": "ခြင်းတောင်း",
    "customers.label.This_number_is_reserved_for": "ဤနံပါတ်သည် သတ်မှတ်ထားသည်",
    "customers.label.ViewT&C": "သတ်မှတ်ချက်များ ကြည့်ပါ",
    "customers.label.TransferringFromPreviousNetwork":
      "ရှေးနာမည်ပြောင်းလဲခြင်း (သင့်ဟောင်းနံပါတ်ကိုယူပါ)",
    "customers.label.SIM_Information": "SIM သတင်းအချက်အလက်",
    "customers.label.Prepaid": "ကြိုတင်ငွေပေးချေမှု",
    "customers.label.Postpaid": "နောက်ဆုံးငွေပေးချေမှု",
    "customers.label.Physical_SIM": "ရုပ်ပိုင်းဆိုင်ရာ SIM",
    "customers.label.eSIM": "eSIM",
    "customers.label.SelectCustomerType": "ဖောက်သည်အမျိုးအစားရွေးချယ်ပါ",
    "customers.label.New_to_Lyca": "Lyca အသစ်",
    "customers.label.Convert_Lyca_Prepaid_to_Postpaid":
      "Lyca ကြိုတင်ငွေပေးချေမှ နောက်ဆုံးငွေပေးချေသို့ ပြောင်းလဲပါ",
    "customers.label.Existing_customer_is_going_to_be_sent_a_secure_link_to_confirm_that_they_wish_to_move_from_prepaid_to_abonnement.":
      "လက်ရှိဖောက်သည်သည် ကြိုတင်ငွေပေးချေမှ ဝယ်ယူမှုသို့ ပြောင်းလဲလိုကြောင်း အတည်ပြုရန် လုံခြုံသော လင့်ခ်တစ်ခုကို ပို့လိမ့်မည်။",
    "customers.label.Customer_to_receive_an_SMS":
      "ဖောက်သည်သည် SMS တစ်ခုလက်ခံရရှိမည်။",
    "customers.label.Lyca_Mobile_Number": "Lyca မိုဘိုင်းနံပါတ်",
    "customers.label.Enter_the_Lyca_Mobile_Number":
      "Lyca မိုဘိုင်းနံပါတ်ကို ထည့်ပါ",
    "customers.label.Nationality": "နိုင်ငံသား",
    "customers.label.Send_Secure_link": "လုံခြုံသောလင့်ခ်ပို့ပါ",
    "customers.label.New_to_Lyca_Mobile": "Lyca Mobile အသစ်",
    "customers.label.serial_number": "နံပါတ်စဉ်",
    "customers.label.Serial_Number": "နံပါတ်စဉ် (နောက်ဆုံး 4 လုံး)",
    "customers.label.PUK_Code": "PUK ကုဒ်",
    "customers.label.PUK_Code_is_not_matched": "PUK ကုဒ်ကို ကိုက်ညီမှုမရှိပါ",
    "customers.label.Switching_to_Lyca_Mobile":
      "Lyca Mobile သို့ ပြောင်းလဲခြင်း",
    "customers.label.Enter_the_PUK_Code": "PUK ကုဒ်ကို ထည့်ပါ",
    "customers.label.Basket": "ဈေးခြင်းတောင်း",
    "customers.label.Gender": "ကျား/မ",
    "customers.label.business_name": "လုပ်ငန်းအမည်",
    "customers.label.phone_number": "ဖုန်းနံပါတ်",
    "customers.label.Date_of_Birth": "မွေးသက္ကရာဇ်",
    "customers.label.VIP": "ဗွီအိုင်ပီ",
    "customers.label.Disability": "မသန်စွမ်းမှု",
    "customers.label.District": "ခရိုင်",
    "customers.label.Is_your_billing_address_same_as_primary_address":
      "သင်၏ဘီလ်လိပ်စာသည် မူလလိပ်စာနှင့်တူညီပါသလား?",
    "customers.label.Supressbill": "ဘီလ်ဖျောက်ရန်",
    "customers.label.SelectCategory": "အမျိုးအစားရွေးချယ်ရန်",
    "customers.label.SelectGender": "ကျား/မရွေးချယ်ရန်",
    "customers.label.SelectPreferences": "နှစ်သက်မှုရွေးချယ်ရန်",
    "customers.label.SelectNationality": "နိုင်ငံသားရွေးချယ်ရန်",
    "customers.label.SelectVIP": "ဗွီအိုင်ပီရွေးချယ်ရန်",
    "customers.label.SelectDisability": "မသန်စွမ်းမှုရွေးချယ်ရန်",
    "customers.label.SelectCity": "မြို့ရွေးချယ်ရန်",
    "customers.label.SelectBillDay": "ဘီလ်နေ့ရွေးချယ်ရန်",
    "customers.label.SelectType": "အမျိုးအစားရွေးချယ်ရန်",
    "customers.label.SelectFiscalYear": "ဘဏ္ဍာနှစ်ရွေးချယ်ရန်",
    "customers.label.SelectFiscalQuarter": "ဘဏ္ဍာသုံးလပတ်ရွေးချယ်ရန်",
    "customers.label.SelectBillMode": "ဘီလ်ပုံစံရွေးချယ်ရန်",
    "customers.label.SelectInvoiceType": "ငွေတောင်းခံလွှာအမျိုးအစားရွေးချယ်ရန်",
    "customers.label.IMSI": "IMSI",
    "customers.label.SalesMotion": "အရောင်းလှုပ်ရှားမှု",
    "customers.label.SpendCap": "အသုံးစရိတ်ကန့်သတ်ချက်",
    "customers.label.ActivationDate": "ဖွင့်ခြင်းရက်စွဲ",
    "customers.label.ExpiryDate": "သက်တမ်းကုန်ဆုံးရက်",
    "customers.label.NextRenewalDate": "နောက်ထပ်သက်တမ်းတိုးရန်ရက်စွဲ",
    "customers.label.BalanceTransfer": "လက်ကျန်ငွေပြောင်းခြင်း",
    "customers.label.RecieverClientId": "လက်ခံသူဖောက်သည် ID",
    "customers.label.Amount": "ငွေပမာဏ",
    "customers.label.EnterTopUpAmount": "ထည့်ရန်ငွေပမာဏရိုက်ထည့်ပါ",
    "customers.label.ResponseId": "တုံ့ပြန်မှု ID",
    "customers.label.BalanceName": "လက်ကျန်ငွေ အမည်",
    "customers.label.Allowance": "ခွင့်ပြုငွေ",
    "customers.label.Consumption": "အသုံးပြုမှု",
    "customers.label.AvailableBalance": "အသုံးပြုနိုင်သောလက်ကျန်ငွေ",
    "customers.label.DaysLeft": "ကျန်ရှိသောရက်များ",
    "customers.label.Discount": "လျှော့စျေး",
    "customers.label.postal_code": "စာတိုက်အမှတ်",
    "customers.label.address_number": "လိပ်စာနံပါတ်",
    "customers.label.city": "မြို့",
    "customers.label.state": "ပြည်နယ်",
    "customers.label.country": "နိုင်ငံ",
    "customers.label.comment_date": "မှတ်ချက်နေ့စွဲ",
    "customers.label.resident_period": "နေထိုင်ချိန်ကာလ",
    "customers.label.postcode": "စာတိုက်အမှတ်",
    "customers.label.how_did_you_hear": "သင်ကဘယ်လိုကျွန်ုပ်တို့ကိုသိခဲ့ပါသလဲ?",
    "customers.label.select_language": "ဘာသာစကားရွေးချယ်ပါ",
    "customers.label.email_address": "အီးမေးလ်လိပ်စာ",
    "customers.label.contact_number": "ဆက်သွယ်ရန်နံပါတ်",
    "customers.label.initials": "စတင်စာလုံးများ",
    "customers.label.communication_type": "ဆက်သွယ်မှုအမျိုးအစား",
    "customers.label.BuySIM": "SIM ဝယ်မည်",
    "customers.label.origination": "မူလ မူတည်ရာ",
    "customers.label.address": "လိပ်စာ",
    "customers.label.destination_address": "ဂူရောက်ရန်လိပ်စာ",
    "customers.label.event": "ဖြစ်ရပ်",
    "customers.label.charge_party": "အခကြေးငွေပေးရသူ",
    "customers.label.service_subs_type": "ဝန်ဆောင်မှု Subscription အမျိုးအစား",
    "customers.label.calling_party": "ခေါ်ဆိုသူ",
    "customers.label.called_party": "လက်ခံသူ",
    "customers.label.usage": "အသုံးပြုမှု",
    "customers.label.monetary_charge": "ငွေကြေးကုန်ကျမှု",
    "customers.label.result_code": "ရလဒ်ကုဒ်",
    "customers.label.generation_time": "ဖန်တီးချိန်",
    "customer.label.generationdatetime": "ထုတ်လုပ်သည့် ရက်စွဲနှင့် အချိန်",
    "customers.label.application_transaction_id": "အက်ပလီကေးရှင်းငွေလွှဲ ID",
    "customers.label.application_name": "အက်ပလီကေးရှင်းအမည်",
    "customers.label.recharge_value": "အကောင့်ဖြည့်တန်ဖိုး",
    "customers.label.interface": "အသုံးပြုမှုမျက်နှာပြင်",
    "customers.label.result": "ရလဒ်",
    "customers.label.comment": "မှတ်ချက်",
    "customers.label.recharge": "အကောင့်ဖြည့်",
    "customers.label.cdr": "CDR",
    "customers.label.notifications": "အသိပေးချက်များ",
    "customers.label.mobile_no": "Enter Mobile No",
    "customers.label.email_id": "Enter Email Id",
    "customers.label.serial_number": "Serial No",
    "customers.label.digital_content": "ဒီဂွစ်တစ်ခုကို အသုံးပြုပါ",
    "customers.label.buySim": "SIM ဝယ်ပါ",
    "customers.label.outstanding_due": "တင်မရသေးသောငွေ",
    "customers.label.due_date": "ပေးချေရမည့်နေ့",
    "customers.label.unbilled_amount": "မလွှာဆောင်ရသေးသောငွေ",
    "customers.label.next_bill_day": "နောက်တစ်ကြိမ်အမိန့်နေ့",
    "customers.label.view_allowances": "ထောက်ပံ့ငွေကိုကြည့်ပါ",
    "customers.label.view_service_details":
      "ဝန်ဆောင်မှုအသေးစိတ်အချက်အလက်များကို ကြည့်ရှုပါ။",
    "customers.label.spend_limit": "အသုံးချမှုကန့်သတ်ချက်",
    "customers.label.topup_balance": "လက်ကျန်ငွေတိုးချဲ့ပါ",
    "customers.label.next_renewal_date": "နောက်ထပ်အသစ်ပြန်ကြိမ်နေ့",
    "customers.label.allowance": "ထောက်ပံ့ငွေ",
    "customers.label.ViewDocumentUpload": "စာရွက်စာတမ်းတင်ခြင်းကို ကြည့်ပါ",
    "customers.label.total_net_amount": "စုစုပေါင်းသန့်စင်ငွေပမာဏ",
    "customers.label.cancelRemark": "မှတ်ချက် ပယ်ဖျက်ပါ။",
    "customers.label.cancelPayment": "ငွေပေးချေမှုကို ပယ်ဖျက်ပါ။",
    "customers.label.all": "အားလုံး",
    "customers.label.billProfile": "ဘောက်ချာပရိုဖိုင်",
    "customers.label.charges": "အခကြေးငွေများ",
    "customers.label.book_order": "စာအုပ်မှန်ကျင့်သုံးရန်",
    "customers.label.customers": "ဖောက်သည်များ",
    "customers.label.created_by": "ဖန်တီးသူ",
    "customers.label.created_on": "ဖန်တီးသောရက်",
    "customers.label.credit_limit": "အကြွေးကန့်သတ်",
    "customers.label.transaction_history": "ငွေလွှဲသမိုင်း",
    "customers.label.external_activity_log": "ပြင်ပလှုပ်ရှားမှုမှတ်တမ်း",
    "customers.label.settings": "ချိန်ညှိမှုများ",
    "system.label.currency_noncurrency": "ငွေမဟုတ်သောငွေ",
    "entity.label.configure": "ကွန်ဖိဂျူး",

    "customers.label.search_for_clients": "ဖောက်သည့်သူများရှာဖွေမှု",
    "customers.label.advance_search": "အဆင့်မြှင့်တင်ရန်ရှာဖွေမှု",
    "customers.label.create_customer": "ဖောက်သည်များဖန်တီးရန်",
    "customers.label.account_no": "အကောင့်နံပါတ်",
    "customers.label.customer_name": "ဖောက်သည့်သူအမည်",
    "customers.label.business_entity": "လုပ်ငန်းစဉ်သည့်အစိုးရ",
    "customers.label.balance": "လက်ကျန်ငွေ",
    "customers.label.valid_from": "မှစ၍ တရားဝင်ပါသည်",
    "customers.label.valid_to": "အထိ တရားဝင်ပါသည်",
    "customers.label.non_currency_details": "ငွေကြေးမဟုတ်သောအသေးစိတ်",
    "customers.label.view_details": "အသေးစိတ်ကြည့်ရှုပါ",
    "customers.label.status": "အခြေအနေ",
    "customers.label.first_name": "အမည်",
    "customers.label.price_discount": "စျေးနှုန်းနှင့် လျှော့စျေး",
    "customers.label.collection_status": "စုဆောင်းမှုအခြေအနေ",
    "customers.label.last_name": "မွေးသက္ကရာဇ်",
    "customers.label.city_area": "မြို့/ဒေသအလယ်",
    "customers.label.email": "အီးမေးလ်",
    "customers.label.phone": "ဖုန်း",
    "customers.label.cafid": "CAF Id",
    "customers.label.enter_business_entity":
      "လုပ်ငန်းအဖွဲ့အစည်းကို ထည့်သွင်းပါ။",
    "customers.label.select": "ရွေးပါ",
    "customers.label.refund": "ပြန်ပေးမှု",
    "customers.label.refund_id": "ပြန်ပေးမှုအိုင်ဒီ",
    "customers.label.refund_amount": "ပြန်ပေးမှုအရင်းအမြစ်",
    "customers.label.select_category_type": "အမျိုးအစားအမျိုးအစားရွေးချယ်ရန်",
    "customers.label.clear": "ရှင်းလင်းပါ",
    "customers.label.search": "ရှာဖွေပါ",
    "customers.label.customer_activation": "ဖောက်သည့်သူကိုဖွင့်ရန်",
    "customers.label.customer_details": "ဖောက်သည့်သူအသေးစိတ်",
    "customers.label.loc": "LOC",
    "customers.label.customer_category": "ဖောက်သည့်သူအမျိုးအစား",
    "customers.label.service_details": "ဝန်ဆောင်မှုအသေးစိတ်",
    "customers.label.name": "အမည်",
    "customers.label.add_service": "ဝန်ဆောင်မှုထည့်ရန်",
    "customers.label.network_node": "ကွန်ယက်နယ်",
    "customers.label.device_details": "ကိရိယာအသေးစိတ်",
    "customers.label.item": "ပစ္စည်း",
    "customers.label.discount_code": "လျှို့ဝှက်ကုဒ်",
    "customers.label.total_price": "စုစုပေါင်းစျေးနှုန်း",
    // "customers.label.device_details": "ကိရိယာအသေးစိတ်",
    "customers.label.plan_details": "စီမံချိန်ညှိုင်းသောလျှောက်လွှာ",
    "customers.label.payment_details": "ငွေပေးချေမှုအသေးစိတ်",
    "customers.label.plan_list": "လျှောက်လွှာစာရင်း",
    "customers.label.plan": "လျှောက်လွှာ",
    "customers.label.bill_item_details": "ဘေလ် အပိုင်းအချက်အလက်များ",
    "customers.label.charge_id": "ကုန်ကျစရိတ် အမှတ်အသား",
    "customers.label.order_id": "အမှာစာ အမှတ်အသား",
    "customers.label.item_tax_details": "အရာဝတ္ထု အခွန် အချက်အလက်များ",
    "customers.label.discount_details": "လျှော့ပေးမှု အချက်အလက်များ",
    "customers.label.sale_date": "ကုန်ရေးရက်",
    "customers.label.contract_period": "စာရင်းရေးလိပ်စာ",
    "customers.label.charge_cycle": "ငွေပမာဏစတင်ခွင့်",
    "customers.label.cancel": "ပယ်ဖျက်",
    "customers.label.next": "နောက်",
    "customers.label.done": "ပြီးစီးပြီး",
    "customers.label.reopen": "ပြန်ဖွင့်သည်။",
    "customers.label.submit": "တင်",
    "customers.label.view_customer": "ဖြည့်သူကိုကြည့်ရန်",
    "customers.label.account_number": "အကောင့်နံပါတ်",
    "customers.label.serial_no": "စျေးနှုန်းနံပါတ်",
    "customers.label.office_hierarchy": "ရာထူးရေးအုပ်စုအရည်အချင်း",
    "customers.label.account_type": "အကောင့်အမျိုးအစား",
    // "customers.label.balance": "လက်ကျန်စစ်",
    "customers.label.stb_serial_no": "STB စျေးနှုန်းနံပါတ်",
    "customers.label.non_currency_balance": "ငွေကြေးမတန်းတမ်းလက်ကျန်",
    "customers.label.service_orders": "ဝန်ဆောင်မှု စာရင်းများ",
    "customers.label.more_info": "ပိုမိုသော အချက်အလက်",
    "customers.label.notes": "မှတ်ချက်များ",
    "customers.label.device": "စက်ရုပ်များ",
    "customers.label.tickets": "လက်မှတ်များ",
    "customers.label.on_demand": "လိုအပ်တယ်",
    "customers.label.on_demand_billing": "လိုအပ်ချက်အရ ငွေတောင်းခံခြင်း",
    "customers.label.account_transaction": "အကောင့်အရွယ်အစားတစ်ခု",
    "customers.label.payments": "ငွေပေးချေများ",
    "customers.label.invoice": "ငွေချေစောင့်",
    "customers.label.contact_information": "ဆက်သွယ်ရန်အချက်အလက်",
    "customers.label.address_information": "လိပ်စာအချက်အလက်",
    "customers.label.billing_information": "ငွေဖြည့်ချိန်ညှိနှိုင်းအချက်အလက်",
    "customers.label.balance_information": "လက်ကျန်အချက်အလက်",
    // "customers.label.customer_name": "ဖောက်သည်အမည်",
    "customers.label.parent_child": "မိသား/အိမ်",
    "customers.label.created_date": "ဖန်တီးခဲ့သည့်ရက်စွဲ",
    "customers.label.district": "ခရိုင်",
    "customers.label.pincode": "ကုဒ်အုပ်စု",
    "customers.label.last_bill_amount": "နောက်ဆုံးငွေပမာဏ",
    "customers.label.last_bill_date": "နောက်ဆုံးဘစ်ကိုက်ညီသည့်ရက်",
    "customers.label.last_bill_paid": "နောက်ဆုံးငွေပေးသွင်းသည်",
    "customers.label.last_paid_amount": "နောက်ဆုံးငွေပေးသွင်းသည့်ပမာဏ",
    "customers.label.last_payment_date": "နောက်ဆုံးငွေပေးချေမည့်ရက်",
    "customers.label.next_bill_date": "နောက်ဆုံးဘစ်ကိုကြည့်ရန်ရက်",
    "customers.label.service_overview": "ဝန်ဆောင်မှုအသေးစိတ်",
    "customers.label.service_without_device": "ကိုယ်ရေးသုံးနေသောဝန်ဆောင်မှု",
    "customers.label.create_ticket": "ထုတ်ယူရန်တင်ရန်",
    "customers.label.service_activation": "ဝန်ဆောင်မှုဖွင့်ခြင်း",
    "customers.label.order_charging": "အမှာန်ကြောင်းခံခြင်း",
    "customers.label.top_up": "ငွေဖြည့်",
    "customers.label.redeem": "ငွေလွှဲပြောင်းရန်",
    "customers.label.collection_name": "ကောလဟလအမည်",
    "customers.label.redeem_voucher": "ဘောက်ချာ ထုတ်ယူပါ။",
    "customers.label.service_id": "ဝန်ဆောင်မှု ID",
    "customers.label.service_code": "ဝန်ဆောင်မှုကုဒ်",
    "customers.label.service_description": "ဝန်ဆောင်မှုဖော်ပြချက်",
    "customers.label.start_date": "စတင်ခဲ့သည့်နေ့စွဲ",
    "customers.label.modified_date": "ပြင်ဆင်ခဲ့သည့်နေ့စွဲ",
    // "customers.label.status": "အခြေအနေ",
    "customers.label.info": "အချက်အလက်",
    "customers.label.action": "လုပ်ဆောင်ချက်",
    "customers.label.add_device": "ကိုယ်တိုင်ကိုတင်သွင်းရန်",
    "customers.label.add_plans": "အစီအစဉ်များထည့်ပါ",
    "customers.label.suspend": "အဆုံးမပိတ်ပါ",
    "customers.label.reactivate": "ထပ်ဖြည့်ရန်",
    "customers.label.terminate": "ပိတ်ဆက်ပါ",
    "customers.label.command_center": "စာရင်းပြင်ဆင်ခြင်း",
    "customers.label.retrack": "ထပ်ကြိုးစာရင်းပြပါ",
    "customers.label.cancel_plans": "အစီအစဉ်များဖျက်ပါ",
    "customers.label.device_overview": "ကိရိယာထွက်ချိန်",
    "customers.label.item_code": "ကုန်ပစ္စည်းကုဒ်",
    "customers.label.orders_overview": "အမှာစာရင်းကိုအသေးစိတ်",
    // "customers.label.plan": "အစီအစဉ်",
    "customers.label.end_date": "အဆုံးသတ်ချိန်",
    "customers.label.price": "စျေးနှုန်း",
    "customers.label.short_description": "အတိုချုံးဖော်ပြချက်",
    "customers.label.description": "ဖော်ပြချက်",
    "customers.label.add_note": "မှတ်ချက်ထည့်ရန်",
    "customers.label.note": "မှတ်ချက်",
    "customers.label.sale_type": "ရောင်းချသည့်အမျိုးအစား",
    "customers.label.charge_code": "ကုန်ကျင်ကုဒ်",
    "customers.label.quantity": "အရေအတွက်",
    // "customers.label.total_price": "စုစုပေါင်းစျေးနှုန်း",
    "customers.label.warranty_date": "အထူးခံရက်စွဲ",
    "customers.label.allocate": "တည်ထောင်ခြင်း",
    "customers.label.contact_info": "ဆက်သွယ်ရန်အချက်အလက်",
    "customers.label.edit_customer": "ကျွန်ုပ်တို့ကိုတည်းဖြတ်ရန်",
    "customers.label.lco": "LCO",
    "customers.label.title": "ခေါင်းစဉ်",
    // "customers.label.customer_category": "သုံးစွဲသူအမျိုးအစား",
    "customers.label.middle_name": "အသံအပြုနာနာမည်",
    "customers.label.caf_id": "CAF Id",
    "customers.label.landline_number": "ကြိုးဖုန်းနံပါတ်",
    "customers.label.user_name": "အသုံးပြုသူအမည်",
    "customers.label.customer_photo": "သင့်ရဲ့အဖုံးပုံ",
    "customers.label.id_proof": "အသေးစိတ်သက်တမ်း",
    "customers.label.id_proof_value": "အသေးစိတ်အမှတ်",
    "customers.label.save": "သိမ်းဆည်းပါ",
    "customers.label.close_customer": "ကုန်သည်တောင်းဆိုခြင်း",
    "customers.label.closure_date": "တောင်းဆိုသည့်နေ့စွဲ",
    "customers.label.closure_reason": "တောင်းဆိုခြင်းအကြောင်း",
    "customers.label.close": "ပိတ်သည်",
    "customers.label.address_info": "လိပ်စာအချက်အလက်",
    "customers.label.edit_address": "လိပ်စာပြုစု",
    "customers.label.address_no": "လိပ်စာနံပါတ်",
    "customers.label.street": "လမ်း",
    "customers.label.building": "အဆောက်ပြေစု",
    "customers.label.zipcode": "စာတိုက်ပေါင်းအုပ်စု",
    "customers.label.billing": "ဘောင်ချာ",
    "customers.label.same_as_primary": "မူလစာပိုင်းထဲကနေလည်း",
    "customers.label.building_code": "အဆောက်ပြေစုကုဒ်",
    "customers.label.add_address": "လိပ်စာထည့်ရန်",
    "customers.label.address_type": "လိပ်စာအမျိုးအစား",
    "customers.label.billing_info": "ငွေပေးချေမှုအချက်အလက်",
    "customers.label.created_adjustment": "အဆုံးသတ်မှတ်ထားသည့်တောင်းခံခြင်း",
    "customers.label.create_order": "အမှာစာ ဖန်တီးရန်",
    "customers.label.sale_catalog": "အရောင်းအဝယ်စာရင်း",
    "customers.label.renew_plan": "အစီအစဉ်ကို သက်တမ်းတိုးပါ။",
    "customers.label.auto_renew": "အလိုအလျောက်စီမှတ်တမ်း",
    // "customers.label.search": "ရှာဖွေရန်",
    "customers.label.entity_name": "လုပ်ငန်းအမည်",
    "customers.label.discount": "လျှော့ချက်",
    "customers.label.provisioning_commands": "ပေးဖော်ရိုက်မှုရွေးစရာများ",
    "customers.label.command": "ဖွင့်လှစ်မှု",
    "customers.label.plans": "စီစစ်များ",
    "customers.label.client_service_detail": "ဖြစ်စဉ်စာရင်းအသေးစိတ်",
    "customers.label.id": "အမှတ်အသား",
    "customers.label.parameter_name": "ပရိုဖိုင်အမည်",
    "customers.label.parameter_value": "ပရိုဖိုင်အမည်တန်ဖိုး",
    "customers.label.request_type": "တောင်းဆိုခြင်းအမျိုးအစား",
    "customers.label.client_info": "ဖြည့်စွက်သူအချက်အလက်",
    "customers.label.service_info": "ဝန်ဆောင်မှုအချက်အလက်",
    "customers.label.new_device_info": "သတင်းအချက်အလက်",
    "customers.label.task_list": "လုပ်ငန်းစာရင်း",
    "customers.label.provisioning_detail": "ထုတ်ယူခြင်းအသေးစိတ်",
    "customers.label.provisioning_id": "ထုတ်ယူခြင်းအမှတ်စဉ်",
    "customers.label.task_id": "လုပ်ငန်းအမှတ်စဉ်",
    "customers.label.sent_message": "ပေးပို့ပြီးပြီစာတစ်စောင်း",
    "customers.label.available_plans": "ရရှိနိုင်သောစီမံခန့်ခွဲများ",
    "customers.label.disconnect_order": "ခွင့်ပြုချက်ပိတ်မည့် အမှတ်စဉ်",
    "customers.label.reason": "အကြောင်းအရာ",
    "customers.label.porting_out": "သယ်ထုတ်ခြင်း။",
    "customers.label.prepaid_to_postpaid": "Postpaid မှ ကြိုတင်ငွေပေးချေပါ။",
    "customers.label.postpaid_to_prepaid": "ကြိုတင်ငွေပေးချေရန် Postpaid",
    "customers.label.addons": "Addons",
    "customers.label.change_plan": "စီမံခန့်ခွဲမှု ပြောင်းလဲမည်",
    "customers.label.swap_sim": "SIM ကိုဖလှယ်ပါ",
    "customers.label.select_date": "ရွေးချယ်မည့်နေ့ကို ရွေးချယ်ပါ",
    "customers.label.order_date": "အမှတ်စဥ်ကုန့်သည်",
    "customers.label.priority": "အလိုအကတ်",
    "customers.label.ticket_date": "လက်မှတ်ရက်စွဲ",
    "customers.label.category": "အမျိုးအစား",
    "customers.label.sub_category": "အမျိုးအစားအောက်ခြေ",
    "customers.label.team": "အဖွဲ့",
    "customers.label.team_user": "အဖွဲ့အသုံးပြုသူ",
    "customers.label.source": "ရာထူး",
    "customers.label.due_time": "အချိန်ဇယားထိုး",
    "customers.label.device_swap": "စက်အပ်အကြောင်းပြောင်း",
    // "customers.label.terminate": "ပိတ်ပင်ပါ",
    "customers.label.confirm": "အတည်ပြုပါ",
    "customers.label.continue": "ဆက်ရန်",
    "customers.label.process_date": "လုပ်ဆောင်သည့်ရက်စွဲ",
    "customers.label.pin_number": "ကုတ်နံပါတ်",
    "customers.label.renewal": "အစီအစဉ်",
    // "customers.label.create_customer": "ဖန်တီးသူ ဖန်တီးပါ",
    "customers.label.individual": "ကိုယ်ရည်နှင့်ပတ်သက်",
    "customers.label.corporate": "ကုမ္ပဏီ",
    "customers.label.corporate_details": "ကုမ္ပဏီ အသေးစိတ်များ",
    "customers.label.contact_person": "ဆက်သွယ်ရန်လိပ်စာ",
    "customers.label.entity": "လူမှု",
    "customers.label.client_category": "သုံးစွဲသူအမျိုးအစား",
    "customers.label.preferences": "အသိပညာများ",
    "customers.label.parent_id": "မူလစာရင်း",
    "customers.label.child": "ကလေး",
    "customers.label.villege_street": "ကျေး/လမ်း",
    "customers.label.billing_address": "ငွေပေးချေမှု လိပ်စာ",
    "customers.label.bill_information": "ငွေယူဆောင်ရန် အချက်အလက်",
    "customers.label.bill_day_of_month": "လစဉ်အတန်းနေ့",
    "customers.label.fiscal_year": "ဘဏ္ဍာရီ နှစ်",
    "customers.label.fiscal_quater": "ဘဏ္ဍာရီ လျှို့",
    "customers.label.bill_mode": "ငွေယူဆောင်အောက်ပါအတိုင်း",
    "customers.label.invoice_type": "ဘဏ္ဍာရီ အမျိုးအစား",
    "customers.label.payment_information": "ငွေပေးချေမှု အချက်အလက်",
    "customers.label.funder_name": "ပေးရှင်းသူအမည်",
    "customers.label.funder_id": "ပေးရှင်းသူ ID",
    "customers.label.po_number": "PO နံပါတ်",
    "customers.label.payment_term": "ငွေပေးချေငွေကြော်ငြာ",
    "customers.label.customer_created_successfully": "ဖောက်သည်မှာအောင်မြင်ပါ",
    "customers.label.go_to_customer": "ကျေးဇူးပြု၍ သူ့အဖြစ်သို့သွားပါ",
    "customers.label.view_order": "အမှာစာကြည့်ရန်",
    "customers.label.disconnect": "ချိတ်ဆက်ရန်",
    "customers.label.apply_promo": "အပိုင်းအစားလွှဲပြောင်းရန်",
    // "customers.label.order_id": "အမှာစာ ID",
    "customers.label.order_type": "အမှာစာအမျိုးအစား",
    "customers.label.billing_cycle": "ငွေပေးချေခြင်းခန့်",
    "customers.label.plan_name": "အစီအစဉ်အမည်",
    "customers.label.user_action": "အသုံးပြုသူလုပ်ငန်း",
    "customers.label.invoice_till_date": "ငွေပေးချေစာရင်းသွင်းလိုသည့်ရက်",
    "customers.label.order_services": "အမှာစာဝန်ဆောင်မှုများ",
    "customers.label.service_type": "ဝန်ဆောင်မှုအမျိုးအစား",
    "customers.label.bill_start_date": "ငွေပေးချေစသည့်နေ့စွဲ",
    "customers.label.bill_end_date": "ငွေပေးချေအဆုံးနေ့စွဲ",
    // "customers.label.invoice_till_date": "ငွေပေးချေစာရင်းသွင်းလိုသည့်ရက်",
    "customers.label.charge_type": "ငွေပေးချေအမျိုးအစား",
    "customers.label.rate_uom": "စာရင်း/UOM",
    "customers.label.discount_description": "လျှော့စျေးအကြောင်း",
    "customers.label.discount_type": "လျှော့စျေးအမျိုးအစား",
    "customers.label.discount_start_date": "လျှော့စျေးစတင်ခြင်းနေ့",
    "customers.label.discount_end_date": "လျှော့စျေးအဆုံးနေ့",
    "customers.label.discount_amount": "လျှော့စျေးပမာဏ",
    "customers.label.order_transaction": "အမှာစာစီမံခန့်",
    "customers.label.user": "အသုံးပြုသူ",
    "customers.label.transaction_date": "ငွေသွင်းမည့်နေ့စွဲ",
    "customers.label.transaction_type": "ငွေသွင်းမည့်အမျိုးအစား",
    "customers.label.actual_date": "အခြေအနေရက်",
    "customers.label.promo": "ပရိုမို",
    "customers.label.promotion": "ပရိုမို",
    "customers.label.disconnection_date": "ခွင့်ပြုမည့်နေ့စွဲ",
    "customers.label.disconnection_reason": "ခွင့်ပြုမည့်အကြောင်း",
    "customers.label.problem_code": "ပြဿနာ ကုဒ်",
    "customers.label.assign_to": "တန်ဖိုးသို့ ပေးပို၍",
    "customers.label.last_comment": "နောက်ဆုံးထွက်ခဲ့သော မှတ်ချက်",
    "customers.label.file_name": "ဖိုင်နာမည်",
    "customers.label.edit_ticket": "အမှတ်တံဆိပ် တည်ဆောက်ပါ",
    "customers.label.close_ticket": "အမှတ်တံဆိပ် ပိတ်ပါ",
    "customers.label.resolution_description": "အကယ်၍ အသိပေးချက်",
    "customers.label.ticket_history": "အမှတ်တံဆိပ် သမိုင်း",
    // "customers.label.last_comment": "နောက်ဆုံးထွက်ခဲ့သော မှတ်ချက်",
    "customers.label.problem_description": "ပြဿနာ ဖော်ပြချက်",
    "customers.label.generate": "ဖန်တီးပါ",
    "customers.label.bill_date": "ဘီလ်ဒင်နေ့",
    "customers.label.amount": "ပမာဏ",
    "customers.label.statement": "ကဏ္ဍ",
    // "customers.label.due_date": "နောက်ဆုံးရက်",
    "customers.label.promotional_message": "ပရိုမိုတိုက်စစ်စာ",
    "customers.label.download": "ဒေါင်းလုတ်",
    "customers.label.due_amount": "ကျော်သောပမာဏ",
    "customers.label.transactions": "ငွေသွင်းမည့်အမှာစာများ",
    "customers.label.file": "ဖိုင်",
    "customers.label.reset": "ပြန်စပ်ရန်",
    "customers.label.order_details": "အမှာစာအသေးစိတ်",
    "customers.label.make_payment": "ငွေပေးချေမည်",
    "customers.label.transaction_id": "ငွေသွင်းစာရင်း",
    "customers.label.credit_amount": "အကြွေးအဝယ်",
    "customers.label.debit_amount": "အကုန်ပေးငွေ",
    "customers.label.cancel_remark": "ဖျက်သိမ်းဆည်းခြင်းမှတ်ချက်",
    "customers.label.pay_invoice": "ငွေပေးချေမည်",
    "customers.label.account": "အကောင့်",
    "customers.label.deposit": "အကောက်ဖိုင်",
    "customers.label.payment_date": "ငွေပေးချေသည့်နေ့စွဲ",
    "customers.label.payment_type": "ငွေပေးချေအမျိုးအစား",
    "customers.label.receipt_no": "လက်ခံရမည့်နံပါတ်",
    "customers.label.cheque_no": "စီးပွားရမည့်နံပါတ်",
    "customers.label.bank_name": "ဘဏ်အမည်",
    "customers.label.branch_name": "စာအုပ်အမည်",
    "customers.label.cheque_date": "စီးပွားရမည့်နေ့စွဲ",
    "customers.label.invoice_id": "စာရင်းစာရင်းအမှတ်",
    "customers.label.invoice_date": "စာရင်းစာရင်းရက်စွဲ",
    "customers.label.invoice_amount": "စာရင်းစာရင်းပမာဏ",
    // "customers.label.due_amount": "ကျော်သောပမာဏ",
    "customers.label.payment_reversal": "ငွေပေးချေခွင့်ပြောင်းခြင်း",
    "customers.label.date_filter": "နေ့စွဲစစ်ပါ",
    "customers.label.add_event_order": "အဖွဲ့မည့် ဖြစ်ရမည့် အစီအစဉ်",
    "customers.label.event_order": "အဖြစ်ဖွင့်မည့်အစီအစဉ်",
    "customers.label.eventdate": "အဖြစ်နေ့အကြို",
    "customers.label.serviceAddress": "ဝန်ဆောင်မှုလိပ်စာ",
    "customers.label.event_name": "ဖြစ်ရမည့်အစီအစဉ်",
    "customers.label.booked_date": "မှာယူထားသောရက်စွဲ",
    "customers.label.event_price": "ဖြစ်ရမည့်အစီအစဉ်ပမာဏ",
    "customers.label.events": "ဖြစ်ရပ်များ",
    "customers.label.format_type": "ပုံနှိပ်နှိုင်းအမျိုးအစား",
    "customers.label.opt_type": "OPT အမျိုးအစား",
    "customers.label.client_bill_profile":
      "ဖောက်သည့်အကြောင်းအရာဖြစ်အောင်လိုက်သောအကြောင်းအရာ",
    "customers.label.edit": "တည်းဖြတ်ရန်",
    "customers.label.type": "အမျိုးအစား",
    "customers.label.client_id": "ဖောက်သည့် ID",
    "customers.label.bill_frequency": "ငွေကြေးအရပ်ကိန်း",
    "customers.label.bill_segment": "ငွေကြေးအစား",
    // "customers.label.next_bill_day": "နောက်ဆုံးငွေကြေးနေ့",
    "customers.label.last_bill_day": "နောက်ဆုံးငွေကြေးနေ့",
    "customers.label.last_bill_no": "နောက်ဆုံးငွေကြေးနံပါတ်",
    "customers.label.bill_suppression_flag":
      "ငွေကြေးဖျက်ပစ်ခြင်းအလိုက်သည့်အပိုင်း",
    "customers.label.bill_suppression_id": "ငွေကြေးဖျက်ပစ်ခြင်း ID",
    "customers.label.first_bill": "ပထမငွေကြေး",
    "customers.label.hot_bill": "အများဆုံးငွေကြေး",
    "customers.label.childs": "ကလေးများ",
    "customers.label.cell_phone": "ဖုန်းနံပါတ်",
    "customers.label.create_client_additional_info":
      "ဝန်ထမ်းအသစ်အချက်အလက်တည်ဆောက်ရန်",
    "customers.label.gender": "ကျား/မ",
    "customers.label.id_type": "ID အမျိုးအစား",
    "customers.label.nationality": "လူမျိုးနာမည်",
    "customers.label.id_number": "ID နံပါတ်",
    "customers.label.job_title": "အလုပ်အကိုင်အမည်",
    "customers.label.age_group": "အသက်အရွယ်အစား",
    "customers.label.uts_customer_id": "UTS ကိုယ်ရေးအခြေအနေ",
    "customers.label.ach_card_name": "ACH ကဒ်အမည်",
    "customers.label.village_street": "ကျေးရွာ/လမ်းမ",
    "customers.label.previous": "ယခင်",
    "customers.label.Disconnect": "ဖြုတ်ရန်",
    "customers.label.ApplyPromo": "ပရိုမိုးရှင်း အသုံးချပါ",
    "customers.label.Service": "ဝန်ဆောင်မှု",
    "customers.label.Product": "ထုတ်ကုန်",
    "customers.label.CreditCard": "ခရက်ဒစ်ကဒ်",
    "customers.label.Paypal": "Paypal",
    "customers.label.BusinessEntity": "စီးပွားရေးအဖွဲ့အစည်း",
    "customers.label.Plan": "အစီအစဉ်",
    "customers.label.Phone": "ဖုန်း",
    "customers.label.TaxExemption": "အခွန်ကင်းလွတ်ခွင့်",
    "customers.label.YES": "ဟုတ်ကဲ့",
    "customers.label.NO": "မဟုတ်ဘူး",
    "customers.label.Resolution": "ပြဿနာအဖြေ",
    "customers.label.AccountNo": "အကောင့်နံပါတ်",
    "customers.label.ChipId": "ချစ်ပ် ID",
    "customers.label.MobileNo": "မိုဘိုင်းနံပါတ်",
    "customers.label.EmailId": "အီးမေးလ် ID",
    "customers.label.SerialNo": "အမှတ်စဥ်",
    "customers.label.LegacyNo": "ဇာတိနံပါတ်",
    "customers.label.searchclient": "ဖောက်သည်ရှာပါ",
    "customers.label.PrimaryAddress": "မူလလိပ်စာ",
    "customers.label.BillingAddress": "ဘီလ်ချိန်လိပ်စာ",
    // "customers.label.lco": "lco",
    "customers.label.EventDate": "အဖြစ်အပျက်ရက်စွဲ",
    "customers.label.CreateAdjustment": "ညှိနှိုင်းမှုဖန်တီးပါ",
    "customers.label.full_name": "အမည်အပြည့်အစုံ",
    "customers.label.bill_collection_action": "ဘောက်ချာစုဆောင်းမှုလှုပ်ရှားမှု",
    "customers.label.collection_actions": "စုဆောင်းမှုလှုပ်ရှားမှုများ",
    "customers.label.action_name": "လှုပ်ရှားမှုအမည်",
    "customers.label.action_date": "လှုပ်ရှားမှုရက်စွဲ",
    "customers.label.balance_due": "ကျန်ငွေ",
    "customers.label.bill_id": "ဘောက်ချာ ID",
    "customers.label.payinfo": "ငွေပေးချေမှု အချက်အလက်",
    "customers.label.cardtoken": "ကဒ်တွန်း",
    "customers.label.autopay": "အလိုလျောက်ငွေပေးချေမည်",
    "customers.label.paynow": "အခုငွေပေးချေပါ",
    "customers.label.featureList": "အင်္ဂါရပ်စာရင်း",
    "customers.label.consumed": "သုံးစွဲမှု",
    "customers.label.updateCreditLimt": "အကြွေးကန့်သတ်ကို အပ်ဒိတ်လုပ်ပါ",
    "customers.label.PendingForApproval": "အတည်ပြုရန်စောင့်ဆိုင်းနေသည်",

    "customers.label.SpendCapHistory": "အသုံးစရိတ်ကန့်သတ်မှုမှတ်တမ်း",
    "customers.label.DateTime": "ရက်စွဲနှင့်အချိန်",
    "customers.label.SpendCapEventName": "အသုံးစရိတ်ကန့်သတ်အဖြစ်အပျက်အမည်",
    "customers.label.SpendingLimit": "အသုံးစရိတ်ကန့်သတ်ချက်",
    "customers.label.ConsumedLimit": "အသုံးပြုထားသောကန့်သတ်ချက်",
    "customers.label.EventId": "အဖြစ်အပျက် ID",
    "customers.label.collectionStatus": "စုဆောင်းမှုအခြေအနေ",
  },
  my: {
    "customers.label.temporaryBlock": "ယာယီတားမြစ်",
    "customers.label.unBlock": "ပိတ်ဆို့မှုဖျက်ရန်",
    "customers.label.feedback": "အကြံပြုချက်",
    "customers.label.event_id": "ဖြစ်စဉ်အိုင်ဒီ",
    "customers.label.slc_state_history": "SLC အခြေအနေမှတ်တမ်း",
    "customers.label.slc": "SLC",
    "customers.label.state_Change_Time": "အခြေနေပြောင်းချိန်",
    "customers.label.event": "ဖြစ်ရပ်",
    "customers.label.previous_state": "ယခင်အခြေအနေ",
    "customers.label.resolution_date": "ဖြေရှင်းသည့်နေ့စွဲ",
    "customers.label.current_state": "လက်ရှိအခြေအနေ",
    "customers.label.created_time": "ဖန်တီးချိန်",
    "customers.label.creation_time": "ဖန်တီးချိန်",
    "customers.label.Promotion": "ပရိုမိုးရှင်း",
    "customers.label.slc_status": "SLC အနေအထား",
    "customers.label.update_slc_status": "SLC အနေအထားကို ပြင်ဆင်ရန်",
    "customers.label.temporary_block": "ယာယီတားမြစ်မှု",
    "customers.label.workflow_id": "အလုပ်လုပ်ငန်းစဉ်အိုင်ဒီ",
    "customers.label.externalPromoId": "ပြင်ပ ပရိုမိုးရှင်း ID",
    "customers.label.externalPromoName": "ပြင်ပ ပရိုမိုးရှင်း အမည်",
    "customers.label.promoCode": "ပရိုမိုးရှင်း ကုဒ်",
    "customers.label.promoDescription": "ပရိုမိုးရှင်း ဖော်ပြချက်",
    "customers.label.ScheduleOrder": "အမှာစာ အချိန်ချိန်းရန်",
    "customers.label.ScheduledDate": "စာရင်းသွင်းထားသည့်ရက်",
    "customers.label.ViewRateLimit": "နှုန်းကန့်သတ်ကိုကြည့်ပါ",
    "customers.label.SelectType": "အမျိုးအစားရွေးပါ",
    "customers.label.search": "ရှာဖွေရန်",
    "customers.label.SelectTaxExemption": "အခွန်ကင်းလွတ်ခွင့် ရွေးပါ",
    "customers.label.ViewTickets": "ဆိုဒ်များကြည့်ရန်",
    "customers.label.TicketHistory": "ဆိုဒ်မှတ်တမ်း",
    "customers.label.ReopenTicket": "ဆိုဒ်ကိုပြန်ဖွင့်ပါ",
    "customers.label.SelectInvoiceType": "ငွေပေးချေမှုအမျိုးအစားကို ရွေးပါ",
    "customers.label.SelectCategory": "အမျိုးအစား ရွေးပါ",
    "customers.label.SelectSubCategory": "ခွဲအမျိုးအစား ရွေးပါ",
    "customers.label.SelectSource": "အရင်းအမြစ် ရွေးပါ",
    "customers.label.TicketHistory": "စာရင်းသွင်းမှတ်တမ်း",
    "customers.label.ViewSpendCap": "အသုံးစရိတ်ကန့်သတ်မှုကြည့်ရန်",
    "customers.label.ResponseMessage": "တုံ့ပြန်မှုမက်ဆေ့ချ်",
    "customers.label.AddPlan": "အစီအစဉ်ထည့်ရန်",
    "customers.label.Basket": "ဈေးခြင်း",
    "customers.label.TotalPrice": "စုစုပေါင်းစျေးနှုန်း",
    "customers.label.Send_Link_to_Customer_to_Complete_Payment":
      "ငွေပေးချေမှုပြီးစီးရန်ဖောက်သည်ထံလင့်ခ်ပေးပို့ပါ",
    "customers.label.CheckPaymentStatus": "ငွေပေးချေမှုအခြေအနေစစ်ဆေးပါ",
    "customers.label.Are_you_sure_you_want_to_terminate?":
      "သင်ရပ်သွားလိုသည်မှာသေချာပါသလား?",
    "customers.label.Unlimited": "အကန့်အသတ်မရှိ",
    "customers.label.days_left": "ကျန်ရှိသောရက်များ",
    "customers.label.search": "ရှာဖွေရန်",
    "customers.label.JobTitle": "အလုပ်အကိုင် ခေါင်းစဉ်",
    "customers.label.SelectDocumentType": "စာရွက်စာတမ်းအမျိုးအစား ရွေးချယ်ပါ",
    "customers.label.SelectEvents": "ဖြစ်စဉ်များကို ရွေးချယ်ပါ",
    "customers.label.SelectFormatType": "ပုံစံအမျိုးအစား ရွေးချယ်ပါ",
    "customers.label.SelectAdjustmentType":
      "ညှိနှိုင်းမှုအမျိုးအစား ရွေးချယ်ပါ",
    "customers.label.card_number": "ကဒ်နံပါတ်",
    "customers.label.Select_OPT_Type": "OTP အမျိုးအစား ရွေးချယ်ပါ",
    "customers.label.StartDate": "စတင်သည့်ရက်",
    "customers.label.EndDate": "ပြီးဆုံးသည့်ရက်",
    "customers.label.Cancel": "မလုပ်တော့ပါ",
    "customers.label.Set": "သတ်မှတ်ပါ",
    "customers.label.PaymentDetails": "ငွေပေးချေမှု အသေးစိတ်",
    "customers.label.PaymentReceipt": "ငွေလက်ခံပြေစာ",
    "customers.label.Status": "အခြေအနေ",
    "customers.label.PaymentAmount": "ငွေပေးချေမှု ပမာဏ",
    "customers.label.Transaction": "ငွေလွှဲမှု",
    "customers.label.PaymentPage": "ငွေပေးချေမှု စာမျက်နှာ",
    "customers.label.ItemCode": "ပစ္စည်းကုဒ်",
    "customers.label.StartDate": "စတင်သည့်ရက်",
    "customers.label.English": "အင်္ဂလိပ်",
    "customers.label.SelectIdProof": "မှတ်ပုံတင်အထောက်အထားရွေးပါ",
    "customers.label.SelectAdjustementCode": "ချိန်ညှိကုဒ်ရွေးပါ",
    "customers.label.SelectAdjustmentType": "ချိန်ညှိမှုအမျိုးအစားရွေးပါ",
    "customers.label.SelectFormat": "ဖော်မက်ရွေးချယ်ပါ",
    "customers.label.AreYouSure?": "သေချာပြီလား?",
    "customers.label.ChargeId": "ကျသင့်ငွေ ID",
    "customers.label.ChargeDescription": "ကျသင့်ငွေရေးရာဖော်ပြချက်",
    "customers.label.DiscountAmount": "လျှော့စျေးပမာဏ",
    "customers.label.NetChargeAmount": "အသင့်ကျသင့်ငွေပမာဏ",
    "customers.label.TaxDescription": "အခွန်ဖော်ပြချက်",
    "customers.label.TaxAmount": "အခွန်ပမာဏ",
    "customers.label.SelectDate": "ရက်စွဲရွေးပါ",
    "customers.label.SelectPriority": "ဦးစားပေးမှုရွေးပါ",
    "customers.label.SelectCategory": "အမျိုးအစားရွေးပါ",
    "customers.label.SelectSubCategory": "ဌာနခွဲအမျိုးအစားရွေးပါ",
    "customers.label.SelectSource": "ရင်းမြစ်ရွေးပါ",
    "customers.label.ViewSpendCap": "အသုံးစရိတ်ကန့်သတ်မှုကြည့်ပါ",
    "customers.label.Amount": "ပမာဏ",
    "customers.label.PlanCode": "အစီအစဉ်ကုဒ်",
    "customers.label.Price": "ဈေးနှုန်း",
    "customers.label.Status": "အခြေအနေ",
    "customers.label.EndDate": "ကုန်ဆုံးမည့်ရက်",
    "customers.label.ContractPeriod": "စာချုပ်ကာလ",
    "customers.label.AutoRenew": "အလိုအလျောက်သက်တမ်းတိုးခြင်း",
    "customers.label.Description": "ဖော်ပြချက်",
    "customers.label.ThankYou": "ကျေးဇူးတင်ပါတယ်!",
    "customers.label.ConnectionActivated":
      "အကောင့်နံပါတ်ဖြင့် ချိတ်ဆက်မှုကို အောင်မြင်စွာဖွင့်လိုက်ပါပြီ",
    "customers.label.GoToCustomerDetail": "ဖောက်သည်အသေးစိတ်သို့သွားပါ",
    "customers.label.Payment": "ငွေပေးချေမှု",
    "customers.label.CustomerToPay": "ဝယ်သူ ပေးချေရမည်:",
    "customers.label.MonthlyPayment": "လစဉ် ပေးချေမှု",
    "customers.label.SetupWithDirectDebitOrCreditCard":
      "ဖြတ်လမ်းငွေထုတ်ကတ် သို့မဟုတ် အကြွေးဝယ်ကတ် ဖြင့် တပ်ဆင်မည်",
    "customers.label.SendLinkToCustomerToCompletePayment":
      "ငွေပေးချေမှုကို ပြီးစီးရန် ဝယ်သူအား လင့်ခ် ပို့ပါ",
    "customers.label.CheckPaymentStatus": "ငွေပေးချေမှု အခြေအနေ စစ်ဆေးပါ",
    "customers.label.ThisNumberIsReservedFor":
      "ဤနံပါတ်ကို သီးသန့်သိမ်းဆည်းထားသည်",
    "customers.label.YouSelected": "သင်ရွေးချယ်ခဲ့သည်",
    "customers.label.SerialNo": "အမှတ်စဉ်",
    "customers.label.PhoneNo": "ဖုန်းနံပါတ်",
    "customers.label.ActivatingCustomer": "ဖောက်သည်ကို ဖွင့်နေသည်...",
    "customers.label.LoadingOrderStatus": "အော်ဒါအခြေအနေ တင်နေသည်...",
    "customers.label.OrderStatus": "အော်ဒါအခြေအနေ:",
    "customers.label.Failed": "မအောင်မြင်ပါ",
    "customers.label.RoamingOutsideEEA": "EEA ပြင်ပတွင် Roaming",
    "customers.label.TariffTermsDetails":
      "သင့်ရဲ့အသုံးပြုခွင့်ထဲမပါဝင်သော စျေးနှုန်းများနှင့် အချိုးအစားများအကြောင်း အသေးစိတ်ကို ကျွန်ုပ်တို့၏ စျေးနှုန်းသတ်မှတ်ချက်များနှင့် ဝက်ဘ်ဆိုဒ်တွင် ကြည့်ရှုပါ။",
    "customers.label.PaymentTerms":
      "ကျွန်ုပ်တို့သည် သင့်ထံမှ SEPA direct debit ဖြင့် ပေးချေမှုကို ချယူမည်ဖြစ်သည်။ ချေးငွေစာချုပ်တွင် ငွေပေးချေမည့် ရက်စွဲကို ပြသမည်။ သတ်မှတ်ချက်များကို ကြိုတင်ပေးချေရန် လိုအပ်နိုင်သည်။ တစ်ချိန်ထဲတွင် သင့်အသုံးပြုမှု အလွန်များသွားပါက အကြားငွေပေးချေမှုများကို ကျွန်ုပ်တို့ တောင်းနိုင်သည်။",
    "customers.label.ServiceAgreementTerms":
      "ဝန်ဆောင်မှုစာချုပ်၏ ကြာမြင့်ချိန်၊ ပြန်လည်သက်တမ်းတိုးခြင်းနှင့် ပယ်ဖျက်မှု",
    "customers.label.Duration": "ကြာမြင့်ချိန်",
    "customers.label.Renewal": "ပြန်လည်သက်တမ်းတိုးခြင်း",
    "customers.label.ContractTermsAndConditions":
      "စာချုပ်သတ်မှတ်ချက်များနှင့်အခြေအနေများ",
    "customers.label.TermsAndConditions": "စည်းကမ်းချက်များနှင့် အခြေအနေများ",
    "customers.label.CustomerExplanation":
      "ငါဖောက်သည်အားအသေးစိတ်ရှင်းလင်းပြပြီ",
    "customers.label.CustomerAgreement":
      "သူတို့ကအမှာစာကိုဆက်လက်လုပ်ဆောင်ရန်သဘောတူသည်။",
    "customers.label.NumberReservedFor": "ဤနံပါတ်သည်ထိန်းသိမ်းထားသည်",
    "customers.label.YouSelected": "သင်ရွေးချယ်ထားသည်",
    "customers.label.SerialNo": "စီရီးနံပါတ်",
    "customers.label.PhoneNo": "ဖုန်းနံပါတ်",
    "customers.label.TotalPrice": "စုစုပေါင်းစျေးနှုန်း",
    "customers.label.FeaturesForEndUsersWithDisabilities":
      "မသန်စွမ်းအသုံးပြုသူများအတွက် လုပ်ဆောင်ချက်များ",
    "customers.label.InformationSupportServices":
      "ကျွန်ုပ်တို့၏ ဝန်ဆောင်မှုများနှင့် ပတ်သက်သော အထောက်အပံ့အချက်အလက်များကို အခြားဖောင်မက်များဖြင့်ရရှိနိုင်ပါသည်။ အခြားဖောင်မက်များဖြင့် အချက်အလက်များကို ရယူလိုပါက သင့်၏ Lycamobile SIM မှ 1200 ကို ခေါ်ဆိုပါ သို့မဟုတ်",
    "customers.label.HowWeUseYourInformation":
      "သင့်၏ အချက်အလက်များကို ကျွန်ုပ်တို့ မည်သို့ အသုံးပြုသည်",
    "customers.label.InformationUsageDetails":
      "သင့်၏ ဝန်ဆောင်မှုများ အသုံးပြုမှုနှင့် ဆက်စပ်သော အချက်အလက်များကို ကျွန်ုပ်တို့ ရယူပါမည်။ ထို့အပြင် သင့်တည်နေရာနှင့် အကောင့်လုပ်ဆောင်မှုများ ပါဝင်ပါသည်။",
    "customers.label.CustomerComplaints":
      "သင့်အနေဖြင့် ဝန်ဆောင်မှု၏ မြန်နှုန်း၊ အရည်အသွေး သို့မဟုတ် အခြားအချက်များနှင့် မကျေနပ်ပါက သုံးစွဲသူဝန်ဆောင်မှုဌာနသို့ ဆက်သွယ်ပါ။",
    "customers.label.DisputeResolution":
      "သင့်တိုင်ကြားချက်ကို 12 လအတွင်း ဆက်သွယ်နိုင်ပါသည်။",
    "customers.label.costsEuro": "ကုန်ကျစရိတ် €",
    "customers.label.thereafterEuro": "ထို့နောက် €",
    "customers.label.forTheFirst": "ပထမအတွက်",
    "customers.label.perMonthInclusiveVAT":
      "လစဉ် (CPI+ 3.9% နှင့်အတူ) VAT အပါအဝင်။ အသေးစိတ်အချက်အလက်များကို ဝက်ဘ်ဆိုက်တွင် ကြည့်ပါ။",
    "customers.label.additionalAddOns":
      "သင့်ရဲ့အစီအစဉ်အတွက် ထပ်ဆောင်း ဝန်ဆောင်မှုများ ရနိုင်ပြီး၊ သင့်ငွေတောင်းခံစာတွင် သီးခြားကျသင့်မည်။",
    "customers.label.paymentTerms":
      "သင်၏ ဝန်ဆောင်မှုများအတွက် လစဉ်ငွေပေးချေ ရမည်ဖြစ်သည်။ ချွင်းချက်မရှိပါက၊ ကျွန်ုပ်တို့သည် နောက်ကျမှုအတွက် အပိုကြေးငွေကောက်ခံနိုင်သည်။",
    "customers.label.durationRenewalTermination":
      "ကာလ၊ အသစ်ပြန်သက်တမ်းတိုးခြင်းနှင့် ဖျက်သိမ်းမှု",
    "customers.label.minimumPeriod":
      "အနည်းဆုံးကာလ 1 လဖြစ်ပြီး၊ ထိုကာလပြီးနောက် 30 ရက်ကြိုတင်အသိပေးခြင်းမရှိဘဲ ဆက်လက်အသုံးပြုနိုင်သည်။",
    "customers.label.cancellationCoolingOff":
      "သင့်မှာ 14 ရက် အတွင်း ဝန်ဆောင်မှုကို ဖျက်သိမ်းခွင့် ရနိုင်သည်။",
    "customers.label.earlyTerminationCharge":
      "သင့်ဝန်ဆောင်မှုစာချုပ်ကို သတ်မှတ်ထားသောကာလအတွင်း ပိတ်လိုက်ပါက သင့်လစဉ်ကြေးငွေနှင့်အညီ အကြေးထပ်ဆောင်းပေးရပါမည်။",
    "customers.label.ContractSummarys":
      "ဤစာချုပ်အကျဉ်းချုပ်နှင့် ၁ လကြာကြာ အပြည်ပြည်ဆိုင်ရာဝန်ဆောင်မှုများကို လက်ခံနိုင်သော ဝန်ဆောင်မှုဖြစ်သည်။ ၎င်းသည် သင့်ကို အသံခေါ်ဆိုမှုများပြုလုပ်ခြင်း၊ SMS များပို့ခြင်းနှင့်လက်ခံခြင်း၊ ဒေတာအသုံးပြုခြင်း၊ အင်တာနက်ကိုအသုံးပြုခြင်းတို့ကို ခွင့်ပြုသည်။",
    "customers.label.The": "ဒီ",
    "customers.label.ComesWith": "ပါဝင်သည်။",
    "customers.label.MobileDataSpeeds":
      "မိုဘိုင်းဒေတာဝန်ဆောင်မှုအမြန်နှုန်းများ",
    "customers.label.DataServiceDescription":
      "Lycamobile ကွန်ရက်မှရရှိနိုင်သော ဒေတာဝန်ဆောင်မှုနှင့် အနည်းဆုံးနှင့်အများဆုံးမြန်နှုန်းများသည် သင့်တည်နေရာ၊ သုံးစွဲသည့်စက်နှင့် ဝယ်ယူထားသည့်အစီအစဉ်ပေါ် မူတည်ပါသည်။ (2G, Edge, 3G, 4G, 5G)",
    "customers.label.SpeedVariation":
      "သင့်မိုဘိုင်းဒေတာဝန်ဆောင်မှု၏မြန်နှုန်းသည် မတည်ငြိမ်နိုင်ပြီး သင့်တည်နေရာ၊ ရာသီဥတု၊ သစ်ပင်များ၊ အဆောက်အဦဆင့်ကဲမှုနှင့် ကွန်ရက်အသုံးပြုသူအရေအတွက်ပေါ်မူတည်ပါသည်။",
    "customers.label.LycamobileBV": "Lycamobile B.V.",
    "customers.label.Robijnlaan17": "Robijnlaan 17,",
    "customers.label.2132WXHoofddorp": "2132WX Hoofddorp,",
    "customers.label.TheNetherlands": "နယ်သာလန်",
    "customers.label.ContractSummary": "စာချုပ်အကျဉ်းချုပ်",
    "customers.label.ContractSummaryDescription1":
      "ဤစာချုပ်အကျဉ်းချုပ်သည် ဥပဒေအရ လိုအပ်သော ဝန်ဆောင်မှုကမ်းလှမ်းမှု၏ အဓိကအချက်များကို ပေးဆောင်ပါသည်။",
    "customers.label.ContractSummaryDescription2":
      "ဝန်ဆောင်မှုကမ်းလှမ်းမှုများကို နှိုင်းယှဉ်ရန် အထောက်အကူပြုသည်။",
    "customers.label.ContractSummaryDescription3":
      "ဝန်ဆောင်မှုနှင့်စပ်လျဉ်းသော ပြည့်စုံသောအချက်အလက်များသည် အခြားစာရွက်စာတမ်းများတွင် ပါရှိသည်။",
    "customers.label.ContractSummaryValidity":
      "ဤစာချုပ်အကျဉ်းချုပ်သည် Checkout သက်တမ်းကုန်ဆုံးသည်အထိ有ထိရောက်မည်။",
    "customers.label.AcceptOffer":
      "ဤကမ်းလှမ်းမှုသည် သင့်တော်မည်ဆိုလျှင် Checkout စာမျက်နှာမှ တဆင့် လက်ခံနိုင်ပါသည်။ သင့်မှတ်တမ်းအတွက် ဤစာရွက်စာတမ်းတစ်စောင်ကို သိမ်းဆည်းထားပါ။",
    "customers.label.Services": "ဝန်ဆောင်မှုများ",
    "customers.label.TermsConditions":
      "ဝန်ဆောင်မှုသဘောတူညီမှု၏ စည်းမျဉ်းများနှင့်သတ်မှတ်ချက်များအောက်တွင်၊ ကျွန်ုပ်တို့က သဘောတူညီမှု၏ အရေးကြီးသောစည်းမျဉ်းတစ်ခုကို ချိုးဖောက်ပြီး၊ သင့်ဝန်ဆောင်မှုတွင် ဒေတာပေးနိုင်မှုကို လုံးဝတားဆီးလျှင်၊ သင့်တိုင်ကြားချက်ကို ၇ ရက်အတွင်း ပြုပြင်မထားလျှင်၊ သဘောတူညီမှုကို ရပ်စဲနိုင်ပါသည်။",
    "customers.label.EmergencyOrganisations":
      "အရေးပေါ်အဖွဲ့အစည်းများနှင့် ခေါ်ဆိုသူတည်နေရာ အချက်အလက်",
    "customers.label.EmergencyCallNetworkDown":
      "Lycamobile ၏ကွန်ရက် အလုပ်မလုပ်သည့်အခါ၊ သင့်ဖုန်းသည် 2G, 3G, 4G သို့မဟုတ် 5G ကွန်ရက်ကို ချိတ်ဆက်နိုင်ရမည်။",
    "customers.label.EmergencyCallAvailability":
      "ကွန်ရက် ရှိနေသမျှသာ အရေးပေါ်ခေါ်ဆိုမှုများ ပြုလုပ်နိုင်ပါသည်။",
    "customers.label.PlanName": "ပလန်အမည်",
    "customers.label.EuropeanOnlineDisputeResolution":
      "ဥရောပအွန်လိုင်း အငြင်းပွားမှုဖြေရှင်းမှုဆိုဒ်",
    "customers.label.ECWebsite": "ec.europa.eu/consumers/odr",
    "customers.label.DisputeResolutionDetails":
      "ဤဆိုဒ်သည် သုံးစွဲသူများအား ကျွန်ုပ်တို့နှင့်အတူ အွန်လိုင်းဝယ်ယူမှုဆိုင်ရာ အငြင်းပွားမှုများကို တင်ပြနိုင်စေရန် ခွင့်ပြုပေးသည်။ သင်သည် ကျွန်ုပ်တို့၏ မတိုင်ခင်အကူအညီပေးခြင်းဆိုင်ရာ စည်းမျဉ်းများနှင့် အခြားလွှဲခြင်းဖြေရှင်းမှုများအကြောင်း အခြားသောသတင်းအချက်အလက်များကို ကျွန်ုပ်တို့၏ ဝက်ဘ်ဆိုဒ်တွင်ကြည့်ရှုနိုင်ပါသည်။",
    "customers.label.NetherlandsLawCompliance":
      "အင်တာနက်ဝန်ဆောင်မှု၏ အမြန်နှုန်းသည့် အချက်အလက်များသည် မမှန်ကန်ခြင်း ရှိပါက၊ ဥပဒေအရ Lycamobile သည် သတ်မှတ်ချိန်အတွင်း ပြန်လည်လုပ်ဆောင်ပေးမည်ဖြစ်သည်။ ပြန်လည်လုပ်ဆောင်မှု မဖြစ်နိုင်ပါက, Lycamobile သည် ဝန်ဆောင်ခ ကို သင့်တင့်သလို လျှော့ချမည်ဖြစ်သည်။",
    "customers.label.DirectoryServiceInfo":
      "သင့်မိုဘိုင်းဖုန်းနံပါတ်ကိုဖုန်းလမ်းညွှန်နှင့်/သို့မဟုတ်ဖုန်းမေးမြန်းမှုဝန်ဆောင်မှုတွင်ထည့်သွင်းပေးရန် ကျွန်ုပ်တို့ကိုတောင်းဆိုနိုင်သည်။ သို့သော် ဤဝန်ဆောင်မှုကိုတောင်းဆိုပါက သင့်နံပါတ်သည် စျေးကွက်ရှာဖွေရေးအတွက် အချက်အလက်စုဆောင်းသောကုမ္ပဏီများထံတွင် မြင်ရနိုင်မည်ဖြစ်သည်။",
    "customers.label.RemediesComplaints":
      "ပြဿနာဖြေရှင်းမှု၊ တိုင်ကြားမှုများနှင့် အငြင်းပွားမှုဖြေရှင်းမှု",
    "customers.label.ContactCustomerService":
      "သင့်အနေဖြင့် ဖုန်းဝန်ဆောင်မှုသို့ ဆက်သွယ်လိုပါက ဝက်ဘ်ဆိုဒ်သို့သွားပြီး 'ဆက်သွယ်ရန်' ကိုနှိပ်ပါ။",
    "customers.label.IncludeMobileNumber":
      "သင်တို့ဖုန်းနံပါတ်ထည့်ပါ။ ကျွန်ုပ်တို့သည်သင့်တိုင်ကြားမှုကိုဖြေရှင်း၍မရပါက၊ သင်သည် ၂၄ လအတွင်း De Geschillencommissie ( Postbus 90600, 2509 LP, Den Haag ) သို့ တင်ပြနိုင်သည်။",
    "customers.label.Termination": "သတ်မှတ်ချုပ်ဆိုမှု",
    "customers.label.TerminationNotice":
      "အနည်းဆုံးကာလပြီးနောက် သင်သည် သတိပေးချက်ပေးပြီး သဘောတူညီမှုကို ပြုလုပ်နိုင်သည်။",
    "customers.label.EarlyTerminationCharge":
      "သင်သည် သတ်မှတ်ထားသော ကာလအတွင်း သဘောတူညီမှုကို ဖြတ်တောက်လိုပါက သို့မဟုတ် သင်၏ အပြစ်ကြောင့် ကျွန်ုပ်တို့သည် သဘောတူညီမှုကို ဖြတ်တောက်ပါက သင်သည် ရှေးဦးဖြတ်တောက်ခကြေးပေးရမည်။",
    "customers.label.OptionalAddOnTermination":
      "အပိုဝန်ဆောင်မှုများသည် သီးခြားဖြတ်တောက်နိုင်ပါသည်။",
    "customers.label.CancellationInfo":
      "သင်သည် ဝန်ဆောင်မှုကို 14 ရက်အတွင်း ဖြတ်တောက်နိုင်သည်။",
    "customers.label.Security": "လုံခြုံရေး",
    "customers.label.DataProtection":
      "သင်၏ကိုယ်ရေးကိုယ်တာအချက်အလက်များကို မူဝါဒအတိုင်း ကာကွယ်ပေးပါသည်။",
    "customers.label.TariffTerms":
      "ကျေးဇူးပြု၍ သတ်မှတ်ထားသော တစ်ခုချင်းစီ၏ ဈေးနှုန်းများနှင့် သင့်ရဲ့ အခွန်များအတွက် တိကျသော အသေးစိတ်များကို ကြည့်ရှုပါ။",
    "customers.label.DeliveryOfService": "ဝန်ဆောင်မှု ပေးပို့မှု",
    "customers.label.PaymentTerms":
      "SEPA များမှတဆင့် သင့်လွှဲရမည့်ငွေကို ကျွန်ုပ်တို့ သင့်အကောင့်မှ ချိတ်ဆက်ထုတ်ယူပါမည်။ သို့မဟုတ်...",
    "customers.label.ServiceStartDate":
      "Lycamobile မှ ဝန်ဆောင်မှု ပေးသည့် ရက်စွဲသည် သင့်လုပ်ဆောင်သည့် မှတ်ပုံတင်ခြင်း၏ ရက်စွဲဖြစ်သည်။",
    "customers.label.ContractDuration":
      "ဝန်ဆောင်မှု သဘောတူညီချက်၏ သက်တမ်း, ပြန်လည်သက်တမ်းတိုးခြင်းနှင့် ဖြုတ်ချခြင်း",
    "customers.label.MinimumPeriod":
      "သင့်စာချုပ်တွင် အနည်းဆုံး သက်တမ်းရှိပြီး 1 လ အနည်းဆုံး သက်တမ်းဖြင့် လစဉ် အထူး အစီအစဉ်များနှင့် 24 လ အထိ သတ်မှတ်စာချုပ်များအတွက် သက်တမ်းရှိသည်။",
    "customers.label.ContractRenewal":
      "စာချုပ်ကို ပြန်လည်သက်တမ်းတိုးရန်, သင့်စာချုပ်သက်တမ်း အတွင်း Lycamobile ကို အကြောင်းကြားပေးရမည်။",
    "customers.label.DataCostDetails":
      "{40 GB} ကို {3 လ} အတွက် {18.90 €} ဖြင့် ဝယ်ယူနိုင်ပါသည်။ ထို့နောက် {27.00 €} တစ်လလျှင်ကျသင့်ပါမည်။ VAT ပါဝင်ပြီး CPI + 3.9% နှုန်းဖြင့်နှစ်စဉ်တိုးမြှင့်မည်ဖြစ်သည်။ အသေးစိတ်အချက်အလက်များကို ကျွန်ုပ်တို့၏ဝက်ဘ်ဆိုဒ်တွင်ကြည့်ရှုပါ။",
    "customers.label.AdditionalAddons":
      "သင့်၏အစီအစဉ်အတွက်ထပ်မံသော Add-ons များရရှိနိုင်ပြီး သီးခြားကုန်ကျစရိတ်ဖြင့်ဝယ်ယူရမည်။",
    "customers.label.SpendingLimits": "အသုံးစရိတ်ကန့်သတ်မှုများ",
    "customers.label.SpendingLimitDetails":
      "Lycamobile သည် သင့်၏စရိတ်များကို သင့်ကြိုက်နှုန်းအတိုင်းထိန်းချုပ်မည်ဖြစ်သည်။ အများဆုံး €250 အထိသတ်မှတ်ထားသည်။",
    "customers.label.PremiumCharges":
      "ထူးခြားသောဖုန်းနံပါတ်များ, SMS များနှင့်နိုင်ငံတကာဖုန်းခေါ်ဆိုမှုများသည် အစီအစဉ်တွင်မပါဝင်ပါ။",
    "customers.label.InternationalRates":
      "နယ်စပ်များတွင် အပြည်ပြည်ဆိုင်ရာခေါ်ဆိုမှုနှုန်းထားများအတိုင်းကျသင့်မည်။",
    "customers.label.RoamingInEEA": "EEA အတွင်း Roaming",
    "customers.label.RoamingOutsideEEA": "EEA အပြင် Roaming",
    "customers.label.RoamingCharges":
      "နှစ်ခြိုက်မှုနှင့်သုံးစွဲမှုများ (ဖုန်းခေါ်, စာတို, ဒေတာ) ကို နယ်စပ်ပြင်ပတွင်အသုံးပြုလျှင်, နိုင်ငံတကာ roaming နှုန်းထားများအတိုင်း ကျသင့်မည်။",
    "customers.label.Any_Out_of_bundle_charges_can_be_found_at":
      "ထပ်မံငွေချထားရမည့်အခကြေးငွေများကို ဒီမှာတွေ့နိုင်ပါသည်။",
    "customers.label.Exclusions_for_voice_international_voice_SMS_Data_Roaming_can_be_found_at":
      "အသံ၊ အပြည်ပြည်ဆိုင်ရာအသံ၊ SMS၊ ဒေတာ Roaming အတွက် ချန်ထားသောအချက်များကို ဒီမှာတွေ့နိုင်ပါသည်။",
    "customers.label.Our_Services_availability":
      "ကျွန်ုပ်တို့၏ ဝန်ဆောင်မှုများသည် နယ်သာလန်၊ EEA သို့မဟုတ် အခြားရွေးချယ်ထားသည့်နေရာများတွင် မရှိနိုင်ပါ။",
    "customers.label.Lycamobile_network_speeds":
      "Lycamobile နက်‌ဝပ်ကွန်ရက်မှတစ်ဆင့် သင့်တည်နေရာတွင်ရရှိနိုင်သည့် အနည်းဆုံးနှင့် အများဆုံးအမြန်နှုန်းများသည် သင့်သုံးသည့်အကြိမ်နှုန်းနှင့် ပတ်သက်ပြီးဖြစ်သည်။",
    "customers.label.Mobile_data_speed_variation":
      "သင့်ဒေတာအမြန်နှုန်းသည် သင့်တည်နေရာ၊ မိုးလေဝသ၊ အပင်ဖုံးအုပ်မှု၊ အဆောက်အဦလျှောက်ပတ်မှုနှင့်ပတ်သက်၍ မတူညီနိုင်ပါ။",
    "customers.label.Price": "စျေးနှုန်း",
    "customers.label.ContractReview": "စာချုပ်သုံးသပ်မှု",
    "customers.label.Terms&Conditions": "သတ်မှတ်ချက်များနှင့်စည်းကမ်းများ",
    "customers.label.ReviewThisContract": "ဤစာချုပ်ကို ပြန်လည်သုံးသပ်ပါ",
    "customers.label.We_have_sent_these_to":
      "ကျွန်ုပ်တို့သည် ဤစာများကို ပို့လိုက်ပါပြီ",
    "customers.label.DownloadContractInformation":
      "စာချုပ်အချက်အလက်ကို ဒေါင်းလုပ်ဆွဲပါ",
    "customers.label.DownloadContractSummary":
      "စာချုပ်အကျဉ်းချုပ်ကို ဒေါင်းလုပ်ဆွဲပါ",
    "customers.label.ContractInformation": "စာချုပ်အချက်အလက်",
    "customers.label.ContactDetails": "ဆက်သွယ်ရန်အသေးစိတ်",
    "customers.label.Description_of_Services": "ဝန်ဆောင်မှုဖော်ပြချက်",
    "customers.label.This_contract_summary_and_our_Abonnement_offer_of":
      "ဤစာချုပ်အကျဉ်းချုပ်နှင့် ကျွန်ုပ်တို့၏ ဝန်ဆောင်မှုကမ်းလှမ်းချက်",
    "customers.label.an_airtime_service_for": "အချိန်သုံးဝန်ဆောင်မှု",
    "customers.label.comes_with:": "ပါဝင်သည်:",
    "customers.label.Any_Out_of_bundle_charges_can_be_found_at:":
      "အပိုဝန်ဆောင်မှုကြေးများကို ဤနေရာတွင် ကြည့်နိုင်သည်:",
    "customers.label.service_description":
      "ဤဝန်ဆောင်မှုသည် သင့်အား အသံခေါ်ဆိုမှုများပြုလုပ်ခြင်းနှင့် လက်ခံခြင်း၊ SMS မက်ဆေ့ချ်များပို့ခြင်းနှင့် လက်ခံခြင်း၊ ဒေတာအသုံးပြုခြင်းနှင့် အင်တာနက်သုံးစွဲခြင်း စသည့် ဝန်ဆောင်မှုများကို ပေးနိုင်သည်။",
    "customers.label.YouHaveChosenNoCap":
      "သင့်တော်သော ကန့်သတ်မရှိသော နည်းလမ်းကို ရွေးချယ်ထားသည်။ ဤသည်မှာ သင်၏ဖုန်းကို ခေါ်ဆိုမှုများ၊ မက်ဆေ့ချ်များ၊ အပြည်ပြည်ဆိုင်ရာ မိနစ်များ၊ roaming နှင့် သင်၏လစဉ် အလွှာမှ ပြင်ပဒေတာများအတွက် အသုံးပြုနိုင်သည်။ ဤအတွက် သင့်အား €60 အထိ အခကြေးငွေ ကောက်ခံမည်ဖြစ်သည်။",
    "customers.label.SelectDate":
      "ရက်စွဲရွေးချယ်ပါ [လစဉ်ငွေပေးချေမှုကို သင်ရွေးချယ်ထားသော ငွေတောင်းခံမှု ပြုလုပ်သည့် ရက်စွဲမှ ၁၄ ရက်အတွင်း သင့်အကောင့်မှ ဖြတ်သွားမည်ဖြစ်သည်] *",
    "customers.label.BillingCycle": "ဘေလ်ဖြည့်ချိန်",
    "customers.label.SelectBilling": "ဘေလ်ရွေးချယ်ပါ",
    "customers.label.I_Agree_To": "ငါသဘောတူသည်",
    "customers.label.TermsAndConditions": "စည်းမျဉ်းများနှင့် သတ်မှတ်ချက်များ",
    "customers.label.ThisNumberIsReservedFor": "ဤနံပါတ်ကို မှာယူထားသည်",
    "customers.label.TotalPrice": "စုစုပေါင်းစျေးနှုန်း:",
    "customers.label.CustomerInfo": "ဖောက်သည်အချက်အလက်",
    "customers.label.title": "ခေါင်းစဉ်",
    "customers.label.SelectTitle": "ခေါင်းစဉ်ရွေးပါ",
    "customers.label.initials": "မူလစာလုံးများ",
    "customers.label.Basket": "ခြင်းတောင်း",
    "customers.label.first_name": "နာမည်",
    "customers.label.last_name": "မျိုးနွယ်အမည်",
    "customers.label.email_address": "အီးမေးလ်လိပ်စာ",
    "customers.label.contact_number": "ဆက်သွယ်ရန်နံပါတ်",
    "customers.label.date_of_birth": "မွေးနေ့",
    "customers.label.select_language": "ဘာသာစကားရွေးပါ",
    "customers.label.how_did_you_hear": "သင့်အနေနဲ့ ဘယ်လိုကြားရသလဲ?",
    "customers.label.postal_code": "စာတိုက်ကုဒ်",
    "customers.label.country": "နိုင်ငံ",
    "customers.label.Enter_address_manually": "လိပ်စာကိုကိုယ်တိုင်ရိုက်ထည့်ပါ",
    "customers.label.Find_address": "လိပ်စာရှာဖွေပါ",
    "customers.label.Select_Address": "လိပ်စာရွေးချယ်ပါ",
    "customers.label.Select_an_address": "တစ်ခုရွေးချယ်ပါ",
    "customers.label.Monthly_Bill_Generation_Date": "လစဉ်ငွေတောင်းခံမှုနေ့စွဲ",
    "customers.label.Select_a_Monthly_Plan": "လစဉ် အစီအစဉ်ရွေးပါ",
    "customers.label.Search_plans": "အစီအစဉ်များရှာဖွေပါ...",
    "customers.label.search": "ရှာဖွေပါ",
    "customers.label.Select_a_plan": "အစီအစဉ်ရွေးချယ်ပါ",
    "customers.label.Basket": "ခြင်းတောင်း",
    "customers.label.This_number_is_reserved_for": "ဤနံပါတ်သည် သတ်မှတ်ထားသည်",
    "customers.label.ViewT&C": "သတ်မှတ်ချက်များ ကြည့်ပါ",
    "customers.label.TransferringFromPreviousNetwork":
      "ရှေးနာမည်ပြောင်းလဲခြင်း (သင့်ဟောင်းနံပါတ်ကိုယူပါ)",
    "customers.label.SIM_Information": "SIM သတင်းအချက်အလက်",
    "customers.label.Prepaid": "ကြိုတင်ငွေပေးချေမှု",
    "customers.label.Postpaid": "နောက်ဆုံးငွေပေးချေမှု",
    "customers.label.Physical_SIM": "ရုပ်ပိုင်းဆိုင်ရာ SIM",
    "customers.label.eSIM": "eSIM",
    "customers.label.SelectCustomerType": "ဖောက်သည်အမျိုးအစားရွေးချယ်ပါ",
    "customers.label.New_to_Lyca": "Lyca အသစ်",
    "customers.label.Convert_Lyca_Prepaid_to_Postpaid":
      "Lyca ကြိုတင်ငွေပေးချေမှ နောက်ဆုံးငွေပေးချေသို့ ပြောင်းလဲပါ",
    "customers.label.Existing_customer_is_going_to_be_sent_a_secure_link_to_confirm_that_they_wish_to_move_from_prepaid_to_abonnement.":
      "လက်ရှိဖောက်သည်သည် ကြိုတင်ငွေပေးချေမှ ဝယ်ယူမှုသို့ ပြောင်းလဲလိုကြောင်း အတည်ပြုရန် လုံခြုံသော လင့်ခ်တစ်ခုကို ပို့လိမ့်မည်။",
    "customers.label.Customer_to_receive_an_SMS":
      "ဖောက်သည်သည် SMS တစ်ခုလက်ခံရရှိမည်။",
    "customers.label.Lyca_Mobile_Number": "Lyca မိုဘိုင်းနံပါတ်",
    "customers.label.Enter_the_Lyca_Mobile_Number":
      "Lyca မိုဘိုင်းနံပါတ်ကို ထည့်ပါ",
    "customers.label.Nationality": "နိုင်ငံသား",
    "customers.label.Send_Secure_link": "လုံခြုံသောလင့်ခ်ပို့ပါ",
    "customers.label.New_to_Lyca_Mobile": "Lyca Mobile အသစ်",
    "customers.label.serial_number": "နံပါတ်စဉ်",
    "customers.label.Serial_Number": "နံပါတ်စဉ် (နောက်ဆုံး 4 လုံး)",
    "customers.label.PUK_Code": "PUK ကုဒ်",
    "customers.label.PUK_Code_is_not_matched": "PUK ကုဒ်ကို ကိုက်ညီမှုမရှိပါ",
    "customers.label.Switching_to_Lyca_Mobile":
      "Lyca Mobile သို့ ပြောင်းလဲခြင်း",
    "customers.label.Enter_the_PUK_Code": "PUK ကုဒ်ကို ထည့်ပါ",
    "customers.label.Basket": "ဈေးခြင်းတောင်း",
    "customers.label.Gender": "ကျား/မ",
    "customers.label.business_name": "လုပ်ငန်းအမည်",
    "customers.label.phone_number": "ဖုန်းနံပါတ်",
    "customers.label.Date_of_Birth": "မွေးသက္ကရာဇ်",
    "customers.label.VIP": "ဗွီအိုင်ပီ",
    "customers.label.Disability": "မသန်စွမ်းမှု",
    "customers.label.District": "ခရိုင်",
    "customers.label.Is_your_billing_address_same_as_primary_address":
      "သင်၏ဘီလ်လိပ်စာသည် မူလလိပ်စာနှင့်တူညီပါသလား?",
    "customers.label.Supressbill": "ဘီလ်ဖျောက်ရန်",
    "customers.label.SelectCategory": "အမျိုးအစားရွေးချယ်ရန်",
    "customers.label.SelectGender": "ကျား/မရွေးချယ်ရန်",
    "customers.label.SelectPreferences": "နှစ်သက်မှုရွေးချယ်ရန်",
    "customers.label.SelectNationality": "နိုင်ငံသားရွေးချယ်ရန်",
    "customers.label.SelectVIP": "ဗွီအိုင်ပီရွေးချယ်ရန်",
    "customers.label.SelectDisability": "မသန်စွမ်းမှုရွေးချယ်ရန်",
    "customers.label.SelectCity": "မြို့ရွေးချယ်ရန်",
    "customers.label.SelectBillDay": "ဘီလ်နေ့ရွေးချယ်ရန်",
    "customers.label.SelectType": "အမျိုးအစားရွေးချယ်ရန်",
    "customers.label.SelectFiscalYear": "ဘဏ္ဍာနှစ်ရွေးချယ်ရန်",
    "customers.label.SelectFiscalQuarter": "ဘဏ္ဍာသုံးလပတ်ရွေးချယ်ရန်",
    "customers.label.SelectBillMode": "ဘီလ်ပုံစံရွေးချယ်ရန်",
    "customers.label.SelectInvoiceType": "ငွေတောင်းခံလွှာအမျိုးအစားရွေးချယ်ရန်",
    "customers.label.IMSI": "IMSI",
    "customers.label.SalesMotion": "အရောင်းလှုပ်ရှားမှု",
    "customers.label.SpendCap": "အသုံးစရိတ်ကန့်သတ်ချက်",
    "customers.label.ActivationDate": "ဖွင့်ခြင်းရက်စွဲ",
    "customers.label.ExpiryDate": "သက်တမ်းကုန်ဆုံးရက်",
    "customers.label.NextRenewalDate": "နောက်ထပ်သက်တမ်းတိုးရန်ရက်စွဲ",
    "customers.label.BalanceTransfer": "လက်ကျန်ငွေပြောင်းခြင်း",
    "customers.label.RecieverClientId": "လက်ခံသူဖောက်သည် ID",
    "customers.label.Amount": "ငွေပမာဏ",
    "customers.label.EnterTopUpAmount": "ထည့်ရန်ငွေပမာဏရိုက်ထည့်ပါ",
    "customers.label.ResponseId": "တုံ့ပြန်မှု ID",
    "customers.label.BalanceName": "လက်ကျန်ငွေ အမည်",
    "customers.label.Allowance": "ခွင့်ပြုငွေ",
    "customers.label.Consumption": "အသုံးပြုမှု",
    "customers.label.AvailableBalance": "အသုံးပြုနိုင်သောလက်ကျန်ငွေ",
    "customers.label.DaysLeft": "ကျန်ရှိသောရက်များ",
    "customers.label.Discount": "လျှော့စျေး",
    "customers.label.postal_code": "စာတိုက်အမှတ်",
    "customers.label.address_number": "လိပ်စာနံပါတ်",
    "customers.label.city": "မြို့",
    "customers.label.state": "ပြည်နယ်",
    "customers.label.comment_date": "မှတ်ချက်ရက်စွဲ",
    "customers.label.country": "နိုင်ငံ",
    "customers.label.resident_period": "နေထိုင်ချိန်ကာလ",
    "customers.label.postcode": "စာတိုက်အမှတ်",
    "customers.label.how_did_you_hear": "သင်ကဘယ်လိုကျွန်ုပ်တို့ကိုသိခဲ့ပါသလဲ?",
    "customers.label.select_language": "ဘာသာစကားရွေးချယ်ပါ",
    "customers.label.email_address": "အီးမေးလ်လိပ်စာ",
    "customers.label.contact_number": "ဆက်သွယ်ရန်နံပါတ်",
    "customers.label.initials": "စတင်စာလုံးများ",
    "customers.label.communication_type": "ဆက်သွယ်မှုအမျိုးအစား",
    "customers.label.BuySIM": "SIM ဝယ်မည်",
    "customers.label.origination": "မူလ မူတည်ရာ",
    "customers.label.address": "လိပ်စာ",
    "customers.label.destination_address": "ဂူရောက်ရန်လိပ်စာ",
    "customers.label.event": "ဖြစ်ရပ်",
    "customers.label.charge_party": "အခကြေးငွေပေးရသူ",
    "customers.label.service_subs_type": "ဝန်ဆောင်မှု Subscription အမျိုးအစား",
    "customers.label.calling_party": "ခေါ်ဆိုသူ",
    "customers.label.called_party": "လက်ခံသူ",
    "customers.label.usage": "အသုံးပြုမှု",
    "customers.label.monetary_charge": "ငွေကြေးကုန်ကျမှု",
    "customers.label.result_code": "ရလဒ်ကုဒ်",
    "customers.label.generation_time": "ဖန်တီးချိန်",
    "customer.label.generationdatetime": "Ngày và giờ tạo",
    "customers.label.transaction_id": "ငွေလွှဲ ID",
    "customers.label.application_transaction_id": "အက်ပလီကေးရှင်းငွေလွှဲ ID",
    "customers.label.application_name": "အက်ပလီကေးရှင်းအမည်",
    "customers.label.recharge_value": "အကောင့်ဖြည့်တန်ဖိုး",
    "customers.label.interface": "အသုံးပြုမှုမျက်နှာပြင်",
    "customers.label.result": "ရလဒ်",
    "customers.label.comment": "မှတ်ချက်",
    "customers.label.recharge": "အကောင့်ဖြည့်",
    "customers.label.cdr": "CDR",
    "customers.label.notifications": "အသိပေးချက်များ",
    "customers.label.mobile_no": "Enter Mobile No",
    "customers.label.email_id": "Enter Email Id",
    "customers.label.serial_number": "Serial No",
    "customers.label.digital_content": "ဒီဂုတ်စာရင်း",
    "customers.label.buySim": "SIM ဝယ်ပါ",
    "customers.label.outstanding_due": "တင်မရသေးသောငွေ",
    "customers.label.due_date": "ပေးချေရမည့်နေ့",
    "customers.label.unbilled_amount": "မလွှာဆောင်ရသေးသောငွေ",
    "customers.label.next_bill_day": "နောက်တစ်ကြိမ်အမိန့်နေ့",
    "customers.label.view_allowances": "ထောက်ပံ့ငွေကိုကြည့်ပါ",
    "customers.label.view_service_details":
      "ဝန်ဆောင်မှုအသေးစိတ်အချက်အလက်များကို ကြည့်ရှုပါ။",
    "customers.label.spend_limit": "အသုံးချမှုကန့်သတ်ချက်",
    "customers.label.topup_balance": "လက်ကျန်ငွေတိုးချဲ့ပါ",
    "customers.label.next_renewal_date": "နောက်ထပ်အသစ်ပြန်ကြိမ်နေ့",
    "customers.label.allowance": "ထောက်ပံ့ငွေ",
    "customers.label.ViewDocumentUpload": "စာရွက်စာတမ်းတင်ခြင်းကို ကြည့်ပါ",
    "customers.label.total_net_amount": "စုစုပေါင်းသန့်စင်ငွေပမာဏ",
    "customers.label.cancelRemark": "မှတ်ချက် ပယ်ဖျက်ပါ။",
    "customers.label.cancelPayment": "ငွေပေးချေမှုကို ပယ်ဖျက်ပါ။",
    "customers.label.all": "အားလုံး",
    "customers.label.billProfile": "ဘောက်ချာပရိုဖိုင်",
    "customers.label.charges": "အခကြေးငွေများ",
    "customers.label.book_order": "စာအုပ်မှန်ကျင့်သုံးရန်",
    "customers.label.customers": "ဖောက်သည်များ",
    "customers.label.search_for_clients": "ဖောက်သည့်သူများရှာဖွေမှု",
    "customers.label.advance_search": "အဆင့်မြှင့်တင်ရန်ရှာဖွေမှု",
    "customers.label.create_customer": "ဖောက်သည်များဖန်တီးရန်",
    "customers.label.account_no": "အကောင့်နံပါတ်",
    "customers.label.created_by": "တည်ဆောက်သူ",
    "customers.label.created_on": "တည်ဆောက်သောနေ့စွဲ",
    "customers.label.credit_limit": "အကြွေးကန့်သတ်",
    "customers.label.transaction_history": "ငွေလွှဲသမိုင်း",
    "customers.label.external_activity_log": "ပြင်ပလှုပ်ရှားမှုမှတ်တမ်း",
    "customers.label.settings": "စိတ်ကြိုက်ပြင်ဆင်မှုများ",
    "system.label.currency_noncurrency": "ငွေ မငွေ",
    "entity.label.configure": "ကိုန်ဖစ်ဂျူး",

    "customers.label.customer_name": "ဖောက်သည့်သူအမည်",
    "customers.label.business_entity": "လုပ်ငန်းစဉ်သည့်အစိုးရ",
    "customers.label.serial_no": "စဥ်နံပါတ်",
    "customers.label.balance": "လက်ကျန်ငွေ",
    "customers.label.valid_from": "Sah Dari",
    "customers.label.valid_to": "Sah Hingga",
    "customers.label.non_currency_details": "Butiran Bukan Mata Wang",
    "customers.label.view_details": "Lihat Butiran",
    "customers.label.status": "အခြေအနေ",
    "customers.label.first_name": "အသုံးပြုသည့်အမည်",
    "customers.label.price_discount": "စျေးနှုန်းနှင့် လျှော့စျေး",
    "customers.label.collection_status": "စုဆောင်းမှုအခြေအနေ",
    "customers.label.last_name": "အဆင့်မြှင့်သောအမည်",
    "customers.label.city_area": "မြို့/ဧရိယာ",
    "customers.label.email": "အီးမေးလိပ်",
    "customers.label.phone": "ဖုန်း",
    "customers.label.cafid": "CAF Id",
    "customers.label.enter_business_entity":
      "လုပ်ငန်းအဖွဲ့အစည်းကို ထည့်သွင်းပါ။",
    "customers.label.select": "ရွေးချယ်ပါ",
    "customers.label.refund": "ပြန်ပေးငွေ",
    "customers.label.refund_id": "ပြန်ပေးငွေရေးအမှတ်",
    "customers.label.refund_amount": "ပြန်ပေးငွေရေးပမာဏ",
    "customers.label.select_category_type": "အမျိုးအစားအမျိုးအစားရွေးချယ်ရန်",
    "customers.label.clear": "ရှင်းလင်းပါ",
    "customers.label.search": "ရှာဖွေပါ",
    "customers.label.customer_activation": "ဖောက်သည့်သူကိုဖွင့်ရန်",
    "customers.label.customer_details": "ဖောက်သည့်သူအသေးစိတ်",
    "customers.label.loc": "LOC",
    "customers.label.customer_category": "ဖောက်သည့်သူအမျိုးအစား",
    "customers.label.service_details": "ဝန်ဆောင်မှုအသေးစိတ်",
    "customers.label.name": "အမည်",
    "customers.label.add_service": "ဝန်ဆောင်မှုထည့်ရန်",
    "customers.label.network_node": "ကွန်ယက်နယ်",
    "customers.label.device_details": "ကိရိယာအသေးစိတ်",
    "customers.label.bill_item_details": "ဘေလ်အကြောင်းအရာအသေးစိတ်",
    "customers.label.charge_id": "ကြေးအမှတ်အသား",
    "customers.label.order_id": "အမှာစာအမှတ်အသား",
    "customers.label.item_tax_details": "ပစ္စည်းအခွန်အသေးစိတ်",
    "customers.label.discount_details": "လျှော့စျေးအသေးစိတ်",
    "customers.label.sale_date": "ရောင်းသူ့ရက်စွဲ",
    "customers.label.item": "ပစ္စည်း",
    "customers.label.discount_code": "လျှို့ဝှက်ကုဒ်",
    "customers.label.total_price": "စုစုပေါင်းစျေးနှုန်း",
    // "customers.label.device_details": "ကိရိယာအသေးစိတ်",
    "customers.label.plan_details": "စီမံချိန်ညှိုင်းသောလျှောက်လွှာ",
    "customers.label.payment_details": "ငွေပေးချေမှုအသေးစိတ်",
    "customers.label.plan_list": "လျှောက်လွှာစာရင်း",
    "customers.label.plan": "လျှောက်လွှာ",
    "customers.label.contract_period": "စာရင်းရေးလိပ်စာ",
    "customers.label.charge_cycle": "ငွေပမာဏစတင်ခွင့်",
    "customers.label.cancel": "ပယ်ဖျက်",
    "customers.label.next": "နောက်",
    "customers.label.done": "ပြီးစီးပြီး",
    "customers.label.reopen": "ပြန်ဖွင့်သည်။",
    "customers.label.submit": "တင်",
    "customers.label.view_customer": "ဖြည့်သူကိုကြည့်ရန်",
    "customers.label.account_number": "အကောင့်နံပါတ်",
    "customers.label.office_hierarchy": "ရာထူးရေးအုပ်စုအရည်အချင်း",
    "customers.label.account_type": "အကောင့်အမျိုးအစား",
    // "customers.label.balance": "လက်ကျန်စစ်",
    "customers.label.stb_serial_no": "STB စျေးနှုန်းနံပါတ်",
    "customers.label.non_currency_balance": "ငွေကြေးမတန်းတမ်းလက်ကျန်",
    "customers.label.service_orders": "ဝန်ဆောင်မှု စာရင်းများ",
    "customers.label.more_info": "ပိုမိုသော အချက်အလက်",
    "customers.label.notes": "မှတ်ချက်များ",
    "customers.label.device": "စက်ရုပ်များ",
    "customers.label.tickets": "လက်မှတ်များ",
    "customers.label.on_demand": "လိုအပ်တယ်",
    "customers.label.on_demand_billing": "လိုအပ်ချက်အရ ငွေတောင်းခံခြင်း",
    "customers.label.payments": "ငွေပေးချေများ",
    "customers.label.invoice": "ငွေချေစောင့်",
    "customers.label.activity_log": "လုပ်ငန်းမှတ်တမ်း",
    "customers.label.contact_information": "ဆက်သွယ်ရန်အချက်အလက်",
    "customers.label.address_information": "လိပ်စာအချက်အလက်",
    "customers.label.billing_information": "ငွေဖြည့်ချိန်ညှိနှိုင်းအချက်အလက်",
    "customers.label.balance_information": "လက်ကျန်အချက်အလက်",
    // "customers.label.customer_name": "ဖောက်သည်အမည်",
    "customers.label.parent_child": "မိသား/အိမ်",
    "customers.label.created_date": "ဖန်တီးခဲ့သည့်ရက်စွဲ",
    "customers.label.district": "ခရိုင်",
    "customers.label.pincode": "ကုဒ်အုပ်စု",
    "customers.label.last_bill_amount": "နောက်ဆုံးငွေပမာဏ",
    "customers.label.last_bill_date": "နောက်ဆုံးဘစ်ကိုက်ညီသည့်ရက်",
    "customers.label.last_bill_paid": "နောက်ဆုံးငွေပေးသွင်းသည်",
    "customers.label.last_paid_amount": "နောက်ဆုံးငွေပေးသွင်းသည့်ပမာဏ",
    "customers.label.last_payment_date": "နောက်ဆုံးငွေပေးချေမည့်ရက်",
    "customers.label.next_bill_date": "နောက်ဆုံးဘစ်ကိုကြည့်ရန်ရက်",
    "customers.label.service_overview": "ဝန်ဆောင်မှုအသေးစိတ်",
    "customers.label.service_without_device": "ကိုယ်ရေးသုံးနေသောဝန်ဆောင်မှု",
    "customers.label.create_ticket": "ထုတ်ယူရန်တင်ရန်",
    "customers.label.service_activation": "ဝန်ဆောင်မှုဖွင့်ခြင်း",
    "customers.label.order_charging": "အမှာန်ကြောင်းခံခြင်း",
    "customers.label.top_up": "ငွေဖြည့်",
    "customers.label.redeem": "ငွေလွှဲပြောင်းရန်",
    "customers.label.collection_name": "ကောလဟလအမည်",
    "customers.label.redeem_voucher": "ဘောက်ချာ ထုတ်ယူပါ။",
    "customers.label.service_id": "ဝန်ဆောင်မှု ID",
    "customers.label.service_code": "ဝန်ဆောင်မှုကုဒ်",
    "customers.label.service_description": "ဝန်ဆောင်မှုဖော်ပြချက်",
    "customers.label.start_date": "စတင်ခဲ့သည့်နေ့စွဲ",
    "customers.label.modified_date": "ပြင်ဆင်ခဲ့သည့်နေ့စွဲ",
    // "customers.label.status": "အခြေအနေ",
    "customers.label.info": "အချက်အလက်",
    "customers.label.action": "လုပ်ဆောင်ချက်",
    "customers.label.add_device": "ကိုယ်တိုင်ကိုတင်သွင်းရန်",
    "customers.label.add_plans": "အစီအစဉ်များထည့်ပါ",
    "customers.label.suspend": "အဆုံးမပိတ်ပါ",
    "customers.label.reactivate": "ထပ်ဖြည့်ရန်",
    "customers.label.terminate": "ပိတ်ဆက်ပါ",
    "customers.label.command_center": "စာရင်းပြင်ဆင်ခြင်း",
    "customers.label.retrack": "ထပ်ကြိုးစာရင်းပြပါ",
    "customers.label.cancel_plans": "အစီအစဉ်များဖျက်ပါ",
    "customers.label.device_overview": "ကိရိယာထွက်ချိန်",
    "customers.label.item_code": "ကုန်ပစ္စည်းကုဒ်",
    "customers.label.orders_overview": "အမှာစာရင်းကိုအသေးစိတ်",
    // "customers.label.plan": "အစီအစဉ်",
    "customers.label.end_date": "အဆုံးသတ်ချိန်",
    "customers.label.price": "စျေးနှုန်း",
    "customers.label.short_description": "အတိုချုံးဖော်ပြချက်",
    "customers.label.description": "ဖော်ပြချက်",
    "customers.label.add_note": "မှတ်ချက်ထည့်ရန်",
    "customers.label.note": "မှတ်ချက်",
    "customers.label.sale_type": "ရောင်းချသည့်အမျိုးအစား",
    "customers.label.charge_code": "ကုန်ကျင်ကုဒ်",
    "customers.label.quantity": "အရေအတွက်",
    // "customers.label.total_price": "စုစုပေါင်းစျေးနှုန်း",
    "customers.label.warranty_date": "အထူးခံရက်စွဲ",
    "customers.label.allocate": "တည်ထောင်ခြင်း",
    "customers.label.contact_info": "ဆက်သွယ်ရန်အချက်အလက်",
    "customers.label.edit_customer": "ကျွန်ုပ်တို့ကိုတည်းဖြတ်ရန်",
    "customers.label.lco": "LCO",
    "customers.label.title": "ခေါင်းစဉ်",
    // "customers.label.customer_category": "သုံးစွဲသူအမျိုးအစား",
    "customers.label.middle_name": "အသံအပြုနာနာမည်",
    "customers.label.caf_id": "CAF Id",
    "customers.label.landline_number": "ကြိုးဖုန်းနံပါတ်",
    "customers.label.user_name": "အသုံးပြုသူအမည်",
    "customers.label.customer_photo": "သင့်ရဲ့အဖုံးပုံ",
    "customers.label.id_proof": "အသေးစိတ်သက်တမ်း",
    "customers.label.id_proof_value": "အသေးစိတ်အမှတ်",
    "customers.label.save": "သိမ်းဆည်းပါ",
    "customers.label.close_customer": "ကုန်သည်တောင်းဆိုခြင်း",
    "customers.label.closure_date": "တောင်းဆိုသည့်နေ့စွဲ",
    "customers.label.closure_reason": "တောင်းဆိုခြင်းအကြောင်း",
    "customers.label.close": "ပိတ်သည်",
    "customers.label.address_info": "လိပ်စာအချက်အလက်",
    "customers.label.edit_address": "လိပ်စာပြုစု",
    "customers.label.address_no": "လိပ်စာနံပါတ်",
    "customers.label.street": "လမ်း",
    "customers.label.building": "အဆောက်ပြေစု",
    "customers.label.zipcode": "စာတိုက်ပေါင်းအုပ်စု",
    "customers.label.billing": "ဘောင်ချာ",
    "customers.label.same_as_primary": "မူလစာပိုင်းထဲကနေလည်း",
    "customers.label.building_code": "အဆောက်ပြေစုကုဒ်",
    "customers.label.add_address": "လိပ်စာထည့်ရန်",
    "customers.label.address_type": "လိပ်စာအမျိုးအစား",
    "customers.label.billing_info": "ငွေပေးချေမှုအချက်အလက်",
    "customers.label.created_adjustment": "အဆုံးသတ်မှတ်ထားသည့်တောင်းခံခြင်း",
    "customers.label.create_order": "အမှာစာ ဖန်တီးရန်",
    "customers.label.sale_catalog": "အရောင်းအဝယ်စာရင်း",
    "customers.label.renew_plan": "အစီအစဉ်ကို သက်တမ်းတိုးပါ။",
    "customers.label.auto_renew": "အလိုအလျောက်စီမှတ်တမ်း",
    // "customers.label.search": "ရှာဖွေရန်",
    "customers.label.entity_name": "လုပ်ငန်းအမည်",
    "customers.label.discount": "လျှော့ချက်",
    "customers.label.provisioning_commands": "ပေးဖော်ရိုက်မှုရွေးစရာများ",
    "customers.label.command": "ဖွင့်လှစ်မှု",
    "customers.label.plans": "စီစစ်များ",
    "customers.label.client_service_detail": "ဖြစ်စဉ်စာရင်းအသေးစိတ်",
    "customers.label.id": "အမှတ်အသား",
    "customers.label.parameter_name": "ပရိုဖိုင်အမည်",
    "customers.label.parameter_value": "ပရိုဖိုင်အမည်တန်ဖိုး",
    "customers.label.request_type": "တောင်းဆိုခြင်းအမျိုးအစား",
    "customers.label.client_info": "ဖြည့်စွက်သူအချက်အလက်",
    "customers.label.service_info": "ဝန်ဆောင်မှုအချက်အလက်",
    "customers.label.new_device_info": "သတင်းအချက်အလက်",
    "customers.label.task_list": "လုပ်ငန်းစာရင်း",
    "customers.label.provisioning_detail": "ထုတ်ယူခြင်းအသေးစိတ်",
    "customers.label.provisioning_id": "ထုတ်ယူခြင်းအမှတ်စဉ်",
    "customers.label.task_id": "လုပ်ငန်းအမှတ်စဉ်",
    "customers.label.sent_message": "ပေးပို့ပြီးပြီစာတစ်စောင်း",
    "customers.label.available_plans": "ရရှိနိုင်သောစီမံခန့်ခွဲများ",
    "customers.label.disconnect_order": "ခွင့်ပြုချက်ပိတ်မည့် အမှတ်စဉ်",
    "customers.label.reason": "အကြောင်းအရာ",
    "customers.label.porting_out": "သယ်ထုတ်ခြင်း။",
    "customers.label.prepaid_to_postpaid": "Postpaid မှ ကြိုတင်ငွေပေးချေပါ။",
    "customers.label.postpaid_to_prepaid": "ကြိုတင်ငွေပေးချေရန် Postpaid",
    "customers.label.addons": "Addons",
    "customers.label.change_plan": "စီမံခန့်ခွဲမှု ပြောင်းလဲမည်",
    "customers.label.swap_sim": "SIM ကိုဖလှယ်ပါ",
    "customers.label.select_date": "ရွေးချယ်မည့်နေ့ကို ရွေးချယ်ပါ",
    "customers.label.order_date": "အမှတ်စဥ်ကုန့်သည်",
    "customers.label.priority": "အလိုအကတ်",
    "customers.label.ticket_date": "လက်မှတ်ရက်စွဲ",
    "customers.label.category": "အမျိုးအစား",
    "customers.label.sub_category": "အမျိုးအစားအောက်ခြေ",
    "customers.label.team": "အဖွဲ့",
    "customers.label.team_user": "အဖွဲ့အသုံးပြုသူ",
    "customers.label.source": "ရာထူး",
    "customers.label.due_time": "အချိန်ဇယားထိုး",
    "customers.label.device_swap": "စက်အပ်အကြောင်းပြောင်း",
    // "customers.label.terminate": "ပိတ်ပင်ပါ",
    "customers.label.confirm": "အတည်ပြုပါ",
    "customers.label.continue": "ဆက်ရန်",
    "customers.label.process_date": "လုပ်ဆောင်သည့်ရက်စွဲ",
    "customers.label.pin_number": "ကုတ်နံပါတ်",
    "customers.label.renewal": "အစီအစဉ်",
    // "customers.label.create_customer": "ဖန်တီးသူ ဖန်တီးပါ",
    "customers.label.individual": "ကိုယ်ရည်နှင့်ပတ်သက်",
    "customers.label.corporate": "ကုမ္ပဏီ",
    "customers.label.corporate_details": "ကုမ္ပဏီ အသေးစိတ်များ",
    "customers.label.contact_person": "ဆက်သွယ်ရန်လိပ်စာ",
    "customers.label.entity": "လူမှု",
    "customers.label.client_category": "သုံးစွဲသူအမျိုးအစား",
    "customers.label.preferences": "အသိပညာများ",
    "customers.label.parent_id": "မူလစာရင်း",
    "customers.label.child": "ကလေး",
    "customers.label.villege_street": "ကျေး/လမ်း",
    "customers.label.billing_address": "ငွေပေးချေမှု လိပ်စာ",
    "customers.label.bill_information": "ငွေယူဆောင်ရန် အချက်အလက်",
    "customers.label.bill_day_of_month": "လစဉ်အတန်းနေ့",
    "customers.label.fiscal_year": "ဘဏ္ဍာရီ နှစ်",
    "customers.label.fiscal_quater": "ဘဏ္ဍာရီ လျှို့",
    "customers.label.bill_mode": "ငွေယူဆောင်အောက်ပါအတိုင်း",
    "customers.label.invoice_type": "ဘဏ္ဍာရီ အမျိုးအစား",
    "customers.label.payment_information": "ငွေပေးချေမှု အချက်အလက်",
    "customers.label.funder_name": "ပေးရှင်းသူအမည်",
    "customers.label.funder_id": "ပေးရှင်းသူ ID",
    "customers.label.po_number": "PO နံပါတ်",
    "customers.label.payment_term": "ငွေပေးချေငွေကြော်ငြာ",
    "customers.label.customer_created_successfully": "ဖောက်သည်မှာအောင်မြင်ပါ",
    "customers.label.go_to_customer": "ကျေးဇူးပြု၍ သူ့အဖြစ်သို့သွားပါ",
    "customers.label.view_order": "အမှာစာကြည့်ရန်",
    "customers.label.disconnect": "ချိတ်ဆက်ရန်",
    "customers.label.apply_promo": "အပိုင်းအစားလွှဲပြောင်းရန်",
    // "customers.label.order_id": "အမှာစာ ID",
    "customers.label.order_type": "အမှာစာအမျိုးအစား",
    "customers.label.billing_cycle": "ငွေပေးချေခြင်းခန့်",
    "customers.label.plan_name": "အစီအစဉ်အမည်",
    "customers.label.user_action": "အသုံးပြုသူလုပ်ငန်း",
    "customers.label.invoice_till_date": "ငွေပေးချေစာရင်းသွင်းလိုသည့်ရက်",
    "customers.label.order_services": "အမှာစာဝန်ဆောင်မှုများ",
    "customers.label.service_type": "ဝန်ဆောင်မှုအမျိုးအစား",
    "customers.label.bill_start_date": "ငွေပေးချေစသည့်နေ့စွဲ",
    "customers.label.bill_end_date": "ငွေပေးချေအဆုံးနေ့စွဲ",
    // "customers.label.invoice_till_date": "ငွေပေးချေစာရင်းသွင်းလိုသည့်ရက်",
    "customers.label.charge_type": "ငွေပေးချေအမျိုးအစား",
    "customers.label.rate_uom": "စာရင်း/UOM",
    "customers.label.discount_description": "လျှော့စျေးအကြောင်း",
    "customers.label.discount_type": "လျှော့စျေးအမျိုးအစား",
    "customers.label.discount_start_date": "လျှော့စျေးစတင်ခြင်းနေ့",
    "customers.label.discount_end_date": "လျှော့စျေးအဆုံးနေ့",
    "customers.label.discount_amount": "လျှော့စျေးပမာဏ",
    "customers.label.order_transaction": "အမှာစာစီမံခန့်",
    "customers.label.user": "အသုံးပြုသူ",
    "customers.label.transaction_date": "ငွေသွင်းမည့်နေ့စွဲ",
    "customers.label.transaction_type": "ငွေသွင်းမည့်အမျိုးအစား",
    "customers.label.actual_date": "အခြေအနေရက်",
    "customers.label.promo": "ပရိုမို",
    "customers.label.promotion": "ပရိုမို",
    "customers.label.disconnection_date": "ခွင့်ပြုမည့်နေ့စွဲ",
    "customers.label.disconnection_reason": "ခွင့်ပြုမည့်အကြောင်း",
    "customers.label.problem_code": "ပြဿနာ ကုဒ်",
    "customers.label.assign_to": "တန်ဖိုးသို့ ပေးပို၍",
    "customers.label.last_comment": "နောက်ဆုံးထွက်ခဲ့သော မှတ်ချက်",
    "customers.label.file_name": "ဖိုင်နာမည်",
    "customers.label.edit_ticket": "အမှတ်တံဆိပ် တည်ဆောက်ပါ",
    "customers.label.close_ticket": "အမှတ်တံဆိပ် ပိတ်ပါ",
    "customers.label.resolution_description": "အကယ်၍ အသိပေးချက်",
    "customers.label.ticket_history": "အမှတ်တံဆိပ် သမိုင်း",
    // "customers.label.last_comment": "နောက်ဆုံးထွက်ခဲ့သော မှတ်ချက်",
    "customers.label.problem_description": "ပြဿနာ ဖော်ပြချက်",
    "customers.label.generate": "ဖန်တီးပါ",
    "customers.label.bill_date": "ဘီလ်ဒင်နေ့",
    "customers.label.amount": "ပမာဏ",
    "customers.label.statement": "ကဏ္ဍ",
    // "customers.label.due_date": "နောက်ဆုံးရက်",
    "customers.label.promotional_message": "ပရိုမိုတိုက်စစ်စာ",
    "customers.label.download": "ဒေါင်းလုတ်",
    "customers.label.due_amount": "ကျော်သောပမာဏ",
    "customers.label.transactions": "ငွေသွင်းမည့်အမှာစာများ",
    "customers.label.file": "ဖိုင်",
    "customers.label.reset": "ပြန်စပ်ရန်",
    "customers.label.order_details": "အမှာစာအသေးစိတ်",
    "customers.label.make_payment": "ငွေပေးချေမည်",
    "customers.label.credit_amount": "အကြွေးအဝယ်",
    "customers.label.debit_amount": "အကုန်ပေးငွေ",
    "customers.label.cancel_remark": "ဖျက်သိမ်းဆည်းခြင်းမှတ်ချက်",
    "customers.label.pay_invoice": "ငွေပေးချေမည်",
    "customers.label.account": "အကောင့်",
    "customers.label.deposit": "အကောက်ဖိုင်",
    "customers.label.payment_date": "ငွေပေးချေသည့်နေ့စွဲ",
    "customers.label.payment_type": "ငွေပေးချေအမျိုးအစား",
    "customers.label.receipt_no": "လက်ခံရမည့်နံပါတ်",
    "customers.label.cheque_no": "စီးပွားရမည့်နံပါတ်",
    "customers.label.bank_name": "ဘဏ်အမည်",
    "customers.label.branch_name": "စာအုပ်အမည်",
    "customers.label.cheque_date": "စီးပွားရမည့်နေ့စွဲ",
    "customers.label.invoice_id": "စာရင်းစာရင်းအမှတ်",
    "customers.label.invoice_date": "စာရင်းစာရင်းရက်စွဲ",
    "customers.label.invoice_amount": "စာရင်းစာရင်းပမာဏ",
    // "customers.label.due_amount": "ကျော်သောပမာဏ",
    "customers.label.payment_reversal": "ငွေပေးချေခွင့်ပြောင်းခြင်း",
    "customers.label.date_filter": "နေ့စွဲစစ်ပါ",
    "customers.label.add_event_order": "အဖွဲ့မည့် ဖြစ်ရမည့် အစီအစဉ်",
    "customers.label.event_order": "အဖြစ်ဖွင့်မည့်အစီအစဉ်",
    "customers.label.eventdate": "အဖြစ်နေ့အကြို",
    "customers.label.serviceAddress": "ဝန်ဆောင်မှုလိပ်စာ",
    "customers.label.event_name": "ဖြစ်ရမည့်အစီအစဉ်",
    "customers.label.booked_date": "မှာယူထားသောရက်စွဲ",
    "customers.label.event_price": "ဖြစ်ရမည့်အစီအစဉ်ပမာဏ",
    "customers.label.events": "ဖြစ်ရပ်များ",
    "customers.label.format_type": "ပုံနှိပ်နှိုင်းအမျိုးအစား",
    "customers.label.opt_type": "OPT အမျိုးအစား",
    "customers.label.client_bill_profile":
      "ဖောက်သည့်အကြောင်းအရာဖြစ်အောင်လိုက်သောအကြောင်းအရာ",
    "customers.label.edit": "တည်းဖြတ်ရန်",
    "customers.label.type": "အမျိုးအစား",
    "customers.label.client_id": "ဖောက်သည့် ID",
    "customers.label.bill_currency": "ငွေကြေးကိုယ်",
    "customers.label.bill_frequency": "ငွေကြေးအရပ်ကိန်း",
    "customers.label.bill_segment": "ငွေကြေးအစား",
    // "customers.label.next_bill_day": "နောက်ဆုံးငွေကြေးနေ့",
    "customers.label.last_bill_day": "နောက်ဆုံးငွေကြေးနေ့",
    "customers.label.last_bill_no": "နောက်ဆုံးငွေကြေးနံပါတ်",
    // "customers.label.payment_type": "ငွေပေးချေမှုအမျိုးအစား",
    "customers.label.bill_suppression_flag":
      "ငွေကြေးဖျက်ပစ်ခြင်းအလိုက်သည့်အပိုင်း",
    "customers.label.bill_suppression_id": "ငွေကြေးဖျက်ပစ်ခြင်း ID",
    "customers.label.first_bill": "ပထမငွေကြေး",
    "customers.label.hot_bill": "အများဆုံးငွေကြေး",
    "customers.label.edit_bill_profile": "ဘီလီယံပရိုဖိုင်ကိုတည်းဖြတ်ပါ",
    "customers.label.bill_suppression": "ဘီလ္လိုတ်ပစ်ခြင်း",
    // "customers.label.more_info": "ပိုမိုသောအချက်အလက်",
    "customers.label.identities": "ရောဂါကုမ္ပဏီ",
    "customers.label.add_client_identities": "ဝန်ထမ်းအကွေစရိတ်များထည့်သွင်းပါ",
    "customers.label.unique_identification":
      "တစ်ဦးနာမည်နှင့်စစ်ဆေးအသုံးပြုနည်း",
    "customers.label.identity_documents": "ရောဂါအရေတွက်",
    "customers.label.additional_info": "အသစ်သတင်းအချက်အလက်",
    "customers.label.nationality": "လူမျိုးသား",
    "customers.label.date_of_birth": "မွေးနေ့",
    "customers.label.preferred_language": "အကြိမ်မှာယူသည့်ဘာသာစကား",
    "customers.label.finance_id": "ဘဏ်ကို ID",
    "customers.label.remarks": "မှတ်ချက်",
    "customers.label.preferred_communication": "မှတ်ချက်ပြင်ဆင်ခြင်း",
    "customers.label.add_client_identifier": "ဝန်ထမ်းအမှတ်တံဆိပ်ထည့်ရန်",
    "customers.label.document_type": "စာရင်းအမျိုးအစား",
    "customers.label.document_uploads": "စာရင်းအမျိုးအစားတင်သွင်းပါ",
    "customers.label.select_file": "ဖိုင်ရွေးချယ်ရန်",
    "customers.label.credit_card_details": "အကြောင်းအရာများ",
    "customers.label.card_number": "ကဒ်နံပါတ်",
    "customers.label.cvv": "CVV",
    "customers.label.card_type": "ကဒ်အမျိုးအစား",
    "customers.label.expiry_date": "သက်တမ်းအားပြည့်စုံသည့်နေ့",
    "customers.label.ach_card": "ACH ကဒ်",
    "customers.label.ach_card_routing_number": "ACH ကဒ်လမ်းညွှန်နံပါတ်",
    "customers.label.bank_account_number": "ဘဏ်စကင်ဖတ်နံပါတ်",
    "customers.label.childs": "ကလေးများ",
    "customers.label.cell_phone": "ဖုန်းနံပါတ်",
    "customers.label.create_client_additional_info":
      "ဝန်ထမ်းအသစ်အချက်အလက်တည်ဆောက်ရန်",
    "customers.label.gender": "ကျား/မ",
    "customers.label.id_type": "ID အမျိုးအစား",
    // "customers.label.nationality": "လူမျိုးနာမည်",
    "customers.label.id_number": "ID နံပါတ်",
    "customers.label.job_title": "အလုပ်အကိုင်အမည်",
    "customers.label.age_group": "အသက်အရွယ်အစား",
    "customers.label.uts_customer_id": "UTS ကိုယ်ရေးအခြေအနေ",
    "customers.label.ach_card_name": "ACH ကဒ်အမည်",
    "customers.label.adjustment": "အောင်းကြောင်း",
    // "customers.label.created_adjustment": "ဖန်တီးသော အောင်းကြောင်း",
    "customers.label.adjustment_date": "အောင်းကြောင်းနေ့စွဲ",
    "customers.label.adjustment_code": "အောင်းကြောင်းကုတ်",
    "customers.label.adjustment_amount": "အောင်းကြောင်းပမာဏ",
    "customers.label.adjustment_type": "အောင်းကြောင်းအမျိုးအစား",
    // "customers.label.activity_log": "လုပ်ဆောင်ချက်အမှတ်တံဆိပ်",
    "customers.label.office_id": "ရုံးအမှတ်",
    "customers.label.history": "သမိုင်း",
    "customers.label.filter_by_date": "နေ့စွဲဖြင့်စစ်ထုတ်ပါ",
    "customers.label.view_usage_details":
      "အသုံးပြုအသေးစိတ်အသေးစိတ်များကိုကြည့်ရန်",
    "customers.label.units": "ယူနစ်များ",
    "customers.label.tax": "အခွန်",
    "customers.label.total_amount": "စုစုပေါင်းပမာဏ",
    "customers.label.account_transaction": "အကောင့်စာရင်း",
    "customers.label.csv_pdf": "CSV/PDF",
    "customers.label.charge_description": "ငွေသတ်မှတ်ချက်",
    "customers.label.journals": "မီဒီယာများ",
    "customers.label.download_financial_summary_data":
      "ဘဏ်အကျယ်အမတ်အားဒေါင်းလုတ်လုပ်ရန်ဒေါင်းလုတ်ခြင်း",
    "customers.label.select_from_date": "မှာယူရန်နေ့စွဲကိုရွေးချယ်ပါ",
    "customers.label.select_to_date": "သို့ပြီးသောနေ့စွဲကိုရွေးချယ်ပါ",
    "customers.label.village_street": "ကျေးရွာ/လမ်းမ",
    "customers.label.previous": "ယခင်",
    "customers.label.Disconnect": "ဖြုတ်ရန်",
    "customers.label.ApplyPromo": "ပရိုမိုးရှင်း အသုံးချပါ",
    "customers.label.Service": "ဝန်ဆောင်မှု",
    "customers.label.Product": "ထုတ်ကုန်",
    "customers.label.CreditCard": "ခရက်ဒစ်ကဒ်",
    "customers.label.Paypal": "Paypal",
    "customers.label.BusinessEntity": "စီးပွားရေးအဖွဲ့အစည်း",
    "customers.label.Plan": "အစီအစဉ်",
    "customers.label.Phone": "ဖုန်း",
    "customers.label.TaxExemption": "အခွန်ကင်းလွတ်ခွင့်",
    "customers.label.YES": "ဟုတ်ကဲ့",
    "customers.label.NO": "မဟုတ်ဘူး",
    "customers.label.Resolution": "ပြဿနာအဖြေ",
    "customers.label.AccountNo": "အကောင့်နံပါတ်",
    "customers.label.ChipId": "ချစ်ပ် ID",
    "customers.label.MobileNo": "မိုဘိုင်းနံပါတ်",
    "customers.label.EmailId": "အီးမေးလ် ID",
    "customers.label.SerialNo": "အမှတ်စဥ်",
    "customers.label.LegacyNo": "ဇာတိနံပါတ်",
    "customers.label.searchclient": "ဖောက်သည်ရှာပါ",
    "customers.label.PrimaryAddress": "မူလလိပ်စာ",
    "customers.label.BillingAddress": "ဘီလ်ချိန်လိပ်စာ",
    // "customers.label.lco": "lco",
    "customers.label.EventDate": "အဖြစ်အပျက်ရက်စွဲ",
    "customers.label.CreateAdjustment": "ညှိနှိုင်းမှုဖန်တီးပါ",
    "customers.label.full_name": "အမည်အပြည့်အစုံ",
    "customers.label.bill_collection_action": "ဘောက်ချာစုဆောင်းမှုလှုပ်ရှားမှု",
    "customers.label.collection_actions": "စုဆောင်းမှုလှုပ်ရှားမှုများ",
    "customers.label.action_name": "လှုပ်ရှားမှုအမည်",
    "customers.label.action_date": "လှုပ်ရှားမှုရက်စွဲ",
    "customers.label.balance_due": "ကျန်ငွေ",
    "customers.label.bill_id": "ဘောက်ချာ ID",
    "customers.label.payinfo": "ငွေပေးချေမှု အချက်အလက်",
    "customers.label.cardtoken": "ကဒ်တွန်း",
    "customers.label.autopay": "အလိုလျောက်ငွေပေးချေမှု",
    "customers.label.paynow": "အခုငွေပေးချေပါ",
    "customers.label.featureList": "အင်္ဂါရပ်စာရင်း",
    "customers.label.consumed": "သုံးစွဲမှု",
    "customers.label.updateCreditLimt": "အကြွေးကန့်သတ်ကိုအပ်ဒိတ်လုပ်ပါ",
    "customers.label.PendingForApproval": "အတည်ပြုရန်စောင့်ဆိုင်းနေသည်",

    "customers.label.SpendCapHistory": "အသုံးစရိတ်ကန့်သတ်မှုမှတ်တမ်း",
    "customers.label.DateTime": "ရက်စွဲနှင့်အချိန်",
    "customers.label.SpendCapEventName": "အသုံးစရိတ်ကန့်သတ်အဖြစ်အပျက်အမည်",
    "customers.label.SpendingLimit": "အသုံးစရိတ်ကန့်သတ်ချက်",
    "customers.label.ConsumedLimit": "အသုံးပြုထားသောကန့်သတ်ချက်",
    "customers.label.EventId": "အဖြစ်အပျက် ID",
    "customers.label.collectionStatus": "စုဆောင်းမှုအခြေအနေ"
  },
};
